angular.module('configs', [])

.constant('API_BASE_URL', 'https://api.freelancer.com')

.constant('API_VERSION', {})

.constant('AUTH_BASE_URL', '')

.constant('AVATAR_PLACEHOLDER', 'https://cdn.warriorforum.com/images/placeholder_avatar.gif?256F')

.constant('BASE_URL', 'https://payments.warriorforum.com/')

.constant('BUTTON_IMAGE_BASE_URL', 'http://tracking.warriorforum.com/')

.constant('DIRECT_ACCESSED_STORAGE', 'direct_accessed')

.constant('EXPERTS_BASE_URL', 'https://experts.warriorforum.com/')

.constant('EXPERTS_API_BASE', 'https://experts.warriorforum.com/api')

.constant('EXPERTS_API_URL', 'https://experts.warriorforum.com/api')

.constant('FEED_TOUR_STORAGE', 'feed_tour')

.constant('FIXED_CHARGE_NEW_ID', 1)

.constant('FIXED_CHARGE_BUMP_ID', 2)

.constant('FIXED_CHARGE_STICKY_ID', 3)

.constant('FORUM_LOGGED_IN_COOKIE', 'bbuserid')

.constant('LAST_LOGGED_IN_STORAGE', 'last_logged_in')

.constant('LINK_TYPE_THREADS_FORUMID', 110)

.constant('EXPERIMENT_COOKIE', 'varid')

.constant('GAF_BASE_URL', '')

.constant('LOGIN_WELCOME_COOKIE', 'bblogin_welcome')

.constant('LOGOUT_URL', 'https://www.warriorforum.com/login.php?do=logout')

.constant('MAILGUN_API_KEY', 'pubkey-0gf9wd6z-7swxebnw3cfups-ixc3cef0')

.constant('MAILGUN_BASE_URL', 'https://api.mailgun.net')

.constant('MONTH_FREE_TRIAL', '3')

.constant('PRODUCT_LINK_BASE_URL', 'https://tracking.warriorforum.com/')

.constant('SENTRY_DSN_URL', 'http://publicKey@ergo.syd.local/mobile')

.constant('SIGNUP_DISMISSED_STORAGE', 'signup_dismissed')

.constant('SIGNUP_URL', 'https://www.warriorforum.com/register.php')

.constant('STRIPE_AUD_PUB_KEY', 'pk_live_NbxzNLVRY1uHfTOCZ47AVXLL')

.constant('STRIPE_PUB_KEY', 'pk_live_jIBwCvnNKwMEwup54rqOP6Ms')

.constant('WF_API_BASE_URL', 'https://www.warriorforum.com/')

.constant('WF_BASE_URL', 'http://www.warriorforum.com/')

.constant('WF_DOMAIN', 'www.warriorforum.com')

.constant('WSO_API_BASE', 'https://payments.warriorforum.com/api')

.constant('WSO_API_PATH', '/api')

.constant('WSO_API_URL', 'https://payments.warriorforum.com/api')

.constant('WSO_FORUMID', 17)

.constant('WSO_FORUMNAME', 'warrior-special-offers-forum')

.constant('FACEBOOK_APP_ID', '730314413766237')

.constant('FACEBOOK_REDIR_URL', 'https://payments.warriorforum.com/oauth/facebook/')

.constant('GOOGLE_APP_ID', '113503922011-dug3roiirceej102mjlvn48a156eqmp7.apps.googleusercontent.com')

.constant('GOOGLE_REDIR_URL', 'https://payments.warriorforum.com/oauth/google/')

.constant('FL_CDN', 'https://cdn1.f-cdn.com')

.constant('THREATMETRIX_ORG_ID', 'lar9e74p')

.constant('RECAPTCHA_PUB_KEY', '6LfRLAATAAAAAKDppJclkQkJ2TzcPnJI7PfWHPxY')

.constant('PAYMENT_METHODS', ['stripe','paypal'])

.constant('WF_TRACKING_COOKIE', 'wf_trk')

.constant('BASE_DOMAIN', 'warriorforum.com')

;
'use strict';

angular.module('wsoButtons', [
  'ngResource'
]);

'use strict';

angular.module('wsoButtons')
  .service('ButtonCodeGenerator', ["URLGenerator", function (URLGenerator) {
    return {
      generateEditorCode: function(seo_url) {
        return '[URL="' + URLGenerator.getProductLinkUrl(seo_url) + '"][IMG]' +  URLGenerator.getButtonImageUrl(seo_url) + '[/IMG][/URL]';
      },

      generateHtmlCode: function(seo_url, alt_text) {
        var lines = [];

        lines.push('<a href="' + URLGenerator.getProductLinkUrl(seo_url) + '">');
        if (alt_text) {
          lines.push('    <img alt="' + alt_text + '" src="' + URLGenerator.getButtonImageUrl(seo_url) + '" />');          
        } else {
          lines.push('    <img src="' + URLGenerator.getButtonImageUrl(seo_url) + '" />');          
        }
        lines.push('</a>');
        return lines.join('\n');        
      },

      generateNoThanksHtmlCode: function(seo_url, css_class) {
        var lines = [];
        var no_thanks_link = URLGenerator.getProductNoThanksLinkUrl(seo_url);

        if (css_class) {
          css_class += ' no-thanks';
        } else {
          css_class = 'no-thanks';
        }

        lines.push('<a class="' + css_class + '" href="' + no_thanks_link + '">No Thanks</a>');
        return lines.join('\n');
      }
    };
  }]);

'use strict';

angular.module('wsoButtons')
  .factory('FormRequest', ["$window", function ($window) {
    var result = {};
    result.post = function (url, data) {
      var $form = $window.$('<form method="post"></form>');
      $form.attr('action', url);
      $form.hide();
      $window.$('body').append($form);
      angular.forEach(data, function (value, key) {
        var $input = $window.$('<textarea type="text"></textarea>');
        $input.attr('name', key);
        $input.text(value);
        $form.append($input);
      });
      $form.submit();
    };
    result.customHttpMethod = function (formType, url, data) {
      // formType must be of the form '<form method="get"></form>''
      var $form = $window.$(formType);
      $form.attr('action', url);
      $form.hide();
      $window.$('body').append($form);
      angular.forEach(data, function (value, key) {
        var $input = $window.$('<textarea type="text"></textarea>');
        $input.attr('name', key);
        $input.text(value);
        $form.append($input);
      });
      $form.submit();
    };
    return result;
  }]);

'use strict';

angular.module('wsoButtons')
  .service('Forum', ["$http", "$resource", "$window", "WSO_FORUMID", "WF_API_BASE_URL", "md5", "ForumURLGenerator", "UrlHelper", function (
    $http,
    $resource,
    $window,
    WSO_FORUMID,
    WF_API_BASE_URL,
    md5,
    ForumURLGenerator,
    UrlHelper) {

    var ForumUserThreadApi = $resource(
      WF_API_BASE_URL + 'get_user_threads.php', {
        callback: 'JSON_CALLBACK'
      }, {
        query: {
          method: 'JSONP',
          isArray: true
        }
      });

    var ForumUserPostApi = $resource(
      WF_API_BASE_URL + 'get_post.php', {
        callback: 'JSON_CALLBACK'
      }, {
        get: {
          method: 'JSONP'
        }
      });

    return {
      // user sent via forum cookie
      queryUserThreads: function (securitytoken) {
        return ForumUserThreadApi.query({
          f: WSO_FORUMID,
          securitytoken: securitytoken
        });
      },

      // user sent via forum cookie
      getUserPost: function (postid, securitytoken) {
        return ForumUserPostApi.get({
          postid: postid,
          securitytoken: securitytoken
        });
      },

      // Get avatars from warriorforum.
      getAvatars: function (names) {
        var api = $resource(
          WF_API_BASE_URL + 'get_avatars.php', {
            callback: 'JSON_CALLBACK'
          }, {
            get: {
              method: 'JSONP'
            }
          });
        return api.get({
          names: names
        }).$promise;
      },

      check: function (params) {
        var config = {};
        config.url = WF_API_BASE_URL + 'check.php';
        config.method = 'POST';
        config.headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
          };
        config.data = $.param(params);
        return $http(config);
      },

      createAccount: function(data) {
        var config = {};
        config.url = WF_API_BASE_URL + 'signup.php';
        config.method = 'POST';
        config.headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
          };

        var post_data = {};
        post_data.captcha = data.captcha;
        post_data.email = data.email;
        post_data.username = data.username;
        post_data.password = md5.createHash(data.password);
        post_data.password_confirm = md5.createHash(data.confirmPassword);
        // Add captcha value.
        if (data.captcha) {
          post_data.response = data.captcha.response;
          post_data.challenge = data.captcha.challenge;
        }
        config.data = $.param(post_data);
        return $http(config);
      },

      clear_login_welcome_cookie: function() {
        var config = {};
        config.url = WF_API_BASE_URL + 'login.php';
        config.method = 'POST';
        config.headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json;q=0.9,image/webp,*/*;q=0.8'
          };

        var post_data = {};
        post_data.securitytoken = $window.SECURITYTOKEN;
        post_data.do = 'clear_login_welcome';
        config.data = $.param(post_data);
        return $http(config);
      },

      login: function(data) {
        var config = {};
        config.url = WF_API_BASE_URL + 'login.php?do=login';
        config.method = 'POST';
        config.headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json;q=0.9,image/webp,*/*;q=0.8'
        };

        var post_data = {};
        post_data.vb_login_username = data.username;
        post_data.cookieuser = 1;
        post_data.vb_login_md5password = md5.createHash(data.password);
        post_data.vb_login_password = '';
        post_data.vb_login_md5password_utf = md5.createHash(data.password);
        post_data.redirect_url = UrlHelper.getParameter('redirect_url');
        post_data.securitytoken = 'guest';
        post_data.do = 'login';
        config.data = $.param(post_data);
        return $http(config);
      },

      forgotPassword: function(data) {
        var config = {};
        config.url = WF_API_BASE_URL + 'login.php?do=emailpassword';
        config.method = 'POST';
        config.headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json;q=0.9,image/webp,*/*;q=0.8'
          };

        var post_data = {};
        post_data.email = data.email;
        post_data.do = 'emailpassword';
        config.data = $.param(post_data);
        return $http(config);
      },

      getRoots: function() {
        var params = {action: 'get_root_forums'};
        return $http.get(ForumURLGenerator.getApiUrl('forums_api.php'), {params: params});
      },

      getThreadPreview: function(args) {
        var url = ForumURLGenerator.getApiUrl('threads_api.php');
        args.action = 'get_preview';

        var config = {};
        config.url = url;
        config.method = 'POST';
        config.headers = {'Content-Type': 'application/x-www-form-urlencoded'};
        config.data = $.param(args);

        return $http(config);
      }
    };
  }])
  .factory('ForumAPIInteceptor', ["WF_API_BASE_URL", "$q", function ForumAPIInteceptor(WF_API_BASE_URL, $q) {

    var error = function(response) {
      var errorCode;
      // We should always have an error message
      if (response.data && response.data.error_code) {
        var errors = response.data.error_code.match(/\.(.*$)/);
        if (errors && errors[1]) {
          errorCode = errors[1];
        } else {
          errorCode = 'INVALID_ERROR';
        }
      } else {
        errorCode = 'INVALID_RESPONSE';
      }
      if (!response.data) { response.data = {}; }
      response.code = errorCode;
      return response;
    };

    return {
      request: function(config) {
        if (config.url.match(WF_API_BASE_URL)) {
          config.useXDomain = true;
          config.withCredentials = true;
        }
        return config;
      },

      response: function(response) {
        if (response.config.url.match(WF_API_BASE_URL) &&
           response.config.method !== 'JSONP') {
          // Check the response validity
          if (response.data && response.data.status === 'success') {
            if (response.data.result) {
              response.data = response.data.result;
            }
          } else {
            return $q.reject(error(response));
          }
        }
        return response;
      },

      responseError: function(response) {
        if (response.config && response.config.url.match(WF_API_BASE_URL)) {
            return $q.reject(error(response));
        }
        return $q.reject(response);
      }
    };
  }])

  .config(["$httpProvider", function($httpProvider) {
    $httpProvider.interceptors.push('ForumAPIInteceptor');
  }]);

'use strict';

angular.module('wsoButtons')
  .service('Funnels', ["$resource", "URLGenerator", function ($resource, URLGenerator) {

    var msInDay = 1000 * 60 * 60 * 24;

    var FunnelsApi = $resource(
      URLGenerator.getAPIURL('funnels', ':verb'), {
      }, {
        'marketplace': {
          'method': 'GET',
          'params': {
            'verb': 'search'
          }
        },
        'affiliateMarketplace': {
          'method': 'GET',
          'params': {
            'verb': 'affiliate_marketplace'
          }
        },
        'watched': {
          'method': 'GET',
          'params': {
            'verb': 'watched'
          }
        },
        'warroom': {
          'method': 'GET',
          'params': {
            'verb': 'warroom'
          }
        }
      }
    );
    var FunnelApi = $resource(
      URLGenerator.getAPIURL('funnels', 'funnels/:funnelId/:verb'), {
        'funnelId': '@funnelId'
      }, {
        'update': {
          'method': 'PUT'
        },
        'get': {
          'method': 'GET'
        },
        'getSales': {
          'method': 'GET',
          'params': {
            'verb': 'sales'
          }
        },
        'searchSales': {
          'method': 'GET',
          'params': {
            'verb': 'sales_search'
          }
        },
        'stats': {
          'method': 'GET',
          'params': {
            'verb': 'stats'
          }
        },
        'dailyStats': {
          'method': 'GET',
          'params': {
            'verb': 'stats_daily'
          }
        },
        'offerStats': {
          'method': 'GET',
          'params': {
            'verb': 'offer_stats'
          }
        },
        'watch': {
          'method': 'POST',
          'params': {
            'verb': 'watch'
          }
        },
        'unwatch': {
          'method': 'POST',
          'params': {
            'verb': 'unwatch'
          }
        },
        'info': {
          'method': 'GET',
          'params': {
            'verb': 'info'
          }
        }
      }
    );

    var OfferApi = $resource(
      URLGenerator.getAPIURL('funnels', 'offer/:offerId/:verb'), {
        'funnelId': '@funnelId'
      }, {
        'getSales': {
          'method': 'GET',
          'params': {
            'verb': 'sales'
          }
        },
        'getStats': {
          'method': 'GET',
          'params': {
            'verb': 'stats'
          }
        },
        'dailyStats': {
          'method': 'GET',
          'params': {
            'verb': 'stats_daily'
          }
        },
      }
    );

    var UserApi = $resource(
      URLGenerator.getAPIURL('funnels', 'user/:username/:verb'), {
        'username': '@username'
      }, {
        'searchUserFunnels': {
          'method': 'GET',
          'params': {
            'verb': 'search'
          }
        }
      }
    );

    var FunnelOrderApi = $resource(
      URLGenerator.getAPIURL('funnels', 'order/:orderId'), {
        'orderId': '@orderId'
      }
    );


    var FunnelVerifyApi = $resource(
      URLGenerator.getAPIURL('funnels', 'verify/:offerId'), {
        'offerId': '@offerId'
      }
    );

    var OfferLandingPageApi = $resource(
      URLGenerator.getAPIURL('funnels', 'create_landing/:offerId'), {
        'offerId': '@offerId'
      }
    );

    var OfferLandingPageForProductApi = $resource(
      URLGenerator.getAPIURL('funnels', 'product-landing/:seo_url'), {
        'seo_url': '@seo_url'
      }
    );

    var EditOfferLandingPageApi = $resource(
      URLGenerator.getAPIURL('funnels', 'edit_landing/:offerId'), {
        'offerId': '@offerId'
      }
    );

    var OffersApi = $resource(
      URLGenerator.getAPIURL('funnels', 'offers/:offerId'), {
        'offerId': '@offerId'
      }
    );

    var _cache = {};

    var treeToArray = function(node) {
      var nodes = [], stack = [];
      node.position = 0;
      stack.push(node);
      while (stack.length > 0) {
        node = stack.pop();
        var left = node.upsell;
        var right = node.downsell;
        var array_node = angular.copy(node);
        delete array_node.upsell;
        delete array_node.downsell;
        delete array_node.parent;
        // The NEW id is a special id of a product that is selected to
        // Create a new offer directly from the funnel page
        if (node.product && node.product.id !== 'NEW') {
          nodes.push(array_node);
        }
        if (typeof left !== 'undefined') {
          left.position = node.position * 2 + 1;
          stack.push(left);
        }
        if (typeof right !== 'undefined') {
          right.position = node.position * 2;
          stack.push(right);
        }
      }
      return nodes;
    };

    var arrayToIndexedArray = function(array) {
      var indexedArray = [];
      for (var i = 0; i < array.length; i++) {
        indexedArray[array[i].position] = array[i];
      }
      return indexedArray;
    };

    var arrayToTree = function(array) {
      array = arrayToIndexedArray(array);
      var tree = array[0];
      for (var i in array) {
        if (typeof array[i * 2 + 1] !== 'undefined') {
          array[i].upsell = array[i * 2 + 1];
          array[i * 2 + 1].saved = true;
          array[i * 2 + 1].type = 'an Upsell';
          array[i * 2 + 1].type_name = 'Upsell';
          if (array[i * 2 + 1].sales_page) {
            array[i * 2 + 1].sales_page_checked = true;
          }
        }
        if (i > 0 && typeof array[i * 2] !== 'undefined') {
          array[i].downsell = array[i * 2];
          array[i * 2].saved = true;
          array[i * 2].type = 'Downsell';
          array[i * 2].type_name = 'Downsell';
          if (array[i * 2].sales_page) {
            array[i * 2].sales_page_checked = true;
          }
        }
        if (i > 0) {
          array[i].parent = array[i / 2];
        }
      }
      return tree;
    };

    var updateSeoUrls = function(array, node) {
      array = arrayToIndexedArray(array);
      var stack = [];
      stack.push(node);
      while (stack.length > 0) {
        node = stack.pop();
        if (typeof array[node.position] !== 'undefined') {
          node.seo_url = array[node.position].seo_url;
          node.id = array[node.position].id;
        }
        node.saved = true;
        if (typeof node.upsell !== 'undefined') {
          stack.push(node.upsell);
        }
        if (typeof node.downsell !== 'undefined') {
          stack.push(node.downsell);
        }
      }

    };


    return {
      arrayToTree: arrayToTree,
      treeToArray: treeToArray,

      // Add a new prodcut
      post: function (original) {
        var nodes = treeToArray(original.offers);
        var funnel = angular.copy(original);
        funnel.offers = nodes;
        var save = FunnelApi.save(funnel);
        save.$promise.then(function (result) {
          updateSeoUrls(result.offers, original.offers);
        });
        return save.$promise;
      },

      // Update a new prodcut
      update: function (original) {
        var nodes = treeToArray(original.offers);
        var funnel = angular.copy(original);
        funnel.offers = nodes;
        funnel.funnelId = funnel.id;
        var save = FunnelApi.update(funnel);
        save.$promise.then(function (result) {
          updateSeoUrls(result.offers, original.offers);
        });
        return save.$promise;
      },

      get: function (funnelId) {
        if (_cache[funnelId]) {
          return _cache[funnelId].$promise;
        } else {
          var funnel = FunnelApi.get({
            'funnelId': funnelId
          });
          funnel.$promise.then(function(funnel) {
            funnel.offers = arrayToTree(funnel.offers);
          });
          return funnel.$promise;
        }
      },

      list: function() {
        return FunnelApi.query().$promise;
      },

      verify: function (offerId, url) {
        var verified = FunnelVerifyApi.get({
          'offerId': offerId,
          'url': url
        });
        return verified.$promise;
      },

      // Get orders' sales
      getOrderSales: function (orderId) {
        var getapi = FunnelOrderApi.get({'orderId': orderId});
        return getapi.$promise;
      },

      myFunnels: function(page, size) {
        var Api = $resource(URLGenerator.getAPIURL('funnels', 'funnels/my'));
        return Api.get({
          'page': page,
          'size': size
        }).$promise;
      },

      search: function (criteria, affiliateMaketplace) {
        var data = {};
        data.priceFrom = criteria.priceFrom;
        data.priceTo = criteria.priceTo;
        data.keyword = criteria.keyword;
        data.page = criteria.page();
        data.size = criteria.count();
        data.history = criteria.history;
        data.tags = criteria.tags;
        // Timestamp avoids IE value.
        data.timestamp = new Date().getTime();

        var sort = criteria.parameters().sorting;
        if (typeof sort !== 'undefined' && Object.keys(sort).length) {
          for (var i in sort) {
            data.sortingField = i;
            data.sortingOrder = sort[i];
            break;
          }
        } else {
          // Set default sorting except 'all'
          if (data.history !== 0) {
            data.sortingField = 'sales';
          }
        }

        if (data.history === 1 || data.history === 2) { // Today or yesterday
          var d = new Date();
          data.tzOffset = d.getTimezoneOffset();
        }
        var Api;
        if (affiliateMaketplace) {
          Api = FunnelsApi.affiliateMarketplace(data);
        } else {
          Api = FunnelsApi.marketplace(data);
        }
        return Api.$promise;
      },

      searchUserFunnels: function (username, page, size, keyword) {
        var funnels = UserApi.searchUserFunnels({
          'page': page,
          'size': size,
          'username': username,
          'keyword': keyword
        });
        return funnels.$promise;
      },

      getAllWatched: function (page, size, sortArray) {
        var sortingField, sortingOrder;
        if (typeof sortArray !== 'undefined') {
          for (var i in sortArray) {
            sortingField = i;
            sortingOrder = sortArray[i];
            break;
          }
        }
        var products = FunnelsApi.watched({
          'page': page,
          'size': size,
          'sf': sortingField,
          'so': sortingOrder,
          // timestamp avoid IE cache.
          'timestamp': new Date().getTime()
        });
        return products.$promise;
      },

      watch: function (funnelId, value) {
        var params = {
          'funnelId': funnelId
        };
        var funnel;
        if (value) {
          funnel = FunnelApi.watch(params);
        } else{
          funnel = FunnelApi.unwatch(params);
        }
        return funnel.$promise;
      },

      stats: function (funnelId, start, end) {
        start = (typeof start === 'undefined') ? null : start.getTime();
        end = (typeof end === 'undefined') ? null : end.getTime() + msInDay;
        return FunnelApi.stats({
          'funnelId': funnelId,
          'start_date': start,
          'end_date': end,
        }).$promise;
      },

      getDailyStats: function (funnelId) {
        return FunnelApi.dailyStats({'funnelId': funnelId}).$promise;
      },

      getOffersStats: function (funnelId, start, end) {
        start = (typeof start === 'undefined') ? null : start.getTime();
        end = (typeof end === 'undefined') ? null : end.getTime() + msInDay;
        return FunnelApi.offerStats({
          'funnelId': funnelId,
          'start_date': start,
          'end_date': end,
        }).$promise;
      },

      getSales: function (funnelId, page, size, start, end) {
        start = (typeof start === 'undefined') ? null : start.getTime();
        end = (typeof end === 'undefined') ? null : end.getTime() + msInDay;
        return FunnelApi.getSales({
          'funnelId': funnelId,
          'page': page,
          'size': size,
          'start_date': start,
          'end_date': end,
        }).$promise;
      },

      searchSales: function (funnelId, keyword) {
        return FunnelApi.searchSales({
          'funnelId': funnelId,
          'q': keyword
        }).$promise;
      },

      getSalesByOfferId: function (offerId, start, end) {
        start = (typeof start === 'undefined') ? null : start.getTime();
        end = (typeof end === 'undefined') ? null : end.getTime() + msInDay;
        return OfferApi.getSales({
          'offerId': offerId,
          'start_date': start,
          'end_date': end,
        }).$promise;
      },

      getStatsByOfferId: function (offerId, start, end) {
        start = (typeof start === 'undefined') ? null : start.getTime();
        end = (typeof end === 'undefined') ? null : end.getTime() + msInDay;
        return OfferApi.getStats({
          'offerId': offerId,
          'start_date': start,
          'end_date': end,
        }).$promise;
      },

      getDailyStatsByOfferId: function (offerId) {
        return OfferApi.dailyStats({'offerId': offerId}).$promise;
      },

      getInfo: function (funnelId) {
        var params = {
          'funnelId': funnelId
        };

        var funnel = FunnelApi.info(params);
        return funnel.$promise;
      },

      getWarroom: function () {
        var funnel = FunnelsApi.warroom();
        return funnel.$promise;
      },

      createLandingPage: function(offerId) {
        var landingPage = OfferLandingPageApi.save({
          'offerId': offerId
        });
        return landingPage.$promise;
      },

      editLandingPage: function(offerId) {
        var landingPage = EditOfferLandingPageApi.save({
          'offerId': offerId
        });
        return landingPage.$promise;
      },

      getOfferByOfferId: function(offerId) {
        var offer = OffersApi.get({
          'offerId': offerId
          }
        );
        return offer.$promise;
      },

      createLandingPageForProduct: function(seo_url) {
        var landingPage = OfferLandingPageForProductApi.save({
          'seo_url': seo_url
        });
        return landingPage.$promise;
      }
    };
  }]);

'use strict';

angular.module('wsoButtons')
  .service('PaidThread', ["$http", "$resource", "WSO_FORUMID", "WF_API_BASE_URL", function ($http, $resource, WSO_FORUMID, WF_API_BASE_URL) {
    var ThreadModerateApi = $resource(
      WF_API_BASE_URL + 'modXwar/thread_moderate.php', {
      }, {
        'renew': {
          'method': 'POST'
        }
      }
    );

    return {
      listPending: function (page, size) {
        return ThreadModerateApi.get({do:'get_pending', page:page, size:size}).$promise;
      },

      listApproved: function (page, size) {
        return ThreadModerateApi.get({do:'get_approved', page:page, size:size}).$promise;
      },

      listNotificationSent: function (page, size) {
        return ThreadModerateApi.get({do:'get_notificationsent', page:page, size:size}).$promise;
      },

      listRejected: function (page, size) {
        return ThreadModerateApi.get({do:'get_rejected', page:page, size:size}).$promise;
      },

      verify: function (threadid) {
        var config = {};
        config.url = WF_API_BASE_URL + 'modXwar/thread_moderate.php?do=action';
        config.method = 'POST';
        config.headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
          };

        var post_data = {};
        post_data.action = 'approve';
        post_data.threadid = threadid;
        config.data = $.param(post_data);
        return $http(config);
      },

      reject: function (threadid, notes) {
        var config = {};
        config.url = WF_API_BASE_URL + 'modXwar/thread_moderate.php?do=action';
        config.method = 'POST';
        config.headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
          };

        var post_data = {};
        post_data.action = 'reject';
        post_data.threadid = threadid;
        post_data.notes = notes;
        config.data = $.param(post_data);
        return $http(config);
      }
    };
  }]);

'use strict';

angular.module('wsoButtons')
  .service('ProductCodeScanner', function () {
    return {
      isProductLink: function(text) {
        var providers = ['jvzoo', 'warriorplus', 'clickbank', 'infusionsoft', 'dealguardian', 'paypal'];

        for (var i = 0; i < providers.length; i++) {
          var provider = providers[i];
          if (text.match(new RegExp(provider, 'ig'))) {
            return true;
          }
        }

        return false;
      },

      scanLinks: function(text) {
        var regLink = /\[url="(.*?)"\]([\s\S]*?)\[\/url\]/gi;
        var matches = [];

        var linkMatch = regLink.exec(text);
        while (linkMatch) {
            linkMatch.link = linkMatch[1];
            linkMatch.content = linkMatch[2];

            if (this.isProductLink(linkMatch.link)) {

              var regImage = /^\s*\[img\]\s*(.*?)\s*\[\/img\]\s*$/ig;
              var imageMatch = regImage.exec(linkMatch.content);
              if (imageMatch) {
                linkMatch.image = imageMatch[1];
              }

              matches.push(linkMatch);
            }
            linkMatch = regLink.exec(text);
        }

        return matches;
      },

      _replaceButton: function(text, buttonLink, buttonCode) {
        var pre = text.slice(0, buttonLink.index);
        var post = text.slice(buttonLink.index + buttonLink[0].length);
        return pre + buttonCode + post;
      },

      _replaceLink: function(text, buttonLink, productLink) {
        var pre = text.slice(0, buttonLink.index);
        var post = text.slice(buttonLink.index + buttonLink[0].length);
        var linkCode = buttonLink[0].replace(buttonLink[1], productLink);
        return pre + linkCode + post;
      },

      replace: function(text, product) {
        var buttonLinks = this.scanLinks(text);
        var buttonCode = '[URL="' + product.link + '"][IMG]' + product.image + '[/IMG][/URL]';
        var buttonCount = 0;
        var linkCount = 0;

        for (var i = buttonLinks.length - 1; i >= 0; i--) {
          var buttonLink = buttonLinks[i];

          if (buttonLink.image) {
            text = this._replaceButton(text, buttonLink, buttonCode);
            buttonCount += 1;
          } else {
            text = this._replaceLink(text, buttonLink, product.link);
            linkCount += 1;
          }
        }

        return {text:text, count:buttonLinks.length, linkCount:linkCount, buttonCount:buttonCount};
      }
    };
  });


'use strict';

angular.module('wsoButtons')
  .service('Products', ["$resource", "URLGenerator", "$window", function ($resource, URLGenerator, $window) {

    var msInDay = 1000 * 60 * 60 * 24;

    var ProductApi = $resource(
      URLGenerator.getAPIURL('products', 'products/:productId/:verb'), {
        'productId': '@productId'
      }, {
        'update': {
          'method': 'PATCH'
        }
      }
    );

    var UserProductApi = $resource(
      URLGenerator.getAPIURL('products', 'products/my'), {
        'productId': '@productId'
      }
    );

    var ProductSalesApi = $resource(
      URLGenerator.getAPIURL('products', 'products/:productId/sales'), {
        'productId': '@productId'
      }
    );

    var ProductStatsApi = $resource(
      URLGenerator.getAPIURL('products', 'products/:productId/stats'), {
        'productId': '@productId'
      }
    );

    var ProductDailyStatsApi = $resource(
      URLGenerator.getAPIURL('products', 'products/:productId/stats_daily'), {
        'productId': '@productId'
      }
    );

    var ProductSaleApi = $resource(
      URLGenerator.getAPIURL('products', 'sales/:saleId'), {
        'saleId': '@saleId'
      }
    );

    var ProductSalesSearchApi = $resource(
      URLGenerator.getAPIURL('products', 'products/:productId/sales/search'), {
        'productId': '@productId'
      }
    );

    var ProductSalesReportApi = $resource(
      URLGenerator.getAPIURL('products','products/salesreport')
    );

    var ProductDeleteApi = $resource(
      URLGenerator.getAPIURL('products','products/:productId')
    );

    var ProductRestoreApi = $resource(
      URLGenerator.getAPIURL('products', 'products/:productId/restore'), {
        'productId': '@productId'
      }
    );

    var StartconApi = $resource(
      URLGenerator.getAPIURL('products', 'startcon/tickets/:type'), {
        'type':'@type'
      }
    );

    var _cache = {};

    return {

      // Add a new prodcut
      post: function (product) {
        var save = ProductApi.save(product);
        save.$promise.then(function (result) {
          _cache[result.seo_url] = result;
          _cache[result.id] = result;
        });
        return save.$promise;
      },

      // Update a new prodcut
      update: function (productId, product) {
        product.productId = product.id;
        var save = ProductApi.update(product);
        save.$promise.then(function (result) {
          _cache[result.seo_url] = result;
          _cache[result.id] = result;
        });
        return save.$promise;
      },

      get: function (productId) {
        if (_cache[productId]) {
          return _cache[productId].$promise;
        } else {
          var product = ProductApi.get({
            'productId': productId
          });
          return product.$promise;
        }
      },

      deleteProduct: function (productId) {
        var data = ProductDeleteApi.delete({
          'productId': productId
        });
        return data.$promise;
      },

      restoreProduct: function (productId) {
        var data = ProductRestoreApi.save({
          'productId': productId
        });
        return data.$promise;
      },

      // Get All User Products
      getAllForUser: function (page, size, options) {
        options = angular.extend(options || {}, {'page': page, 'size': size});
        var products = UserProductApi.get(options);
        return products.$promise;
      },

      // Get an aggregate of all sales and agregate sales data
      getSalesReport: function(page, size, start, end, searchItem, searchValue, statusFilter, countryFilter){
        start = (typeof start === 'undefined' || start === null) ? null : start.getTime();
        end = (typeof end === 'undefined' || end === null ) ? null : end.getTime() + msInDay;
        var transactions = ProductSalesReportApi.get({
          'page': page,
          'size': size,
          'start_date':start,
          'end_date': end,
          'search_item': searchItem,
          'search_value': searchValue,
          'status_filter': statusFilter,
          'country_filter': countryFilter
        });
        return transactions.$promise;
      },

      getSale: function (saleId, useMaster) {
        var sale = ProductSaleApi.get({
          'saleId': saleId,
          'um': useMaster // use master.
        });
        return sale.$promise;
      },

      getStats: function (productId, start, end) {
        start = (typeof start === 'undefined') ? null : start.getTime();
        end = (typeof end === 'undefined') ? null : end.getTime() + msInDay;
        var stats = ProductStatsApi.get({
          'productId': productId,
          'start_date': start,
          'end_date': end,
        });
        return stats.$promise;
      },

      getDailyStats: function (productId) {
        var stats = ProductDailyStatsApi.get({
          'productId': productId
        });
        return stats.$promise;
      },

      // Take one of the viewsByDay/revenueByDay things given
      // by getDailyStats, and put them into datapoints buckets
      // between start and end. Approximately.
      // ok, I'm sure I should be using d3 histogram or something here,
      // but I can't get it to do what I want.
      rebinStats: function (data, datapoints, start, end) {
        if (data.length === 0) {
          return [];
        }

        if (typeof start === 'undefined') {
          start = new Date($window._.first(data)[0]).getTime() - msInDay * 2;
        } else {
          start = start.getTime();
        }
        // Add a day to make sure we get everything in that day.
        end = end.getTime() + msInDay;

        // Some exceedingly dodgy hacks to try to get single day
        // buckets as we view small amounts of data. Doesn't actually 'work',
        // but close enough for now.
        // TODO make it simple round to the nearest day in all situations,
        // since that's all we know about it (and show).
        var days = Math.ceil((end - start) / msInDay);
        if (datapoints > days) {
          datapoints = days;
        }

        var interval = (end - start) / datapoints;
        var bins = [];
        var currentPos = new Date(start);
        var j = 0;
        while (j < data.length && new Date(data[j][0]) < currentPos) {
          ++j;
        }

        var begin = j;
        for (var i = 0; i < datapoints; ++i) {
          var nextPos = new Date(currentPos.getTime() + interval);
          var current = [new Date(currentPos.getTime() + interval / 2), 0];

          while (j < data.length && new Date(data[j][0]) < nextPos) {
            current[1] += data[j][1];
            ++j;
          }

          bins.push(current);
          currentPos = nextPos;
        }

        return (j !== begin) ? bins : [];
      },

      getSales: function (productId, page, size, start, end) {
        start = (typeof start === 'undefined') ? null : start.getTime();
        end = (typeof end === 'undefined') ? null : end.getTime() + msInDay;
        var sales = ProductSalesApi.get({
          'productId': productId,
          'page': page,
          'size': size,
          'start_date': start,
          'end_date': end,
        });
        return sales.$promise;
      },

      getSalesByKeyword: function (productId, keyword) {
        var sales = ProductSalesSearchApi.get({
          'productId': productId,
          'q': keyword
        });
        return sales.$promise;
      },

      getStartConProducts: function (type) {
        var startcon = StartconApi.get({type:type});
        return startcon.$promise;
      }
    };
  }]);

'use strict';

angular.module('wsoButtons')
  .service('taSelection', ['$window', '$document',
    /* istanbul ignore next: all browser specifics and PhantomJS dosen't seem to support half of it */
    function ($window, $document) {
      // need to dereference the document else the calls don't work correctly
      var _document = $document[0];

      return {
        // Some basic selection functions
        getSelectionElement: function () {
          var range, sel, container;
          if (_document.selection && _document.selection.createRange) {
            // IE case
            range = _document.selection.createRange();
            return range.parentElement();
          } else if ($window.getSelection) {
            sel = $window.getSelection();
            if (sel.getRangeAt) {
              if (sel.rangeCount > 0) {
                range = sel.getRangeAt(0);
              }
            } else {
              // Old WebKit selection object has no getRangeAt, so
              // create a range from other selection properties
              range = _document.createRange();
              range.setStart(sel.anchorNode, sel.anchorOffset);
              range.setEnd(sel.focusNode, sel.focusOffset);

              // Handle the case when the selection was selected backwards (from the end to the start in the document)
              if (range.collapsed !== sel.isCollapsed) {
                range.setStart(sel.focusNode, sel.focusOffset);
                range.setEnd(sel.anchorNode, sel.anchorOffset);
              }
            }

            if (range) {
              container = range.commonAncestorContainer;

              // Check if the container is a text node and return its parent if so
              return container.nodeType === 3 ? container.parentNode : container;
            }
          }
        },
        setSelectionToElementStart: function (el) {
          if (_document.createRange && $window.getSelection) {
            var range = _document.createRange();
            range.selectNodeContents(el);
            range.setStart(el, 0);
            range.setEnd(el, 0);

            var sel = $window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
          } else if (_document.selection && _document.body.createTextRange) {
            var textRange = _document.body.createTextRange();
            textRange.moveToElementText(el);
            textRange.collapse(true);
            textRange.moveEnd('character', 0);
            textRange.moveStart('character', 0);
            textRange.select();
          }
        },
        setSelectionToElementEnd: function (el) {
          if (_document.createRange && $window.getSelection) {
            var range = _document.createRange();
            range.selectNodeContents(el);
            range.collapse(false);

            var sel = $window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
          } else if (_document.selection && _document.body.createTextRange) {
            var textRange = _document.body.createTextRange();
            textRange.moveToElementText(el);
            textRange.collapse(false);
            textRange.select();
          }
        },
        getSelectedText: function (el) {
          return el.value.slice(el.selectionStart, el.selectionEnd);
        },
        replaceSelectedText: function (el, text) {
          el.value = el.value.slice(0, el.selectionStart) + text + el.value.slice(el.selectionEnd);
        },
        surroundSelectedText: function (el, prefix, suffix) {
          var preText = el.value.slice(0, el.selectionStart);
          var selectedText = el.value.slice(el.selectionStart, el.selectionEnd);
          var postText = el.value.slice(el.selectionEnd);
          el.value = preText + prefix + selectedText + suffix + postText;
          el.selectionStart = (preText + prefix).length;
          el.selectionEnd = el.selectionStart + selectedText.length;
        },
        insertAtSelectionStart: function (el, text) {
          var preText = el.value.slice(0, el.selectionStart);
          var selectedText = el.value.slice(el.selectionStart, el.selectionEnd);
          var postText = el.value.slice(el.selectionEnd);
          el.value = preText + text + selectedText + postText;
          el.selectionStart = (preText + text).length;
          el.selectionEnd = el.selectionStart + selectedText.length;
        }
      };
    }
  ]);

'use strict';

angular.module('wsoButtons')
  .service('URLGenerator', ["WSO_API_BASE", "EXPERTS_API_BASE", "API_VERSION", "PRODUCT_LINK_BASE_URL", "BUTTON_IMAGE_BASE_URL", "BASE_URL", "FACEBOOK_APP_ID", "FACEBOOK_REDIR_URL", "GOOGLE_APP_ID", "GOOGLE_REDIR_URL", "$httpParamSerializer", function(
    WSO_API_BASE, EXPERTS_API_BASE, API_VERSION, PRODUCT_LINK_BASE_URL,
    BUTTON_IMAGE_BASE_URL, BASE_URL, FACEBOOK_APP_ID, FACEBOOK_REDIR_URL,
    GOOGLE_APP_ID, GOOGLE_REDIR_URL, $httpParamSerializer) {
    var utmParams = null;

    var _appendUTMParams = function(URL){
      if(utmParams){
        return URL + '?' + utmParams;
      }
      return URL;
    };

    var _getVersion = function(type) {
        if (typeof API_VERSION[type] !== 'undefined') {
            return API_VERSION[type];
        } else {
            return '0.1';
        }
    };

    var _getAPIURLComponent = function(type, uri) {
      return type + '/' + _getVersion(type) +'/' + uri;
    };

    var setUtmParams = function(params){
      utmParams = $httpParamSerializer(params);
    };

    var getPageUrl = function(uri) {
      return BASE_URL + uri;
    };

    var getAPIURL = function(type, uri) {
        return WSO_API_BASE + '/' + _getAPIURLComponent(type, uri);
    };

    var getExpertsApiUrl = function(type, uri) {
        return EXPERTS_API_BASE + '/' + _getAPIURLComponent(type, uri);
    };

    // Absolute API, for forum to call.
    var getPaymentApiUrl = function(type, uri) {
        return BASE_URL + 'api/' + _getAPIURLComponent(type, uri);
    };

    var getProductLinkUrl = function(seo_url) {
      if (!seo_url) {
        seo_url = '';
      }

      return PRODUCT_LINK_BASE_URL + 'c/' + seo_url;
    };

    var getProductNoThanksLinkUrl = function(seo_url) {
      if (!seo_url) {
        seo_url = '';
      }

      return PRODUCT_LINK_BASE_URL + 'n/' + seo_url;
    };

    var getButtonImageUrl = function(seo_url) {
      if (!seo_url) {
        seo_url = '';
      }

      return BUTTON_IMAGE_BASE_URL + 'i/' + seo_url;
    };

    var getLandingPageURL = function(seo_url){
      return BASE_URL + 'p/' +seo_url;
    };

    var getPostProductUrl = function(){
      return _appendUTMParams(BASE_URL + 'my-products/post-wso');
    };

    var getFeatureArticleApi = function(uri) {
        return getAPIURL('feature_articles', uri);
    };

    var FB_LOGIN_URL = 'https://www.facebook.com/dialog/oauth?client_id=' +
      FACEBOOK_APP_ID + '&redirect_uri=' + FACEBOOK_REDIR_URL + '&scope=public_profile,email';

    var GOOGLE_LOGIN_URL = 'https://accounts.google.com/o/oauth2/auth?access_type=offline&response_type=code&client_id=' +
      GOOGLE_APP_ID + '&redirect_uri=' + GOOGLE_REDIR_URL + '&scope=https://www.googleapis.com/auth/plus.login https://www.googleapis.com/auth/plus.me https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile#_';

    return {
        getAPIURL: getAPIURL,
        getExpertsApiUrl: getExpertsApiUrl,
        getPageUrl: getPageUrl,
        getPaymentApiUrl: getPaymentApiUrl,
        getProductLinkUrl: getProductLinkUrl,
        getButtonImageUrl: getButtonImageUrl,
        getProductNoThanksLinkUrl: getProductNoThanksLinkUrl,
        fbLoginUrl: FB_LOGIN_URL,
        googleLoginUrl: GOOGLE_LOGIN_URL,
        getLandingPageURL: getLandingPageURL,
        getPostProductUrl: getPostProductUrl,
        setUtmParams: setUtmParams,
        getFeatureArticleApi: getFeatureArticleApi,
    };
  }])
  .factory('FlaskInteceptor', ["WSO_API_URL", "EXPERTS_API_URL", "WSO_API_PATH", "$cookies", function(WSO_API_URL, EXPERTS_API_URL, WSO_API_PATH, $cookies) {
    var isWsoApiUrl = function(url) {
      if (url.match(new RegExp('^' + WSO_API_PATH))) {
        return true;
      }

      if (url.match(WSO_API_URL)) {
        return true;
      }

      return false;
    };

    var isExpertsApiUrl = function(url) {
      if (url.match(EXPERTS_API_URL)) {
        return true;
      }

      return false;
    };

    return {
      request: function(config) {
        if (isWsoApiUrl(config.url)) {
          config.useXDomain = true;
          config.withCredentials = true;
          if ($cookies.get('XSRF-TOKEN')) {
            config.headers['X-XSRF-TOKEN'] = $cookies.get('XSRF-TOKEN');
          }
        }
        return config;
      },
      isWsoApiUrl: isWsoApiUrl,
      isExpertsApiUrl: isExpertsApiUrl
    };
  }])
  .config(["$httpProvider", function($httpProvider) {
    $httpProvider.interceptors.push('FlaskInteceptor');
  }]);

'use strict';

angular.module('filters', [])
  .filter('filename', function () {
    return function(input) {
      return input.split('/').pop();
    };
  });


/*
textAngular
Author : Austin Anderson
License : 2013 MIT
Version 1.2.1

See README.md or https://github.com/fraywing/textAngular/wiki for requirements and use.
*/

(function () { // encapsulate all variables so they don't become global vars
  'use strict';

  // fix a webkit bug, see: https://gist.github.com/shimondoodkin/1081133
  // this is set true when a blur occurs as the blur of the ta-bind triggers before the click
  var globalContentEditableBlur = false;
  /* istanbul ignore next: Browser Un-Focus fix for webkit */
  if (/AppleWebKit\/([\d.]+)/.exec(navigator.userAgent)) { // detect webkit
    document.addEventListener('click', function () {
      var curelement = window.event.target;
      if (globalContentEditableBlur && curelement !== null) {
        var isEditable = false;
        var tempEl = curelement;
        while (tempEl !== null && tempEl.tagName.toLowerCase() !== 'html' && !isEditable) {
          isEditable = tempEl.contentEditable === 'true';
          tempEl = tempEl.parentNode;
        }
        if (!isEditable) {
          document.getElementById('textAngular-editableFix-010203040506070809').setSelectionRange(0, 0); // set caret focus to an element that handles caret focus correctly.
          curelement.focus(); // focus the wanted element.
        }
      }
      globalContentEditableBlur = false;
    }, false); // add global click handler
    angular.element(document.body).append('<input id="textAngular-editableFix-010203040506070809" style="width:1px;height:1px;border:none;margin:0;padding:0;position:absolute; top: -10000; left: -10000;" unselectable="on" tabIndex="-1">');
  }
  // IE version detection - http://stackoverflow.com/questions/4169160/javascript-ie-detection-why-not-use-simple-conditional-comments
  // We need this as IE sometimes plays funny tricks with the contenteditable.
  // ----------------------------------------------------------
  // If you're not in IE (or IE version is less than 5) then:
  // ie === undefined
  // If you're in IE (>=5) then you can determine which version:
  // ie === 7; // IE7
  // Thus, to detect IE:
  // if (ie) {}
  // And to detect the version:
  // ie === 6 // IE6
  // ie > 7 // IE8, IE9, IE10 ...
  // ie < 9 // Anything less than IE9
  // ----------------------------------------------------------
  /* istanbul ignore next: untestable browser check */
  var ie = (function () {
    var undef, rv = -1; // Return value assumes failure.
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    var trident = ua.indexOf('Trident/');

    if (msie > 0) {
      // IE 10 or older => return version number
      rv = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    } else if (trident > 0) {
      // IE 11 (or newer) => return version number
      var rvNum = ua.indexOf('rv:');
      rv = parseInt(ua.substring(rvNum + 3, ua.indexOf('.', rvNum)), 10);
    }

    return ((rv > -1) ? rv : undef);
  }());

  // Thanks to answer in http://stackoverflow.com/questions/2308134/trim-in-javascript-not-working-in-ie
  /* istanbul ignore next: trim shim for older browsers */
  if (typeof String.prototype.trim !== 'function') {
    String.prototype.trim = function () {
      return this.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    };
  }

  // tests against the current jqLite/jquery implementation if this can be an element
  // function validElementString(string) {
  //   try {
  //     return angular.element(string).length !== 0;
  //   } catch (any) {
  //     return false;
  //   }
  // }

  /*
    Custom stylesheet for the placeholders rules.
    Credit to: http://davidwalsh.name/add-rules-stylesheets
  */
  var sheet, addCSSRule, removeCSSRule;
  /* istanbul ignore else: IE <8 test*/
  if (ie > 8 || ie === undefined) {
    var topsheet = (function () {
      // Create the <style> tag
      var style = document.createElement('style');
      /* istanbul ignore else : WebKit hack :( */
      if (/AppleWebKit\/([\d.]+)/.exec(navigator.userAgent)) {
        style.appendChild(document.createTextNode(''));
      }

      // Add the <style> element to the page, add as first so the styles can be overridden by custom stylesheets
      document.head.insertBefore(style, document.head.firstChild);

      return style.sheet;
    })();

    // this sheet is used for the placeholders later on.
    sheet = (function () {
      // Create the <style> tag
      var style = document.createElement('style');
      /* istanbul ignore else : WebKit hack :( */
      if (/AppleWebKit\/([\d.]+)/.exec(navigator.userAgent)) {
        style.appendChild(document.createTextNode(''));
      }

      // Add the <style> element to the page, add as first so the styles can be overridden by custom stylesheets
      document.head.appendChild(style);

      return style.sheet;
    })();

    var _addCSSRule;
    // use as: addCSSRule("header", "float: left");
    addCSSRule = function (selector, rules) {
      _addCSSRule(sheet, selector, rules);
    };
    _addCSSRule = function (sheet, selector, rules) {
      var insertIndex;
      /* istanbul ignore else: firefox catch */
      if (sheet.rules) {
        insertIndex = Math.max(sheet.rules.length - 1, 0);
      } else if (sheet.cssRules) {
        insertIndex = Math.max(sheet.cssRules.length - 1, 0);
      }
      /* istanbul ignore else: untestable IE option */
      if (sheet.insertRule) {
        sheet.insertRule(selector + '{' + rules + '}', insertIndex);
      } else {
        sheet.addRule(selector, rules, insertIndex);
      }
      // return the index of the stylesheet rule
      return insertIndex;
    };

    var _removeCSSRule;
    removeCSSRule = function (index) {
      _removeCSSRule(sheet, index);
    };
    _removeCSSRule = function (sheet, index) {
      /* istanbul ignore else: untestable IE option */
      if (sheet.removeRule) {
        sheet.removeRule(index);
      } else {
        sheet.deleteRule(index);
      }
    };

    // add generic styling for the editor
    _addCSSRule(topsheet, '.ta-scroll-window.form-control', 'height: 300px; overflow: auto; font-family: inherit; font-size: 100%; position: relative; padding: 0;');
    _addCSSRule(topsheet, '.ta-root.focussed .ta-scroll-window.form-control', 'border-color: #66afe9; outline: 0; -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);');
    _addCSSRule(topsheet, '.ta-editor.ta-html', 'min-height: 300px; height: auto; overflow: auto; font-family: inherit; font-size: 100%;');
    _addCSSRule(topsheet, '.ta-scroll-window .ta-bind', 'height: auto; min-height: 300px; padding: 6px 12px;');

    // add the styling for the awesomness of the resizer
    _addCSSRule(topsheet, '.ta-root .ta-resizer-handle-overlay', 'z-index: 100; position: absolute; display: none;');
    _addCSSRule(topsheet, '.ta-root .ta-resizer-handle-overlay > .ta-resizer-handle-info', 'position: absolute; bottom: 16px; right: 16px; border: 1px solid black; background-color: #FFF; padding: 0 4px; opacity: 0.7;');
    _addCSSRule(topsheet, '.ta-root .ta-resizer-handle-overlay > .ta-resizer-handle-background', 'position: absolute; bottom: 5px; right: 5px; left: 5px; top: 5px; border: 1px solid black; background-color: rgba(0, 0, 0, 0.2);');
    _addCSSRule(topsheet, '.ta-root .ta-resizer-handle-overlay > .ta-resizer-handle-corner', 'width: 10px; height: 10px; position: absolute;');
    _addCSSRule(topsheet, '.ta-root .ta-resizer-handle-overlay > .ta-resizer-handle-corner-tl', 'top: 0; left: 0; border-left: 1px solid black; border-top: 1px solid black;');
    _addCSSRule(topsheet, '.ta-root .ta-resizer-handle-overlay > .ta-resizer-handle-corner-tr', 'top: 0; right: 0; border-right: 1px solid black; border-top: 1px solid black;');
    _addCSSRule(topsheet, '.ta-root .ta-resizer-handle-overlay > .ta-resizer-handle-corner-bl', 'bottom: 0; left: 0; border-left: 1px solid black; border-bottom: 1px solid black;');
    _addCSSRule(topsheet, '.ta-root .ta-resizer-handle-overlay > .ta-resizer-handle-corner-br', 'bottom: 0; right: 0; border: 1px solid black; cursor: se-resize; background-color: white;');
  }

  // recursive function that returns an array of angular.elements that have the passed attribute set on them
  function getByAttribute(element, attribute) {
    var resultingElements = [];
    var childNodes = element.children();
    if (childNodes.length) {
      angular.forEach(childNodes, function (child) {
        resultingElements = resultingElements.concat(getByAttribute(angular.element(child), attribute));
      });
    }
    if (element.attr(attribute) !== undefined) {
      resultingElements.push(element);
    }
    return resultingElements;
  }

  // this global var is used to prevent multiple fires of the drop event. Needs to be global to the textAngular file.
  var dropFired = false;
  var textAngular = angular.module('textAngular', ['textAngularSetup', 'warriorUtils']);

  // setup the global contstant functions for setting up the toolbar

  // all tool definitions
  var taTools = {};
  /*
    A tool definition is an object with the following key/value parameters:
      action: [function(deferred, restoreSelection)]
          a function that is executed on clicking on the button - this will allways be executed using ng-click and will
          overwrite any ng-click value in the display attribute.
          The function is passed a deferred object ($q.defer()), if this is wanted to be used `return false;` from the action and
          manually call `deferred.resolve();` elsewhere to notify the editor that the action has finished.
          restoreSelection is only defined if the rangy library is included and it can be called as `restoreSelection()` to restore the users
          selection in the WYSIWYG editor.
      display: [string]?
          Optional, an HTML element to be displayed as the buton. The `scope` of the button is the tool definition object with some additional functions
          If set this will cause buttontext and iconclass to be ignored
      buttontext: [string]?
          if this is defined it will replace the contents of the element contained in the `display` element
      iconclass: [string]?
          if this is defined an icon (<i>) will be appended to the `display` element with this string as it's class
      activestate: [function(commonElement)]?
          this function is called on every caret movement, if it returns true then the class taOptions.classes.toolbarButtonActive
          will be applied to the `display` element, else the class will be removed
      disabled: [function()]?
          if this function returns true then the tool will have the class taOptions.classes.disabled applied to it, else it will be removed
    Other functions available on the scope are:
      name: [string]
          the name of the tool, this is the first parameter passed into taRegisterTool
      isDisabled: [function()]
          returns true if the tool is disabled, false if it isn't
      displayActiveToolClass: [function(boolean)]
          returns true if the tool is 'active' in the currently focussed toolbar
      onElementSelect: [Object]
          This object contains the following key/value pairs and is used to trigger the ta-element-select event
          element: [String]
            an element name, will only trigger the onElementSelect action if the tagName of the element matches this string
          filter: [function(element)]?
            an optional filter that returns a boolean, if true it will trigger the onElementSelect.
          action: [function(event, element, editorScope)]
            the action that should be executed if the onElementSelect function runs
  */
  // name and toolDefinition to add into the tools available to be added on the toolbar
  function registerTextAngularTool(name, toolDefinition) {
    if (!name || name === '' || taTools.hasOwnProperty(name)) {
      throw ('textAngular Error: A unique name is required for a Tool Definition');
    }
    // if(
    //  (toolDefinition.display && (toolDefinition.display === '' || !validElementString(toolDefinition.display))) ||
    //  (!toolDefinition.display && !toolDefinition.buttontext && !toolDefinition.iconclass)
    // )
    // throw('textAngular Error: Tool Definition for "' + name + '" does not have a valid display/iconclass/buttontext value');
    taTools[name] = toolDefinition;
  }

  textAngular.constant('taRegisterTool', registerTextAngularTool);
  textAngular.value('taTools', taTools);

  textAngular.config([

    function () {
      // clear taTools variable. Just catches testing and any other time that this config may run multiple times...
      angular.forEach(taTools, function (value, key) {
        delete taTools[key];
      });
    }
  ]);

  textAngular.directive('colorToolbarGroup', function () {
    return {
      replace: true,
      restrict: 'E',
      template: '<div class="btn-group" uib-dropdown on-toggle="toggled(open)">' +
        '<button type="button" class="btn button-label btn-default btn-color-preview" ng-click="executeAction(undefined, activeColor)"><a href="#">A<span class="color-preview" style="background-color:{{activeColor}}"></span></a></button>' +
        '<button type="button" class="btn btn-default dropdown-toggle btn-color-dropdown" uib-dropdown-toggle><span class="caret"></span></button>' +
        '<div class="colorPicker-palette dropdown-menu" uib-dropdown-menu role="menu">' +
        '    <div ng-repeat="color in palette" class="colorPicker-swatch" ng-click="chooseColor(color)" style=\'background-color:{{color}}\'><a href="#"></a></div>' +
        '</div>' +
        '</div>',

      link: function (scope) {
        scope.activeColor = 'red';
        scope.chooseColor = function (color) {
          scope.activeColor = color;
          scope.executeAction(undefined, scope.activeColor);
        };
      }
    };
  });

  textAngular.directive('fontToolbarGroup', function () {
    return {
      replace: true,
      restrict: 'E',
      template: '<div class="btn-group" uib-dropdown on-toggle="toggled(open)">' +
        '<button type="button" class="btn button-label btn-default dropdown-toggle" uib-dropdown-toggle>Font <span class="caret"></span></button>' +
        '<ul class="dropdown-menu" uib-dropdown-menu role="menu">' +
        '    <li ng-repeat="font in fonts" ng-click="$parent.isopen = false; executeAction(undefined, font)"><a href="#"><font face="{{font}}">{{font}}</font></a></li>' +
        '</ul>' +
        '</div>'
    };
  });

  textAngular.directive('smileyToolbarGroup', function () {
    return {
      replace: true,
      restrict: 'E',
      template: '<div class="btn-group" uib-dropdown on-toggle="toggled(open)">' +
        '<button type="button" class="btn button-label btn-default btn-smiley-preview dropdown-toggle" uib-dropdown-toggle><span class="icon-toolbar-smilie"/></button>' +
        '<button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle><span class="caret"></span></button>' +
        '<ul class="dropdown-menu"  role="menu" uib-dropdown-menu>' +
        '    <li ng-repeat="smiley in smilies" ng-click="$parent.isopen = false; executeAction(undefined, smiley.code)"><a href="#"><span class="{{smiley.icon}} icon-smiley">{{smiley.name}}</span></a></li>' +
        '</ul>' +
        '</div>'
    };
  });

  textAngular.directive('sizeToolbarGroup', function () {
    return {
      replace: true,
      restrict: 'E',
      template: '<div class="btn-group" uib-dropdown on-toggle="toggled(open)">' +
        '<button type="button" class="btn button-label btn-default dropdown-toggle" uib-dropdown-toggle>Size <span class="caret"></span></button>' +
        '<ul class="dropdown-menu" role="menu" uib-dropdown-menu>' +
        '    <li ng-repeat="size in sizes" ng-click="$parent.isopen = false; executeAction(undefined, size)"><a href="#"><font size="{{size}}">{{size}}</font></a></li>' +
        '</ul>' +
        '</div>'
    };
  });

  textAngular.directive('usernameTagDropdown', function () {
    return {
      replace: true,
      restrict: 'E',
      template: '<ul class="TagList" ng-if="similarUsernames.length > 0" dropdown is-open="isopen">' +
        '<li class="TagList-item" ng-repeat="username in similarUsernames track by $index">' +
        '    <button class="TagList-link" type="button" ng-click="insertUserUrl(username)">{{username}}</button>' +
        '</li>' +
        '</ul>'
    };
  });

  textAngular.service('taEditorHistory', function () {
    var _stack = [];
    var _position = null;
    var _softHead = false;

    this.softPush = function (text) {
      if (_stack[_position] === text) {
        return;
      }

      if (_softHead) {
        this._prune();
        _stack[_position] = text;
      } else {
        this.push(text);
        _softHead = true;
      }
    };

    this.toString = function () {
      for (var i = 0; i < _stack.length; i++) {
        if (i === _position) {
          console.log('<' + i + '> ' + _stack[i]);
        } else {
          console.log('[' + i + '] ' + _stack[i]);
        }
      }
    };

    this._prune = function () {
      _stack = _stack.slice(0, _position + 1);
    };

    this.push = function (text) {
      this._prune();
      _stack.push(text);
      _position = _stack.length - 1;
      _softHead = false;
    };

    this.movePrevious = function () {
      if (_position > 0) {
        _position -= 1;
        _softHead = false;
        return _stack[_position];
      }

      return null;
    };

    this.moveNext = function () {
      if (_position < _stack.length - 1) {
        _position += 1;
        _softHead = false;
        return _stack[_position];
      }

      return null;
    };
  });

  textAngular.service('taEditorManipulation', function () {
    this.stripTags = function (tag, str, maxInterationCount) {
      tag = tag.toUpperCase();
      var openTag = '[' + tag + ']';
      var closeTag = '[/' + tag + ']';

      if (maxInterationCount === undefined) {
        maxInterationCount = -1;
      }

      while (maxInterationCount !== 0) {
        var strUppercase = str.toUpperCase();
        var startIndex = strUppercase.indexOf(openTag);
        var endIndex = strUppercase.indexOf(closeTag);

        if (startIndex < 0 || endIndex < 0) {
          return str;
        }

        var text = str.substr(startIndex + openTag.length, endIndex - startIndex - openTag.length);
        str = str.substr(0, startIndex) + text + str.substr(endIndex + closeTag.length);

        maxInterationCount -= 1;
      }

      return str;
    };

    this.stripComplexTags = function (tag, str) {
      tag = tag.toUpperCase();
      var openTag = '[' + tag + '=';
      var closeTag = '[/' + tag + ']';

      while (true) {
        var strUppercase = str.toUpperCase();
        var startIndex = strUppercase.indexOf(openTag);
        var endIndex = strUppercase.indexOf(closeTag);

        if (startIndex < 0 || endIndex < 0) {
          return str;
        }

        var openend = str.indexOf(']', startIndex);
        if (openend < 0) {
          return str;
        }

        if (openend > startIndex && openend < endIndex) {
          var text = str.substr(openend + 1, endIndex - openend - 1);
          str = str.substr(0, startIndex) + text + str.substr(endIndex + closeTag.length);
        } else {
          return str;
        }
      }
    };

    this.unformat = function (str) {
      if (!str) {
        return str;
      }

      var simplestrip = ['b', 'i', 'u'];
      var complexstrip = ['font', 'color', 'size'];

      var i;
      for (i = 0; i < simplestrip.length; i++) {
        str = this.stripTags(simplestrip[i].toUpperCase(), str);
      }

      for (i = 0; i < complexstrip.length; i++) {
        str = this.stripComplexTags(complexstrip[i].toUpperCase(), str);
      }

      return str;
    };
  });

  textAngular.factory('taEditorCommand', ['$window', 'taEditorManipulation',
    function ($window, taEditorManipulation) {
      function EditorCommand(editor) {
        this._insertList = function (listtype) {
          var opentag = '[LIST' + (listtype ? ('=' + listtype) : '') + ']\n';
          var closetag = '[/LIST]';
          var txt = editor.getSelectedText();
          if (txt) {
            var regex = new RegExp('([\r\n]+|^[\r\n]*)(?!\\[\\*\\]|\\[\\/?list)(?=[^\r\n])', 'gi');
            txt = opentag + txt.replace(regex, '$1[*]') + '\n' + closetag;
            editor.replaceSelection(txt);
          } else {
            editor.startCommand();

            editor.wrapSelection(opentag, closetag);

            var promptText = 'Enter a list item';
            var listvalue = $window.prompt(promptText, '');
            while (listvalue) {
              editor.insertAtSelectionStart('[*]' + listvalue + '\n');
              listvalue = $window.prompt(promptText, '');
            }

            editor.endCommand();
          }
        };

        this.insertUnorderedList = function () {
          return this._insertList();
        };

        this.insertOrderedList = function () {
          return this._insertList(1);
        };

        this.unformatSelection = function () {
          var text = editor.getSelectedText();
          text = taEditorManipulation.unformat(text);
          editor.setSelectedText(text);
        };

        this.indentSelection = function () {
          editor.wrapSelectionInBlock('INDENT');
        };

        this.outdentSelection = function () {
          var text = editor.getSelectedText();
          text = taEditorManipulation.stripTags('INDENT', text, 1);
          editor.setSelectedText(text);
        };

        this.wrapSelectionInBlock = function (command) {
          this.wrapSelection('[' + command + ']', '[/' + command + ']');
        };

        this.wrapSelection = function (prefix, suffix) {
          editor.wrapSelection(prefix, suffix);
        };

        this.replaceSelection = function (text) {
          editor.replaceSelection(text);
        };
      }

      return EditorCommand;
    }
  ]);

  textAngular.directive('textAngular', [
    '$compile', '$timeout', 'taOptions', 'taEditorManipulation', 'taEditorHistory', 'taSelection', 'taEditorCommand', 'textAngularManager', '$window', '$document', '$animate', '$log', 'Users', 'BbCode', 'Debounce',
    function ($compile, $timeout, taOptions, taEditorManipulation, taEditorHistory, taSelection, taEditorCommand, textAngularManager, $window, $document, $animate, $log, Users, BbCode, Debounce) {
      return {
        require: '?ngModel',
        scope: {},
        restrict: 'EA',
        link: function (scope, element, attrs, ngModel) {
          // all these vars should not be accessable outside this directive
          var _focusin, _focusout,
            _originalContents, _toolbars,
            _serial = (attrs.serial) ? attrs.serial : Math.floor(Math.random() * 10000000000000000),
            _name = (attrs.name) ? attrs.name : 'textAngularEditor' + _serial;

          var oneEvent = function (_element, event, action) {
            $timeout(function () {
              // shim the .one till fixed
              var _func = function () {
                _element.off(event, _func);
                action();
              };
              _element.on(event, _func);
            }, 100);
          };
          var commands = new taEditorCommand(scope);
          // get the settings from the defaults and add our specific functions that need to be on the scope
          angular.extend(scope, angular.copy(taOptions), {
            commands: commands,

            _commandDepth: 0,

            startCommand: function () {
              this._commandDepth += 1;
            },

            endCommand: function () {
              this._commandDepth -= 1;

              if (this._commandDepth === 0) {
                this._hackUpdateModel();
                this._pushState();
              }
            },

            replaceSelection: function (text) {
              this.startCommand();
              taSelection.replaceSelectedText(scope.displayElements.html[0], text);
              this.endCommand();
            },

            _softPushState: function (text) {
              if (text === undefined) {
                text = this.getText();
              }

              taEditorHistory.softPush(text);
            },

            _pushState: function (text) {
              if (text === undefined) {
                text = this.getText();
              }

              taEditorHistory.push(text);
            },

            undo: function () {
              var text = taEditorHistory.movePrevious();

              if (text === null) {
                return;
              }

              this._setText(text);
            },

            redo: function () {
              var text = taEditorHistory.moveNext();

              if (text === null) {
                return;
              }

              this._setText(text);
            },

            _hackUpdateModel: function () {
              // todo BJB not sure why
              // $(scope.displayElements.html).val(text);
              // is not firing the $watch('html') ?!?
              ngModel.$setViewValue(scope.displayElements.html.val());
            },

            _setText: function (text) {
              angular.element(scope.displayElements.html).val(text);
              this._hackUpdateModel();
            },

            setText: function (text) {
              this.startCommand();
              this._setText(text);
              this._hackUpdateModel();
              this.endCommand();
            },

            getText: function () {
              return angular.element(scope.displayElements.html).val();
            },

            getSelectedText: function () {
              return taSelection.getSelectedText(scope.displayElements.html[0]);
            },

            setSelectedText: function (text) {
              this.startCommand();
              taSelection.replaceSelectedText(scope.displayElements.html[0], text);
              this.endCommand();
            },

            // wraps the selection in the provided tag / execCommand function. Should only be called in WYSIWYG mode.
            wrapSelectionInBlock: function (command) {
              this.startCommand();
              taSelection.surroundSelectedText(scope.displayElements.html[0], '[' + command + ']', '[/' + command + ']');
              this.endCommand();
            },

            wrapSelection: function (prefix, suffix) {
              this.startCommand();
              taSelection.surroundSelectedText(scope.displayElements.html[0], prefix, suffix);
              this.endCommand();
            },

            insertAtSelectionStart: function (text) {
              this.startCommand();
              taSelection.insertAtSelectionStart(scope.displayElements.html[0], text);
              this.endCommand();
            },

            showHtml: true
          });
          // setup the options from the optional attributes
          if (attrs.taFocussedClass) {
            scope.classes.focussed = attrs.taFocussedClass;
          }
          if (attrs.taTextEditorClass) {
            scope.classes.textEditor = attrs.taTextEditorClass;
          }
          if (attrs.taHtmlEditorClass) {
            scope.classes.htmlEditor = attrs.taHtmlEditorClass;
          }
          // optional setup functions
          if (attrs.taTextEditorSetup) {
            scope.setup.textEditorSetup = scope.$parent.$eval(attrs.taTextEditorSetup);
          }
          if (attrs.taHtmlEditorSetup) {
            scope.setup.htmlEditorSetup = scope.$parent.$eval(attrs.taHtmlEditorSetup);
          }
          // optional fileDropHandler function
          if (attrs.taFileDrop) {
            scope.fileDropHandler = scope.$parent.$eval(attrs.taFileDrop);
          } else {
            scope.fileDropHandler = scope.defaultFileDropHandler;
          }

          _originalContents = element[0].innerHTML;
          // clear the original content
          element[0].innerHTML = '';

          // Setup the HTML elements as variable references for use later
          scope.displayElements = {
            // we still need the hidden input even with a textarea as the textarea may have invalid/old input in it,
            // wheras the input will ALLWAYS have the correct value.
            // forminput: angular.element("<input type='hidden' tabindex='-1' style='display: none;'>"),
            html: angular.element('<textarea></textarea>'),
            text: angular.element('<div></div>'),
            autoSuggestPopup: angular.element('<username-tag-dropdown/>'),
            // other toolbased elements
            scrollWindow: angular.element('<div class="ta-scroll-window"></div>'),
            popover: angular.element('<div class="popover fade bottom" style="max-width: none; width: 305px;"><div class="arrow"></div></div>'),
            popoverContainer: angular.element('<div class="popover-content"></div>'),
            resize: {
              overlay: angular.element('<div class="ta-resizer-handle-overlay"></div>'),
              background: angular.element('<div class="ta-resizer-handle-background"></div>'),
              anchors: [
                angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tl"></div>'),
                angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tr"></div>'),
                angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-bl"></div>'),
                angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-br"></div>')
              ],
              info: angular.element('<div class="ta-resizer-handle-info"></div>')
            }
          };

          // Setup the popover
          scope.displayElements.popover.append(scope.displayElements.popoverContainer);
          scope.displayElements.scrollWindow.append(scope.displayElements.popover);

          scope.displayElements.popover.on('mousedown', function (e, eventData) {
            /* istanbul ignore else: this is for catching the jqLite testing*/
            if (eventData) {
              angular.extend(e, eventData);
            }
            // this prevents focusout from firing on the editor when clicking anything in the popover
            e.preventDefault();
            return false;
          });

          // define the popover show and hide functions
          scope.showPopover = function (_el) {
            scope.reflowPopover(_el);
            scope.displayElements.popover.css('display', 'block');
            $animate.addClass(scope.displayElements.popover, 'in');
            oneEvent(element, 'click keyup', function () {
              scope.hidePopover();
            });
          };
          scope.reflowPopover = function (_el) {
            if (scope.displayElements.text[0].offsetHeight - 51 > _el[0].offsetTop) {
              scope.displayElements.popover.css('top', _el[0].offsetTop + _el[0].offsetHeight + 'px');
              scope.displayElements.popover.removeClass('top').addClass('bottom');
            } else {
              scope.displayElements.popover.css('top', _el[0].offsetTop - 54 + 'px');
              scope.displayElements.popover.removeClass('bottom').addClass('top');
            }
            scope.displayElements.popover.css('left', Math.max(0,
              Math.min(
                scope.displayElements.text[0].offsetWidth - 305,
                _el[0].offsetLeft + (_el[0].offsetWidth / 2.0) - 152.5
              )
            ) + 'px');
          };
          scope.hidePopover = function () {
            $animate.removeClass(scope.displayElements.popover, 'in', /* istanbul ignore next: dosen't test with mocked animate */ function () {
              scope.displayElements.popover.css('display', '');
              scope.displayElements.popoverContainer.attr('style', '');
              scope.displayElements.popoverContainer.attr('class', 'popover-content');
            });
          };

          // setup the resize overlay
          scope.displayElements.resize.overlay.append(scope.displayElements.resize.background);
          angular.forEach(scope.displayElements.resize.anchors, function (anchor) {
            scope.displayElements.resize.overlay.append(anchor);
          });
          scope.displayElements.resize.overlay.append(scope.displayElements.resize.info);
          scope.displayElements.scrollWindow.append(scope.displayElements.resize.overlay);

          // allow for insertion of custom directives on the textarea and div
          scope.setup.htmlEditorSetup(scope.displayElements.html);
          // scope.setup.textEditorSetup(scope.displayElements.text);
          scope.displayElements.html.attr({
            'id': 'taHtmlElement' + _serial,
            'ng-show': 'showHtml',
            // 'ta-bind': 'ta-bind',
            'ng-model': 'html'
          });

          // scope.displayElements.text.attr({
          // 'id': 'taTextElement' + _serial,
          // 'contentEditable': 'true',
          // 'ta-bind': 'ta-bind'
          // 'ng-model': 'html'
          // });
          scope.displayElements.scrollWindow.attr({
            'ng-hide': 'showHtml'
          });
          // if(attrs.taDefaultWrap) scope.displayElements.text.attr('ta-default-wrap', attrs.taDefaultWrap);

          // add the main elements to the original element
          // scope.displayElements.scrollWindow.append(scope.displayElements.text);
          element.append(scope.displayElements.scrollWindow);
          element.append(scope.displayElements.html);
          element.append(scope.displayElements.autoSuggestPopup);

          // scope.displayElements.forminput.attr('name', _name);
          // element.append(scope.displayElements.forminput);

          if (attrs.tabindex) {
            element.removeAttr('tabindex');
            // scope.displayElements.text.attr('tabindex', attrs.tabindex);
            scope.displayElements.html.attr('tabindex', attrs.tabindex);
          }

          if (attrs.placeholder) {
            // scope.displayElements.text.attr('placeholder', attrs.placeholder);
            scope.displayElements.html.attr('placeholder', attrs.placeholder);
          }

          if(attrs.taUsernameTag){
            scope.displayElements.html.attr('ng-keyup', 'checkMessageForTag()');
            scope.displayElements.html.attr('ng-click', 'checkMessageForTag()');
          }

          if (attrs.taDisabled) {
            // scope.displayElements.text.attr('ta-readonly', 'disabled');
            scope.displayElements.html.attr('ta-readonly', 'disabled');
            scope.disabled = scope.$parent.$eval(attrs.taDisabled);
            scope.$parent.$watch(attrs.taDisabled, function (newVal) {
              scope.disabled = newVal;
              if (scope.disabled) {
                element.addClass(scope.classes.disabled);
              } else {
                element.removeClass(scope.classes.disabled);
              }
            });
          }

          // compile the scope with the text and html elements only - if we do this with the main element it causes a compile loop
          $compile(scope.displayElements.scrollWindow)(scope);
          $compile(scope.displayElements.html)(scope);
          $compile(scope.displayElements.autoSuggestPopup)(scope);

          scope.updateTaBindtaTextElement = scope['updateTaBindtaTextElement' + _serial];
          scope.updateTaBindtaHtmlElement = scope['updateTaBindtaHtmlElement' + _serial];

          // add the classes manually last
          element.addClass('ta-root');
          scope.displayElements.scrollWindow.addClass('ta-text ta-editor ' + scope.classes.textEditor);
          scope.displayElements.html.addClass('ta-html ta-editor ' + scope.classes.htmlEditor);

          // used in the toolbar actions
          scope._actionRunning = false;
          // var _savedSelection = false;
          scope.startAction = function () {
            scope._actionRunning = true;
            // if rangy library is loaded return a function to reload the current selection
            // if($window.rangy && $window.rangy.saveSelection){
            // _savedSelection = $window.rangy.saveSelection();
            // return function(){
            // if(_savedSelection) $window.rangy.restoreSelection(_savedSelection);
            // };
            // }
          };
          scope.endAction = function () {
            scope.displayElements.html[0].focus();

            scope._actionRunning = false;
            // if (_savedSelection) {
            //   $window.rangy.removeMarkers(_savedSelection);
            // }
            // _savedSelection = false;
            scope.updateSelectedStyles();
            // only update if in text or WYSIWYG mode
            if (!scope.showHtml) {
              scope['updateTaBindtaTextElement' + _serial]();
            }
          };

          // note that focusout > focusin is called everytime we click a button - except bad support: http://www.quirksmode.org/dom/events/blurfocus.html
          // cascades to displayElements.text and displayElements.html automatically.
          _focusin = function () {
            element.addClass(scope.classes.focussed);
            _toolbars.focus();
          };
          scope.displayElements.html.on('focus', _focusin);
          // scope.displayElements.text.on('focus', _focusin);
          _focusout = function (e) {
            // if we are NOT runnig an action and have NOT focussed again on the text etc then fire the blur events
            if (!scope._actionRunning && $document[0].activeElement !== scope.displayElements.html[0] && $document[0].activeElement !== scope.displayElements.text[0]) {
              element.removeClass(scope.classes.focussed);
              _toolbars.unfocus();
              // to prevent multiple apply error defer to next seems to work.
              $timeout(function () {
                element.triggerHandler('blur');
              }, 0);
            }
            e.preventDefault();
            return false;
          };
          scope.displayElements.html.on('blur', _focusout);
          scope.displayElements.html.on('keydown', function (e) {
            // ctrl + z
            if (e.which === 90 && e.ctrlKey) {
              scope.undo();
              e.preventDefault();
            }
          });
          scope.displayElements.html.on('keyup', function (e) {
            if (e.which === 90 && e.ctrlKey) {
              e.preventDefault();
            }
          });
          // scope.displayElements.text.on('blur', _focusout);

          // Setup the default toolbar tools, this way allows the user to add new tools like plugins.
          // This is on the editor for future proofing if we find a better way to do this.
          scope.queryFormatBlockState = function (command) {
            return command.toLowerCase() === $document[0].queryCommandValue('formatBlock').toLowerCase();
          };
          scope.switchView = function () {
            scope.showHtml = !scope.showHtml;
            //Show the HTML view
            if (scope.showHtml) {
              //defer until the element is visible
              $timeout(function () {
                // [0] dereferences the DOM object from the angular.element
                return scope.displayElements.html[0].focus();
              }, 100);
            } else {
              //Show the WYSIWYG view
              //defer until the element is visible
              $timeout(function () {
                // [0] dereferences the DOM object from the angular.element
                return scope.displayElements.text[0].focus();
              }, 100);
            }
          };

          // changes to the model variable from outside the html/text inputs
          // if no ngModel, then the only input is from inside text-angular
          if (attrs.ngModel) {
            var _firstRun = true;
            ngModel.$render = function () {

              if (_firstRun) {
                // we need this firstRun to set the originalContents otherwise it gets overrided by the setting of ngModel to undefined from NaN
                _firstRun = false;
                // if view value is null or undefined initially and there was original content, set to the original content
                var _initialValue = scope.$parent.$eval(attrs.ngModel);
                if ((_initialValue === undefined || _initialValue === null) && (_originalContents && _originalContents !== '')) {
                  // on passing through to taBind it will be sanitised
                  ngModel.$setViewValue(_originalContents);
                }
              }
              // scope.displayElements.forminput.val(ngModel.$viewValue);
              scope._pushState(ngModel.$viewValue);
              // if the editors aren't focused they need to be updated, otherwise they are doing the updating
              /* istanbul ignore else: don't care */
              if (!scope._elementSelectTriggered && $document[0].activeElement !== scope.displayElements.html[0] && $document[0].activeElement !== scope.displayElements.text[0]) {
                // catch model being null or undefined

                scope.html = ngModel.$viewValue || '';
              }
            };
          } else {
            // if no ngModel then update from the contents of the origional html.
            // scope.displayElements.forminput.val(_originalContents);
            scope.html = _originalContents;
          }

          // changes from taBind back up to here
          scope.$watch('html', function (newValue, oldValue) {
            if (newValue !== oldValue) {
              if (attrs.ngModel && ngModel.$viewValue !== newValue) {
                ngModel.$setViewValue(newValue);
              }
              // scope.displayElements.forminput.val(newValue);
              scope._softPushState(newValue);
            }
          });

          scope.userTagPattern = /(^|\s)\@([a-zA-Z0-9_]+)/gim;
          scope.similarUsernames = [];
          scope.indexOfCurrentTag = null;
          scope.prevCaretPos = null;

          scope.checkMessageForTag = Debounce.do(function(){
            if (scope.displayElements.html === undefined){
              return;
            }

            var caretPos = scope.displayElements.html.prop('selectionStart');
            if(caretPos === scope.prevCaretPos){
              return;
            }
            scope.prevCaretPos = caretPos;

            var usernameFragment = scope.getCurrentTagFragment(caretPos);
            if(usernameFragment) {
              Users.getSimilarUsernames(usernameFragment).then(
                function(response){
                  scope.similarUsernames = response.usernames;
                }
              );
            } else {
              scope.similarUsernames = [];
            }
          }, 100, true);

          scope.getCurrentTagFragment = function(caretPos){
            var textareaContent = scope.displayElements.html.val();
            var msgBeforeCaret = (textareaContent).substring(0, caretPos);
            var tagsFound = msgBeforeCaret.match(scope.userTagPattern);
            if(tagsFound === null) {
              return null;
            }
            var tagStartPointerPos;
            var tagEndPointerPos = 0;
            angular.forEach(tagsFound, function(tag){
              tagStartPointerPos = msgBeforeCaret.indexOf(tag, tagEndPointerPos);
              tagEndPointerPos = tagStartPointerPos + tag.length;
            });
            while(msgBeforeCaret.charAt(tagStartPointerPos) !== '@'){
              tagStartPointerPos++;
            }

            scope.indexOfCurrentTag = tagStartPointerPos;
            return msgBeforeCaret.substring(tagStartPointerPos + 1, msgBeforeCaret.length);
          };

          scope.insertUserUrl = function(username){
            if (scope.displayElements.html === undefined) {
                return;
            }

            var caretPos = scope.displayElements.html.prop('selectionStart');
            var textareaContent = scope.displayElements.html.val();
            var msgBeforeCurrentTag = (textareaContent).substring(0, scope.indexOfCurrentTag);
            var msgAfterCaret = (textareaContent).substring(caretPos, textareaContent.length);
            var userUrl = BbCode.userProfile(username);
            scope.displayElements.html.val(msgBeforeCurrentTag + userUrl + msgAfterCaret);

            caretPos = scope.indexOfCurrentTag + userUrl.length;
            scope.displayElements.html.focus();
            scope.displayElements.html[0].setSelectionRange(caretPos, caretPos);
            scope.displayElements.html.trigger('input');
            scope.similarUsernames = [];
          };

          if (attrs.taTargetToolbars) {
            _toolbars = textAngularManager.registerEditor(_name, scope, attrs.taTargetToolbars.split(','));
          } else {
            var _toolbar = angular.element('<div text-angular-toolbar name="textAngularToolbar' + _serial + '">');
            // passthrough init of toolbar options
            if (attrs.taToolbar) {
              _toolbar.attr('ta-toolbar', attrs.taToolbar);
            }

            if (attrs.taToolbarClass) {
              _toolbar.attr('ta-toolbar-class', attrs.taToolbarClass);
            }

            if (attrs.taToolbarGroupClass) {
              _toolbar.attr('ta-toolbar-group-class', attrs.taToolbarGroupClass);
            }

            if (attrs.taToolbarButtonClass) {
              _toolbar.attr('ta-toolbar-button-class', attrs.taToolbarButtonClass);
            }

            if (attrs.taToolbarActiveButtonClass) {
              _toolbar.attr('ta-toolbar-active-button-class', attrs.taToolbarActiveButtonClass);
            }

            if (attrs.taFocussedClass) {
              _toolbar.attr('ta-focussed-class', attrs.taFocussedClass);
            }

            element.prepend(_toolbar);
            $compile(_toolbar)(scope.$parent);
            _toolbars = textAngularManager.registerEditor(_name, scope, ['textAngularToolbar' + _serial]);
          }

          scope.$on('$destroy', function () {
            textAngularManager.unregisterEditor(_name);
          });

          // catch element select event and pass to toolbar tools
          scope.$on('ta-element-select', function (event, element) {
            _toolbars.triggerElementSelect(event, element);
          });

          scope.$on('ta-drop-event', function (event, element, dropEvent, dataTransfer) {
            scope.displayElements.text[0].focus();
            if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
              angular.forEach(dataTransfer.files, function (file) {
                // taking advantage of boolean execution, if the fileDropHandler returns true, nothing else after it is executed
                // If it is false then execute the defaultFileDropHandler if the fileDropHandler is NOT the default one
                try {
                  return scope.fileDropHandler(file, scope.wrapSelection) ||
                    (scope.fileDropHandler !== scope.defaultFileDropHandler &&
                      scope.defaultFileDropHandler(file, scope.wrapSelection));
                } catch (error) {
                  $log.error(error);
                }
              });
              dropEvent.preventDefault();
              dropEvent.stopPropagation();
            }
          });
        }
      };
    }
  ]).factory('taBrowserTag', [

    function () {
      return function (tag) {
        /* istanbul ignore next: ie specific test */
        if (!tag) {
          return (ie <= 8) ? 'P' : 'p';
        } else if (tag === '') {
          return (ie === undefined) ? 'div' : (ie <= 8) ? 'P' : 'p';
        } else {
          return (ie <= 8) ? tag.toUpperCase() : tag;
        }
      };
    }
  ]).directive('taBind', ['$timeout', '$window', '$document', 'taFixChrome', 'taBrowserTag', 'taSelection', 'taSelectableElements', 'taApplyCustomRenderers',
    function ($timeout, $window, $document, taFixChrome, taBrowserTag, taSelection, taSelectableElements, taApplyCustomRenderers) {
      // Uses for this are textarea or input with ng-model and ta-bind='text'
      // OR any non-form element with contenteditable="contenteditable" ta-bind="html|text" ng-model
      return {
        require: 'ngModel',
        scope: {},
        link: function (scope, element, attrs, ngModel) {
          // the option to use taBind on an input or textarea is required as it will sanitize all input into it correctly.
          var _isContentEditable = element.attr('contenteditable') !== undefined && element.attr('contenteditable');
          _isContentEditable = true;
          var _isInputFriendly = _isContentEditable || element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input';
          var _isReadonly = false;
          var _focussed = false;

          // defaults to the paragraph element, but we need the line-break or it doesn't allow you to type into the empty element
          // non IE is '<p><br/></p>', ie is '<p></p>' as for once IE gets it correct...
          var _defaultVal, _defaultTest;
          // set the default to be a paragraph value
          if (attrs.taDefaultWrap === undefined) {
            attrs.taDefaultWrap = 'p';
          }
          /* istanbul ignore next: ie specific test */
          if (attrs.taDefaultWrap === '') {
            _defaultVal = '';
            _defaultTest = (ie === undefined) ? '<div><br></div>' : (ie >= 11) ? '<p><br></p>' : (ie <= 8) ? '<P>&nbsp;</P>' : '<p>&nbsp;</p>';
          } else {
            _defaultVal = (ie === undefined || ie >= 11) ?
              '<' + attrs.taDefaultWrap + '><br></' + attrs.taDefaultWrap + '>' :
              (ie <= 8) ?
              '<' + attrs.taDefaultWrap.toUpperCase() + '></' + attrs.taDefaultWrap.toUpperCase() + '>' :
              '<' + attrs.taDefaultWrap + '></' + attrs.taDefaultWrap + '>';
            _defaultTest = (ie === undefined || ie >= 11) ?
              '<' + attrs.taDefaultWrap + '><br></' + attrs.taDefaultWrap + '>' :
              (ie <= 8) ?
              '<' + attrs.taDefaultWrap.toUpperCase() + '>&nbsp;</' + attrs.taDefaultWrap.toUpperCase() + '>' :
              '<' + attrs.taDefaultWrap + '>&nbsp;</' + attrs.taDefaultWrap + '>';
          }

          element.addClass('ta-bind');

          // in here we are undoing the converts used elsewhere to prevent the < > and & being displayed when they shouldn't in the code.
          var _compileHtml = function () {
            if (_isContentEditable) {
              return element[0].innerHTML;
            }
            if (_isInputFriendly) {
              return element.val();
            }
            throw ('textAngular Error: attempting to update non-editable taBind');
          };

          //used for updating when inserting wrapped elements
          scope.$parent['updateTaBind' + (attrs.id || '')] = function () {
            if (!_isReadonly) {
              ngModel.$setViewValue(_compileHtml());
            }
          };

          //this code is used to update the models when data is entered/deleted
          if (_isInputFriendly) {
            if (!_isContentEditable) {
              element.on('paste cut', function () {
                // timeout to next is needed as otherwise the paste/cut event has not finished actually changing the display
                if (!_isReadonly) {
                  $timeout(function () {
                    ngModel.$setViewValue(_compileHtml());
                  }, 0);
                }
              });
              // if a textarea or input just add in change and blur handlers, everything else is done by angulars input directive
              element.on('change blur', function () {
                if (!_isReadonly) {
                  ngModel.$setViewValue(_compileHtml());
                }
              });
            } else {
              element.on('cut', function (e) {
                // timeout to next is needed as otherwise the paste/cut event has not finished actually changing the display
                if (!_isReadonly) {
                  $timeout(function () {
                    ngModel.$setViewValue(_compileHtml());
                  }, 0);
                } else {
                  e.preventDefault();
                }
              });
              element.on('paste', function (e, eventData) {
                /* istanbul ignore else: this is for catching the jqLite testing*/
                if (eventData) {
                  angular.extend(e, eventData);
                }
                var text;
                // for non-ie
                if (e.clipboardData || (e.originalEvent && e.originalEvent.clipboardData)) {
                  text = (e.originalEvent || e).clipboardData.getData('text/plain');
                  // for ie
                } else if ($window.clipboardData) {
                  text = $window.clipboardData.getData('Text');
                }
                // if theres non text data and we aren't in read-only do default
                if (!text && !_isReadonly) {
                  return true;
                }
                // prevent the default paste command
                e.preventDefault();
                if (!_isReadonly) {
                  var _working = angular.element('<div></div>');
                  _working[0].innerHTML = text;
                  // this strips out all HTML tags
                  text = _working.text();
                  if ($document[0].selection) {
                    var range = $document[0].selection.createRange();
                    range.pasteHTML(text);
                  } else {
                    $document[0].execCommand('insertText', false, text);
                  }
                  ngModel.$setViewValue(_compileHtml());
                }
              });

              // all the code specific to contenteditable divs
              element.on('keyup', function (event, eventData) {
                /* istanbul ignore else: this is for catching the jqLite testing*/
                if (eventData) {
                  angular.extend(event, eventData);
                }
                if (!_isReadonly) {
                  // if enter - insert new taDefaultWrap, if shift+enter insert <br/>
                  if (_defaultVal !== '' && event.keyCode === 13) {
                    if (!event.shiftKey) {
                      // new paragraph, br should be caught correctly
                      var selection = taSelection.getSelectionElement();
                      if (selection.tagName.toLowerCase() !== attrs.taDefaultWrap && selection.tagName.toLowerCase() !== 'li' && (selection.innerHTML.trim() === '' || selection.innerHTML.trim() === '<br>')) {
                        var _new = angular.element(_defaultVal);
                        angular.element(selection).replaceWith(_new);
                        taSelection.setSelectionToElementStart(_new[0]);
                      }
                    }
                  }
                  var val = _compileHtml();
                  if (_defaultVal !== '' && val.trim() === '') {
                    element[0].innerHTML = _defaultVal;
                    taSelection.setSelectionToElementStart(element.children()[0]);
                  }
                  ngModel.$setViewValue(val);
                }
              });

              element.on('blur', function () {
                _focussed = false;
                var val = _compileHtml();
                /* istanbul ignore else: if readonly don't update model */
                if (!_isReadonly) {
                  if (val === _defaultTest) {
                    ngModel.$setViewValue('');
                  } else {
                    ngModel.$setViewValue(_compileHtml());
                  }
                }
                ngModel.$render();
              });

              // Placeholders not supported on ie 8 and below
              if (attrs.placeholder && (ie > 8 || ie === undefined)) {
                var ruleIndex;
                if (attrs.id) {
                  ruleIndex = addCSSRule('#' + attrs.id + '.placeholder-text:before', 'content: "' + attrs.placeholder + '"');
                } else {
                  throw ('textAngular Error: An unique ID is required for placeholders to work');
                }

                scope.$on('$destroy', function () {
                  removeCSSRule(ruleIndex);
                });
              }

              element.on('focus', function () {
                _focussed = true;
                ngModel.$render();
              });
            }
          }

          // parsers trigger from the above keyup function or any other time that the viewValue is updated and parses it for storage in the ngModel
          // ngModel.$parsers.push(_sanitize);
          // because textAngular is bi-directional (which is awesome) we need to also sanitize values going in from the server
          // ngModel.$formatters.push(_sanitize);

          var selectorClickHandler = function (event) {
            // emit the element-select event, pass the element
            scope.$emit('ta-element-select', this);
            event.preventDefault();
            return false;
          };
          var fileDropHandler = function (event, eventData) {
            /* istanbul ignore else: this is for catching the jqLite testing*/
            if (eventData) {
              angular.extend(event, eventData);
            }
            // emit the drop event, pass the element, preventing should be done elsewhere
            if (!dropFired && !_isReadonly) {
              dropFired = true;
              var dataTransfer;
              if (event.originalEvent) {
                dataTransfer = event.originalEvent.dataTransfer;
              } else {
                dataTransfer = event.dataTransfer;
              }
              scope.$emit('ta-drop-event', this, event, dataTransfer);
              $timeout(function () {
                dropFired = false;
              }, 100);
            }
          };

          //used for updating when inserting wrapped elements
          scope.$parent['reApplyOnSelectorHandlers' + (attrs.id || '')] = function () {
            /* istanbul ignore else */
            if (!_isReadonly) {
              angular.forEach(taSelectableElements, function (selector) {
                // check we don't apply the handler twice
                element.find(selector)
                  .off('click', selectorClickHandler)
                  .on('click', selectorClickHandler);
              });
            }
          };

          // changes to the model variable from outside the html/text inputs
          ngModel.$render = function () {
            // catch model being null or undefined
            var val = ngModel.$viewValue || '';
            // if the editor isn't focused it needs to be updated, otherwise it's receiving user input
            if ($document[0].activeElement !== element[0]) {
              // Not focussed
              if (_isContentEditable) {
                // WYSIWYG Mode
                if (attrs.placeholder) {
                  if (val === '') {
                    // blank
                    if (_focussed) {
                      element.removeClass('placeholder-text');
                    } else {
                      element.addClass('placeholder-text');
                    }
                    element[0].innerHTML = _defaultVal;
                  } else {
                    // not-blank
                    element.removeClass('placeholder-text');
                    element[0].innerHTML = val;
                  }
                } else {
                  if (val === '') {
                    element[0].innerHTML = _defaultVal;
                  } else {
                    element[0].innerHTML = val;
                  }
                }
                // if in WYSIWYG and readOnly we kill the use of links by clicking
                if (!_isReadonly) {
                  angular.forEach(taSelectableElements, function (selector) {
                    element.find(selector).on('click', selectorClickHandler);
                  });
                  element.on('drop', fileDropHandler);
                } else {
                  element.off('drop', fileDropHandler);
                }
              } else if (element[0].tagName.toLowerCase() !== 'textarea' && element[0].tagName.toLowerCase() !== 'input') {
                // make sure the end user can SEE the html code as a display. This is a read-only display element
                element[0].innerHTML = taApplyCustomRenderers(val);
              } else {
                // only for input and textarea inputs
                element.val(val);
              }
            } else {
              /* istanbul ignore else: in other cases we don't care */
              if (_isContentEditable) {
                // element is focussed, test for placeholder
                element.removeClass('placeholder-text');
              }
            }
          };

          if (attrs.taReadonly) {
            //set initial value
            _isReadonly = scope.$parent.$eval(attrs.taReadonly);
            if (_isReadonly) {
              element.addClass('ta-readonly');
              // we changed to readOnly mode (taReadonly='true')
              if (element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input') {
                element.attr('disabled', 'disabled');
              }
              if (element.attr('contenteditable') !== undefined && element.attr('contenteditable')) {
                element.removeAttr('contenteditable');
              }
            } else {
              element.removeClass('ta-readonly');
              // we changed to NOT readOnly mode (taReadonly='false')
              if (element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input') {
                element.removeAttr('disabled');
              } else if (_isContentEditable) {
                element.attr('contenteditable', 'true');
              }
            }
            // taReadonly only has an effect if the taBind element is an input or textarea or has contenteditable='true' on it.
            // Otherwise it is readonly by default
            scope.$parent.$watch(attrs.taReadonly, function (newVal, oldVal) {
              if (oldVal === newVal) {
                return;
              }
              if (newVal) {
                element.addClass('ta-readonly');
                // we changed to readOnly mode (taReadonly='true')
                if (element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input') {
                  element.attr('disabled', 'disabled');
                }
                if (element.attr('contenteditable') !== undefined && element.attr('contenteditable')) {
                  element.removeAttr('contenteditable');
                }
                // turn ON selector click handlers
                angular.forEach(taSelectableElements, function (selector) {
                  element.find(selector).on('click', selectorClickHandler);
                });
                element.off('drop', fileDropHandler);
              } else {
                element.removeClass('ta-readonly');
                // we changed to NOT readOnly mode (taReadonly='false')
                if (element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input') {
                  element.removeAttr('disabled');
                } else if (_isContentEditable) {
                  element.attr('contenteditable', 'true');
                }
                // remove the selector click handlers
                angular.forEach(taSelectableElements, function (selector) {
                  element.find(selector).off('click', selectorClickHandler);
                });
                element.on('drop', fileDropHandler);
              }
              _isReadonly = newVal;
            });
          }

          // Initialise the selectableElements
          // if in WYSIWYG and readOnly we kill the use of links by clicking
          if (_isContentEditable && !_isReadonly) {
            angular.forEach(taSelectableElements, function (selector) {
              element.find(selector).on('click', selectorClickHandler);
            });
            element.on('drop', fileDropHandler);
            element.on('blur', function () {
              /* istanbul ignore next: webkit fix */
              if (/AppleWebKit\/([\d.]+)/.exec(navigator.userAgent)) { // detect webkit
                globalContentEditableBlur = true;
              }
            });
          }
        }
      };
    }
  ]).factory('taApplyCustomRenderers', ['taCustomRenderers',
    function (taCustomRenderers) {
      return function (val) {
        var element = angular.element('<div></div>');
        element[0].innerHTML = val;

        angular.forEach(taCustomRenderers, function (renderer) {
          var elements = [];
          // get elements based on what is defined. If both defined do secondary filter in the forEach after using selector string
          if (renderer.selector && renderer.selector !== '') {
            elements = element.find(renderer.selector);
            /* istanbul ignore else: shouldn't fire, if it does we're ignoring everything */
          } else if (renderer.customAttribute && renderer.customAttribute !== '') {
            elements = getByAttribute(element, renderer.customAttribute);
          }
          // process elements if any found
          angular.forEach(elements, function (_element) {
            _element = angular.element(_element);
            if (renderer.selector && renderer.selector !== '' && renderer.customAttribute && renderer.customAttribute !== '') {
              if (_element.attr(renderer.customAttribute) !== undefined) {
                renderer.renderLogic(_element);
              }
            } else {
              renderer.renderLogic(_element);
            }
          });
        });

        return element[0].innerHTML;
      };
    }
  ]).directive('taMaxText', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, elem, attrs, ctrl) {
        var max = parseInt(scope.$eval(attrs.taMaxText));
        if (isNaN(max)) {
          throw ('Max text must be an integer');
        }
        attrs.$observe('taMaxText', function (value) {
          max = parseInt(value);
          if (isNaN(max)) {
            throw ('Max text must be an integer');
          }
          if (ctrl.$dirty) {
            ctrl.$setViewValue(ctrl.$viewValue);
          }
        });

        function validator(viewValue) {
          var source = angular.element('<div/>');
          source.html(viewValue);
          var length = source.text().length;
          if (length <= max) {
            ctrl.$setValidity('taMaxText', true);
            return viewValue;
          } else {
            ctrl.$setValidity('taMaxText', false);
            return undefined;
          }
        }
        ctrl.$parsers.unshift(validator);
      }
    };
  }).factory('taFixChrome', function () {
    // get whaterever rubbish is inserted in chrome
    // should be passed an html string, returns an html string
    var taFixChrome = function (html) {
      // default wrapper is a span so find all of them
      var $html = angular.element('<div>' + html + '</div>');
      var spans = angular.element($html).find('span');
      for (var s = 0; s < spans.length; s++) {
        var span = angular.element(spans[s]);
        // chrome specific string that gets inserted into the style attribute, other parts may vary. Second part is specific ONLY to hitting backspace in Headers
        if (span.attr('style') && span.attr('style').match(/line-height: 1.428571429;|color: inherit; line-height: 1.1;/i)) {
          span.attr('style', span.attr('style').replace(/( |)font-family: inherit;|( |)line-height: 1.428571429;|( |)line-height:1.1;|( |)color: inherit;/ig, ''));
          if (!span.attr('style') || span.attr('style') === '') {
            if (span.next().length > 0 && span.next()[0].tagName === 'BR') {
              span.next().remove();
            }
            span.replaceWith(span[0].innerHTML);
          }
        }
      }
      // regex to replace ONLY offending styles - these can be inserted into various other tags on delete
      var result = $html[0].innerHTML.replace(/style="[^"]*?(line-height: 1.428571429;|color: inherit; line-height: 1.1;)[^"]*"/ig, '');
      // only replace when something has changed, else we get focus problems on inserting lists
      if (result !== $html[0].innerHTML) {
        $html[0].innerHTML = result;
      }
      return $html[0].innerHTML;
    };
    return taFixChrome;
  }).directive('textAngularToolbar', [
    '$compile', 'textAngularManager', 'taOptions', 'taTools', 'taToolExecuteAction', '$window',
    function ($compile, textAngularManager, taOptions, taTools, taToolExecuteAction, $window) {
      return {
        scope: {
          name: '@' // a name IS required
        },
        restrict: 'EA',
        link: function (scope, element, attrs) {
          if (!scope.name || scope.name === '') {
            throw ('textAngular Error: A toolbar requires a name');
          }
          angular.extend(scope, angular.copy(taOptions));
          if (attrs.taToolbar) {
            scope.toolbar = scope.$parent.$eval(attrs.taToolbar);
          }
          if (attrs.taToolbarClass) {
            scope.classes.toolbar = attrs.taToolbarClass;
          }
          if (attrs.taToolbarGroupClass) {
            scope.classes.toolbarGroup = attrs.taToolbarGroupClass;
          }
          if (attrs.taToolbarButtonClass) {
            scope.classes.toolbarButton = attrs.taToolbarButtonClass;
          }
          if (attrs.taToolbarActiveButtonClass) {
            scope.classes.toolbarButtonActive = attrs.taToolbarActiveButtonClass;
          }
          if (attrs.taFocussedClass) {
            scope.classes.focussed = attrs.taFocussedClass;
          }

          scope.disabled = true;
          scope.focussed = false;
          scope._$element = element;
          element[0].innerHTML = '';
          element.addClass('ta-toolbar ' + scope.classes.toolbar);

          scope.$watch('focussed', function () {
            if (scope.focussed) {
              element.addClass(scope.classes.focussed);
            } else {
              element.removeClass(scope.classes.focussed);
            }
          });

          var setupToolElement = function (toolDefinition, toolScope) {
            var toolElement;

            if (toolDefinition && toolDefinition.display) {
              toolElement = angular.element(toolDefinition.display);
            } else if (toolDefinition.colorMenu) {
              toolElement = angular.element('<color-icon />');
            } else if (toolDefinition.menu) {
              toolElement = angular.element('<button type="button" data-toggle="dropdown"></button>');
              toolElement.addClass(scope.classes.toolbarButton);
            } else {
              toolElement = angular.element('<button type="button">');
              toolElement.addClass(scope.classes.toolbarButton);
            }

            toolElement.attr('name', toolScope.name);
            // important to not take focus from the main text/html entry
            toolElement.attr('unselectable', 'on');
            toolElement.attr('ng-disabled', 'isDisabled()');
            toolElement.attr('tabindex', '-1');
            toolElement.attr('ng-click', 'executeAction()');
            toolElement.attr('ng-class', 'displayActiveToolClass(active)');

            if (toolScope.class) {
              toolElement.addClass(toolScope.class);
            }

            if (toolScope.tooltip) {
              toolElement.attr({
                'popover': toolScope.tooltip,
                'popover-trigger': 'mouseenter',
                'popover-popup-delay': 400
              });
            }

            // toolElement.on('mousedown', function(e, eventData){
            //  /* istanbul ignore else: this is for catching the jqLite testing*/
            //  if(eventData) angular.extend(e, eventData);
            //  // this prevents focusout from firing on the editor when clicking toolbar buttons
            //  e.preventDefault();
            //  return false;
            // });
            if (toolDefinition && !toolDefinition.display && !toolScope._display && !toolDefinition.colorMenu) {

              if (toolDefinition.menu) {
                toolElement[0].innerHTML = toolDefinition.content + '<span class="caret"></span>';
              } else if (toolDefinition.buttontext) {
                toolElement[0].innerHTML = toolDefinition.buttontext;
              } else if (toolDefinition.content) {
                toolElement[0].innerHTML = toolDefinition.content;
              } else if (toolDefinition.iconurl) {
                toolElement[0].innerHTML = '<img src="' + toolDefinition.iconurl + '"/>';
              }

              // add the icon to the front of the button if there is content
              if (toolDefinition.iconclass) {
                var icon = angular.element('<i>'),
                  content = toolElement[0].innerHTML;
                icon.addClass(toolDefinition.iconclass);
                toolElement[0].innerHTML = '';
                toolElement.append(icon);
                if (content && content !== '') {
                  toolElement.append('&nbsp;' + content);
                }
              }
            }

            toolScope._lastToolDefinition = angular.copy(toolDefinition);

            return $compile(toolElement)(toolScope);
          };

          // Keep a reference for updating the active states later
          scope.tools = {};
          // create the tools in the toolbar
          // default functions and values to prevent errors in testing and on init
          scope._parent = {
            disabled: true,
            showHtml: false,
            queryFormatBlockState: function () {
              return false;
            }
          };
          var defaultChildScope = {
            $window: $window,
            $editor: function () {
              // dynamically gets the editor as it is set
              return scope._parent;
            },
            isDisabled: function () {
              // to set your own disabled logic set a function or boolean on the tool called 'disabled'
              return ( // this bracket is important as without it it just returns the first bracket and ignores the rest
                false
                // when the button's disabled function/value evaluates to true
                // this.$eval('disabled') || this.$eval('disabled()') ||
                // // all buttons except the HTML Switch button should be disabled in the showHtml (RAW html) mode
                // (this.name !== 'html' && this.$editor().showHtml) ||
                // // if the toolbar is disabled
                // this.$parent.disabled ||
                // // if the current editor is disabled
                // this.$editor().disabled
              );
            },
            fonts: ['Arial', 'Arial Black', 'Arial Narrow', 'Book Antiqua', 'Century Gothic', 'Comic Sans MS', 'Courier New', 'Fixedsys', 'Franklin Gothic Medium', 'Garamond', 'Georgia', 'Impact', 'Lucida Console', 'Lucida Sans Unicode', 'Microsoft Sans Serif', 'Palatino Linotype', 'System', 'Tahoma', 'Times New Roman', 'Trebuchet MS', 'Verdana'],


            sizes: [1, 2, 3, 4, 5, 6, 7],
            palette: ['Black', 'Sienna', 'DarkOliveGreen', 'DarkGreen', 'DarkSlateBlue', 'Navy', 'Indigo', 'DarkSlateGray', 'DarkRed', 'DarkOrange', 'Olive', 'Green', 'Teal', 'Blue', 'SlateGray', 'DimGray', 'Red', 'SandyBrown', 'YellowGreen', 'SeaGreen', 'MediumTurquoise', 'RoyalBlue', 'Purple', 'Gray', 'Magenta', 'Orange', 'Yellow', 'Lime', 'Cyan', 'DeepSkyBlue', 'DarkOrchid', 'Silver', 'Pink', 'Wheat', 'LemonChiffon', 'PaleGreen', 'PaleTurquoise', 'LightBlue', 'Plum', 'White'],
            smilies: [{
              'icon': 'icon-toolbar-smile',
              'name': 'Smile',
              'code': ':)'
            }, {
              'icon': 'icon-toolbar-redface',
              'name': 'Embarrassment',
              'code': ':o'
            }, {
              'icon': 'icon-toolbar-biggrin',
              'name': 'Big Grin',
              'code': ':D'
            }, {
              'icon': 'icon-toolbar-wink',
              'name': 'Wink',
              'code': ';)'
            }, {
              'icon': 'icon-toolbar-tongue',
              'name': 'Stick Out Tongue',
              'code': ':p'
            }, {
              'icon': 'icon-toolbar-cool',
              'name': 'Cool',
              'code': ':cool:'
            }, {
              'icon': 'icon-toolbar-rolleyes',
              'name': 'Roll Eyes (Sarcastic)',
              'code': ':rolleyes:'
            }, {
              'icon': 'icon-toolbar-mad',
              'name': 'Mad',
              'code': ':mad:'
            }, {
              'icon': 'icon-toolbar-eek',
              'name': 'EEK!',
              'code': ':eek:'
            }, {
              'icon': 'icon-toolbar-confused',
              'name': 'Confused',
              'code': ':confused:'
            }, {
              'icon': 'icon-toolbar-frown',
              'name': 'Frown',
              'code': ':('
            }],
            displayActiveToolClass: function () {
              return '';
            },
            executeAction: taToolExecuteAction
          };

          var tool_directive_map = {
            'colors': {
              html: '<color-toolbar-group/>',
              tooltip: 'Colors'
            },
            'fonts': {
              html: '<font-toolbar-group/>',
              tooltip: 'Fonts'
            },
            'smilies': {
              html: '<smiley-toolbar-group/>',
              tooltip: 'Smilies'
            },
            'sizes': {
              html: '<size-toolbar-group/>',
              tooltip: 'Sizes'
            }
          };

          angular.forEach(scope.toolbar, function (group) {
            if (group.length === 1 && tool_directive_map[group[0]]) {
              var tool = group[0];
              var info = tool_directive_map[group[0]];
              var toolElement = angular.element(info.html);
              var toolScope = angular.extend(scope.$new(true), taTools[tool], defaultChildScope, {
                name: tool
              });
              scope.tools[tool] = toolScope;
              toolElement.attr({
                'popover': info.tooltip,
                'popover-trigger': 'mouseenter',
                'popover-popup-delay': 400
              });
              scope.tools[tool].$element = $compile(toolElement)(toolScope);
              toolElement = element.append(scope.tools[tool].$element);
            } else {
              // setup the toolbar group
              var groupElement = angular.element('<div>');
              groupElement.addClass(scope.classes.toolbarGroup);
              angular.forEach(group, function (tool) {
                // init and add the tools to the group
                // a tool name (key name from taTools struct)
                //creates a child scope of the main angularText scope and then extends the childScope with the functions of this particular tool
                // reference to the scope and element kept
                scope.tools[tool] = angular.extend(scope.$new(true), taTools[tool], defaultChildScope, {
                  name: tool
                });
                scope.tools[tool].$element = setupToolElement(taTools[tool], scope.tools[tool]);
                // append the tool compiled with the childScope to the group element
                groupElement.append(scope.tools[tool].$element);
              });
              // append the group to the toolbar
              element.append(groupElement);
            }
          });

          // update a tool
          // if a value is set to null, remove from the display
          // when forceNew is set to true it will ignore all previous settings, used to reset to taTools definition
          // to reset to defaults pass in taTools[key] as _newTool and forceNew as true, ie `updateToolDisplay(key, taTools[key], true);`
          // scope.updateToolDisplay = function(key, _newTool, forceNew){
          //  var toolInstance = scope.tools[key];
          //  if(toolInstance){
          //    // get the last toolDefinition, then override with the new definition
          //    if(toolInstance._lastToolDefinition && !forceNew) _newTool = angular.extend({}, toolInstance._lastToolDefinition, _newTool);
          //    if(_newTool.buttontext === null && _newTool.iconclass === null && _newTool.display === null)
          //      throw('textAngular Error: Tool Definition for updating "' + key + '" does not have a valid display/iconclass/buttontext value');

          //    // if tool is defined on this toolbar, update/redo the tool
          //    if(_newTool.buttontext === null){
          //      delete _newTool.buttontext;
          //    }
          //    if(_newTool.iconclass === null){
          //      delete _newTool.iconclass;
          //    }
          //    if(_newTool.display === null){
          //      delete _newTool.display;
          //    }

          //    var toolElement = setupToolElement(_newTool, toolInstance);
          //    toolInstance.$element.replaceWith(toolElement);
          //    toolInstance.$element = toolElement;
          //  }
          // };

          // we assume here that all values passed are valid and correct
          // scope.addTool = function(key, _newTool, groupIndex, index){
          //  scope.tools[key] = angular.extend(scope.$new(true), taTools[key], defaultChildScope, {name: key});
          //  scope.tools[key].$element = setupToolElement(taTools[key], scope.tools[key]);
          //  var group;
          //  if(groupIndex === undefined) groupIndex = scope.toolbar.length - 1;
          //  group = angular.element(element.children()[groupIndex]);

          //  if(index === undefined){
          //    group.append(scope.tools[key].$element);
          //    scope.toolbar[groupIndex][scope.toolbar[groupIndex].length - 1] = key;
          //  }else{
          //    group.children().eq(index).after(scope.tools[key].$element);
          //    scope.toolbar[groupIndex][index] = key;
          //  }
          // };

          textAngularManager.registerToolbar(scope);

          scope.$on('$destroy', function () {
            textAngularManager.unregisterToolbar(scope.name);
          });
        }
      };
    }
  ]).service('taToolExecuteAction', ['$q',
    function ($q) {
      // this must be called on a toolScope or instance
      return function (editor, arg0) {
        if (editor !== undefined) {
          this.$editor = function () {
            return editor;
          };
        }

        var deferred = $q.defer(),
          promise = deferred.promise;
        var _editor = this.$editor();
        promise['finally'](function () {
          _editor.endAction.call(_editor);
        });
        // pass into the action the deferred function and also the function to reload the current selection if rangy available
        var result;
        try {
          if (this.action) {
            result = this.action(deferred, _editor.startAction(), arg0);
          } else {
            console.log('no action!');
          }

        } catch (any) {
          console.log(any);
        }
        if (result || result === undefined) {
          // if true or undefined is returned then the action has finished. Otherwise the deferred action will be resolved manually.
          deferred.resolve();
        }
      };
    }
  ]).service('textAngularManager', ['taToolExecuteAction', 'taTools', 'taRegisterTool',
    function (taToolExecuteAction, taTools, taRegisterTool) {
      // this service is used to manage all textAngular editors and toolbars.
      // All publicly published functions that modify/need to access the toolbar or editor scopes should be in here
      // these contain references to all the editors and toolbars that have been initialised in this app
      var toolbars = {},
        editors = {};
      // when we focus into a toolbar, we need to set the TOOLBAR's $parent to be the toolbars it's linked to.
      // We also need to set the tools to be updated to be the toolbars...
      return {
        // register an editor and the toolbars that it is affected by
        registerEditor: function (name, scope, targetToolbars) {
          // targetToolbars are optional, we don't require a toolbar to function
          if (!name || name === '') {
            throw ('textAngular Error: An editor requires a name');
          }
          if (!scope) {
            throw ('textAngular Error: An editor requires a scope');
          }
          if (editors[name]) {
            throw ('textAngular Error: An Editor with name "' + name + '" already exists');
          }
          // _toolbars is an ARRAY of toolbar scopes
          var _toolbars = [];
          angular.forEach(targetToolbars, function (_name) {
            if (toolbars[_name]) {
              var toolbarScope = toolbars[_name];
              toolbarScope._parent = scope;
              _toolbars.push(toolbarScope);
            }
            // if it doesn't exist it may not have been compiled yet and it will be added later
          });
          editors[name] = {
            scope: scope,
            toolbars: targetToolbars,
            _registerToolbar: function (toolbarScope) {
              // add to the list late
              if (this.toolbars.indexOf(toolbarScope.name) >= 0) {
                _toolbars.push(toolbarScope);
              }
            },
            // this is a suite of functions the editor should use to update all it's linked toolbars
            editorFunctions: {
              disable: function () {
                // disable all linked toolbars
                angular.forEach(_toolbars, function (toolbarScope) {
                  toolbarScope.disabled = true;
                });
              },
              enable: function () {
                // enable all linked toolbars
                angular.forEach(_toolbars, function (toolbarScope) {
                  toolbarScope.disabled = false;
                });
              },
              focus: function () {
                // this should be called when the editor is focussed
                angular.forEach(_toolbars, function (toolbarScope) {
                  toolbarScope._parent = scope;
                  toolbarScope.disabled = false;
                  toolbarScope.focussed = true;
                });
              },
              unfocus: function () {
                // this should be called when the editor becomes unfocussed
                angular.forEach(_toolbars, function (toolbarScope) {
                  toolbarScope.disabled = true;
                  toolbarScope.focussed = false;
                });
              },
              updateSelectedStyles: function (selectedElement) {
                // update the active state of all buttons on liked toolbars
                angular.forEach(_toolbars, function (toolbarScope) {
                  angular.forEach(toolbarScope.tools, function (toolScope) {
                    if (toolScope.activeState) {
                      toolScope.active = toolScope.activeState(selectedElement);
                    }
                  });
                });
              },
              sendKeyCommand: function (event) {
                // we return true if we applied an action, false otherwise
                var result = false;
                if (event.ctrlKey || event.metaKey) {
                  angular.forEach(taTools, function (tool, name) {
                    if (tool.commandKeyCode && tool.commandKeyCode === event.which) {
                      for (var _t = 0; _t < _toolbars.length; _t++) {
                        if (_toolbars[_t].tools[name] !== undefined) {
                          taToolExecuteAction.call(_toolbars[_t].tools[name], scope);
                          result = true;
                          break;
                        }
                      }
                    }
                  });
                }
                return result;
              },
              triggerElementSelect: function (event, element) {
                // search through the taTools to see if a match for the tag is made.
                // if there is, see if the tool is on a registered toolbar and not disabled.
                // NOTE: This can trigger on MULTIPLE tools simultaneously.
                var elementHasAttrs = function (_element, attrs) {
                  var result = true;
                  for (var i = 0; i < attrs.length; i++) {
                    result = result && _element.attr(attrs[i]);
                  }
                  return result;
                };
                var workerTools = [];
                var unfilteredTools = {};
                var result = false;
                element = angular.element(element);
                // get all valid tools by element name, keep track if one matches the
                var onlyWithAttrsFilter = false;
                angular.forEach(taTools, function (tool, name) {
                  if (
                    tool.onElementSelect &&
                    tool.onElementSelect.element &&
                    tool.onElementSelect.element.toLowerCase() === element[0].tagName.toLowerCase() &&
                    (!tool.onElementSelect.filter || tool.onElementSelect.filter(element))
                  ) {
                    // this should only end up true if the element matches the only attributes
                    onlyWithAttrsFilter = onlyWithAttrsFilter ||
                      (angular.isArray(tool.onElementSelect.onlyWithAttrs) && elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs));
                    if (!tool.onElementSelect.onlyWithAttrs || elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs)) {
                      unfilteredTools[name] = tool;
                    }
                  }
                });
                // if we matched attributes to filter on, then filter, else continue
                if (onlyWithAttrsFilter) {
                  angular.forEach(unfilteredTools, function (tool, name) {
                    if (tool.onElementSelect.onlyWithAttrs && elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs)) {
                      workerTools.push({
                        'name': name,
                        'tool': tool
                      });
                    }
                  });
                  // sort most specific (most attrs to find) first
                  workerTools.sort(function (a, b) {
                    return b.tool.onElementSelect.onlyWithAttrs.length - a.tool.onElementSelect.onlyWithAttrs.length;
                  });
                } else {
                  angular.forEach(unfilteredTools, function (tool, name) {
                    workerTools.push({
                      'name': name,
                      'tool': tool
                    });
                  });
                }
                // Run the actions on the first filtered tool only
                if (workerTools.length > 0) {
                  var tool = workerTools[0].tool;
                  var name = workerTools[0].name;
                  for (var _t = 0; _t < _toolbars.length; _t++) {
                    if (_toolbars[_t].tools[name] !== undefined) {
                      tool.onElementSelect.action.call(_toolbars[_t].tools[name], event, element, scope);
                      result = true;
                      break;
                    }
                  }
                }
                return result;
              }
            }
          };
          return editors[name].editorFunctions;
        },
        // retrieve editor by name, largely used by testing suites only
        retrieveEditor: function (name) {
          return editors[name];
        },
        unregisterEditor: function (name) {
          delete editors[name];
        },
        // registers a toolbar such that it can be linked to editors
        registerToolbar: function (scope) {
          if (!scope) {
            throw ('textAngular Error: A toolbar requires a scope');
          }
          if (!scope.name || scope.name === '') {
            throw ('textAngular Error: A toolbar requires a name');
          }
          if (toolbars[scope.name]) {
            throw ('textAngular Error: A toolbar with name "' + scope.name + '" already exists');
          }
          toolbars[scope.name] = scope;
          angular.forEach(editors, function (_editor) {
            _editor._registerToolbar(scope);
          });
        },
        // retrieve toolbar by name, largely used by testing suites only
        retrieveToolbar: function (name) {
          return toolbars[name];
        },
        // retrieve toolbars by editor name, largely used by testing suites only
        retrieveToolbarsViaEditor: function (name) {
          var result = [],
            _this = this;
          angular.forEach(this.retrieveEditor(name).toolbars, function (name) {
            result.push(_this.retrieveToolbar(name));
          });
          return result;
        },
        unregisterToolbar: function (name) {
          delete toolbars[name];
        },
        // functions for updating the toolbar buttons display
        updateToolsDisplay: function (newTaTools) {
          // pass a partial struct of the taTools, this allows us to update the tools on the fly, will not change the defaults.
          var _this = this;
          angular.forEach(newTaTools, function (_newTool, key) {
            _this.updateToolDisplay(key, _newTool);
          });
        },
        // this function resets all toolbars to their default tool definitions
        resetToolsDisplay: function () {
          var _this = this;
          angular.forEach(taTools, function (_newTool, key) {
            _this.resetToolDisplay(key);
          });
        },
        // update a tool on all toolbars
        updateToolDisplay: function (toolKey, _newTool) {
          var _this = this;
          angular.forEach(toolbars, function (toolbarScope, toolbarKey) {
            _this.updateToolbarToolDisplay(toolbarKey, toolKey, _newTool);
          });
        },
        // resets a tool to the default/starting state on all toolbars
        resetToolDisplay: function (toolKey) {
          var _this = this;
          angular.forEach(toolbars, function (toolbarScope, toolbarKey) {
            _this.resetToolbarToolDisplay(toolbarKey, toolKey);
          });
        },
        // update a tool on a specific toolbar
        updateToolbarToolDisplay: function (toolbarKey, toolKey, _newTool) {
          if (toolbars[toolbarKey]) {
            toolbars[toolbarKey].updateToolDisplay(toolKey, _newTool);
          } else {
            throw ('textAngular Error: No Toolbar with name "' + toolbarKey + '" exists');
          }
        },
        // reset a tool on a specific toolbar to it's default starting value
        resetToolbarToolDisplay: function (toolbarKey, toolKey) {
          if (toolbars[toolbarKey]) {
            toolbars[toolbarKey].updateToolDisplay(toolKey, taTools[toolKey], true);
          } else {
            throw ('textAngular Error: No Toolbar with name "' + toolbarKey + '" exists');
          }
        },
        // removes a tool from all toolbars and it's definition
        removeTool: function (toolKey) {
          delete taTools[toolKey];
          angular.forEach(toolbars, function (toolbarScope) {
            delete toolbarScope.tools[toolKey];
            for (var i = 0; i < toolbarScope.toolbar.length; i++) {
              var toolbarIndex;
              for (var j = 0; j < toolbarScope.toolbar[i].length; j++) {
                if (toolbarScope.toolbar[i][j] === toolKey) {
                  toolbarIndex = {
                    group: i,
                    index: j
                  };
                  break;
                }
                if (toolbarIndex !== undefined) {
                  break;
                }
              }
              if (toolbarIndex !== undefined) {
                toolbarScope.toolbar[toolbarIndex.group].slice(toolbarIndex.index, 1);
                toolbarScope._$element.children().eq(toolbarIndex.group).children().eq(toolbarIndex.index).remove();
              }
            }
          });
        },
        // toolkey, toolDefinition are required. If group is not specified will pick the last group, if index isnt defined will append to group
        addTool: function (toolKey, toolDefinition, group, index) {
          taRegisterTool(toolKey, toolDefinition);
          angular.forEach(toolbars, function (toolbarScope) {
            toolbarScope.addTool(toolKey, toolDefinition, group, index);
          });
        },
        // adds a Tool but only to one toolbar not all
        addToolToToolbar: function (toolKey, toolDefinition, toolbarKey, group, index) {
          taRegisterTool(toolKey, toolDefinition);
          toolbars[toolbarKey].addTool(toolKey, toolDefinition, group, index);
        },
        // this is used when externally the html of an editor has been changed and textAngular needs to be notified to update the model.
        // this will call a $digest if not already happening
        refreshEditor: function (name) {
          if (editors[name]) {
            editors[name].scope.updateTaBindtaTextElement();
            /* istanbul ignore else: phase catch */
            if (!editors[name].scope.$$phase) {
              editors[name].scope.$digest();
            }
          } else {
            throw ('textAngular Error: No Editor with name "' + name + '" exists');
          }
        }
      };
    }
  ]);
})();

'use strict';

/*
textAngular
Author : Austin Anderson
License : 2013 MIT
Version 1.2.1

See README.md or https://github.com/fraywing/textAngular/wiki for requirements and use.
*/
var textAngularSetup = angular.module('textAngularSetup', []);

// Here we set up the global display defaults, to set your own use a angular $provider#decorator.
textAngularSetup.value('taOptions', {
  toolbar: [
    ['unformat'],
    ['fonts'],
    ['sizes'],
    ['colors'],
    ['smilies'],
    ['undo', 'redo'],
    ['bold', 'italics', 'underline', 'justifyLeft', 'justifyCenter', 'justifyRight', 'ol', 'ul',
      'indent', 'outdent', 'insertLink', 'insertEmail', 'insertImage', 'quote', 'code', 'html', 'php'
    ]
  ],
  classes: {
    focussed: 'focussed',
    toolbar: 'btn-toolbar',
    toolbarGroup: 'btn-group',
    toolbarButton: 'btn btn-default',
    toolbarButtonActive: 'active',
    disabled: 'disabled',
    textEditor: 'form-control',
    htmlEditor: 'form-control'
  },
  setup: {
    // wysiwyg mode
    textEditorSetup: function () { /* Do some processing here */ },
    // raw html
    htmlEditorSetup: function () { /* Do some processing here */ }
  },
  defaultFileDropHandler:
  /* istanbul ignore next: untestable image processing */
  function (file, insertAction) {
    var reader = new FileReader();
    if (file.type.substring(0, 5) === 'image') {
      reader.onload = function () {
        if (reader.result !== '') {
          insertAction('insertImage', reader.result, true);
        }
      };

      reader.readAsDataURL(file);
      return true;
    }
    return false;
  }
});

textAngularSetup.constant('taTranslations', {
  toggleHTML: 'Toggle HTML',
  insertImage: 'Please enter a image URL to insert',
  insertEmail: 'Please enter the email address for the link',
  insertLink: 'Please enter a URL to insert',
  insertVideo: 'Please enter a youtube URL to embed'
});

textAngularSetup.run(['taRegisterTool', '$window', 'taTranslations', 'taSelection',
  function (taRegisterTool, $window, taTranslations) {
    taRegisterTool('html', {
      content: '<span class="icon-toolbar-html"></span>',
      class: 'html-button',
      tooltip: 'Wrap [HTML] tags around selected text',
      action: function () {
        this.$editor().commands.wrapSelectionInBlock('HTML');
      }
    });
    taRegisterTool('smilies', {
      tooltip: 'Smilies',
      action: function (deferred, restoreSelection, code) {
        return this.$editor().commands.replaceSelection(code);
      }
    });
    taRegisterTool('fonts', {
      tooltip: 'Fonts',
      action: function (deferred, restoreSelection, menuitem) {
        return this.$editor().wrapSelection('[FONT="' + menuitem + '"]', '[/FONT]');
      }
    });
    taRegisterTool('colors', {
      tooltip: 'Colors',
      action: function (deferred, restoreSelection, menuitem) {
        return this.$editor().commands.wrapSelection('[COLOR="' + menuitem + '"]', '[/COLOR]');
      }
    });
    taRegisterTool('sizes', {
      content: 'Sizes',
      menu: {
        'items': ['1', '2', '3', '4', '5', '6', '7']
      },

      action: function (deferred, restoreSelection, menuitem) {
        return this.$editor().commands.wrapSelection('[SIZE="' + menuitem + '"]', '[/SIZE]');
      }
    });
    taRegisterTool('ul', {
      tooltip: 'Unordered List',
      content: '<span class="icon-toolbar-insertunorderedlist"></span>',
      action: function () {
        this.$editor().commands.insertUnorderedList();
      }
    });
    taRegisterTool('ol', {
      tooltip: 'Ordered List',
      content: '<span class="icon-toolbar-insertorderedlist"></span>',
      action: function () {
        this.$editor().commands.insertOrderedList();
      }
    });
    taRegisterTool('undo', {
      tooltip: 'Undo',
      content: '<span class="icon-toolbar-undo"></span>',
      action: function () {
        return this.$editor().undo();
      }
    });
    taRegisterTool('redo', {
      tooltip: 'Redo',
      content: '<span class="icon-toolbar-redo"></span>',
      action: function () {
        return this.$editor().redo();
      }
    });
    taRegisterTool('bold', {
      tooltip: 'Bold',
      content: '<span class="icon-toolbar-bold"></span>',
      action: function () {
        return this.$editor().commands.wrapSelectionInBlock('B');
      },
      commandKeyCode: 98
    });
    taRegisterTool('unformat', {
      tooltip: 'Remove Text Formatting',
      content: '<span class="icon-toolbar-removeformat"></span>',
      action: function () {
        return this.$editor().commands.unformatSelection();
      }
    });
    taRegisterTool('code', {
      tooltip: 'Wrap [CODE] tags around selected text',
      class: 'code-button',
      content: '<span class="icon-toolbar-code"></span>',
      action: function () {
        return this.$editor().commands.wrapSelectionInBlock('CODE');
      }
    });
    taRegisterTool('php', {
      tooltip: 'Wrap [PHP] tags around selected text',
      class: 'php-button',
      content: '<span class="icon-toolbar-php"></span>',
      action: function () {
        return this.$editor().commands.wrapSelectionInBlock('PHP');
      }
    });
    taRegisterTool('quote', {
      tooltip: 'Wrap [QUOTE] tags around selected text',
      content: '<span class="icon-toolbar-quote"></span>',
      action: function () {
        return this.$editor().commands.wrapSelectionInBlock('QUOTE');
      }
    });
    taRegisterTool('justifyLeft', {
      tooltip: 'Align Left',
      content: '<span class="icon-toolbar-justifyleft"></span>',
      action: function () {
        return this.$editor().commands.wrapSelectionInBlock('LEFT');
      }
    });
    taRegisterTool('justifyRight', {
      tooltip: 'Align Right',
      content: '<span class="icon-toolbar-justifyright"></span>',
      action: function () {
        return this.$editor().commands.wrapSelectionInBlock('RIGHT');
      }
    });
    taRegisterTool('justifyCenter', {
      tooltip: 'Align Center',
      content: '<span class="icon-toolbar-justifycenter"></span>',
      action: function () {
        return this.$editor().commands.wrapSelectionInBlock('CENTER');
      }
    });
    taRegisterTool('indent', {
      tooltip: 'Increase Indent',
      content: '<span class="icon-toolbar-indent"></span>',
      tooltiptext: 'Indent',
      action: function () {
        return this.$editor().commands.indentSelection();
      }
    });
    taRegisterTool('outdent', {
      tooltip: 'Decrease Indent',
      content: '<span class="icon-toolbar-outdent"></span>',
      tooltiptext: 'Outdent',
      action: function () {
        return this.$editor().commands.outdentSelection();
      }
    });
    taRegisterTool('italics', {
      tooltip: 'Italic',
      content: '<span class="icon-toolbar-italic"></span>',
      action: function () {
        return this.$editor().commands.wrapSelectionInBlock('I');
      },
      commandKeyCode: 105
    });
    taRegisterTool('underline', {
      tooltip: 'Underline',
      content: '<span class="icon-toolbar-underline"></span>',
      action: function () {
        return this.$editor().commands.wrapSelectionInBlock('U');
      },
      commandKeyCode: 117
    });
    taRegisterTool('insertImage', {
      tooltip: 'Insert Image',
      content: '<span class="icon-toolbar-insertimage"></span>',
      action: function () {
        var imageLink;
        imageLink = $window.prompt(taTranslations.insertImage, 'http://');
        if (imageLink && imageLink !== '' && imageLink !== 'http://') {
          return this.$editor().commands.replaceSelection('[IMG]' + imageLink + '[/IMG]');
        }
      }
    });
    taRegisterTool('insertEmail', {
      tooltip: 'Insert Email',
      content: '<span class="icon-toolbar-email"></span>',
      action: function () {
        var emailAddress = $window.prompt(taTranslations.insertEmail);
        if (emailAddress && emailAddress !== '') {
          return this.$editor().commands.wrapSelection('[EMAIL="' + emailAddress + '"]', '[/EMAIL]');
        }
      }
    });
    taRegisterTool('insertLink', {
      tooltip: 'Insert Link',
      content: '<span class="icon-toolbar-createlink"></span>',
      action: function () {
        var urlLink = $window.prompt(taTranslations.insertLink, 'http://');
        if (urlLink && urlLink !== '' && urlLink !== 'http://') {
          // todo BJB escape
          return this.$editor().commands.wrapSelection('[URL="' + urlLink + '"]', '[/URL]');
        }
      }
    });
  }
]);

'use strict';

angular.module('wfOnboarding', [
  'warriorUtils',
  'angularFileUpload',
  'multi-transclude',
  'ui.bootstrap',
  'ui.bootstrap.modal'
]).run(["WfTrackingCookie", function(WfTrackingCookie){
    WfTrackingCookie.init();
}]);

'use strict';

angular.module('wfOnboarding')
  .controller('OnboardingCtrl', ["$scope", "$timeout", "$window", "Onboarding", "Users", "ForumURLGenerator", "wfCookieExperiment", function(
    $scope, $timeout, $window, Onboarding, Users, ForumURLGenerator, wfCookieExperiment) {

    var encouragementPhrases = [
      'Select your first topic',
      'Follow more topics',
      'Good topic!',
      'Go further, select more topics',
      'Nice choice',
      'You can select more topics to follow or simply click continue to get started'
    ];

    $scope.topics = $window.topics.map(function(x) {
      x.selected = false;
      return x;
    });

    $scope.selectedTopics = [];
    $scope.minTopicCount = 5;

    $scope.encourage = function() {
      if ($scope.selectedTopics.length < $scope.minTopicCount) {
        return encouragementPhrases[$scope.selectedTopics.length];
      } else {
        return encouragementPhrases[$scope.minTopicCount];
      }
    };

    $scope.remainingTopics = function() {
       var diff = $scope.minTopicCount - $scope.selectedTopics.length;
       if (diff > 0) {
          return 'Follow '  + diff + '+ topics to get started';
       } else {
          return 'Good job!';
       }
    };

    $window.callbackComplete = function() {
      $scope.next();
    };

    $scope.continueText = function() {
      if ($scope.selectedTopics < 1) {
        return 'Continue';
      } else {
        return 'CONTINUE';
      }
    };

    $scope.select = function(topic) {
      var idx = $scope.selectedTopics.indexOf(topic);
      if (idx < 0) {
        $scope.selectedTopics.push(topic);
        Onboarding.saveInterest({tagId: topic.id});
      } else {
        $scope.selectedTopics.splice(idx, 1);
        Onboarding.deleteInterest({tagId: topic.id});
      }
    };

    $scope.maxPages = 4;

    $scope.next = function() {
      if (($scope.pageNumber + 1) < $scope.maxPages) {
        $scope.pageNumber = Onboarding.nextPage($scope.pageNumber);
      }
      if (($scope.pageNumber +1) === $scope.maxPages) {
        $timeout(function() {
          $window.location.href = ForumURLGenerator.getFeedUrl();
        }, 5000);
      }
    };

    $scope.done = function() {
      $timeout(function() {
        $window.location.href = ForumURLGenerator.getFeedUrl();
      }, 5000);
      $scope.pageNumber = Onboarding.nextPage($scope.pageNumber);
    };

    $scope.showAnnualPayment = wfCookieExperiment.getVariation(27, 2);
}]);

'use strict';
// Add a "submitted" boolean to the form object when the form
// has been submitted. You can use <form_name>.submitted to then
// display validation error
angular.module('wfOnboarding')
  .directive('freeTrialSignup', ["BASE_URL", "MONTH_FREE_TRIAL", function(BASE_URL, MONTH_FREE_TRIAL) {

    return {
      link: function(scope, element) {

        element.on('click', function() {
          var url = BASE_URL + 'membership/freetrial/' + MONTH_FREE_TRIAL;
          window.frame = window.open(url);
        });
      }
    };
  }]);

'use strict';
// Add a "submitted" boolean to the form object when the form
// has been submitted. You can use <form_name>.submitted to then
// display validation error
angular.module('wfOnboarding')
  .directive('purchaseAnnualMembership', ["URLGenerator", function(URLGenerator) {
    return {
      link: function(scope, element) {
        element.on('click', function() {
          var url = URLGenerator.getPageUrl('war-room/join');
          window.frame = window.open(url);
        });
      }
    };
  }]);

'use strict';

angular.module('wfOnboarding')
  .service('Onboarding', ["$http", "$uibModal", "WSO_API_BASE", "$resource", "Analytics", "URLGenerator", function($http, $uibModal, WSO_API_BASE, $resource, Analytics, URLGenerator) {
    var onboardingPaginationUrl = URLGenerator.getAPIURL('onboarding', 'page');
    var OnboardingAPI = $resource(onboardingPaginationUrl,
    {},
    {'update': {
      'method': 'PATCH'
    }});

    var InterestsAPI = $resource(URLGenerator.getAPIURL('onboarding', 'topics/interests/:tagId'),
        {'tagId': '@tagId'},
        {
          'deleteInterest' : {
            method: 'PATCH'
          }
        }
      );
    var AllInterestsAPI = $resource(URLGenerator.getAPIURL('onboarding', 'topics/interests/'), {}, {
      'query':  {method:'GET', isArray:true},
    });
    var ExpertiseAPI = $resource(URLGenerator.getAPIURL('onboarding', 'topics/expertise/:tagId'), {'tagId': '@tagId'});

    var saveInterest = function(tag_id) {
      InterestsAPI.save(tag_id);
    };

    var deleteInterest = function(tag_id) {
      InterestsAPI.deleteInterest({
        tagId: tag_id.tagId,
        'action': 'delete'
      });
    };

    var saveExpertise = function(tag_id) {
      ExpertiseAPI.save(tag_id);
    };

    var deleteExpertise = function(tag_id) {
      ExpertiseAPI.delete(tag_id);
    };

    var nextPage = function(pageNumber) {
      OnboardingAPI.update({
      'page': pageNumber,
        'skipped': false});
      pageNumber = pageNumber + 1;
      return pageNumber;
    };

    var skipPage = function(pageNumber) {
      OnboardingAPI.update({
        'page': pageNumber,
        'skipped': true});
      pageNumber = pageNumber + 1;
      return pageNumber;
    };

    return {
      skipPage: skipPage,
      nextPage: nextPage,
      saveInterest: saveInterest,
      deleteInterest: deleteInterest,
      saveExpertise: saveExpertise,
      deleteExpertise: deleteExpertise,
      getInterests: function() {
        return AllInterestsAPI.query().$promise;
      }
    };
  }]);

'use strict';

angular.module('warriorUtils', [
  'wsoButtons',
  'angular-md5',
  'angular-tour',
  'ngCookies',
  'ngResource',
  'ngSanitize',
  'ngMessages',
  'ngRoute',
  'ngAnimate',
  'configs',
  'flAnalytics',
  'flUi',
  'flValidation',
  'filters',
  'reCAPTCHA',
  'ui.bootstrap',
  'ui.keypress',
  'angularPayments',
  'angular-stripe',
  'multi-transclude',
  'dcbImgFallback',
  'vcRecaptcha',
  'infinite-scroll',
  'sn.addthis'
])
.config(["reCAPTCHAProvider", "$animateProvider", "stripeProvider", "STRIPE_PUB_KEY", "vcRecaptchaServiceProvider", "RECAPTCHA_PUB_KEY", function (reCAPTCHAProvider, $animateProvider, stripeProvider, STRIPE_PUB_KEY, vcRecaptchaServiceProvider, RECAPTCHA_PUB_KEY) {
  reCAPTCHAProvider.setPublicKey('6LfHsgMAAAAAAMVjkB1nC_nI5qfAjVk0qxz4VtPV');
  vcRecaptchaServiceProvider.setSiteKey(RECAPTCHA_PUB_KEY);
  reCAPTCHAProvider.setOptions({
    theme: 'clean'
  });
  stripeProvider.setPublishableKey(STRIPE_PUB_KEY);
  $animateProvider.classNameFilter(/animate/);
}]);

'use strict';

angular.module('warriorUtils').component('closeOnClick', {
  bindings: {
    target: '@'
  },
  template: '<a ng-click="$ctrl.close()"><wf-icon src="close"></wf-icon></a>',
  controller: function() {
    var ctrl = this;

    ctrl.close = function() {
      angular.element('#' + ctrl.target).remove();
    };
  }
});

'use strict';

angular.module('warriorUtils').component('trackAbTestView', {
  bindings: {
    test: '@',
    variation: '@',
    referenceType: '@',
    referenceValue: '@'
  },
  controller: ["$window", "$timeout", function($window, $timeout) {
    var ctrl = this;

    var timeout = 5000;
    $timeout(function() {
      $window._t.push(['abtest', {
        test: ctrl.test,
        variation: ctrl.variation,
        reference_type: ctrl.referenceType,
        reference_value: ctrl.referenceValue,
      }]);
    }, timeout);
  }]
});

'use strict';

angular.module('warriorUtils').component('wfNotifications', {
  bindings: {
    unread: '@',
    logout: '@'
  },
  templateUrl: '/views/warriorUtils/wfNotifications.html',
  controller: ["$scope", "Notifications", "IconManager", function($scope, Notifications, IconManager) {
    var ctrl = this;

    ctrl.state = {
      showDropdown: false,
      loading: false,
      hasNext: false
    };

    ctrl.totalUnread = ctrl.unread;
    ctrl.currentPage = 1;
    ctrl.data = {};

    var formatNotifications = function(notifications) {
      notifications.forEach(function(notification) {
        notification.created_at = new Date(notification.created_at);
        notification.sub_icon = IconManager.notificationIcon(notification.event_name);
      });

      return notifications;
    };

    var appendNotifications = function(notifications) {
      notifications = formatNotifications(notifications);
      ctrl.data.notifications = ctrl.data.notifications.concat(notifications);
    };

    if (ctrl.logout) {
      Notifications.getNextByEvent('generic', 'logout_notif').then(function(data) {
        ctrl.data.notifications = formatNotifications(data.notifications);
        ctrl.state.hasNext = data.has_next;
        ctrl.state.loading = false;
      });
    }

    ctrl.initialize = function() {
      if (ctrl.data.notifications) {
        return;
      }

      ctrl.state.loading = true;
      Notifications.getNext().then(function(data) {
        ctrl.data.notifications = formatNotifications(data.notifications);
        ctrl.state.hasNext = data.has_next;
      }).finally(function() {
        ctrl.state.loading = false;
      });
    };

    ctrl.isEmpty = function() {
      return !ctrl.data.notifications || ctrl.data.notifications.length === 0;
    };

    ctrl.hasUnread = function() {
      return ctrl.totalUnread > 0;
    };

    ctrl.toggleDropdown = function() {
      ctrl.state.showDropdown = !ctrl.state.showDropdown;
    };

    ctrl.hideDropdown = function() {
      ctrl.state.showDropdown = false;
      ctrl.markAsRead();
    };

    var setAsRead = function(notifications) {
      notifications.forEach(function(notification) {
        notification.is_read = true;
      });
    };

    ctrl.markAsRead = function() {
      if(ctrl.totalUnread <= 0) {
        return false;
      }

      Notifications.markAsRead(ctrl.data.notifications);
      setAsRead(ctrl.data.notifications);
      ctrl.totalUnread -= ctrl.data.notifications.length;
    };

    ctrl.markAllAsRead = function() {
      if(ctrl.totalUnread <= 0) {
        return false;
      }

      Notifications.markAllAsRead(ctrl.data.notifications[0]);
      setAsRead(ctrl.data.notifications);
      ctrl.totalUnread = 0;
    };

    ctrl.nextBatch = function() {
      if(!ctrl.state.hasNext || ctrl.state.loading) {
        //Don't request if last page already reached
        return false;
      }

      ctrl.state.loading = true;
      var last_entry = ctrl.data.notifications[ctrl.data.notifications.length-1];
      Notifications.getNext(last_entry.id).then(function(data) {
        appendNotifications(data.notifications);
        ctrl.state.hasNext = data.has_next;
        ctrl.state.loading = false;
      }).finally(function() {
        ctrl.state.loading = false;
      });
    };

    $scope.$emit('notificationsReady');
  }]
});

'use strict';

angular.module('warriorUtils')
  .controller('UserMembershipCtrl', ["URLGenerator", "wfCookieExperiment", "Users", "$scope", "$window", "MONTH_FREE_TRIAL", function(URLGenerator,
    wfCookieExperiment,
    Users,
    $scope,
    $window,
    MONTH_FREE_TRIAL) {

    var experimentId = 29;
    $scope.show_nibiru_version = wfCookieExperiment.getVariation(experimentId, 2);
    $scope.show_membership = false;

    $scope.freeTrialSignup = function() {
      var url = URLGenerator.getPageUrl('membership/freetrial/' + MONTH_FREE_TRIAL);
      $window.frame = $window.open(url);
    };

    $scope.warRoomJoin = function() {
      var url = URLGenerator.getPageUrl('war-room/join');
      $window.frame = $window.open(url);
    };

    Users.get().then(function(result) {
      $scope.is_war_room_member = result.war_room_member;
      $scope.free_trial_eligible = result.free_trial_eligible;
      $scope.is_on_free_trial = result.is_on_free_trial;
      $scope.show_membership = true;
    });
  }]);

'use strict';

angular.module('warriorUtils')
  .directive('formLocator', function() {
    return {
      link: function(scope) {
        scope.$emit('formLocator', scope);
      }
    };
  });

angular.module('warriorUtils')
  .controller('CompleteRegistrationCtrl', ["$scope", "$uibModalInstance", "Forum", "Analytics", "$interval", "$rootScope", "reCAPTCHA", "Login", "options", "PendingAccount", "$window", "WF_BASE_URL", function ($scope, $uibModalInstance, Forum, Analytics, $interval, $rootScope, reCAPTCHA, Login, options, PendingAccount, $window, WF_BASE_URL) {

    $scope.user = {};
    $scope.options = options;
    var pendingProviderId = options.pendingProviderId;
    var provider = options.provider;
    if (options.verifyEmail) {
      $scope.step = 'notice';
      $scope.email = options.verifyEmail;
      $scope.redirectUrl = WF_BASE_URL;
      $scope.ok = function() {
        $window.location.href = WF_BASE_URL;
      };
    } else {
      $scope.step = 'register';
      $scope.user.username = options.username;
    }
    function createAccount(user) {
      user.pendingProviderId = pendingProviderId;
      var createAccountSuccess = function(result) {
        Analytics.trackAction('wf-register-social-modal', 'registered', 'SUCCESS');
        if (result.result.redirect_url) {
          $scope.redirectUrl = result.result.redirect_url;
          $window.location.href = $scope.redirectUrl;
        }
      };

      var createAccountError = function(result) {
        Analytics.trackAction('wf-register-social-modal', 'registered', 'ERROR');
        var parameter, error;
        if (result.code) {
          var matches = result.code.match(/(.*?)[\._](.*)/);
          if (matches) {
            parameter = matches[1].toLowerCase();
            error = matches[2].toLowerCase();
          }
        }

        if (parameter === 'captcha') {
          if (error === 'incorrect') {
            reCAPTCHA.reload();
            $scope.step = 'captcha';
            $scope.captcha.$error = {'incorrect':true};
          } else if (error === 'missing') {
            $scope.step = 'captcha';
          }
        } else {
          if (parameter === 'password' && error === 'not_matched') {
            parameter = 'confirmPassword';
            error = 'repeat';
          }

          if ($scope.signupform[parameter]) {
            if (error === 'missing') {
              error = 'required';
            }

            if (error === 'taken') {
              error = 'used';
            }

            $scope.signupform[parameter].$setValidity(error, false);
          }

          $scope.step = 'initial';
        }
      };

      PendingAccount.completeRegistration(user, pendingProviderId, provider).then(createAccountSuccess, createAccountError);
    }

    $scope.submit = function(user) {
      createAccount(user);
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .controller('ErrorCtrl', function() {
});

'use strict';

angular.module('warriorUtils')
  .controller('FollowUserCtrl', ["URLGenerator", "Users", "$scope", "$attrs", function (URLGenerator, Users, $scope, $attrs) {
    $scope.isFollowed = false;
    $scope.errorText = '';
    $scope.showFollowNotif = false;

    var init = function(username){
      Users.isFollowing(username).then(function (response) {
        setIsFollowed(response.result);
      });
    };

    var follow = function (username) {
      Users.followUser(username).then(function () {
        setIsFollowed(true);
        $scope.showFollowNotif = true;
      });
    };

    var unfollow = function (username) {
      Users.unfollowUser(username).then(function () {
        setIsFollowed(false);
        $scope.showFollowNotif = false;
      });
    };

    var setIsFollowed = function(isFollowed) {
      $scope.isFollowed = isFollowed;
      if($scope.isFollowed) {
        $scope.followDisplayText = 'Unfollow Author';
      } else {
        $scope.followDisplayText = 'Follow Author';
      }
    };

    $scope.followToggle = function () {
      if ($scope.isFollowed) {
        unfollow($attrs.authorUsername);
      } else {
        follow($attrs.authorUsername);
      }
    };

    $scope.hideFollowNotif = function() {
      $scope.showFollowNotif = false;
    };

    init($attrs.authorUsername);

  }]);

'use strict';

angular.module('warriorUtils')
  .controller('ForgotPasswordModalCtrl', ["$scope", "$uibModalInstance", "Forum", "$interval", "Analytics", "$rootScope", "Signup", "Login", "options", function ($scope, $uibModalInstance, Forum, $interval, Analytics, $rootScope, Signup, Login, options) {
    Analytics.trackEvent('wf-forgotpw-modal', undefined, 'load');
    if (angular.isDefined($rootScope.autoload)) {
      $interval.cancel($rootScope.autoload);
    }

    $scope.user = {};
    $scope.options = options;
    $scope.unknownerror = false;
    $scope.step = 'initial';

    var getPassword = function(user) {

      var getPasswordSuccess = function() {
        $scope.step = 'notice';
      };

      Forum.forgotPassword(user).then(getPasswordSuccess);
    };

    $scope.submit = function (user) {
      if ($scope.step === 'initial') {
        getPassword(user);
      } else if ($scope.step === 'notice') {
        $uibModalInstance.close();
      }
    };

    $scope.signup = function(options) {
      Signup.openSignupModal(options);
      $uibModalInstance.close();
    };

    $scope.login = function(options) {
      Login.openLoginModal(options);
      $uibModalInstance.close();
    };

    $scope.forgotpassword = function(options) {
      Login.openForgotPasswordModal(options);
      $uibModalInstance.close();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .controller('ForumSearchCtrl', ["$scope", "$window", "WF_BASE_URL", function($scope, $window, WF_BASE_URL) {
    $scope.search = function(query) {
      $window.location.href = WF_BASE_URL + 'search/' + query;
    };
  }]);

'use strict';

angular.module('warriorUtils')

.controller('GreetingModalCtrl', ["$scope", "WSO_API_BASE", "$http", "$uibModalInstance", "message", "trackingSection", "trackingSubsection", "$sce", "Analytics", function($scope, WSO_API_BASE, $http, $uibModalInstance, message, trackingSection, trackingSubsection, $sce, Analytics) {
  Analytics.trackEvent('wf-welcome-modal', undefined, 'load');

  $scope.message = message;
  $scope.trackingSection = trackingSection;
  $scope.trackingSubsection = trackingSubsection;

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.close = function(result) {
    $uibModalInstance.close(result);
  };

  $scope.trustAsHtml = function(str) {
    return $sce.trustAsHtml(str);
  };
}]);


'use strict';

angular.module('warriorUtils')
  .controller('HackCtrl', ["$scope", function ($scope) {
    $scope.doSave = function(value) {
      $scope.name = value;
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .controller('HeaderCtrl', ["$scope", "$timeout", "$window", "ForumURLGenerator", "Login", "Signup", "UserSetting", function ($scope, $timeout, $window, ForumURLGenerator, Login, Signup, UserSetting) {
    $scope.state = {
      showNotifications: false,
      showOverlay: false
    };

    $scope.dropdowns = {
      marketplace: false,
      forum: false,
      search: false,
      userMenu: false
    };

    $scope.searchQuery = '';

    var options = {welcomeMessage: 'Welcome to'};
    var dropdownTimer;

    $scope.login = function(){
      Login.openLoginModal(options);
    };

    $scope.signup = function(){
      Signup.openSignupModal(options);
    };

    $scope.search = function() {
      $window.location.href = ForumURLGenerator.getSearchUrl($scope.searchQuery);
    };

    $scope.toggleMobileNav = function(){
      $scope.$emit('ui.mobileNavigation');
    };

    $scope.toggleDropdown = function(name) {
      $scope.dropdowns[name] = !$scope.dropdowns[name];
    };

    $scope.showDropdown = function(name) {
      dropdownTimer = $timeout(function() {
        $scope.dropdowns[name] = true;
      }, 200);
    };

    $scope.isAnyDropdownActive = function() {
      return $scope.dropdowns.marketplace || $scope.dropdowns.forum || $scope.dropdowns.search || $scope.dropdowns.userMenu;
    };

    $scope.hideDropdown = function(name) {
      $timeout.cancel(dropdownTimer);
      $scope.dropdowns[name] = false;
    };

    $scope.showOverlay = function() {
      $scope.state.showOverlay = true;
    };

    $scope.hideOverlay = function() {
      $scope.state.showOverlay = false;
    };

    $scope.setViewPreference = function(preference) {
      var value = 0;
      if (preference === 'classic') {
        value = 2;
      } else if (preference === 'modern') {
        value = 1;
      }

      UserSetting.change('view_preference', value).then(function() {
        $window.location.reload();
      });
    };

    $scope.$watch('dropdowns', function() {
      $timeout(function() {
        $scope.state.showOverlay = $scope.isAnyDropdownActive();
      }, 50);
    }, true);

    $scope.$on('notificationsReady', function(e) {
      $scope.state.showNotifications = true;
      e.stopPropagation();
    });
  }]);

'use strict';

angular.module('warriorUtils')
  .controller('HoodiePaymentModalCtrl', ["$scope", "$controller", "$uibModalInstance", "paymentChoiceConfig", "Auth", "$window", function($scope, $controller, $uibModalInstance, paymentChoiceConfig, Auth, $window) {
    $controller('PaymentModalCtrl', {$scope:$scope, $uibModalInstance: $uibModalInstance, paymentChoiceConfig: paymentChoiceConfig});
    $scope.show.email = true;

    function loggedIn(user) {
      $scope.show.email = false;
      $scope.item.email = user.email;
    }

    function loggedOut() {
      $scope.show.email = true;
    }

    Auth.onLoggedIn(loggedIn, loggedOut);

    $scope.beforePaymentServiceCharge = function(paymentData) {
      paymentData.email = $scope.item.email;
    };

    $scope.paymentSuccess = function() {
      $window.location.href = 'https://warriorforum.wufoo.com/forms/m1htd5dw00pyk3z/';
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .controller('LoginCtrl', ["$scope", "Login", function ($scope, Login) {
    $scope.openLogin = function ($event) {
      if ($event) {
        $event.preventDefault();
      }

      Login.openLoginModal();
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .directive('formLocator', function() {
    return {
      link: function(scope) {
        scope.$emit('formLocator', scope);
      }
    };
  });

angular.module('warriorUtils')
  .controller('LoginModalCtrl', ["$scope", "$uibModalInstance", "Forum", "$interval", "Analytics", "$rootScope", "Signup", "ForgotPassword", "options", "URLGenerator", "$window", function ($scope, $uibModalInstance, Forum, $interval, Analytics, $rootScope, Signup, ForgotPassword, options, URLGenerator, $window) {
    Analytics.trackEvent('wf-login-modal', undefined, 'load');
    if (angular.isDefined($rootScope.autoload)) {
      $interval.cancel($rootScope.autoload);
    }

    $scope.$on('formLocator', function(event, scope) {
      $scope.loginform = scope.loginform;
    });

    $scope.fbLoginUrl = URLGenerator.fbLoginUrl;
    $scope.googleLoginUrl = URLGenerator.googleLoginUrl;
    $scope.user = {};
    $scope.options = options;
    $scope.options.welcomeMessage = $scope.options.welcomeMessage || 'To continue, log in to';
    $scope.unknownerror = false;

    function login(user) {
      var loginSuccess = function(result) {
        Analytics.trackAction('wf-login-modal', 'loggedin', 'SUCCESS');
        $scope.redirectUrl = false;
        if (result.data && result.data.redirect && result.data.redirect_url) {
          $scope.redirectUrl = result.data.redirect_url;
        }

        if ($scope.redirectUrl) {
          $window.location.href = $scope.redirectUrl;
          return;
        }

        $rootScope.$broadcast('user.refreshlogin');
        $rootScope.$broadcast('user.refreshlogin.ok');
        $uibModalInstance.close();
      };

      var loginError = function(result) {
        Analytics.trackAction('wf-login-modal', 'loggedin', 'ERROR');
        var parameter, error;
        if (result.code) {
          var matches = result.code.match(/(.*)\.(.*)/);
          if (matches) {
            parameter = matches[1].toLowerCase();
            error = matches[2].toLowerCase();
          }
        } else {
          $scope.unknown_error = true;
        }

        $scope.remaining_strikes = result.data.message.remaining_strikes;

        if ($scope.loginform[parameter]) {
          if (error === 'missing') {
            error = 'required';
          }

          $scope.loginform[parameter].$setValidity(error, false);
        } else {
          $scope.login_error = error;
        }
      };

      Forum.login(user).then(loginSuccess, loginError);
    }

    $scope.submit = function (user) {
      login(user);
    };

    $scope.signup = function(options) {
      if(options.welcomeMessage && options.welcomeMessage.startsWith('To continue')){
        options.welcomeMessage = 'To continue, sign up to';
      }
      Signup.openSignupModal(options);
      $uibModalInstance.close();
    };

    $scope.forgotpassword = function(options) {
      ForgotPassword.openForgotPasswordModal(options);
      $uibModalInstance.close();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .controller('MainCtrl', function() {

});

'use strict';

angular.module('warriorUtils')
  .controller('MenuCtrl', ["$location", "$rootScope", "$scope", "$window", "Auth", "Users", "BASE_URL", "LOGOUT_URL", "WF_BASE_URL", function($location, $rootScope, $scope, $window, Auth, Users,
    BASE_URL, LOGOUT_URL, WF_BASE_URL) {

    $scope.user = {};
    $scope.forum_url = WF_BASE_URL;
    $scope.forum_menu = false;
    $scope.state = 'initializing';
    $scope.sales_funnel = false;
    $scope.activeNav = $location.url().split('/')[1];
    $scope.welcomeMessage = 'Welcome to';

    $scope.set_active = function(nav){
      $scope.activeNav = nav;
    };

    function loggedIn(user) {
      $scope.state = 'done';
      $scope.user = user;
      var host = $window.location.host;
      $scope.logoutUrl = LOGOUT_URL + '&from=logout&redirect_to=' + host;
    }

    function notLoggedIn() {
      $scope.state = 'done';
      $scope.user = {};
    }

    Auth.onLoggedIn(loggedIn, notLoggedIn);
  }]);

'use strict';

angular.module('warriorUtils')
  .controller('MobileNavigationCtrl', ["$scope", "$window", "ForumURLGenerator", "UserSetting", function ($scope, $window, ForumURLGenerator, UserSetting) {
    $scope.state = {
      showAllMarketplaces: false,
      showAllForums: false
    };

    $scope.searchQuery = '';

    $scope.search = function() {
      $window.location.href = ForumURLGenerator.getSearchUrl($scope.searchQuery);
    };

    $scope.toggleMarketplaceList = function() {
      $scope.state.showAllMarketplaces = !$scope.state.showAllMarketplaces;
    };

    $scope.toggleForumList = function() {
      $scope.state.showAllForums = !$scope.state.showAllForums;
    };

    $scope.setViewPreference = function(preference) {
      var value = 0;
      if (preference === 'classic') {
        value = 2;
      } else if (preference === 'modern') {
        value = 1;
      }

      UserSetting.change('view_preference', value).then(function() {
        $window.location.reload();
      });
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .controller('NavTabCtrl', ["$scope", function($scope) {
    $scope.showTopVoted = false;

    $scope.toggleTopVoted = function() {
      $scope.showTopVoted = !$scope.showTopVoted;
    };
    
    $scope.hideTopVoted = function() {
      $scope.showTopVoted = false;
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .controller('PaymentChoiceModalCtrl', ["$interval", "$rootScope", "$scope", "$uibModalInstance", "$window", "Analytics", "Coupon", "Debounce", "IconManager", "paymentChoiceConfig", "PaymentsService", function (
    $interval,
    $rootScope,
    $scope,
    $uibModalInstance,
    $window,
    Analytics,
    Coupon,
    Debounce,
    IconManager,
    paymentChoiceConfig,
    PaymentsService) {

    var trackingSectionName = 'wf-paymentpage-grey-modal';
    Analytics.trackEvent(trackingSectionName, undefined, 'load');

    var pendingCouponTransaction = paymentChoiceConfig.pendingCouponTransaction;
    if (pendingCouponTransaction) {
      PaymentsService.setCouponTransactionId(pendingCouponTransaction);
    }

    $scope.state = {
      'verifyingCode': false,
      'couponEnabled': true,
      'couponApplied': false
    };

    $scope.step = 'loading';
    $scope.stripeEnabled = true;
    $scope.paymentchoice = 'paypal';

    if (angular.isDefined($rootScope.autoload)) {
      $interval.cancel($rootScope.autoload);
    }

    $scope.item = paymentChoiceConfig.item;
    $scope.item.couponCode = '';

    PaymentsService.createPendingFixedCharge(paymentChoiceConfig.item).then(function(result) {
      $scope.item.fixedChargeItemAmount = result.amount;
      $scope.item.fixedChargeItemName = result.name;
      $scope.item.fixedChargeItemDescription = result.description;
      $scope.item.pendingFixedChargeId = result.pending_txn_id;
      $scope.item.fixedChargeItemType = result.type;
      $scope.stripeEnabled = result.allow_credit_card;

      PaymentsService.getReferenceAccount().then(function(result) {
        $scope.step = 'billingPaymentPage';
        $scope.referenceAccount = result.account;
      }, function() {
        $scope.step = 'initial';
      });
    });

    $scope.toggleChoice = function(choice) {
      $scope.paymentchoice = choice;
    };

    $scope.itemIcon = function(itemType) {
        return IconManager.fixedChargeIcon(itemType);
    };

    $scope.clickPurchase = function() {
      $scope.processing = true;
    };

    $scope.clearError = function() {
      $scope.stripeError = false;
    };

    $scope.handleStripe = function(status, response) {
      if ($scope.paymentchoice !== 'stripe') {
        return;
      }

      if (status !== 200) {
        Analytics.trackAction(trackingSectionName, 'card_added', 'ERROR');
        $scope.stripeError = response.error.message;
        $scope.processing = false;
      }
      else {
        var token = response;
        angular.extend(token, paymentChoiceConfig.item);
        Analytics.trackAction(trackingSectionName, 'card_added', 'SUCCESS');
        PaymentsService.chargeWithStripe({
          pendingFixedChargeId: paymentChoiceConfig.item.pendingFixedChargeId,
          id: token.id,
          isAutoBump: paymentChoiceConfig.item.isAutoBump
        }).then(function(result) {
          $scope.processing = false;
          if (result.result) {
            $scope.step = 'paid';
            Analytics.trackAction(trackingSectionName, 'new_stripe_token_paid', 'SUCCESS');
          }
          else {
            Analytics.trackAction(trackingSectionName, 'new_stripe_token_paid', 'ERROR');
            $scope.step = 'error';
            $scope.errorMessage = result.message;
          }
        });
      }
    };

    $scope.selectPaypal = function() {
      if ($scope.processing) {
        return false;
      }
      $scope.processing = true;
      $scope.payWithPaypal();
      Analytics.trackAction(trackingSectionName, 'select-paypal', 'initial');
    };

    $scope.payWithBillingAgreement = function(item, referenceAccount) {
      $scope.processing = true;
      if (referenceAccount.type === 'Stripe') {
        PaymentsService.chargeWithStripe({
          pendingFixedChargeId: item.pendingFixedChargeId,
          isAutoBump: item.isAutoBump
        }).then(function(result) {
          $scope.processing = true;
          if (result.result === true ) {
            Analytics.trackAction(trackingSectionName, 'stripe_billing_paid', 'SUCCESS');
            $scope.step = 'paid';
            $scope.processing = false;
          } else {
            $scope.processing = false;
            Analytics.trackAction(trackingSectionName, 'stripe_billing_paid', 'ERROR');
            $scope.errorMessage = result.message;
            $scope.step = 'error';
          }
        });
      } else if ($scope.referenceAccount.type === 'PayPal') {
        $scope.payWithPaypal();
      } else {
        $scope.step = 'initial';
      }
    };

    $scope.removeStripeBillingAccount = function() {
      $scope.step = 'initial';
      PaymentsService.removeStripeBillingAccount();
    };

    $scope.removePaypalBillingAccount = function() {
      $scope.step = 'initial';
      PaymentsService.removePaypalBillingAccount();
    };

    $scope.payWithPaypal = function() {
      PaymentsService.chargeWithPaypal({
          pendingFixedChargeId: paymentChoiceConfig.item.pendingFixedChargeId,
          isAutoBump: paymentChoiceConfig.item.isAutoBump
        }).then(function(result) {
          if (result.redirect) {
            $window.location = result.redirect;
          } else if (result.result === false) {
            $scope.step = 'error';
            $scope.errorMessage = result.message;
            $scope.processing = false;
          } else {
            $scope.step = 'paid';
            $scope.processing = false;
          }
        });
    };

    var formatItem = function(originalItem) {
      originalItem = angular.copy(originalItem);
      originalItem.coupon_code = originalItem.couponCode;
      return originalItem;
    };

    var initialOrBillingPage = function () {
      if ($scope.referenceAccount) {
        return 'billingPaymentPage';
      }

      return 'initial';
    };

    $scope.applyCouponCode = function() {
      $scope.processing = true;
      var item = formatItem($scope.item);
      PaymentsService.createPendingFixedCharge(item).then(function(result) {
        $scope.item.fixedChargeItemAmount = result.amount;
        $scope.item.fixedChargeItemName = result.name;
        $scope.item.fixedChargeItemDescription = result.description;
        $scope.item.pendingFixedChargeId = result.pending_txn_id;
        $scope.item.fixedChargeItemType = result.type;
        $scope.processing = false;
        $scope.state.couponApplied = true;
        $scope.step = initialOrBillingPage();
      }, function () {
        $scope.processing = false;
      });
    };

    $scope.validateCode = function () {
      $scope.state.verifyingCode = true;
      Coupon.validate($scope.item.couponCode, $scope.item.fixedChargeItemType).then(function () {
        $scope.state.validCoupon = true;
        $scope.state.verifyingCode = false;
      }, function () {
        $scope.state.validCoupon = false;
        $scope.state.verifyingCode = false;
      });
    };

    $scope.verifyCouponCode = Debounce.do(function() {
      $scope.validateCode();
    }, 300);

    $scope.isCouponButtonDisabled = function() {
      return !$scope.item.couponCode || $scope.state.validCoupon === false || $scope.state.verifyingCode;
    };

    $scope.backToPayment = function() {
      $scope.step = initialOrBillingPage();
    };

    $scope.addNewPaymentMethod = function() {
      $scope.step = 'initial';
    };

    $scope.enterCoupon = function () {
      $scope.step = 'coupon';
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.redirect = function () {
      if (paymentChoiceConfig.redirectUrl) {
        $window.location.href = paymentChoiceConfig.redirectUrl;
      } else {
        $window.location.reload();
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  /**
   * @ngdoc controller
   * @name warriorUtils.PaymentModalCtrl
   *
   * @description
   * An extendable controller for handling payments. TODO BJB replace all other
   * payment modals with deriviates of this controller.
   *
   * extendable functions
   *  $scope.beforePaymentServiceCharge
   *  $scope.paymentSuccess
   */
  .controller('PaymentModalCtrl', ["$scope", "$uibModalInstance", "$rootScope", "$interval", "$window", "PaymentsService", "paymentChoiceConfig", "Analytics", function ($scope, $uibModalInstance, $rootScope, $interval, $window, PaymentsService, paymentChoiceConfig, Analytics) {
    var trackingSectionName = 'wf-paymentpage-grey-modal';

    Analytics.trackEvent(trackingSectionName, undefined, 'load');

    $scope.beforePaymentServiceCharge = function() {

    };

    $scope.step = 'loading';
    $scope.paymentchoice = 'stripe';
    if (angular.isDefined($rootScope.autoload)) {
      $interval.cancel($rootScope.autoload);
    }
    $scope.item = paymentChoiceConfig.item;
    $scope.show = {};
    PaymentsService.createPendingFixedCharge(paymentChoiceConfig.item).then(function(result) {
        $scope.item.fixedChargeItemAmount = result.amount;
        $scope.item.fixedChargeItemName = result.name;
        $scope.item.pendingFixedChargeId = result.pending_txn_id;
        $scope.item.fixedChargeItemType = result.type;

        PaymentsService.getReferenceAccount().then(function(result) {
          $scope.step = 'billingPaymentPage';
          $scope.referenceAccount = result.account;
        }, function() {
          $scope.step = 'initial';
        });
    });

    // todo fix
    // PaymentsService.checkIfAutoBump(paymentChoiceConfig.item.itemId).then(function(result) {
    //   if (result.autobump) {
    //     $scope.item['hasAutoBump'] = true;
    //   }
    // });

    $scope.clickPurchase = function() {
      $scope.processing = true;
    };

    $scope.clearError = function() {
      $scope.stripeError = false;
    };

    $scope.handleStripe = function(status, response) {
      if (status !== 200) {
        Analytics.trackAction(trackingSectionName, 'card_added', 'ERROR');
        $scope.stripeError = response.error.message;
        $scope.processing = false;
      } else {
        var token = response;
        angular.extend(token, paymentChoiceConfig.item);
        Analytics.trackAction(trackingSectionName, 'card_added', 'SUCCESS');

        var chargeInfo = {};
        $scope.beforePaymentServiceCharge(chargeInfo);
        chargeInfo.pendingFixedChargeId = paymentChoiceConfig.item.pendingFixedChargeId;
        chargeInfo.id = token.id;

        PaymentsService.chargeWithStripe(chargeInfo).then(function(result) {
          $scope.processing = false;
          if (result.result) {
            $scope.step = 'paid';
            Analytics.trackAction(trackingSectionName, 'new_stripe_token_paid', 'SUCCESS');

            if ($scope.paymentSuccess) {
              $scope.paymentSuccess(result);
            }
          } else {
            Analytics.trackAction(trackingSectionName, 'new_stripe_token_paid', 'ERROR');
            $scope.step = 'error';
            $scope.errorMessage = result.message;
          }
        });
      }
    };

    $scope.selectPaypal = function() {
      if ($scope.processing) {
        return false;
      }
      $scope.processing = true;
      $scope.payWithPaypal();
      Analytics.trackAction(trackingSectionName, 'select-paypal', 'initial');
    };

    $scope.payWithBillingAgreement = function(item, referenceAccount) {
      $scope.processing = true;
      if (referenceAccount.type === 'Stripe') {
        var chargeInfo = {};
        $scope.beforePaymentServiceCharge(chargeInfo);
        chargeInfo.pendingFixedChargeId = item.pendingFixedChargeId;
        PaymentsService.chargeWithStripe(chargeInfo).then(function(result) {
          $scope.processing = true;
          if (result.result === true ) {
            if ($scope.paymentSuccess) {
              $scope.paymentSuccess(result);
            }
            Analytics.trackAction(trackingSectionName, 'stripe_billing_paid', 'SUCCESS');
            $scope.step = 'paid';
          } else {
            $scope.processing = false;
            Analytics.trackAction(trackingSectionName, 'stripe_billing_paid', 'ERROR');
            $scope.errorMessage = result.message;
            $scope.step = 'error';
          }
        });
      } else if ($scope.referenceAccount.type === 'PayPal') {
        $scope.payWithPaypal();
      } else {
        $scope.step = 'initial';
      }
    };

    $scope.removeStripeBillingAccount = function() {
      $scope.step = 'initial';
      PaymentsService.removeStripeBillingAccount();
    };

    $scope.payWithPaypal = function() {
      var chargeInfo = {};
      $scope.beforePaymentServiceCharge(chargeInfo);
      chargeInfo.pendingFixedChargeId = paymentChoiceConfig.item.pendingFixedChargeId;
      PaymentsService.chargeWithPaypal(chargeInfo).then(function(result) {
          if (result.redirect) {
            $window.location = result.redirect;
          } else if (result.result === false) {
            $scope.step = 'error';
            $scope.errorMessage = result.message;
            $scope.processing = false;
          } else {
            if ($scope.paymentSuccess) {
              $scope.paymentSuccess(result);
            } else {
              $scope.step = 'paid';
              $scope.processing = false;
            }
          }
        });
    };

    $scope.addNewPaymentMethod = function() {
      $scope.step = 'initial';
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.reload = function () {
      $window.location.reload();
    };
  }]);

'use strict';

angular.module('warriorUtils').controller('PostThreadCtrl', ["$scope", "$window", function($scope, $window) {
  $scope.newThreadData = {};
  $scope.newThreadData.securitytoken = $window.SECURITYTOKEN;
  $scope.newThreadData.action = 'create';
  $scope.submitted = false;
  $scope.isSubmitting = false;
  $scope.modalHidden = true;
  $scope.nonFieldError = false;

  var backdropClass = 'Modal-backdrop';
  var backdropString = '<div class=' + backdropClass + '></div>';

  $scope.showPostThreadModal = function() {
    if ($scope.modalHidden) {
      $scope.modalHidden = false;
      angular.element('.PostWidget.Card').append(backdropString);
    }
  };

  $scope.hidePostThreadModal = function() {
    $scope.modalHidden = true;
    angular.element('.PostWidget.Card .' + backdropClass).remove();
  };
}]);

'use strict';

angular.module('warriorUtils')
  .controller('ProfileMenuCtrl', ["$scope", "$window", "LOGOUT_URL", function($scope, $window, LOGOUT_URL) {
    $scope.menuVisible = false;

    var origin = $window.location.origin;
    $scope.logoutUrl = LOGOUT_URL + '&from=logout&redirect_to=' + origin;

    $scope.showMenu = function() {
      $scope.menuVisible = true;
      $scope.$emit('sideBarOpen', $scope.menuVisible);
    };

    $scope.hideMenu = function() {
      $scope.menuVisible = false;
      $scope.$emit('sideBarOpen', $scope.menuVisible);
    };

    $scope.toggleMenu = function () {
      $scope.menuVisible = !$scope.menuVisible;
      $scope.$emit('sideBarOpen', $scope.menuVisible);
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .controller('SignupCtrl', ["$scope", "Signup", function ($scope, Signup) {
    $scope.openSignup = function ($event) {
      if ($event) {
        $event.preventDefault();
      }

      Signup.openSignupModal();
    };

    $scope.doSave = function(value) {
      $scope.name = value;
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .directive('formLocator', function() {
    return {
      link: function(scope) {
        scope.$emit('formLocator', scope);
      }
    };
  });

angular.module('warriorUtils')
  .controller('SignupModalCtrl', ["$scope", "$uibModalInstance", "Forum", "Analytics", "$interval", "$rootScope", "reCAPTCHA", "Login", "options", "$window", "URLGenerator", function ($scope, $uibModalInstance, Forum, Analytics, $interval, $rootScope, reCAPTCHA, Login, options, $window, URLGenerator) {
    Analytics.trackEvent('wf-register-modal', undefined, 'load');
    if (angular.isDefined($rootScope.autoload)) {
      $interval.cancel($rootScope.autoload);
    }

    $scope.$on('formLocator', function(event, scope) {
      $scope.signupform = scope.signupform;
    });

    $scope.step = 'initial';
    $scope.captcha = {};
    $scope.user = {};
    $scope.options = options;
    $scope.options.welcomeMessage = $scope.options.welcomeMessage || 'To continue, sign up to';
    $scope.fbLoginUrl = URLGenerator.fbLoginUrl;
    $scope.googleLoginUrl = URLGenerator.googleLoginUrl;


    if (options.email) {
      $scope.user.email = options.email;
    }

    function createAccount(user) {
      var createAccountSuccess = function(result) {
        Analytics.trackAction('wf-register-modal', 'registered', 'SUCCESS');
        if (result.data.redirect && result.data.redirect_url) {
          $scope.redirectUrl = result.data.redirect_url;
        }
        if (options.redirectImmediately) {
            $window.location.href = $scope.redirectUrl;
        }
        else {
          $scope.step = 'notice';
        }
        $rootScope.$broadcast('user.refreshlogin');
        delete $scope.captcha.$error;
      };

      var createAccountError = function(result) {
        Analytics.trackAction('wf-register-modal', 'registered', 'ERROR');
        var parameter, error;
        if (result.code) {
          var matches = result.code.match(/(.*?)[\._](.*)/);
          if (matches) {
            parameter = matches[1].toLowerCase();
            error = matches[2].toLowerCase();
          }
        }

        if (parameter === 'captcha') {
          if (error === 'incorrect') {
            reCAPTCHA.reload();
            $scope.step = 'captcha';
            $scope.captcha.$error = {'incorrect':true};
          } else if (error === 'missing') {
            $scope.step = 'captcha';
          }
        } else {
          if (parameter === 'password' && error === 'not_matched') {
            parameter = 'confirmPassword';
            error = 'repeat';
          }

          if ($scope.signupform[parameter]) {
            if (error === 'missing') {
              error = 'required';
            }

            if (error === 'taken') {
              error = 'used';
            }

            $scope.signupform[parameter].$setValidity(error, false);
          }

          $scope.step = 'initial';
        }
      };

      if (!options.passwordConfirm) {
        user.confirmPassword = user.password;
      }
      Forum.createAccount(user).then(createAccountSuccess, createAccountError);
    }

    $scope.signupErrorMessage = function(signupform) {
      if (signupform.$valid) {
        return '';
      }

      var errs = [];
      if (signupform.username.$invalid) {
        errs.push('username');
      }

      if (signupform.email.$invalid) {
        errs.push('email');
      }

      if (signupform.password.$invalid) {
        errs.push('password');
      }

      if (signupform.$error.recaptcha !== undefined) {
        errs.push('captcha');
      }

      var brokenElements = '';
      if (errs.length === 1) {
        brokenElements = errs[0];
      } else {
        for (var i = 0; i < errs.length; i++) {
          brokenElements+=(errs[i]);

          if ((errs.length - i) === 2) {
            brokenElements+=(' and ');
          }

          if ((errs.length - i) > 2){
            brokenElements+=(', ');
          }
        }
      }

      var errorMessage = 'Please fix your ' + brokenElements + '.';
      return errorMessage;
    };

    $scope.submit = function (user) {
      if ($scope.step === 'initial') {
        createAccount(user);
      } else if ($scope.step === 'captcha') {
        createAccount(user);
      } else { // notice
        $uibModalInstance.close();
      }
    };

    $scope.login = function(options) {
      if(options.welcomeMessage && options.welcomeMessage.startsWith('To continue')){
        options.welcomeMessage = 'To continue, log in to';
      }
      Login.openLoginModal(options);
      $uibModalInstance.close();
    };

    $scope.ok = function () {
      if ($scope.redirectUrl) {
        $window.location.href = $scope.redirectUrl;
      } else {
        $rootScope.$broadcast('user.refreshlogin.ok');
      }
      $uibModalInstance.close();
    };

    $scope.cancel = function () {
      if ($scope.step === 'notice') {
        $scope.ok();
      } else {
        $uibModalInstance.dismiss('cancel');
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .controller('UserMenuCtrl', ["$scope", "Signup", "Login", function ($scope, Signup, Login) {
    var options = {
      welcomeMessage: 'Welcome to'
    };

    $scope.login = function () {
      Login.openLoginModal(options);
    };
    $scope.signup = function () {
      Signup.openSignupModal(options);
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .controller('UserTasksCtrl', ["UserTaskList", "$scope", "$window", function (UserTaskList, $scope, $window) {
    var cta_text = {
      'resendEmail': 'Resend Activation Email',
      'openPostThreadModal': 'Ask Now!',
      'browseMarketplace': 'Browse Marketplace'
    };

    $scope.state = {};
    $scope.state.show = false;
    $scope.state.show_cta = false;
    $scope.state.show_skip_link = false;

    var show = function($show) {
      $scope.state.show = $show;
    };

    var showSkipLink = function($show_skip_link) {
      $scope.state.show_skip_link = $show_skip_link;
    };

    var setCta = function(current_task) {
      if (current_task && current_task.task.cta) {
        $scope.cta_text = cta_text[current_task.task.cta];
        $scope.state.show_cta = true;
      } else {
        $scope.state.show_cta = false;
      }
    };

    $scope.getNextTask = function() {
      $scope.current_task = $scope.user_task_list.getNextTask();
      setCta($scope.current_task);
    };

    $scope.executeCTA = function(task) {
      if (task === 'resendEmail') {
        $window.location = '/register.php?do=requestemail';
      } else if (task === 'openPostThreadModal') {
        $scope.$emit('feed.openPostThreadModal');
      } else if (task === 'browseMarketplace') {
        $window.location = '/warrior-special-offers';
      }

    };

    $scope.init = function(taskGroupId) {
      UserTaskList.create(taskGroupId).then(function(user_task_list){
        $scope.user_task_list = user_task_list;
        $scope.current_task = $scope.user_task_list.getCurrentTask();
        $scope.percent_complete = $scope.user_task_list.getCompletedPercentage();
        show($scope.percent_complete < 100);
        showSkipLink($scope.user_task_list.getRemainingTaskCount() > 1);
        setCta($scope.current_task);

      });
    };

  }]);
'use strict';

angular.module('warriorUtils')
  .controller('WarroomSignupLoginCtrl', ["$scope", "$uibModal", "Forum", "Auth", "$window", "$rootScope", "BASE_URL", "Users", function ($scope, $uibModal, Forum, Auth, $window, $rootScope, BASE_URL, Users) {
    function notifyAuthenticated() {
      $scope.$emit('Authenticated');
    }

    var ModalInstanceCtrl = ['$scope', '$window', 'BASE_URL', '$uibModalInstance', function ($scope, $window, BASE_URL, $uibModalInstance) {
      $scope.$on('formLocator', function(event, scope) {
        $scope.loginform = scope.loginform;
        $scope.signupform = scope.signupform;
      });

      $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
      };

      $scope.choice = 'signup';
      $scope.createAccountSubmit = function(user) {
        var createAccountSuccess = function() {
          notifyAuthenticated();
          $rootScope.$broadcast('user.refreshlogin');
          $scope.processing = false;
        };

        var createAccountError = function(result) {
          $scope.processing = false;
          var parameter, error;
          if (result.code) {
            var matches = result.code.match(/(.*)\.(.*)/);
            if (matches) {
              parameter = matches[1].toLowerCase();
              error = matches[2].toLowerCase();
            }
          }

          if (parameter === 'password' && error === 'not_matched') {
            parameter = 'confirmPassword';
            error = 'repeat';
          }

          if ($scope.signupform[parameter]) {
            if (error === 'missing') {
              error = 'required';
            }
            $scope.signupform[parameter].$setValidity(error, false);
          }
        };
        $scope.processing = true;
        Forum.createAccount(user).then(createAccountSuccess, createAccountError);
      };

      $scope.loginSubmit = function(user) {
        var loginSuccess = function() {
          notifyAuthenticated();
          $scope.processing = false;
        };

        var loginError = function(result) {
          var parameter, error;
          if (result.code) {
            var matches = result.code.match(/(.*)\.(.*)/);
            if (matches) {
              parameter = matches[1].toLowerCase();
              error = matches[2].toLowerCase();
            }
          } else {
            $scope.unknown_error = true;
          }

          if ($scope.loginform[parameter]) {
            if (error === 'missing') {
              error = 'required';
            }

            $scope.loginform[parameter].$setValidity(error, false);
          } else {
            $scope.login_error = error;
          }
          $scope.processing = false;
        };
        $scope.processing = true;
        Forum.login(user).then(loginSuccess, loginError);
      };
    }];

    $scope.openPurchaseModal = function() {
      $scope.loading = true;
      var loggedIn = function() {
        notifyAuthenticated();
        $scope.loading = false;
      };

      var notLoggedIn = function() {
        $scope.loading = false;
        $uibModal.open({
          windowClass: 'default-modal',
          templateUrl: '/views/warrior/warroomsignuplogin.html',
          controller: ModalInstanceCtrl,
          backdrop: 'static',
          size: 'lg'
        });
      };
      Users.get().then(loggedIn, notLoggedIn);
    };
  }]);

angular.module('warriorUtils')
  .directive('wfWarroomSignupLogin', ["URLGenerator", "wfWindowLocation", "ConfirmationModal", "Users", function(URLGenerator, wfWindowLocation, ConfirmationModal, Users) {
    return {
      scope: {
        'membershipTypeId': '@',
        'freeTrialMembershipTypeId': '@',
      },
      controller: 'WarroomSignupLoginCtrl',
      link: function(scope, element) {
        var getMembershipSignupUrl = function() {
          if (scope.membershipTypeId) {
            return URLGenerator.getPageUrl('membership/signup/' + scope.membershipTypeId);
          }

          if (scope.freeTrialMembershipTypeId) {
            return URLGenerator.getPageUrl('membership/freetrial/' + scope.freeTrialMembershipTypeId);
          }

          // 12 months War Room at $97/year
          return URLGenerator.getPageUrl('membership/signup/1');
        };

        scope.$on('Authenticated', function() {
          wfWindowLocation.redirect(getMembershipSignupUrl());
        });

        element.click(function() {
          var modalOptions = {
            positiveCTA: 'Confirm',
            negativeCTA: 'Cancel',
            content: 'War Room Membership $97 USD / Year',
            modalTitle: 'Confirm Payment',
          };

          var loggedIn = function(){
            ConfirmationModal.open(modalOptions).then(function(item){
              if(item === modalOptions.positiveCTA){
                scope.openPurchaseModal();
              }
            });
          };

          var notLoggedIn = function(){
            scope.openPurchaseModal();
          };

          Users.get().then(loggedIn, notLoggedIn);
        });
      }
    };
  }]);

/* jshint -W100 */

var app = angular.module('warriorUtils');

app.constant('COUNTRIES', [{
    'name': 'Afghanistan (‫افغانستان‬‎)',
    'code': 'af',
    'numCode': '93'
}, {
    'name': 'Albania (Shqipëri)',
    'code': 'al',
    'numCode': '355'
}, {
    'name': 'Algeria (‫الجزائر‬‎)',
    'code': 'dz',
    'numCode': '213'
}, {
    'name': 'American Samoa',
    'code': 'as',
    'numCode': '1684'
}, {
    'name': 'Andorra',
    'code': 'ad',
    'numCode': '376'
}, {
    'name': 'Angola',
    'code': 'ao',
    'numCode': '244'
}, {
    'name': 'Anguilla',
    'code': 'ai',
    'numCode': '1264'
}, {
    'name': 'Antigua and Barbuda',
    'code': 'ag',
    'numCode': '1268'
}, {
    'name': 'Argentina',
    'code': 'ar',
    'numCode': '54'
}, {
    'name': 'Armenia (Հայաստան)',
    'code': 'am',
    'numCode': '374'
}, {
    'name': 'Aruba',
    'code': 'aw',
    'numCode': '297'
}, {
    'name': 'Australia',
    'code': 'au',
    'numCode': '61'
}, {
    'name': 'Austria (Österreich)',
    'code': 'at',
    'numCode': '43'
}, {
    'name': 'Azerbaijan (Azərbaycan)',
    'code': 'az',
    'numCode': '994'
}, {
    'name': 'Bahamas',
    'code': 'bs',
    'numCode': '1242'
}, {
    'name': 'Bahrain (‫البحرين‬‎)',
    'code': 'bh',
    'numCode': '973'
}, {
    'name': 'Bangladesh (বাংলাদেশ)',
    'code': 'bd',
    'numCode': '880'
}, {
    'name': 'Barbados',
    'code': 'bb',
    'numCode': '1246'
}, {
    'name': 'Belarus (Беларусь)',
    'code': 'by',
    'numCode': '375'
}, {
    'name': 'Belgium (België)',
    'code': 'be',
    'numCode': '32'
}, {
    'name': 'Belize',
    'code': 'bz',
    'numCode': '501'
}, {
    'name': 'Benin (Bénin)',
    'code': 'bj',
    'numCode': '229'
}, {
    'name': 'Bermuda',
    'code': 'bm',
    'numCode': '1441'
}, {
    'name': 'Bhutan (འབྲུག)',
    'code': 'bt',
    'numCode': '975'
}, {
    'name': 'Bolivia',
    'code': 'bo',
    'numCode': '591'
}, {
    'name': 'Bosnia and Herzegovina (Босна и Херцеговина)',
    'code': 'ba',
    'numCode': '387'
}, {
    'name': 'Botswana',
    'code': 'bw',
    'numCode': '267'
}, {
    'name': 'Brazil (Brasil)',
    'code': 'br',
    'numCode': '55'
}, {
    'name': 'British Indian Ocean Territory',
    'code': 'io',
    'numCode': '246'
}, {
    'name': 'British Virgin Islands',
    'code': 'vg',
    'numCode': '1284'
}, {
    'name': 'Brunei',
    'code': 'bn',
    'numCode': '673'
}, {
    'name': 'Bulgaria (България)',
    'code': 'bg',
    'numCode': '359'
}, {
    'name': 'Burkina Faso',
    'code': 'bf',
    'numCode': '226'
}, {
    'name': 'Burundi (Uburundi)',
    'code': 'bi',
    'numCode': '257'
}, {
    'name': 'Cambodia (កម្ពុជា)',
    'code': 'kh',
    'numCode': '855'
}, {
    'name': 'Cameroon (Cameroun)',
    'code': 'cm',
    'numCode': '237'
}, {
    'name': 'Canada',
    'code': 'ca',
    'numCode': '1'
}, {
    'name': 'Cape Verde (Kabu Verdi)',
    'code': 'cv',
    'numCode': '238'
}, {
    'name': 'Caribbean Netherlands',
    'code': 'bq',
    'numCode': '599'
}, {
    'name': 'Cayman Islands',
    'code': 'ky',
    'numCode': '1345'
}, {
    'name': 'Central African Republic (République centrafricaine)',
    'code': 'cf',
    'numCode': '236'
}, {
    'name': 'Chad (Tchad)',
    'code': 'td',
    'numCode': '235'
}, {
    'name': 'Chile',
    'code': 'cl',
    'numCode': '56'
}, {
    'name': 'China (中国)',
    'code': 'cn',
    'numCode': '86'
}, {
    'name': 'Colombia',
    'code': 'co',
    'numCode': '57'
}, {
    'name': 'Comoros (‫جزر القمر‬‎)',
    'code': 'km',
    'numCode': '269'
}, {
    'name': 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
    'code': 'cd',
    'numCode': '243'
}, {
    'name': 'Congo (Republic) (Congo-Brazzaville)',
    'code': 'cg',
    'numCode': '242'
}, {
    'name': 'Cook Islands',
    'code': 'ck',
    'numCode': '682'
}, {
    'name': 'Costa Rica',
    'code': 'cr',
    'numCode': '506'
}, {
    'name': 'Côte d’Ivoire',
    'code': 'ci',
    'numCode': '225'
}, {
    'name': 'Croatia (Hrvatska)',
    'code': 'hr',
    'numCode': '385'
}, {
    'name': 'Cuba',
    'code': 'cu',
    'numCode': '53'
}, {
    'name': 'Curaçao',
    'code': 'cw',
    'numCode': '599'
}, {
    'name': 'Cyprus (Κύπρος)',
    'code': 'cy',
    'numCode': '357'
}, {
    'name': 'Czech Republic (Česká republika)',
    'code': 'cz',
    'numCode': '420'
}, {
    'name': 'Denmark (Danmark)',
    'code': 'dk',
    'numCode': '45'
}, {
    'name': 'Djibouti',
    'code': 'dj',
    'numCode': '253'
}, {
    'name': 'Dominica',
    'code': 'dm',
    'numCode': '1767'
}, {
    'name': 'Dominican Republic (República Dominicana)',
    'code': 'do',
    'numCode': '1'
}, {
    'name': 'Ecuador',
    'code': 'ec',
    'numCode': '593'
}, {
    'name': 'Egypt (‫مصر‬‎)',
    'code': 'eg',
    'numCode': '20'
}, {
    'name': 'El Salvador',
    'code': 'sv',
    'numCode': '503'
}, {
    'name': 'Equatorial Guinea (Guinea Ecuatorial)',
    'code': 'gq',
    'numCode': '240'
}, {
    'name': 'Eritrea',
    'code': 'er',
    'numCode': '291'
}, {
    'name': 'Estonia (Eesti)',
    'code': 'ee',
    'numCode': '372'
}, {
    'name': 'Ethiopia',
    'code': 'et',
    'numCode': '251'
}, {
    'name': 'Falkland Islands (Islas Malvinas)',
    'code': 'fk',
    'numCode': '500'
}, {
    'name': 'Faroe Islands (Føroyar)',
    'code': 'fo',
    'numCode': '298'
}, {
    'name': 'Fiji',
    'code': 'fj',
    'numCode': '679'
}, {
    'name': 'Finland (Suomi)',
    'code': 'fi',
    'numCode': '358'
}, {
    'name': 'France',
    'code': 'fr',
    'numCode': '33'
}, {
    'name': 'French Guiana (Guyane française)',
    'code': 'gf',
    'numCode': '594'
}, {
    'name': 'French Polynesia (Polynésie française)',
    'code': 'pf',
    'numCode': '689'
}, {
    'name': 'Gabon',
    'code': 'ga',
    'numCode': '241'
}, {
    'name': 'Gambia',
    'code': 'gm',
    'numCode': '220'
}, {
    'name': 'Georgia (საქართველო)',
    'code': 'ge',
    'numCode': '995'
}, {
    'name': 'Germany (Deutschland)',
    'code': 'de',
    'numCode': '49'
}, {
    'name': 'Ghana (Gaana)',
    'code': 'gh',
    'numCode': '233'
}, {
    'name': 'Gibraltar',
    'code': 'gi',
    'numCode': '350'
}, {
    'name': 'Greece (Ελλάδα)',
    'code': 'gr',
    'numCode': '30'
}, {
    'name': 'Greenland (Kalaallit Nunaat)',
    'code': 'gl',
    'numCode': '299'
}, {
    'name': 'Grenada',
    'code': 'gd',
    'numCode': '1473'
}, {
    'name': 'Guadeloupe',
    'code': 'gp',
    'numCode': '590'
}, {
    'name': 'Guam',
    'code': 'gu',
    'numCode': '1671'
}, {
    'name': 'Guatemala',
    'code': 'gt',
    'numCode': '502'
}, {
    'name': 'Guinea (Guinée)',
    'code': 'gn',
    'numCode': '224'
}, {
    'name': 'Guinea-Bissau (Guiné Bissau)',
    'code': 'gw',
    'numCode': '245'
}, {
    'name': 'Guyana',
    'code': 'gy',
    'numCode': '592'
}, {
    'name': 'Haiti',
    'code': 'ht',
    'numCode': '509'
}, {
    'name': 'Honduras',
    'code': 'hn',
    'numCode': '504'
}, {
    'name': 'Hong Kong (香港)',
    'code': 'hk',
    'numCode': '852'
}, {
    'name': 'Hungary (Magyarország)',
    'code': 'hu',
    'numCode': '36'
}, {
    'name': 'Iceland (Ísland)',
    'code': 'is',
    'numCode': '354'
}, {
    'name': 'India (भारत)',
    'code': 'in',
    'numCode': '91'
}, {
    'name': 'Indonesia',
    'code': 'id',
    'numCode': '62'
}, {
    'name': 'Iran (‫ایران‬‎)',
    'code': 'ir',
    'numCode': '98'
}, {
    'name': 'Iraq (‫العراق‬‎)',
    'code': 'iq',
    'numCode': '964'
}, {
    'name': 'Ireland',
    'code': 'ie',
    'numCode': '353'
}, {
    'name': 'Israel (‫ישראל‬‎)',
    'code': 'il',
    'numCode': '972'
}, {
    'name': 'Italy (Italia)',
    'code': 'it',
    'numCode': '39'
}, {
    'name': 'Jamaica',
    'code': 'jm',
    'numCode': '1876'
}, {
    'name': 'Japan (日本)',
    'code': 'jp',
    'numCode': '81'
}, {
    'name': 'Jordan (‫الأردن‬‎)',
    'code': 'jo',
    'numCode': '962'
}, {
    'name': 'Kazakhstan (Казахстан)',
    'code': 'kz',
    'numCode': '7'
}, {
    'name': 'Kenya',
    'code': 'ke',
    'numCode': '254'
}, {
    'name': 'Kiribati',
    'code': 'ki',
    'numCode': '686'
}, {
    'name': 'Kuwait (‫الكويت‬‎)',
    'code': 'kw',
    'numCode': '965'
}, {
    'name': 'Kyrgyzstan (Кыргызстан)',
    'code': 'kg',
    'numCode': '996'
}, {
    'name': 'Laos (ລາວ)',
    'code': 'la',
    'numCode': '856'
}, {
    'name': 'Latvia (Latvija)',
    'code': 'lv',
    'numCode': '371'
}, {
    'name': 'Lebanon (‫لبنان‬‎)',
    'code': 'lb',
    'numCode': '961'
}, {
    'name': 'Lesotho',
    'code': 'ls',
    'numCode': '266'
}, {
    'name': 'Liberia',
    'code': 'lr',
    'numCode': '231'
}, {
    'name': 'Libya (‫ليبيا‬‎)',
    'code': 'ly',
    'numCode': '218'
}, {
    'name': 'Liechtenstein',
    'code': 'li',
    'numCode': '423'
}, {
    'name': 'Lithuania (Lietuva)',
    'code': 'lt',
    'numCode': '370'
}, {
    'name': 'Luxembourg',
    'code': 'lu',
    'numCode': '352'
}, {
    'name': 'Macau (澳門)',
    'code': 'mo',
    'numCode': '853'
}, {
    'name': 'Macedonia (FYROM) (Македонија)',
    'code': 'mk',
    'numCode': '389'
}, {
    'name': 'Madagascar (Madagasikara)',
    'code': 'mg',
    'numCode': '261'
}, {
    'name': 'Malawi',
    'code': 'mw',
    'numCode': '265'
}, {
    'name': 'Malaysia',
    'code': 'my',
    'numCode': '60'
}, {
    'name': 'Maldives',
    'code': 'mv',
    'numCode': '960'
}, {
    'name': 'Mali',
    'code': 'ml',
    'numCode': '223'
}, {
    'name': 'Malta',
    'code': 'mt',
    'numCode': '356'
}, {
    'name': 'Marshall Islands',
    'code': 'mh',
    'numCode': '692'
}, {
    'name': 'Martinique',
    'code': 'mq',
    'numCode': '596'
}, {
    'name': 'Mauritania (‫موريتانيا‬‎)',
    'code': 'mr',
    'numCode': '222'
}, {
    'name': 'Mauritius (Moris)',
    'code': 'mu',
    'numCode': '230'
}, {
    'name': 'Mexico (México)',
    'code': 'mx',
    'numCode': '52'
}, {
    'name': 'Micronesia',
    'code': 'fm',
    'numCode': '691'
}, {
    'name': 'Moldova (Republica Moldova)',
    'code': 'md',
    'numCode': '373'
}, {
    'name': 'Monaco',
    'code': 'mc',
    'numCode': '377'
}, {
    'name': 'Mongolia (Монгол)',
    'code': 'mn',
    'numCode': '976'
}, {
    'name': 'Montenegro (Crna Gora)',
    'code': 'me',
    'numCode': '382'
}, {
    'name': 'Montserrat',
    'code': 'ms',
    'numCode': '1664'
}, {
    'name': 'Morocco (‫المغرب‬‎)',
    'code': 'ma',
    'numCode': '212'
}, {
    'name': 'Mozambique (Moçambique)',
    'code': 'mz',
    'numCode': '258'
}, {
    'name': 'Myanmar (Burma) (မြန်မာ)',
    'code': 'mm',
    'numCode': '95'
}, {
    'name': 'Namibia (Namibië)',
    'code': 'na',
    'numCode': '264'
}, {
    'name': 'Nauru',
    'code': 'nr',
    'numCode': '674'
}, {
    'name': 'Nepal (नेपाल)',
    'code': 'np',
    'numCode': '977'
}, {
    'name': 'Netherlands (Nederland)',
    'code': 'nl',
    'numCode': '31'
}, {
    'name': 'New Caledonia (Nouvelle-Calédonie)',
    'code': 'nc',
    'numCode': '687'
}, {
    'name': 'New Zealand',
    'code': 'nz',
    'numCode': '64'
}, {
    'name': 'Nicaragua',
    'code': 'ni',
    'numCode': '505'
}, {
    'name': 'Niger (Nijar)',
    'code': 'ne',
    'numCode': '227'
}, {
    'name': 'Nigeria',
    'code': 'ng',
    'numCode': '234'
}, {
    'name': 'Niue',
    'code': 'nu',
    'numCode': '683'
}, {
    'name': 'Norfolk Island',
    'code': 'nf',
    'numCode': '672'
}, {
    'name': 'North Korea (조선 민주주의 인민 공화국)',
    'code': 'kp',
    'numCode': '850'
}, {
    'name': 'Northern Mariana Islands',
    'code': 'mp',
    'numCode': '1670'
}, {
    'name': 'Norway (Norge)',
    'code': 'no',
    'numCode': '47'
}, {
    'name': 'Oman (‫عُمان‬‎)',
    'code': 'om',
    'numCode': '968'
}, {
    'name': 'Pakistan (‫پاکستان‬‎)',
    'code': 'pk',
    'numCode': '92'
}, {
    'name': 'Palau',
    'code': 'pw',
    'numCode': '680'
}, {
    'name': 'Palestine (‫فلسطين‬‎)',
    'code': 'ps',
    'numCode': '970'
}, {
    'name': 'Panama (Panamá)',
    'code': 'pa',
    'numCode': '507'
}, {
    'name': 'Papua New Guinea',
    'code': 'pg',
    'numCode': '675'
}, {
    'name': 'Paraguay',
    'code': 'py',
    'numCode': '595'
}, {
    'name': 'Peru (Perú)',
    'code': 'pe',
    'numCode': '51'
}, {
    'name': 'Philippines',
    'code': 'ph',
    'numCode': '63'
}, {
    'name': 'Poland (Polska)',
    'code': 'pl',
    'numCode': '48'
}, {
    'name': 'Portugal',
    'code': 'pt',
    'numCode': '351'
}, {
    'name': 'Puerto Rico',
    'code': 'pr',
    'numCode': '1'
}, {
    'name': 'Qatar (‫قطر‬‎)',
    'code': 'qa',
    'numCode': '974'
}, {
    'name': 'Réunion (La Réunion)',
    'code': 're',
    'numCode': '262'
}, {
    'name': 'Romania (România)',
    'code': 'ro',
    'numCode': '40'
}, {
    'name': 'Russia (Россия)',
    'code': 'ru',
    'numCode': '7'
}, {
    'name': 'Rwanda',
    'code': 'rw',
    'numCode': '250'
}, {
    'name': 'Saint Barthélemy (Saint-Barthélemy)',
    'code': 'bl',
    'numCode': '590'
}, {
    'name': 'Saint Helena',
    'code': 'sh',
    'numCode': '290'
}, {
    'name': 'Saint Kitts and Nevis',
    'code': 'kn',
    'numCode': '1869'
}, {
    'name': 'Saint Lucia',
    'code': 'lc',
    'numCode': '1758'
}, {
    'name': 'Saint Martin (Saint-Martin (partie française))',
    'code': 'mf',
    'numCode': '590'
}, {
    'name': 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
    'code': 'pm',
    'numCode': '508'
}, {
    'name': 'Saint Vincent and the Grenadines',
    'code': 'vc',
    'numCode': '1784'
}, {
    'name': 'Samoa',
    'code': 'ws',
    'numCode': '685'
}, {
    'name': 'San Marino',
    'code': 'sm',
    'numCode': '378'
}, {
    'name': 'São Tomé and Príncipe (São Tomé e Príncipe)',
    'code': 'st',
    'numCode': '239'
}, {
    'name': 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
    'code': 'sa',
    'numCode': '966'
}, {
    'name': 'Senegal (Sénégal)',
    'code': 'sn',
    'numCode': '221'
}, {
    'name': 'Serbia (Србија)',
    'code': 'rs',
    'numCode': '381'
}, {
    'name': 'Seychelles',
    'code': 'sc',
    'numCode': '248'
}, {
    'name': 'Sierra Leone',
    'code': 'sl',
    'numCode': '232'
}, {
    'name': 'Singapore',
    'code': 'sg',
    'numCode': '65'
}, {
    'name': 'Sint Maarten',
    'code': 'sx',
    'numCode': '1721'
}, {
    'name': 'Slovakia (Slovensko)',
    'code': 'sk',
    'numCode': '421'
}, {
    'name': 'Slovenia (Slovenija)',
    'code': 'si',
    'numCode': '386'
}, {
    'name': 'Solomon Islands',
    'code': 'sb',
    'numCode': '677'
}, {
    'name': 'Somalia (Soomaaliya)',
    'code': 'so',
    'numCode': '252'
}, {
    'name': 'South Africa',
    'code': 'za',
    'numCode': '27'
}, {
    'name': 'South Korea (대한민국)',
    'code': 'kr',
    'numCode': '82'
}, {
    'name': 'South Sudan (‫جنوب السودان‬‎)',
    'code': 'ss',
    'numCode': '211'
}, {
    'name': 'Spain (España)',
    'code': 'es',
    'numCode': '34'
}, {
    'name': 'Sri Lanka (ශ්‍රී ලංකාව)',
    'code': 'lk',
    'numCode': '94'
}, {
    'name': 'Sudan (‫السودان‬‎)',
    'code': 'sd',
    'numCode': '249'
}, {
    'name': 'Suriname',
    'code': 'sr',
    'numCode': '597'
}, {
    'name': 'Swaziland',
    'code': 'sz',
    'numCode': '268'
}, {
    'name': 'Sweden (Sverige)',
    'code': 'se',
    'numCode': '46'
}, {
    'name': 'Switzerland (Schweiz)',
    'code': 'ch',
    'numCode': '41'
}, {
    'name': 'Syria (‫سوريا‬‎)',
    'code': 'sy',
    'numCode': '963'
}, {
    'name': 'Taiwan (台灣)',
    'code': 'tw',
    'numCode': '886'
}, {
    'name': 'Tajikistan',
    'code': 'tj',
    'numCode': '992'
}, {
    'name': 'Tanzania',
    'code': 'tz',
    'numCode': '255'
}, {
    'name': 'Thailand (ไทย)',
    'code': 'th',
    'numCode': '66'
}, {
    'name': 'Timor-Leste',
    'code': 'tl',
    'numCode': '670'
}, {
    'name': 'Togo',
    'code': 'tg',
    'numCode': '228'
}, {
    'name': 'Tokelau',
    'code': 'tk',
    'numCode': '690'
}, {
    'name': 'Tonga',
    'code': 'to',
    'numCode': '676'
}, {
    'name': 'Trinidad and Tobago',
    'code': 'tt',
    'numCode': '1868'
}, {
    'name': 'Tunisia (‫تونس‬‎)',
    'code': 'tn',
    'numCode': '216'
}, {
    'name': 'Turkey (Türkiye)',
    'code': 'tr',
    'numCode': '90'
}, {
    'name': 'Turkmenistan',
    'code': 'tm',
    'numCode': '993'
}, {
    'name': 'Turks and Caicos Islands',
    'code': 'tc',
    'numCode': '1649'
}, {
    'name': 'Tuvalu',
    'code': 'tv',
    'numCode': '688'
}, {
    'name': 'U.S. Virgin Islands',
    'code': 'vi',
    'numCode': '1340'
}, {
    'name': 'Uganda',
    'code': 'ug',
    'numCode': '256'
}, {
    'name': 'Ukraine (Україна)',
    'code': 'ua',
    'numCode': '380'
}, {
    'name': 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
    'code': 'ae',
    'numCode': '971'
}, {
    'name': 'United Kingdom',
    'code': 'gb',
    'numCode': '44'
}, {
    'name': 'United States',
    'code': 'us',
    'numCode': '1'
}, {
    'name': 'Uruguay',
    'code': 'uy',
    'numCode': '598'
}, {
    'name': 'Uzbekistan (Oʻzbekiston)',
    'code': 'uz',
    'numCode': '998'
}, {
    'name': 'Vanuatu',
    'code': 'vu',
    'numCode': '678'
}, {
    'name': 'Vatican City (Città del Vaticano)',
    'code': 'va',
    'numCode': '39'
}, {
    'name': 'Venezuela',
    'code': 've',
    'numCode': '58'
}, {
    'name': 'Vietnam (Việt Nam)',
    'code': 'vn',
    'numCode': '84'
}, {
    'name': 'Wallis and Futuna',
    'code': 'wf',
    'numCode': '681'
}, {
    'name': 'Yemen (‫اليمن‬‎)',
    'code': 'ye',
    'numCode': '967'
}, {
    'name': 'Zambia',
    'code': 'zm',
    'numCode': '260'
}, {
    'name': 'Zimbabwe',
    'code': 'zw',
    'numCode': '263'
}]);


'use strict';

angular.module('warriorUtils')

.controller('FunnelController', ["$scope", "$uibModal", function($scope, $uibModal) {
  $scope.selectUpsell = function(node) {
    $scope.$emit('selected', node);
  };
  $scope.selectFrontend = function(node) {
    $scope.$emit('selected_frontend', node);
  };
  $scope.addUpsell = function(parent) {
    parent.upsell = {'type': 'an Upsell', 'parent': parent, 'position': 1};
    $scope.$emit('selected', parent.upsell);
  };
  $scope.edit = function(node) {
    $scope.$emit('edit', node);
  };

  $scope.deleteUpsell = function($event, parent) {
    $event.stopPropagation();
    var modalInstance = $uibModal.open({
      templateUrl: '/views/wsomanager/template/funnel/funnel-branch-delete.html',
      controller: 'FunnelModalController',
      resolve: {
        type: function () {
          return parent.upsell.type_name;
        }
      }
    });

    modalInstance.result.then(function () {
      var upsell = parent.upsell;
      delete parent.upsell;
      $scope.$emit('selected', false);
      $scope.$emit('deleted', upsell);
    });
  };
}])


.controller('FunnelBranchController', ["$scope", "$uibModal", function($scope, $uibModal) {
  $scope.select = function(node) {
    $scope.$emit('selected', node);
  };

  $scope.edit = function(node) {
    $scope.$emit('edit', node);
  };

  $scope.addUpsell = function(parent) {
    parent.upsell = {'type': 'an Upsell', 'type_name': 'Upsell', 'parent': parent};
    $scope.$emit('selected', parent.upsell);
  };

  $scope.addDownsell = function(parent) {
    parent.downsell = {'type': 'a Downsell', 'type_name': 'Downsell', 'parent': parent};
    $scope.$emit('selected', parent.downsell);
  };

  $scope.deleteDownsell = function($event, parent) {
    $event.stopPropagation();
    var modalInstance = $uibModal.open({
      templateUrl: '/views/wsomanager/template/funnel/funnel-branch-delete.html',
      controller: 'FunnelModalController',
      resolve: {
        type: function () {
          return parent.downsell.type_name;
        }
      }
    });

    modalInstance.result.then(function () {
      var downsell = parent.downsell;
      delete parent.downsell;
      $scope.$emit('selected', false);
      $scope.$emit('deleted', downsell);
    });
  };

  $scope.deleteUpsell = function($event, parent) {
    $event.stopPropagation();
    var modalInstance = $uibModal.open({
      templateUrl: '/views/wsomanager/template/funnel/funnel-branch-delete.html',
      controller: 'FunnelModalController',
      resolve: {
        type: function () {
          return parent.upsell.type_name;
        }
      }
    });

    modalInstance.result.then(function () {
      var upsell = parent.upsell;
      delete parent.upsell;
      $scope.$emit('selected', false);
      $scope.$emit('deleted', upsell);
    });
  };
}])

.controller('FunnelModalController', ["$scope", "$uibModalInstance", "type", function($scope, $uibModalInstance, type) {
  $scope.type = type;
  $scope.ok = function () {
    $uibModalInstance.close('ok');
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}])

.directive('funnel', function() {
  return {
    restrict: 'E',
    scope: {
      ngModel: '=',
      editable: '@',
      ngSelected: '='
    },
    require: ['funnel', '?ngModel', '?ngSelected'],
    controller: 'FunnelController',
    templateUrl: '/views/wsomanager/template/funnel/funnel.html',
    replace: true,
    link: function(scope, element, attrs, ctrls) {
      var ngModelCtrl = ctrls[0];

      if (!ngModelCtrl) {
        return; // do nothing if no ng-model
      }

    }
  };
})

.directive('funnelBranch', ["RecursionHelper", function(RecursionHelper) {
  return {
    restrict: 'E',
    scope: {
      ngModel: '=',
      editable: '=',
      ngSelected: '='
    },
    require: ['funnelBranch', '?ngModel', '?ngSelected'],
    controller: 'FunnelBranchController',
    templateUrl: '/views/wsomanager/template/funnel/funnel-branch.html',
    replace: true,
    compile: function(element) {
      return RecursionHelper.compile(element, function(){
          // Define your normal link function here.
          // Alternative: instead of passing a function,
          // you can also pass an object with
          // a 'pre'- and 'post'-link function.

      });
    }
  };
}]);

'use strict';

angular.module('warriorUtils')
  .directive('wfLogin', ["Login", function (Login) {
    return {
      scope: {
        welcomeMessage: '@'
      },
      link: function (scope, element) {
        element.click(function (event) {
          event.preventDefault();

          Login.openLoginModal({
            welcomeMessage: scope.welcomeMessage
          });
        });
      }
    };
  }]);

'use strict';

// just like ng-class but allows definition of a wf-parent-class-selector of 
// where to apply the classes
function parentClassDirective() {
  function shallowCopy(src, dst) {
    if (angular.isArray(src)) {
      dst = dst || [];

      for (var i = 0, ii = src.length; i < ii; i++) {
        dst[i] = src[i];
      }
    } else if (angular.isObject(src)) {
      dst = dst || {};

      for (var key in src) {
        if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
          dst[key] = src[key];
        }
      }
    }

    return dst || src;
  }

  function arrayDifference(tokens1, tokens2) {
    var values = [];

    outer:
    for(var i = 0; i < tokens1.length; i++) {
      var token = tokens1[i];
      for(var j = 0; j < tokens2.length; j++) {
        if(token === tokens2[j]) {
          continue outer;
        }
      }
      values.push(token);
    }
    return values;
  }

  function arrayClasses (classVal) {
    if (angular.isArray(classVal)) {
      return classVal;
    } else if (angular.isString(classVal)) {
      return classVal.split(' ');
    } else if (angular.isObject(classVal)) {
      var classes = [];
      angular.forEach(classVal, function(v, k) {
        if (v) {
          classes = classes.concat(k.split(' '));
        }
      });
      return classes;
    }
    return classVal;
  }
  
  var name = 'wfParentClass';
  return ['$animate', function($animate) {
    return {
      restrict: 'AC',
      link: function(scope, element, attr) {
        var oldVal;

        function ngClassWatchAction(newVal) {
          var newClasses = arrayClasses(newVal || []);
          if (!oldVal) {
            addClasses(newClasses);
          } else if (!angular.equals(newVal,oldVal)) {
            var oldClasses = arrayClasses(oldVal);
            updateClasses(oldClasses, newClasses);
          }

          oldVal = shallowCopy(newVal);
        }

        scope.$watch(attr[name], ngClassWatchAction, true);

        attr.$observe('class', function() {
          ngClassWatchAction(scope.$eval(attr[name]));
        });

        function targetElement() {
          var $targetElement = window.$(element[0]).parents(scope.$eval(attr.wfParentClassSelector));
          return angular.element($targetElement[0]);
        }

        function addClasses(classes) {
          var newClasses = digestClassCounts(classes, 1);
          // attr.$addClass(newClasses);
          targetElement().addClass(newClasses);
        }

        // function removeClasses(classes) {
        //   var newClasses = digestClassCounts(classes, -1);
        //   // attr.$removeClass(newClasses);
        //   targetElement().removeClass(newClasses);
        // }

        function digestClassCounts (classes, count) {
          var classCounts = element.data('$classCounts') || {};
          var classesToUpdate = [];
          angular.forEach(classes, function (className) {
            if (count > 0 || classCounts[className]) {
              classCounts[className] = (classCounts[className] || 0) + count;
              if (classCounts[className] === +(count > 0)) {
                classesToUpdate.push(className);
              }
            }
          });
          element.data('$classCounts', classCounts);
          return classesToUpdate.join(' ');
        }

        function updateClasses (oldClasses, newClasses) {
          var toAdd = arrayDifference(newClasses, oldClasses);
          var toRemove = arrayDifference(oldClasses, newClasses);
          toAdd = digestClassCounts(toAdd, 1);
          toRemove = digestClassCounts(toRemove, -1);
          if (toAdd && toAdd.length) {
            // $animate.addClass(element, toAdd);
            $animate.addClass(targetElement(), toAdd);
            // targetElement().addClass(newClasses);
          }
          if (toRemove && toRemove.length) {
            // $animate.removeClass(element, toRemove);
            $animate.removeClass(targetElement(), toRemove);
            // targetElement().removeClass(newClasses);
          }
        }
      }
    };
  }];
}

angular.module('warriorUtils')
  .directive('wfParentClass', parentClassDirective());

'use strict';

angular.module('warriorUtils')
  .directive('wfPaymentChoice', ["$window", "$uibModal", "Analytics", function ($window, $uibModal, Analytics) {
    var autoOpenAlready;

    // Sample:
    // <button wf-payment-choice
    // fixed-charge-item-id=2
    // item-id=2
    // item-class='thread'
    // autoOpen=1
    // >PaymentChoice</button>
    return {
      scope: {
        'fixedChargeItemId':'@',
        'itemId':'@',
        'itemClass':'@'
      },

      link: function (scope, element, attrs) {
        var config = {
          'name': '',
          'desc': '',
          'price': 0,
          'redirectUrl': attrs.redirectUrl,
          'item': {
            'fixedChargeItemId': scope.fixedChargeItemId,
            'itemId': scope.itemId,
            'itemClass': scope.itemClass
          }
        };

        function shouldAutoOpen() {
          if (attrs.autoOpen) {
            return true;
          }

          if ($window.location.search.indexOf('openpc=' + attrs.fixedChargeItemId) >= 0) {
            return true;
          }

          return false;
        }

        var openPaymentChoiceModal = function(config) {
          var template = '/views/warrior/nibiru/payment_modal.html';

          Analytics.trackEvent('inpage-signuplogin', undefined, 'load');
          $uibModal.open({
            windowClass: 'default-modal payment-modal',
            templateUrl: template,
            controller: 'PaymentChoiceModalCtrl',
            backdrop: 'static',
            size: 'sm',
            resolve: {
              paymentChoiceConfig: function() {
                return config;
              }
            }
          });
        };

        element.click(function (event) {
          event.preventDefault();
          openPaymentChoiceModal(config);
        });

        if (shouldAutoOpen() && !autoOpenAlready) {
          // param autoOpenAlready is to prevent several auto open modals in the
          // page and will pop up two identical modals.
          autoOpenAlready = true;
          openPaymentChoiceModal(config);
        }
      }
    };
  }]).directive('wfPaymentChoiceAutoBump', function () {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: '/views/warrior/paymentchoiceautobump.html'
    };
  });

'use strict';

angular.module('warriorUtils')

.controller('ProfilePaginationController', ['$scope', '$attrs', '$parse', function($scope, $attrs, $parse) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
      setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;

  this.init = function(ngModelCtrl_, config) {
    ngModelCtrl = ngModelCtrl_;
    this.config = config;

    ngModelCtrl.$render = function() {
      self.render();
    };
    if ($attrs.itemsPerPage) {
      $scope.$parent.$watch($parse($attrs.itemsPerPage), function(value) {
        self.itemsPerPage = parseInt(value, 10);
        $scope.totalPages = self.calculateTotalPages();
      });
    } else {
      this.itemsPerPage = config.itemsPerPage;
    }
  };

  this.calculateTotalPages = function() {
    var totalPages = this.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / this.itemsPerPage);
    return Math.max(totalPages || 0, 1);
  };

  this.render = function() {
    $scope.page = parseInt(ngModelCtrl.$viewValue, 10) || 1;
  };

  $scope.selectPage = function(page) {
    if ($scope.page !== page && page > 0 && page <= $scope.totalPages) {
      ngModelCtrl.$setViewValue(page);
      ngModelCtrl.$render();
    }
  };

  $scope.getText = function(key ) {
    return $scope[key + 'Text'] || self.config[key + 'Text'];
  };
  $scope.noPrevious = function() {
    return $scope.page === 1;
  };
  $scope.noNext = function() {
    return $scope.page === $scope.totalPages;
  };

  $scope.$watch('totalItems', function() {
    $scope.totalPages = self.calculateTotalPages();
  });

  $scope.$watch('totalPages', function(value) {
    setNumPages($scope.$parent, value); // Readonly variable

    if ($scope.page > value) {
      $scope.selectPage(value);
    } else {
      ngModelCtrl.$render();
    }
  });
}])

.constant('profilePaginationConfig', {
  itemsPerPage: 10,
  boundaryLinks: false,
  directionLinks: true,
  firstText: 'First',
  previousText: 'Prev',
  nextText: 'Next',
  lastText: 'Last',
  rotate: true
})

.directive('profilepagination', ['$parse', 'profilePaginationConfig', function($parse, paginationConfig) {
  return {
    restrict: 'E',
    scope: {
      itemsPerPage: '=',
      totalItems: '=',
      firstText: '@',
      previousText: '@',
      nextText: '@',
      lastText: '@'
    },
    require: ['profilepagination', '?ngModel'],
    controller: 'ProfilePaginationController',
    templateUrl: '/views/wsomanager/template/profile/pagination.html',
    replace: true,
    link: function(scope, element, attrs, ctrls) {
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
        return; // do nothing if no ng-model
      }

      // Setup configuration parameters
      var maxSize = angular.isDefined(attrs.maxSize) ? scope.$parent.$eval(attrs.maxSize) : paginationConfig.maxSize,
          rotate = angular.isDefined(attrs.rotate) ? scope.$parent.$eval(attrs.rotate) : paginationConfig.rotate;
      scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : paginationConfig.boundaryLinks;
      scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : paginationConfig.directionLinks;

      paginationCtrl.init(ngModelCtrl, paginationConfig);

      if (attrs.maxSize) {
        scope.$parent.$watch($parse(attrs.maxSize), function(value) {
          maxSize = parseInt(value, 10);
          paginationCtrl.render();
        });
      }

      // Create page object used in template
      function makePage(number, text, isActive) {
        return {
          number: number,
          text: text,
          active: isActive
        };
      }

      function getPages(currentPage, totalPages) {
        var pages = [];

        // Default page limits
        var startPage = 1, endPage = totalPages;
        var isMaxSized = (angular.isDefined(maxSize) && maxSize < totalPages);

        // recompute if maxSize
        if (isMaxSized) {
          if (rotate) {
            // Current page is displayed in the middle of the visible ones
            startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
            endPage = startPage + maxSize - 1;

            // Adjust if limit is exceeded
            if (endPage > totalPages) {
              endPage = totalPages;
              startPage = endPage - maxSize + 1;
            }
          } else {
            // Visible pages are paginated with maxSize
            startPage = ((Math.ceil(currentPage / maxSize) - 1) * maxSize) + 1;

            // Adjust last page if limit is exceeded
            endPage = Math.min(startPage + maxSize - 1, totalPages);
          }
        }

        // Add page number links
        for (var number = startPage; number <= endPage; number++) {
          var page = makePage(number, number, number === currentPage);
          pages.push(page);
        }

        // Add links to move between page sets
        if (isMaxSized && ! rotate) {
          if (startPage > 1) {
            var previousPageSet = makePage(startPage - 1, '...', false);
            pages.unshift(previousPageSet);
          }

          if (endPage < totalPages) {
            var nextPageSet = makePage(endPage + 1, '...', false);
            pages.push(nextPageSet);
          }
        }

        return pages;
      }

      var originalRender = paginationCtrl.render;
      paginationCtrl.render = function() {
        originalRender();
        if (scope.page > 0 && scope.page <= scope.totalPages) {
          scope.pages = getPages(scope.page, scope.totalPages);
        }
      };
    }
  };
}]);

'use strict';

angular.module('warriorUtils')
  .directive('profilerating', function() {
    // The directive is exclusively used by profile rating as the rating
    // is only correct under class 'profile-reputation-ratings'
    return {
      restrict: 'AE',
      replace: 'true',
      scope: {
        rating: '@value'
      },
      templateUrl: '/views/wsomanager/template/profile/profilerating.html'
    };
  });

'use strict';

angular.module('warriorUtils')
  .directive('wfSignup', ["Signup", function (Signup) {
    return {
      scope: {
        'wfSignup': '@',
        'welcomeMessage': '@'
      },
      link: function (scope, element) {
        element.click(function (event) {
          event.preventDefault();

          Signup.openSignupModal({
            'templateUrl':scope.wfSignup,
            'welcomeMessage': scope.welcomeMessage
          });
        });
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .directive('tmh', ["FL_CDN", "THREATMETRIX_ORG_ID", function (FL_CDN, THREATMETRIX_ORG_ID) {
    var js_src = FL_CDN + '/fp/tags.js?org_id=' + THREATMETRIX_ORG_ID + '&session_id=wsovisitor';
    var template = '<script type="text/javascript" src="' + js_src + '"></script><noscript><iframe style="width: 100px; height: 100px; border: 0; position: absolute; top: -5000px;" src="' + js_src + '"></iframe></noscript>';

    return {
      restrict: 'E',

      link: function (scope, element) {
        var match = document.cookie.match(/wsovisitor=(.*?)(;|$)/);
        if (match) {
          var wsovisitor = match[1];
          var html = template.replace(/wsovisitor/g, wsovisitor);
          element.html(html);
        }
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .directive('wfCompile', ['$compile', function ($compile) {
      return function(scope, element, attrs) {
          scope.$watch(
              function(scope) {
                  // watch the 'compile' expression for changes
                  return scope.$eval(attrs.wfCompile);
              },
              function(value) {
                  // when the 'compile' expression changes
                  // assign it into the current DOM
                  element.html(value);

                  // compile the new DOM and link it to the current
                  // scope.
                  // NOTE: we only compile .childNodes so that
                  // we don't get into infinite loop compiling ourselves
                  $compile(element.contents())(scope);
              }
          );
      };
  }]);

'use strict';

// A modified version of angular-deep-blur
// https://github.com/myplanet/angular-deep-blur
// This version contains a fix to support the blur event in Firefox

angular.module('warriorUtils')
  .directive('wfDeepBlur', ["$timeout", function($timeout) {
    return {
      restrict: 'A',
      controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
        var leaveExpr = $attrs.wfDeepBlur;
        var dom = $element[0];

        function containsDom(parent, dom) {
          while (dom) {
            if (dom === parent) {
              return true;
            }

            dom = dom.parentNode;
          }

          return false;
        }

        function onBlur(e) {
          // e.relatedTarget for Chrome
          // explicitOriginalTarget for Firefox
          // document.activeElement for IE 11
          var targetElement = e.target;
          if (!containsDom(dom, targetElement) && (dom.currentStyle ? dom.currentStyle.display : getComputedStyle(dom, null).display) !== 'none' ) {
            $timeout(function () {
              $scope.$apply(leaveExpr);
            }, 10);
          }
        }

        document.addEventListener('click', onBlur, true);
      }]
    };
  }]);

'use strict';
/**
 * @ngdoc directive
 * @name flUtils.directive:flSvg
 * @element A
 * @function
 *
 * @description
 * Allow inserting an SVG as an inline element, instead of an external one
 * through <img>, allowing CSS styling of the SVG. The CSS classes applied on
 * the <fl-svg> element are "transcluded" (cut & paste) onto the SVG element.
 *
 * @example
  ```
    // to render /icons/wfIcon-bump.svg
    <wf-icon src="bump"></wf-icon>
  ```
 */
angular.module('warriorUtils')
.directive('wfIcon', ["$templateCache", function($templateCache) {
  return {
    restrict: 'E',
    link: function(scope, element, attrs) {
      if (attrs.src) {
        var url = '/icons/wfIcon-' + attrs.src + '.svg';
        var html = $templateCache.get(url);
        element.append(html);
      }
      if (attrs.class) {
        element.find('svg').attr('class', attrs.class);
        element.removeAttr('class');
      }
    }
  };
}]);

'use strict';
/**
 * @ngdoc directive
 * @name flUtils.directive:wfSvg
 * @element A
 * @function
 *
 * @description
 * Allow inserting an SVG as an inline element, instead of an external one
 * through <img>, allowing CSS styling of the SVG. The CSS classes applied on
 * the <fl-svg> element are "transcluded" (cut & paste) onto the SVG element.
 *
 * @example
  ```
    <wf-svg src="/images/test.svg"></wf-svg>
  ```
 */
angular.module('warriorUtils')
.directive('wfSvg', function() {
  return {
    restrict: 'E',
    templateUrl: function(elem, attrs) {
      return attrs.src;
    },
    link: function(scope, element, attrs) {
      if (attrs.class) {
        element.find('svg').attr('class', attrs.class);
        element.removeAttr('class');
      }
    }
  };
});

'use strict';

angular.module('warriorUtils')
  .directive('wfTrackUserMovement', ["UserTask", function (UserTask) {

    // Sample:
    // <div wf-track-user-movement page='forum' page-id=2></div>
    return {
      scope: {
        'page':'@',
        'pageId': '@'
      },
      link: function (scope) {
        UserTask.track_page_visit(scope.page, scope.pageId);
      }

    };
  }]);
'use strict';

angular.module('warriorUtils')
  .service('$date', function () {
    return {
      now: function () {
        return new Date();
      }
    };
  });

angular.module('warriorUtils')
  .filter('ago', ["$date", function ($date) {
    return function (date) {
      var secondsAgo = ($date.now() - date) / 1000;
      var minutesAgo = secondsAgo / 60;
      var hoursAgo = minutesAgo / 60;
      var daysAgo = hoursAgo / 24;
      var weeksAgo = daysAgo / 7;
      var yearsAgo = daysAgo / 365;

      yearsAgo = Math.round(yearsAgo);
      weeksAgo = Math.round(weeksAgo);
      daysAgo = Math.round(daysAgo);
      hoursAgo = Math.round(hoursAgo);
      minutesAgo = Math.round(minutesAgo);
      secondsAgo = Math.round(secondsAgo);

      if (yearsAgo > 0) {
        return yearsAgo === 1 ? '1 year ago' : yearsAgo + ' years ago';
      }

      if (weeksAgo > 0) {
        return weeksAgo === 1 ? '1 week ago' : weeksAgo + ' weeks ago';
      }

      if (daysAgo > 0) {
        return daysAgo === 1 ? '1 day ago' : daysAgo + ' days ago';
      }

      if (hoursAgo > 0) {
        return hoursAgo === 1 ? '1 hour ago' : hoursAgo + ' hours ago';
      }

      if (minutesAgo > 0) {
        return minutesAgo === 1 ? '1 minute ago' : minutesAgo + ' minutes ago';
      }

      if (secondsAgo > 0) {
        return secondsAgo === 1 ? '1 second ago' : secondsAgo + ' seconds ago';
      } else {
        return 'less than a second ago';
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .filter('andMore', function () {
    return function (num, max) {
      if (max === undefined) {
        max = 10;
      }

      if (isNaN(num)) {
        return '';
      } else if (num <= max) {
        return num.toString();
      }
      else {
        return max.toString() + '+';
      }
    };
  });

'use strict';

/*
Purpose:  Capitalize First Letter of Words in String
'this is my string' -> 'This Is My String'
*/

angular.module('warriorUtils')
  .filter('capitalize', function () {
    return function (str) {
        return str.split(' ')
          .map(function(word) {
              return word.substring(0,1).toUpperCase() + word.substring(1);
          }).join(' ');
      };
    });
'use strict';

/*
Purpose:        Interpolate a sales figure and return the range it belongs in
Other:          Test file in '/test/spec/filters/quantifySales.js'
*/

angular.module('warriorUtils')
  .filter('quantifySale', function () {
    return function (sale) {
      if (sale === '' || typeof (sale) === undefined ||
        typeof (sale) === Boolean || isNaN(sale) || /\D/.test(sale)) {
        return '';
      } else if (sale < 10) {
        return '<10';
      } else if (sale < 50) {
        return '10+';
      } else if (sale < 100) {
        return '50+';
      } else if (sale < 200) {
        return '100+';
      } else if (sale < 350) {
        return '200+';
      } else if (sale < 500) {
        return '350+';
      } else if (sale < 750) {
        return '500+';
      } else if (sale < 1000) {
        return '750+';
      } else {
        return '1000+';
      }
    };
  });

'use strict';

angular.module('warriorUtils')
  .filter('shortNum', function() {
    return function(num) {
      var thousand = 1000;
      var million = 1000000;
      var shortenedNum = '';

      if (isNaN(num)) {
        return shortenedNum;
      }
      else if (num < thousand) {
        return num.toString();
      }
      else if (num >= thousand && num < million) {
        shortenedNum = (num / thousand).toFixed(1);
        return shortenedNum.toString().replace('.0', '') + 'K';
      }

      return shortenedNum;
    };
  });

'use strict';

angular.module('warriorUtils')
  // jshint ignore:start
  /**
  * @ngdoc filter
  * @name truncate
  * @desciption
  * Strings with the filter will be truncated to a specified limit
  * and an ellipsis (...) will be appended.
  * Options with Truncate:
  *   1)  Will break on the a specified number of letters. Will not truncate mid word.
  *       If ":true" is appended then it will truncate mid word
  *   2)  Will give you the first set of letters and the last set of letters.
  *   3)  Will split on the number of words.
  * @usage
  * <td class="sales-stats-name" data-title="'Product Name'" >
  *     <span ng-hide="showExtraDetail">{{ transaction.product_name | characters: 25 :true}}</span>
  *     <span ng-show="showExtraDetail">{{ transaction.product_name }}</span>
  * </td>
  * <td class="sales-stats-name" data-title="'Product Name'" >
  *     <span ng-hide="showExtraDetail">{{ transaction.product_name | splitcharacters: 10}}</span>
  *     <span ng-show="showExtraDetail">{{ transaction.product_name }}</span>
  * </td>
  * <td class="sales-stats-name" data-title="'Product Name'" >
  *     <span ng-hide="showExtraDetail">{{ transaction.product_name | words:5}}</span>
  *     <span ng-show="showExtraDetail">{{ transaction.product_name }}</span>
  * </td>
  * @ownership
  * This code belongs to Brian Matthews at https://github.com/sparkalow/angular-truncate
  * as of 16 Feb 2015. Code has been copied and pasted and modified due to lack of bowerfication
  */
  // jshint ignore:end
  // 1)
  .filter('characters', function () {
    return function (input, chars, breakOnWord) {
      if (input === null) {return '';}
      if (isNaN(chars)) {return input;}
      if (chars <= 0) {return '';}
      if (input && input.length > chars) {
          input = input.substring(0, chars);

          if (!breakOnWord) {
              var lastspace = input.lastIndexOf(' ');
              //get last space
              if (lastspace !== -1) {
                  input = input.substr(0, lastspace);
              }
          }else{
              while(input.charAt(input.length-1) === ' '){
                  input = input.substr(0, input.length -1);
              }
          }
          return input + '…';
      }
      return input;
    };
  })
  // 2)
  .filter('splitcharacters', function() {
    return function (input, chars) {
      if (input === null) {return '';}
      if (isNaN(chars)) {return input;}
      if (chars <= 0) {return '';}
      if (input && input.length > chars) {
          var prefix = input.substring(0, chars/2);
          var postfix = input.substring(input.length-chars/2, input.length);
          return prefix + '...' + postfix;
      }
      return input;
    };
  })
  // 3)
  .filter('words', function () {
    return function (input, words) {
      if (input === null) {return '';}
      if (isNaN(words)) {return input;}
      if (words <= 0) {return '';}
      if (input) {
          var inputWords = input.split(/\s+/);
          if (inputWords.length > words) {
              input = inputWords.slice(0, words).join(' ') + '…';
          }
      }
      return input;
    };
  });

'use strict';
// Provide a common layer for interaction with the REST API
angular.module('warriorUtils')
  .factory('APIBackendInterceptor', ["$q", "$log", "Analytics", "WSO_API_BASE", "EXPERTS_API_BASE", "WF_BASE_URL", "$rootScope", "$window", "FlaskInteceptor", function APIBackendInterceptor($q, $log,
        Analytics, WSO_API_BASE, EXPERTS_API_BASE, WF_BASE_URL, $rootScope, $window, FlaskInteceptor) {
    return {
      response: function(response) {
        if (FlaskInteceptor.isWsoApiUrl(response.config.url) || FlaskInteceptor.isExpertsApiUrl(response.config.url)) {
          // Check the response validity
          if (response.data && response.data.status === 'success') {
            if (response.data.result) {
                response.data = response.data.result;
            }
          } else {
            // Shouldn't happen, report the error
            var errorCode = 'INVALID_RESPONSE';
            $rootScope.$broadcast('error-api', {
              message: 'Error communicating with server.', reload: true
            });
            $log.error('api: invalid server response: ' + response.data);
            //TODO: Remove that when Sentry is up
            Analytics.trackAction('error', response.config.url, errorCode, {
              response: response.data,
              status: response.status,
              status_text: response.statusText
            });
            response.data.code = errorCode;
            return $q.reject(response);
          }
        }
        return response;
      },
      responseError: function(response) {
        if (!response.config) {
          return $q.reject(response);
        }

        if (FlaskInteceptor.isWsoApiUrl(response.config.url) || FlaskInteceptor.isExpertsApiUrl(response.config.url)) {
          var userMessage = 'Error communicating with server.';
          var errorCode;
          // We should always have an error message
          if (response.data && response.data.error_code) {
            var errors = response.data.error_code.match(/\.(.*$)/);
            if (errors && errors[1]) {
              errorCode = errors[1];
            } else {
              $log.error('invalid error code: ' + response.data.error_code);
              errorCode = 'UNKNOWN_ERROR';
            }
            userMessage = response.data.message;
            if (errorCode === 'REDIRECT_TO_FORUM') {
              $window.location.href = WF_BASE_URL;
            }
          } else {
            $log.error('api: invalid response: ' + response.data);
            errorCode = 'INVALID_RESPONSE';
            //TODO: Remove that when Sentry is up
            Analytics.trackAction('error', response.config.url, errorCode, {
              response: response.data,
              status: response.status,
              status_text: response.statusText
            });
          }

          if (angular.isObject(response.data)) {
            response.data.code = errorCode;
          }

          if (response.status !== 401 && response.status !== 404) {
            $rootScope.$broadcast('error-api', {
              message: userMessage, reload: true
            });
          }
        }

        return $q.reject(response);
      }
    };
  }])

  .config(["$httpProvider", function($httpProvider) {
    $httpProvider.interceptors.push('APIBackendInterceptor');
  }]);


'use strict';

angular.module('warriorUtils')
  .factory('Auth', ["$q", "$rootScope", "$resource", "Users", "$log", "$window", "Login", function AuthService($q, $rootScope, $resource, Users,
    $log, $window, Login) {

    var self;

    var auth = {
      userId: null,
      user: null,
      authenticated: null,
      admin: false
    };

    var _setUser = function(user) {
      auth.user = user;
      auth.userId = parseInt(user.id, 10);
      auth.admin = user.admin;
      auth.authenticated = true;
      $rootScope.$broadcast('user.login');
    };

    var _checkAuthenticated = function() {
      Users.reset();
      auth.authenticated = null;
      var user = Users.get();
      user.then(function(user) {
        _setUser(user);
      }, function(){
        self.logout();
      });
      return user;
    };

    self = {

      logout: function() {
        auth.user = null;
        auth.userId = null;
        auth.authenticated = false;
        auth.admin = false;
        $rootScope.$broadcast('user.logout');
      },

      // have we heard back from the backend that the user is authenticated
      isAuthenticated: function() {
        return auth.authenticated === true;
      },

      // have we heard back from the backend that the user is unauthenticated
      isUnAuthenticated: function() {
        return auth.authenticated === false;
      },

      // waiting to hear back from the backend
      isAuthenticationPending: function() {
        return auth.authenticated === null;
      },

      // have we heard back from the backend that the user is admin
      isAdmin: function() {
        return auth.admin === true;
      },

      onLoggedIn: function(onUserAuthenticated, onNotUserAuthenticated, args) {
        var options = {
          'show_login': false
        };
        angular.extend(options, args);

        function _onUserAuthenticated() {
          if (onUserAuthenticated) {
            onUserAuthenticated(auth.user);
          }
        }

        function _onNotUserAuthenticated() {
          if (self.isUnAuthenticated() && options.show_login) {
            Login.openLoginModal({'closable': false});
          }

          if (onNotUserAuthenticated) {
            onNotUserAuthenticated();
          }
        }

        $rootScope.$on('user.login', _onUserAuthenticated);
        $rootScope.$on('user.logout', _onNotUserAuthenticated);

        if (this.isAuthenticated()) {
          _onUserAuthenticated(auth.user);
        } else {
          _onNotUserAuthenticated();
        }
      },

      adminRequired: function(onAdminAuthenticated, onNotAdminAuthenticated, args) {
        var options = {
          'show_login': true
        };
        angular.extend(options, args);

        function onUserAuthenticated() {
          if (auth.admin) {
            if (onAdminAuthenticated) {
              onAdminAuthenticated(auth.user);
            }
          } else {
            if (onNotAdminAuthenticated) {
              onNotAdminAuthenticated();
            }
          }
        }

        this.onLoggedIn(onUserAuthenticated, onNotAdminAuthenticated, options);
      },

      loginRequired: function(onUserAuthenticated, onNotUserAuthenticated, args) {
        var options = {
          'show_login': true
        };
        angular.extend(options, args);

        this.onLoggedIn(onUserAuthenticated, onNotUserAuthenticated, options);
      },

      // Get userId
      getUserId: function() {
        return auth.userId;
      },

      checkAuthenticated: function() {
        var user = _checkAuthenticated();

        $rootScope.$on('user.refreshlogin', function() {
          _checkAuthenticated();
        });
        return user;
      }
    };

    return self;
  }])

  // HTTP interceptor for 401 UNAUTHORIZED
  // Logout the current user if it happens (it should not!)
  .factory('AutoLogoutInterceptor', ["$q", "$injector", function AutoLogoutInterceptor($q, $injector) {
    return {
      responseError: function(response) {
        // Filter out login requests with invalid credentials
        if (response.status === 401) {
          // Clear invalid session token
          // Differed injection is need to work around circular
          // dependency between Auth & $http
          $injector.invoke(['Auth', function(Auth) {
            Auth.logout();
          }]);
        }
        return $q.reject(response);
      }
    };
  }])


  .config(["$httpProvider", function($httpProvider) {
    $httpProvider.interceptors.push('AutoLogoutInterceptor');
  }]);


'use strict';

angular.module('warriorUtils')
  .service('BbCode', ["ForumURLGenerator", function(ForumURLGenerator) {
    return {
      userProfile: function(username) {
        return '[URL="' + ForumURLGenerator.getProfile(username) + '"]' + username + '[/URL] ';
      },
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .controller('BlankModalCtrl', ["$scope", "BlankModal", function ($scope, BlankModal) {
    $scope.openModal = function ($event) {
      if ($event) {
        $event.preventDefault();
      }

      BlankModal.openModal();
    };
  }]);

angular.module('warriorUtils')
  .service('BlankModal', ["$uibModal", function ($uibModal) {
    return {
      openModal: function (options) {
        var opt = {
          'closable': true
        };
        angular.extend(opt, options);
        $uibModal.open({
          windowClass: 'default-modal',
          templateUrl: '/views/warrior/blankmodal.html',
          controller: 'BlankModalModalCtrl',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            options: function() {
              return opt;
            }
          }
        });
      }
    };
  }]);


angular.module('warriorUtils')
  .controller('BlankModalModalCtrl', ["$scope", "$uibModalInstance", "Forum", "Analytics", "$interval", "$rootScope", "reCAPTCHA", "Login", "options", function ($scope, $uibModalInstance, Forum, Analytics, $interval, $rootScope, reCAPTCHA, Login, options) {
    Analytics.trackEvent('wf-register-modal', undefined, 'load');
    if (angular.isDefined($rootScope.autoload)) {
      $interval.cancel($rootScope.autoload);
    }

    $scope.$on('formLocator', function(event, scope) {
      $scope.signupform = scope.signupform;
    });

    $scope.step = 'initial';
    $scope.captcha = {};
    $scope.user = {};
    $scope.options = options;

    function createAccount(user) {
      var createAccountSuccess = function() {
        $scope.step = 'notice';
        Analytics.trackAction('wf-register-modal', 'registered', 'SUCCESS');
        $rootScope.$broadcast('user.refreshlogin');
        delete $scope.captcha.$error;
      };

      var createAccountError = function(result) {
        Analytics.trackAction('wf-register-modal', 'registered', 'ERROR');
        var parameter, error;
        if (result.code) {
          var matches = result.code.match(/(.*)\.(.*)/);
          if (matches) {
            parameter = matches[1].toLowerCase();
            error = matches[2].toLowerCase();
          }
        }

        if (parameter === 'captcha') {
          if (error === 'incorrect') {
            reCAPTCHA.reload();
            $scope.step = 'captcha';
            $scope.captcha.$error = {'incorrect':true};
          } else if (error === 'missing') {
            $scope.step = 'captcha';
          }
        } else {
          if (parameter === 'password' && error === 'not_matched') {
            parameter = 'confirmPassword';
            error = 'repeat';
          }

          if ($scope.signupform[parameter]) {
            if (error === 'missing') {
              error = 'required';
            }

            $scope.signupform[parameter].$setValidity(error, false);
          }

          $scope.step = 'initial';
        }
      };

      Forum.createAccount(user).then(createAccountSuccess, createAccountError);
    }

    $scope.submit = function (user) {
      if ($scope.step === 'initial') {
        createAccount(user);
      } else if ($scope.step === 'captcha') {
        createAccount(user);
      } else { // notice
        $uibModalInstance.close();
      }
    };

    $scope.login = function(options) {
      Login.openLoginModal(options);
      $uibModalInstance.close();
    };

    $scope.ok = function () {
      $rootScope.$broadcast('user.refreshlogin.ok');
      $uibModalInstance.close();
    };

    $scope.cancel = function () {
      if ($scope.step === 'notice') {
        $scope.ok();
      } else {
        $uibModalInstance.dismiss('cancel');
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .factory('BotClassifier', ["RequestHeader", function(RequestHeader) {

    // AWS Stats Bots Useragent
    var whitelistedRobots = [
      {name: 'Google',    userAgentPattern: 'googlebot'},
      {name: 'Google',    userAgentPattern: 'google\-sitemap'},
      {name: 'Google',    userAgentPattern: 'google[_+ ]web[_+ ]preview'},
      {name: 'Google',    userAgentPattern: 'feedfetcher\-google'},
      {name: 'Bing',      userAgentPattern: 'bingpreview'},
      {name: 'Bing',      userAgentPattern: 'bingbot'},
      {name: 'MSN',       userAgentPattern: 'msnbot'},
      {name: 'Yahoo',     userAgentPattern: 'yahoo\-blogs'},
      {name: 'Yahoo',     userAgentPattern: 'yahoo\-verticalcrawler'},
      {name: 'Yahoo',     userAgentPattern: 'yahoofeedseeker'},
      {name: 'Yahoo',     userAgentPattern: 'yahooseeker\-testing'},
      {name: 'Yahoo',     userAgentPattern: 'yahooseeker'},
      {name: 'Yahoo',     userAgentPattern: 'yahoo\-mmcrawler'},
      {name: 'Yahoo',     userAgentPattern: 'yahoo!_mindset'},
      {name: 'Yahoo',     userAgentPattern: 'yahoo! slurp'},
      {name: 'Yahoo',     userAgentPattern: 'yahoo pipes'},
      {name: 'Yahoo',     userAgentPattern: 'yahoo-newscrawler'},
      {name: 'Yahoo',     userAgentPattern: 'yahoocachesystem'},
      {name: 'Yahoo',     userAgentPattern: 'yahooexternalcache'},
      {name: 'Yahoo',     userAgentPattern: 'yahoo! searchmonkey'},
      {name: 'Yahoo',     userAgentPattern: 'yahooysmcm'},
      {name: 'Twitter',   userAgentPattern: 'twitterbot'},
      {name: 'Twitter',   userAgentPattern: 'twitterfeed'},
      {name: 'Looksmart', userAgentPattern: 'nutch'},
      {name: 'Looksmart', userAgentPattern: 'wisenutbot'},
      {name: 'Looksmart', userAgentPattern: 'zyborg'},
      {name: 'Kosmix',    userAgentPattern: 'cfetch'},
      {name: 'Kosmix',    userAgentPattern: '^voyager\/'},
      {name: 'AllTheWeb', userAgentPattern:'fast\-webcrawler'},
      {name: 'AltaVista', userAgentPattern: 'scooter'}
    ];

    var isUserAgentBot = function(userAgent) {
      if(userAgent === null) {
        return false;
      }

      for(var i=0; i < whitelistedRobots.length; i++) {
        var regex = new RegExp(whitelistedRobots[i].userAgentPattern, 'i');
        if(userAgent.match(regex) !== null) {
          return true;
        }
      }

      return false;
    };

    return {
      getBotsList: function() {
        return whitelistedRobots;
      },

      isBot: function(userAgent) {
        return isUserAgentBot(userAgent);
      },

      isCurrentUserBot: function() {
        return isUserAgentBot(RequestHeader.getUserAgent());
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('CompleteRegistration', ["$uibModal", function ($uibModal) {
    return {
      openModal: function (options) {
        var opt = {
          'closable': false
        };
        angular.extend(opt, options);

        if (!opt.templateUrl) {
          opt.templateUrl = '/views/warrior/CompleteRegistration.html';
        }

        $uibModal.open({
          windowClass: 'FullscreenModal',
          windowTemplateUrl: '/views/warrior/FullScreenSignupModalWindow.html',
          templateUrl: opt.templateUrl,
          controller: 'CompleteRegistrationCtrl',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            options: function() {
              return opt;
            }
          }
        });
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('CountryList', function() {

    var self = [
      {type: 'Any'},
      {type: 'Afghanistan'},
      {type: 'Albania'},
      {type: 'Algeria'},
      {type: 'Andorra'},
      {type: 'Angola'},
      {type: 'Antarctica'},
      {type: 'Antigua and Barbuda'},
      {type: 'Argentina'},
      {type: 'Armenia'},
      {type: 'Australia'},
      {type: 'Austria'},
      {type: 'Azerbaijan'},
      {type: 'Bahamas'},
      {type: 'Bahrain'},
      {type: 'Bangladesh'},
      {type: 'Barbados'},
      {type: 'Belarus'},
      {type: 'Belgium'},
      {type: 'Belize'},
      {type: 'Benin'},
      {type: 'Bermuda'},
      {type: 'Bhutan'},
      {type: 'Bolivia'},
      {type: 'Bosnia and Herzegovina'},
      {type: 'Botswana'},
      {type: 'Brazil'},
      {type: 'Brunei'},
      {type: 'Bulgaria'},
      {type: 'Burkina Faso'},
      {type: 'Burma'},
      {type: 'Burundi'},
      {type: 'Cambodia'},
      {type: 'Cameroon'},
      {type: 'Canada'},
      {type: 'Cape Verde'},
      {type: 'Central African Republic'},
      {type: 'Chad'},
      {type: 'Chile'},
      {type: 'China'},
      {type: 'Colombia'},
      {type: 'Comoros'},
      {type: 'Congo,Republic of the'},
      {type: 'Costa Rica'},
      {type: 'Cote d\'Ivoire'},
      {type: 'Croatia'},
      {type: 'Cuba'},
      {type: 'Cyprus'},
      {type: 'Czech Republic'},
      {type: 'Denmark'},
      {type: 'Djibouti'},
      {type: 'Dominica'},
      {type: 'Dominican Republic'},
      {type: 'East Timor'},
      {type: 'Ecuador'},
      {type: 'Egypt'},
      {type: 'El Salvador'},
      {type: 'Equatorial Guinea'},
      {type: 'Eritrea'},
      {type: 'Estonia'},
      {type: 'Ethiopia'},
      {type: 'Fiji'},
      {type: 'Finland'},
      {type: 'France'},
      {type: 'Gabon'},
      {type: 'Gambia'},
      {type: 'Georgia'},
      {type: 'Germany'},
      {type: 'Ghana'},
      {type: 'Greece'},
      {type: 'Greenland'},
      {type: 'Grenada'},
      {type: 'Guatemala'},
      {type: 'Guinea'},
      {type: 'Guinea-Bissau'},
      {type: 'Guyana'},
      {type: 'Haiti'},
      {type: 'Honduras'},
      {type: 'Hong Kong'},
      {type: 'Hungary'},
      {type: 'Iceland'},
      {type: 'India'},
      {type: 'Indonesia'},
      {type: 'Iran'},
      {type: 'Iraq'},
      {type: 'Ireland'},
      {type: 'Israel'},
      {type: 'Italy'},
      {type: 'Jamaica'},
      {type: 'Japan'},
      {type: 'Jordan'},
      {type: 'Kazakhstan'},
      {type: 'Kenya'},
      {type: 'Kiribati'},
      {type: 'Korea, North'},
      {type: 'Korea, South'},
      {type: 'Kuwait'},
      {type: 'Kyrgyzstan'},
      {type: 'Laos'},
      {type: 'Latvia'},
      {type: 'Lebanon'},
      {type: 'Lesotho'},
      {type: 'Liberia'},
      {type: 'Libya'},
      {type: 'Liechtenstein'},
      {type: 'Lithuania'},
      {type: 'Luxembourg'},
      {type: 'Macedonia'},
      {type: 'Madagascar'},
      {type: 'Malawi'},
      {type: 'Malaysia'},
      {type: 'Maldives'},
      {type: 'Mali'},
      {type: 'Malta'},
      {type: 'Marshall Islands'},
      {type: 'Mauritania'},
      {type: 'Mauritius'},
      {type: 'Mexico'},
      {type: 'Micronesia'},
      {type: 'Moldova'},
      {type: 'Mongolia'},
      {type: 'Morocco'},
      {type: 'Monaco'},
      {type: 'Mozambique'},
      {type: 'Namibia'},
      {type: 'Nauru'},
      {type: 'Nepal'},
      {type: 'Netherlands'},
      {type: 'New Zealand'},
      {type: 'Nicaragua'},
      {type: 'Niger'},
      {type: 'Nigeria'},
      {type: 'Norway'},
      {type: 'Oman'},
      {type: 'Pakistan'},
      {type: 'Panama'},
      {type: 'Papua New Guinea'},
      {type: 'Paraguay'},
      {type: 'Peru'},
      {type: 'Philippines'},
      {type: 'Poland'},
      {type: 'Portugal'},
      {type: 'Qatar'},
      {type: 'Romania'},
      {type: 'Russia'},
      {type: 'Rwanda'},
      {type: 'Samoa'},
      {type: 'San Marino'},
      {type: 'Sao Tome'},
      {type: 'Saudi Arabia'},
      {type: 'Senegal'},
      {type: 'Serbia and Montenegro'},
      {type: 'Seychelles'},
      {type: 'Sierra Leone'},
      {type: 'Singapore'},
      {type: 'Slovakia'},
      {type: 'Slovenia'},
      {type: 'Solomon Islands'},
      {type: 'Somalia'},
      {type: 'South Africa'},
      {type: 'Spain'},
      {type: 'Sri Lanka'},
      {type: 'Sudan'},
      {type: 'Suriname'},
      {type: 'Swaziland'},
      {type: 'Sweden'},
      {type: 'Switzerland'},
      {type: 'Syria'},
      {type: 'Taiwan'},
      {type: 'Tajikistan'},
      {type: 'Tanzania'},
      {type: 'Thailand'},
      {type: 'Togo'},
      {type: 'Tonga'},
      {type: 'Trinidad and Tobago'},
      {type: 'Tunisia'},
      {type: 'Turkey'},
      {type: 'Turkmenistan'},
      {type: 'Uganda'},
      {type: 'Ukraine'},
      {type: 'United Arab Emirates'},
      {type: 'United Kingdom'},
      {type: 'United States'},
      {type: 'Uruguay'},
      {type: 'Uzbekistan'},
      {type: 'Vanuatu'},
      {type: 'Venezuela'},
      {type: 'Vietnam'},
      {type: 'Yemen'},
      {type: 'Zambia'}
    ];

    return self;
  });

'use strict';

angular.module('warriorUtils')
  .service('Coupon', ["$resource", "URLGenerator", function($resource, URLGenerator) {
    var CouponsApi = $resource(
      URLGenerator.getAPIURL('coupons', 'coupons'), {}, {
        'validate': {
          'method': 'GET',
          'isArray': false,
          'url': URLGenerator.getAPIURL('coupons', 'coupons/validate')
        }
      }
    );

    return {
      create: function(coupon) {
        return CouponsApi.save(coupon).$promise;
      },
      validate: function(couponCode, itemType) {
        return CouponsApi.validate({
          'coupon_code': couponCode,
          'item_type': itemType
        }).$promise;
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('Debounce', function() {
    return {
      do: function(funcToDebounce, minTimeInterval, isCallBefore) {
        if (!isCallBefore){
          isCallBefore = false;
        }

        var timeout;
        return function() {
          var context = this, args = arguments;
          var later = function() {
            timeout = null;
            if (!isCallBefore) {
              funcToDebounce.apply(context, args);
            }
          };
          var callNow = isCallBefore && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, minTimeInterval);
          if (callNow) {
            funcToDebounce.apply(context, args);
          }
        };
      }
    };
  });

'use strict';

angular.module('warriorUtils')
  .service('DeviceClassifier', ["$window", function($window) {

    return {
      isMobileScreen: function() {
        var defaultMobileWidth = 800;
        var screen = angular.element($window);
        return screen.width() <= defaultMobileWidth;
      }
    };
  }]);
  
'use strict';

angular.module('warriorUtils')
  .service('Enum', function() {

    var self = {
      submitted: 'submitted',
      scheduled: 'scheduled',
      rejected: 'rejected',
      paid: 'paid',
      finished: 'finished'
    };

    return self;
  });

'use strict';

angular.module('warriorUtils')
  .service('ExpertsUrlGenerator', ["EXPERTS_BASE_URL", function(EXPERTS_BASE_URL) {
    var getPageUrl = function(uri) {
      return EXPERTS_BASE_URL + uri;
    };

    return {
      'getPageUrl': getPageUrl
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('Features', ["Users", "$q", function(Users, $q) {
    return {
      is_active: function(feature) {
        var deferred = $q.defer();
        Users.get().then(function(user) {
          deferred.resolve(user.features[feature]);
        });
        return deferred.promise;
      },

      get_active: function() {
        var deferred = $q.defer();
        Users.get().then(function(user) {
          var features = {};
          angular.forEach(user.features, function(value, feature) {
            if (value === true) {
              features[feature] = true;
            } 
          });
          deferred.resolve(features);
        });
        return deferred.promise;
      },
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('Files', ["$resource", "URLGenerator", function ($resource, URLGenerator) {
    var FileApi = $resource(
      URLGenerator.getAPIURL('files', 'files/:id'), {
        'id': '@id'
      }
    );

    var addFile = function (file, type) {
      var result = FileApi.save({
        'filename': file.name,
        'content_type': file.type,
        'filesize': file.size,
        'type': type
      });
      return result;
    };

    return {

      addProductFile: function (file) {
        return addFile(file, 'ProductFile').$promise;
      },

      addExpertUserFile: function (file) {
        return addFile(file, 'ExpertUserFile').$promise;
      },

      addBannerFile: function (file) {
        return addFile(file, 'BannerFile').$promise;
      },

      remove: function (id) {
        var result = FileApi.remove({
          'id': id
        });
        return result.$promise;
      },

      upload_file: function (item) {
        return function (file_info) {
          item.url = file_info.file_path;
          item.id = file_info.id;
          item.info = file_info;
          item.formData = [{
            'key': file_info.key
          }, {
            'x-amz-meta-id': file_info.id
          }, {
            'x-amz-meta-type': file_info.type
          }, {
            'x-amz-date': file_info.date
          }, {
            'acl': 'private'
          }, {
            'Content-Type': item.file.type
          }, {
            'AWSAccessKeyId': file_info.aws_key
          }, {
            'success_action_status': '201'
          }, {
            'Policy': file_info.policy
          }, {
            'Signature': file_info.signature
          }];
          if (file_info.security_token) {
            item.formData.push({'x-amz-security-token': file_info.security_token});
          }
          item.method = 'POST';
          item.upload();
        };
      }

    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('ForgotPassword', ["$uibModal", function($uibModal) {
    return {
      openForgotPasswordModal: function(options) {
        var opt = {
          'closable': true
        };
        angular.extend(opt, options);
        $uibModal.open({
          windowClass: 'FullscreenModal',
          windowTemplateUrl: '/views/warrior/FullScreenSignupModalWindow.html',
          templateUrl: '/views/warrior/FullScreenForgotPasswordModal.html',
          controller: 'ForgotPasswordModalCtrl',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            options: function() {
              return opt;
            }
          }
        });

      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('ForumThread', ["$http", "ForumURLGenerator", function ($http, ForumURLGenerator) {
    return {
      post: function(forumData) {
        var config = {};
        forumData.do = 'postthread';
        config.url = ForumURLGenerator.getApiUrl('threads_api.php');
        config.method = 'POST';

        config.headers = {
          'Content-Type': 'application/x-www-form-urlencoded'
        };

        config.data = $.param(forumData);
        return $http(config);
      },

      get: function(urlParam) {
        var config = {};
        config.url = ForumURLGenerator.getApiUrl('threads_api.php');
        if ($.param(urlParam)){
          config.url = config.url + '?' + $.param(urlParam);
        }

        config.method = 'GET';
        return $http(config);
      }
    };
  }]);
 
'use strict';

angular.module('warriorUtils')
  .service('ForumURLGenerator', ["WF_BASE_URL", "WF_API_BASE_URL", "$httpParamSerializer", function(WF_BASE_URL, WF_API_BASE_URL, $httpParamSerializer) {
    var HTTP_API_BASE_URL = WF_API_BASE_URL.replace('https://', 'http://');
    var string_param = null;

    var _appendParams = function(URL){
      if(string_param){
        return URL + '?' + string_param;
      }
      return URL;
    };

    return {
      setParams: function(params){
        string_param = $httpParamSerializer(params);
      },

      getProfile: function(username) {
        return WF_BASE_URL + 'members/' + username +'.html';
      },

      getApiUrl: function(uri, is_http) {
        if (is_http === undefined) {
          is_http = false;
        }
        if (is_http) {
          return HTTP_API_BASE_URL + 'api/' + uri;
        } else {
          return WF_API_BASE_URL + 'api/' + uri;
        }
      },

      getThread: function(threadid) {
        return WF_BASE_URL + 'showthread.php?t=' + threadid;
      },

      getProduct: function(threadid) {
        return WF_BASE_URL + 'war-desk/offer/' + threadid;
      },

      getPost: function(post_id) {
        return WF_BASE_URL + 'showthread.php?p=' + post_id;
      },

      getAdminLogin: function() {
        return WF_BASE_URL + 'adminXwar/index.php';
      },

      getAbsoluteUrl: function(str) {
        if (!str) {
          str = '';
        }

        return WF_BASE_URL + str;
      },

      getFeedUrl: function() {
        return WF_BASE_URL + 'feed';
      },

      getThanks: function() {
        return WF_API_BASE_URL + 'post_thanks.php';
      },

      getOfferUrl: function (arg) {
        return WF_BASE_URL + 'offer' + '/' + arg;
      },

      getNewOfferUrl: function(){
        return _appendParams(WF_BASE_URL + 'offer/new');
      },

      getSpamDecimatorUrl: function() {
        return _appendParams(WF_BASE_URL + 'decimator.php');
      },

      getSearchUrl: function(searchQuery) {
        return _appendParams(WF_BASE_URL + 'search/' + searchQuery);
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .controller('GreetingCtrl', ["GreetingModal", "$scope", function (GreetingModal, $scope) {
    $scope.openModal = function(content) {
      var welcome_message = {};
      welcome_message.id = 1;
      welcome_message.body = content;
      GreetingModal.openModal(welcome_message);
    };
}]);

angular.module('warriorUtils')
  .service('GreetingModal', ["$http", "$uibModal", "$window", "WSO_API_BASE", "Forum", "Analytics", function ($http, $uibModal, $window, WSO_API_BASE, Forum, Analytics) {

    var openModal = function(welcome_message) {
      var trackingSection = 'wf-welcome-modal';
      var trackingSubsection = 'wf-welcome-modal-' + welcome_message.id;

      var modal = $uibModal.open({
        windowClass: 'default-modal welcome-modal',
        templateUrl: '/views/warrior/greetingmodal.html',
        controller: 'GreetingModalCtrl',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          message: function() {
            return welcome_message.body;
          },
          trackingSection: function() {
            return trackingSection;
          },
          trackingSubsection: function() {
            return trackingSubsection;
          }
        }
      });

      function cancelled() {
        Analytics.trackEvent(trackingSection, trackingSubsection, 'cancelled');
      }

      function success() {
        Analytics.trackEvent(trackingSection, trackingSubsection, 'closed');
      }

      Analytics.trackEvent(trackingSection, trackingSubsection, 'load');
      modal.result.then(success, cancelled);
    };

    var fetchMessageAndOpenModal = function(getBroadcastMessage) {
      var apiPath;
      if(getBroadcastMessage) {
        apiPath = '/users/0.1/self/message/broadcasts';
      } else {
        apiPath = '/users/0.1/self/message';
      }

      var queryString = $window.location.search;
      $http.get(WSO_API_BASE + apiPath + queryString).success(function(welcome_message){
        Forum.clear_login_welcome_cookie();
        openModal(welcome_message);
        var msg = {
          message_id: welcome_message.id,
          content_id: welcome_message.content_id
        };

        $http.post(WSO_API_BASE + '/users/0.1/self/message', msg);
      });

    };

    return {
      // user sent via forum cookie
      openModal: openModal,
      fetchMessageAndOpenModal: fetchMessageAndOpenModal
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .factory('IconManager', function() {
    var DefaultIcon = 'warrior-logo-small--dark';

    var FixedChargeIcons = {
      'bump': 'bump',
      'sticky': 'pushpin'
    };

    var NotificationIcons = {
      'banner/finished': 'offline-marketing',
      'thread/dropoff': 'graph',
      'thread/approved_paid': 'check',
      'thread/approved_unpaid': 'check',
      'thread/new_post': 'topicsx2',
      'generic/logout_notif': 'offline-marketing',
      'generic/join_war_room': 'warrior-logo-small--dark'
    };

    return {
      fixedChargeIcon: function(type) {
        var icon = FixedChargeIcons[type];
        if (icon) {
          return icon;
        }

        return DefaultIcon;
      },
      notificationIcon: function(event) {
        var icon = NotificationIcons[event];
        if (icon) {
          return icon;
        }

        return DefaultIcon;
      }
    };
  });

'use strict';

angular.module('warriorUtils')
  .factory('LocalStorage', ["$window", function ($window) {
    var localStorage = {};

    var addItem = function(key, value, createdAt) {
      if(!value) {
        value = true;
      }

      if(!createdAt) {
        createdAt = Date.now();
      }

      var item = {
        value: value,
        createdAt: createdAt
      };

      try {
        $window.localStorage.setItem(key, JSON.stringify(item));
      }
      catch(e) {
        localStorage[key] = JSON.stringify(item);
      }
    };

    var getItem = function(key) {
      var item = null;
      try {
        item = $window.localStorage.getItem(key);
      }
      catch(e) {
        item = localStorage[key];
      }

      if(item) {
        return JSON.parse(item);
      }
    };

    var getItemValue = function(key, defaultValue) {
      var item = getItem(key);
      if(item) {
        return item.value;
      }

      return defaultValue;
    };

    var removeItem = function(key) {
      try {
        $window.localStorage.removeItem(key);
      }
      catch(e) {
        delete localStorage[key];
      }
    };

    var isOverByMinutes = function(timestamp, minutes) {
      return Date.now() > (parseInt(timestamp, 10) + (minutes * 60000));
    };

    var isItemExpired = function(key, minutes) {
      var item = getItem(key);
      if(item) {
        return isOverByMinutes(item.createdAt, minutes);
      }

      return false;
    };

    var isItemSet = function(key) {
      try {
        if($window.localStorage.getItem(key)) {
          return true;
        }
      }
      catch(e) {
        if(localStorage[key]) {
          return true;
        }
      }

      return false;
    };

    var isItemSetAndExpired = function(key, minutes) {
      return isItemSet(key) && isItemExpired(key, minutes);
    };

    var clear = function() {
      try {
        $window.localStorage.clear();
      }
      catch(e) {
        localStorage = {};
      }
    };

    return {
      set: addItem,
      get: getItemValue,
      remove: removeItem,
      isSet: isItemSet,
      isExpired: isItemExpired,
      isSetAndExpired: isItemSetAndExpired,
      clearAll: clear
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('Login', ["$uibModal", function($uibModal) {
    var modalInstance;

    return {
      openLoginModal: function(options) {
        // already open
        if (modalInstance) {
          return;
        }

        var nullifyModalInstance = function() {
          modalInstance = null;
        };

        var opt = {
          'closable': true
        };

        angular.extend(opt, options);

        modalInstance = $uibModal.open({
          windowClass: 'FullscreenModal',
          windowTemplateUrl: '/views/warrior/FullScreenSignupModalWindow.html',
          templateUrl: '/views/warrior/FullScreenLoginModal.html',
          controller: 'LoginModalCtrl',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            options: function() {
              return opt;
            }
          }
        });

        modalInstance.result.then(nullifyModalInstance, nullifyModalInstance);
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('Membership', ["$resource", "URLGenerator", function ($resource, URLGenerator) {
    var MembershipsApi = $resource(URLGenerator.getAPIURL('memberships', 'memberships'), {
      }, {
        'cancelByType': {
          'method': 'PATCH',
          'isArray': false,
          'url': URLGenerator.getAPIURL('memberships', 'memberships/cancel_by_type')
        },
        'cancelUser': {
          'method': 'PATCH',
          'isArray': false,
          'url': URLGenerator.getAPIURL('memberships', 'memberships/cancel_user')
        },
        'getActiveByType': {
          'method': 'GET',
          'isArray': false,
          'url': URLGenerator.getAPIURL('memberships', 'memberships/get_active_by_type/:membership_type')
        }
      }
    );

    var getMembershipTypeByName = function(typeName) {
      var memberships = {
        'war-room': '12'
      };

      return memberships[typeName];
    };

    return {
      getType: function(typeName) {
        return getMembershipTypeByName(typeName);
      },
      cancelByType: function(typeName) {
        var type = getMembershipTypeByName(typeName);
        return MembershipsApi.cancelByType({
          'membership_type': type
        }).$promise;
      },
      cancelUser: function(email, typeName) {
        var type = getMembershipTypeByName(typeName);
        return MembershipsApi.cancelUser({
          'email': email,
          'membership_type': type
        }).$promise;
      },
      getActiveByType: function(typeName) {
        var type = getMembershipTypeByName(typeName);
        return MembershipsApi.getActiveByType({
          'membership_type': type
        }).$promise;
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('Notifications', ["$resource", "URLGenerator", function($resource, URLGenerator) {
    var NotificationsApi = $resource(
      URLGenerator.getAPIURL('notifications', 'forum/notifications'), {
      }, {
        'clear': {
          'method': 'PATCH',
          'isArray': false,
          'url': URLGenerator.getAPIURL('notifications', 'forum/notifications/clear')
        },
        'clearAllBefore': {
          'method': 'PATCH',
          'isArray': false,
          'url': URLGenerator.getAPIURL('notifications', 'forum/notifications/clear_before')
        },
        'getByType': {
          'method': 'GET',
          'isArray': false,
          'url': URLGenerator.getAPIURL('notifications', 'forum/notifications/type/:type')
        },
        'getByEvent': {
          'method': 'GET',
          'isArray': false,
          'url': URLGenerator.getAPIURL('notifications', 'forum/notifications/type/:type/event/:event_name')
        },
        'getNextByEvent': {
          'method': 'GET',
          'isArray': false,
          'url': URLGenerator.getAPIURL('notifications', 'forum/notifications/type/:type/event/:event_name/next')
        },
        'getNext': {
          'method': 'GET',
          'url': URLGenerator.getAPIURL('notifications', 'forum/notifications/next')
        }
      }
    );

    return {
      getByPage: function(page) {
        return NotificationsApi.get({
          'page': page,
          'size': 20
        }).$promise;
      },

      getNext: function(prev) {
        return NotificationsApi.getNext({
          'prev': prev
        }).$promise;
      },

      getByType: function(type, page, count) {
        if (count === undefined) {
          count = 20;
        }

        return NotificationsApi.getByType({
          type: type,
          page: page,
          size: count
        }).$promise;
      },

      getByTypeWithin: function(type, timeMin, timeMax, count) {
        if (count === undefined) {
          count = 10;
        }

        return NotificationsApi.getByType({
          type: type,
          since: timeMin,
          ending: timeMax,
          size: count
        }).$promise;
      },

      getByEvent: function(type, event_name, page, count) {
        if (count === undefined) {
            count = 20;
        }

        if(!type) {
            throw new Error('Missing notification type');
        }

        if(!event_name) {
            throw new Error('Missing notification event_name');
        }

        if(!page) {
          page = 1;
        }

        return NotificationsApi.getByEvent({
          'type': type,
          'event_name': event_name,
          'page': page,
          'size': count,
        }).$promise;
      },

      getNextByEvent: function(type, event_name, prev, count) {
        count = count || 20;

        if(!type) {
            throw new Error('Missing notification type');
        }

        if(!event_name) {
            throw new Error('Missing notification event_name');
        }

        return NotificationsApi.getNextByEvent({
          'type': type,
          'event_name': event_name,
          'prev': prev,
          'size': count,
        }).$promise;
      },

      markAsRead: function(notifications) {
        var notification_ids = notifications.map(function(n) {
          return n.id;
        });

        return NotificationsApi.clear({
          'notification_ids': notification_ids
        }).$promise;
      },

      markAllAsRead: function(last_notification) {
        return NotificationsApi.clearAllBefore({
          'notification_id': last_notification.id
        }).$promise;
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .factory('PaymentsService', ["$q", "$rootScope", "$resource", "$log", "URLGenerator", function PaymentService($q, $rootScope, $resource, $log, URLGenerator) {

    var AddPaymentApi = $resource(URLGenerator.getAPIURL('payments', 'add_payment'));

    var PaymentMethodApi = $resource(
      URLGenerator.getAPIURL(
        'payments', 'methods/:payment_method'),
        {
          'payment_method': '@payment_method'
        }, {
          'remove': {
            'method': 'DELETE'
          },
          'get': {
            'method': 'GET'
          }
        }
    );

    var pendingCouponId;

    var FixedChargeAPI = $resource(
      URLGenerator.getPaymentApiUrl(
        'payments', 'fixed_charge/:type/:pendingFixedChargeId'), {
      }, {
        'stripeCharge': {
          'method': 'POST',
          'params': {
            'type': 'stripe',
            'pendingFixedChargeId': '@pendingFixedChargeId'
          }
        },
        'paypalCharge': {
          'method': 'POST',
          'params': {
            'type': 'paypal',
            'pendingFixedChargeId': '@pendingFixedChargeId'
          }
        }
    });

    var PrimaryPaymentMethodApi = $resource(URLGenerator.getAPIURL('payments', 'methods/primary/:payment_method'), {
      'payment_method': '@type'
      }, {
        'update': {
          'method': 'PATCH'
      }
    });

    return {
      // Requesting a request token for a payment method
      requestToken: function(payment_type) {
        var get_request_token = AddPaymentApi.get({
          'payment_type': payment_type
        });

        return get_request_token.$promise;

      },

      setCouponTransactionId: function(txnId) {
        pendingCouponId = txnId;
      },

      // Requesting a request token for a payment method
      getPaymentMethods: function(payment_method) {
          var payment_methods = PaymentMethodApi.get({'payment_method':payment_method});
          return payment_methods.$promise;
      },

      refund: function(payment_type, id) {
        var RefundPaymentApi = $resource(URLGenerator.getAPIURL('payments', 'refund/' + id));
        return RefundPaymentApi.save().$promise;
      },

      removePaymentMethod: function(id) {
        var remove_responder = PaymentMethodApi.remove({
          'id':id
        });
        return remove_responder.$promise;
      },

      chargeWithStripe: function(data) {
        data.pendingCouponId = pendingCouponId;
        return FixedChargeAPI.stripeCharge(data).$promise;
      },

      chargeWithPaypal: function(data) {
        data.pendingCouponId = pendingCouponId;
        return FixedChargeAPI.paypalCharge(data).$promise;
      },

      getReferenceAccount: function() {
        var API = $resource(URLGenerator.getPaymentApiUrl('payments', 'reference_account'));
        return API.get().$promise;
      },

      getCouponValid: function(parameters) {
        var API = $resource(URLGenerator.getPaymentApiUrl('payments', 'coupon/:code/valid'));
        var promise = API.get(parameters).$promise;
        return promise;
      },

      createPendingFixedCharge: function(parameters) {
        parameters.pendingCouponId = pendingCouponId;
        var API = $resource(URLGenerator.getPaymentApiUrl('payments', 'fixed_charge/pending'));
        return API.save(parameters).$promise;
      },

      removeStripeBillingAccount: function() {
        var API = $resource(URLGenerator.getPaymentApiUrl('payments', 'stripe/remove_billing_account'));
        return API.save().$promise;
      },

      removePaypalBillingAccount: function() {
        var API = $resource(URLGenerator.getPaymentApiUrl('payments', 'paypal/remove_billing_account'));
        return API.save().$promise;
      },

      checkIfAutoBump: function(threadId) {
        var API = $resource(URLGenerator.getPaymentApiUrl('payments', 'fixed_charge/' + threadId + '/autobump'));
        return API.get().$promise;
      },

      updatePrimaryPaymentMethod: function(method) {
        return PrimaryPaymentMethodApi.update(method).$promise;
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('Random', function() {
    return {
      getInteger: function(min, max) {
        return Math.round(Math.random() * (max - min)) + min;
      }
    };
  });

'use strict';

angular.module('warriorUtils')
  .factory('RecursionHelper', ["$compile", function ($compile) {
    return {
        /**
         * Manually compiles the element, fixing the recursion loop.
         * @param element
         * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
         * @returns An object containing the linking functions.
         */
        compile: function(element, link){
            // Normalize the link parameter
            if(angular.isFunction(link)){
                link = { post: link };
            }

            // Break the recursion loop by removing the contents
            var contents = element.contents().remove();
            var compiledContents;
            return {
                pre: (link && link.pre) ? link.pre : null,
                /**
                 * Compiles and re-adds the contents
                 */
                post: function(scope, element){
                    // Compile the contents
                    if(!compiledContents){
                        compiledContents = $compile(contents);
                    }
                    // Re-add the compiled contents to the element
                    compiledContents(scope, function(clone){
                        element.append(clone);
                    });

                    // Call the post-linking function, if any
                    if(link && link.post){
                        link.post.apply(null, arguments);
                    }
                }
            };
        }
    };
}]);

'use strict';

angular.module('warriorUtils')
  .service('Reputation', ["$resource", "URLGenerator", function($resource, URLGenerator) {
    return {
      // Get user overall reputation data
      getOverallReputation: function(userId) {
        var repApi = $resource(
          URLGenerator.getAPIURL('reputation', 'overall/:userId'), {
            'userId': userId
          }
        );

        var rep = repApi.get();
        return rep.$promise;
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .factory('RequestHeader', ["$window", "WF_DOMAIN", function($window, WF_DOMAIN) {

    var _getUserAgent = function() {
      return $window.navigator.userAgent;
    };

    var _getReferrer = function(_document) {
      return _document.referrer;
    };

    var _isReferrerForum = function(_document) {
      var referrer = _getReferrer(_document);
      if(referrer) {
        return referrer.indexOf('//' + WF_DOMAIN) > -1;
      }

      return false;
    };

    var _isDirectAccess = function(_document) {
      if(!_getReferrer(_document)) {
        return true;
      }

      return false;
    };

    return {
      getUserAgent: _getUserAgent,
      getReferrer: _getReferrer,
      isReferrerForum: _isReferrerForum,
      isDirectAccess: _isDirectAccess
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .factory('Scroller', ["$location", "$anchorScroll", "$window", function($location, $anchorScroll, $window) {
    var scrollTo = function (elementId) {
      $location.hash(elementId);
      $anchorScroll();
    };

    var scrollToTop = function(){
      $window.scrollTo(0, 0);
    };

    return {
      scrollTo: scrollTo,
      scrollToTop: scrollToTop
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('Signup', ["$uibModal", "LocalStorage", "SIGNUP_DISMISSED_STORAGE", function($uibModal, LocalStorage, SIGNUP_DISMISSED_STORAGE) {

    var modalInstance;

    return {
      wasClosedWithinMinutes: function(minutes) {
        if (LocalStorage.isSet(SIGNUP_DISMISSED_STORAGE)) {
          return !LocalStorage.isExpired(SIGNUP_DISMISSED_STORAGE, minutes);
        }

        return false;
      },

      openSignupModal: function(options) {
        if (modalInstance) {
          return;
        }

        var nullifyModalInstance = function() {
          modalInstance = null;
        };

        var opt = {
          'closable': true,
          'redirectImmediately': false,
          'passwordConfirm': true
        };

        angular.extend(opt, options);

        opt.passwordConfirm = false;
        opt.redirectImmediately = true;
        modalInstance = $uibModal.open({
          windowClass: 'FullscreenModal',
          windowTemplateUrl: '/views/warrior/FullScreenSignupModalWindow.html',
          templateUrl: '/views/warrior/FullScreenSignupModal.html',
          controller: 'SignupModalCtrl',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            options: function() {
              return opt;
            }
          }
        });

        modalInstance.result.then(nullifyModalInstance, function() {
          nullifyModalInstance();
          LocalStorage.set(SIGNUP_DISMISSED_STORAGE);
        });
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('SignupWall', ["$window", "BotClassifier", "RequestHeader", "Signup", "ForumAuthentication", "UrlHelper", "wfCookieExperiment", function(
    $window,
    BotClassifier,
    RequestHeader,
    Signup,
    ForumAuthentication,
    UrlHelper,
    wfCookieExperiment) {

    var whitelistPages = [
      '/login.php',
      '/warrior-special-offers',
      '/other-website-products-services',
      '/warriors-hire',
      '/web-hosting-offers',
      '/warrior-forum-classified-ads',
      '/wanted-members-looking-hire-you',
      '/affiliate-program-database',
      '/add-banner',
      '/tools'
    ];

    var isWhitelistPage = function() {
      for(var i=0; i < whitelistPages.length; i++) {
        if($window.location.pathname.indexOf(whitelistPages[i]) > -1) {
          return true;
        }
      }

      return false;
    };

    return {
      shouldShowModal: function() {
        if (ForumAuthentication.isAuthenticated()) {
          return false;
        }

        if (UrlHelper.getParameter('signup') === '1') {
          return true;
        }

        if (UrlHelper.getParameter('from') === 'logout') {
          return false;
        }

        if (isWhitelistPage()) {
          return false;
        }

        if (BotClassifier.isCurrentUserBot()) {
          return false;
        }

        if (Signup.wasClosedWithinMinutes(30)) {
          return false;
        }

        var signupWallExperimentId = 79;
        if (wfCookieExperiment.getVariation(signupWallExperimentId, 2) === 1) {
          return false;
        }

        if (RequestHeader.isReferrerForum(document)) {
          return true;
        }

        return false;
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('Formatter', ["$window", "$filter", function ($window, $filter) {
    var capitalize = function(word) {
      return $filter('uppercase')(word.charAt(0)) + word.slice(1);
    };

    var replaceUnderscoresWithSpaces = function(word) {
      return word.replace(/_/g, ' ');
    };

    var formatThreadActionTitle = function(actionTitle) {
      actionTitle = capitalize(actionTitle);
      actionTitle = replaceUnderscoresWithSpaces(actionTitle);
      return actionTitle;
    };

    var formatUnixDate = function(unixDate, format) {
      return $window.moment(unixDate * 1000).format(format);
    };

    return {
      formatThreadActionTitle: formatThreadActionTitle,
      formatUnixDate: formatUnixDate
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('Tags', ["$resource", "URLGenerator", function($resource, URLGenerator) {

    var TagApi = $resource(URLGenerator.getAPIURL('config', 'tags'));
    var TagCache = [];
    var fetched = false;
    var arrived = false;
    var pendingpromise = null;
    return {
      // Get All Tags
      getAll: function() {
        if (!arrived) {
          if (!fetched) {
            var tag_promise = TagApi.query();
            pendingpromise = tag_promise.$promise;
            pendingpromise.then(function(result) {
              TagCache = result;
              arrived = true;
            });
            fetched = true;
            return pendingpromise;
          }
          else {
            return pendingpromise;
          }
        } else {
          return TagCache.$promise;
        }
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .factory('UrlHelper', ["$window", function($window) {

    var getUrlParameter = function (parameter) {
      var pageUrl = $window.location.search.substring(1);
      var urlVars = pageUrl.split('&');
      var result = '';

      for (var i = 0; i < urlVars.length; i+=1) {
        var paramName = urlVars[i] || '';
        var sParameterName = paramName.split(/=(.+)?/);

        if (sParameterName[0] === parameter) {
          result = sParameterName[1];
        }
      }

      return result;
    };

    return {
      getParameter: function(parameter) {
        return getUrlParameter(parameter);
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .factory('UserTask', ["$resource", "URLGenerator", function UserTask($resource, URLGenerator) {


    var UserTaskGroupAPI = $resource(
      URLGenerator.getAPIURL('user_task', 'task_group/:verb/:taskGroupId'), {
          'taskGroupId': '@taskGroupId'
        }, {
        'get_tasks': {
          'method': 'GET'
        }
    });

    var UserTaskAPI = $resource(
      URLGenerator.getAPIURL('user_task', ':user_task/:page_type/:page_id'), {
        }, {
        'track_visit': {
          'method': 'GET'
        }
    });

    return {
      get_tasks: function(taskGroupId) {
        return UserTaskGroupAPI.get_tasks({'verb': 'get', 'taskGroupId': taskGroupId}).$promise;
      },

      track_page_visit: function(page_type, id) {
        return UserTaskAPI.track_visit({'user_task': 'track_visit', 'page_type': page_type, 'page_id': id });
      }

    };
  }]);
'use strict';
angular.module('warriorUtils')
  .factory('UserTaskList', ['UserTask', function(UserTask){
    var UserTaskList = function(user_task_list){
      this.task_list =  user_task_list;
      this.current_task_index = null;
      this.percent_complete = null;
    };

    UserTaskList.prototype.getNextTask = function() {
      for (var i = this.current_task_index+1; i <= this.task_list.length; i++){
        if (i === this.task_list.length){
          i = 0;
        }

        if(!this.task_list[i].is_done){
          this.current_task_index = i;
          return this.getCurrentTask();
        }

      }
    };

    UserTaskList.prototype.getCurrentTask = function() {
      return this.task_list[this.current_task_index];
    };

    UserTaskList.prototype.getCompletedPercentage = function() {
        var done = 0;
        var percent_complete = 0;
        for(var i = 0; i < this.task_list.length; i++){
          if (this.task_list[i].is_done){
              done++;
          }
        }

        percent_complete = (done/this.task_list.length) * 100;

        if (percent_complete === 100){
          this.setComplete();
        }

        return percent_complete;
    };

    UserTaskList.prototype.getRemainingTaskCount = function() {
      var done = 0;
      var remaining_tasks = 0;
      for(var i = 0; i < this.task_list.length; i++){
        if (this.task_list[i].is_done){
            done++;
        }
      }

      remaining_tasks = this.task_list.length - done;

      return remaining_tasks;
    };

    UserTaskList.prototype.getCurrentTaskIndex = function() {
      for(var i = 0; i < this.task_list.length; i++){
        if(!this.task_list[i].is_done){
          return i;
        }
      }
      return null;
    };

    UserTaskList.prototype.setComplete = function() {
      this.current_task_index = null;
    };


    return {
      create: function(taskGroupId) {
        return UserTask.get_tasks(taskGroupId).then(function(response){
          var user_task_list = new UserTaskList(response.result);
          user_task_list.current_task_index = user_task_list.getCurrentTaskIndex();
          return user_task_list;
        });
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('Users', ["$resource", "$http", "$window", "URLGenerator", "ForumURLGenerator", "$injector", "$q", function($resource, $http, $window, URLGenerator, ForumURLGenerator, $injector, $q) {

    var SelfApi = $resource(URLGenerator.getAPIURL('users', 'users/self'));
    var UserApi = $resource(URLGenerator.getAPIURL('users', 'users/:verb/:username'),
                            {},
                            {
                              'followUser': {'method': 'POST', 'params': {'verb':'followers'}},
                              'unfollowUser': {'method': 'PATCH', 'params': {'verb': 'followers'}},
                              'following': {'method': 'GET', 'params': {'verb': 'following'}}
                            });
    var UsersApi = $resource(URLGenerator.getAPIURL('users', 'similar/:username_fragment'),
                            {},
                            {
                              'similarUsernames': {'method': 'GET', 'params': {'verb': 'similar'}}
                            });
    var user;

    return {

      // Return current user
      get: function() {
        user = user || SelfApi.get();
        return user.$promise;
      },

      // Reset the current user
      reset: function() {
        user = null;
      },

      // Signup a new user
      signup: function(email, username, password) {
        user = UserApi.save({
          'email': email,
          'username': username,
          'password': password
        });
        return user.$promise;
      },

      // Get user public info
      getPublicInfoByUsername: function(username) {
        var userInfoApi = $resource(
          URLGenerator.getAPIURL('users', 'info/:username'), {
            'username': username
          }
        );

        var user = userInfoApi.get();
        return user.$promise;
      },

      // Get user public info
      check: function(user) {
        var d = $q.defer();
        $injector.invoke(['Forum', function(Forum) {
          Forum.check(user).then(function(result) {
            d.resolve(result);
          }, function(result) {
            d.reject(result);
          });
        }]);
        return d.promise;
      },

      // Check user based on username.
      getbyUsername: function(username) {
        var userAPI = $resource(
          URLGenerator.getAPIURL('users', 'wfusers/:username'), {
            'username': username
          }
        );
        var user = userAPI.get();
        return user.$promise;
      },

      getSimilarUsernames: function(usernameFragment) {
        var escapedUsernameFragment = $window.encodeURIComponent(usernameFragment);
        return UsersApi.similarUsernames({'username_fragment': escapedUsernameFragment}).$promise;
      },

      isAwaitingConfirmUser: function(user) {
        if (user.usergroupid === 3) {
          return true;
        } else {
          return false;
        }
      },

      followUser: function(username) {
        return UserApi.followUser({'username': username, 'follow': true}).$promise;
      },

      unfollowUser: function(username) {
        return UserApi.unfollowUser({'username': username, 'follow': false}).$promise;
      },

      isFollowing: function(username) {
        return UserApi.following({'username': username}).$promise;
      }

    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('Variation', ["$cookies", "wfMath", function($cookies, wfMath) {
    if (!$cookies.wsogroup) {
      $cookies.wsogroup = wfMath.randomInt(12);
    }

    return {
      getVariation: function(variation_count) {
        return $cookies.wsogroup % variation_count;
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  /**
   * @ngdoc factory
   * @name wfManager.wfCookieExperiment
   *
   * @description
   * Provide a getVariation method to select variations randomly for users
   * based off a client side cookie.
   *
   * in SQL
   *    mod(strtol(LEFT(md5($cookies.get(EXPERIMENT_COOKIE) + experimentId), 4), 16), variationCount)
   *
   */
  .factory('wfCookieExperiment', ["$cookies", "EXPERIMENT_COOKIE", "$window", "md5", "wfWindowLocation", function($cookies, EXPERIMENT_COOKIE, $window, md5, wfWindowLocation) {
    var getRandomIndex =  function(experimentId) {
      if ($cookies.get(EXPERIMENT_COOKIE) === undefined) {
        $cookies.put(EXPERIMENT_COOKIE, Math.round(Math.random() * Math.pow(2, 32)));
      }

      //Creates a unique (per experiment for a user) random number
      var var_experiment_id = parseInt($cookies.get(EXPERIMENT_COOKIE), 10) + experimentId;

      //Hash the string of that number
      var hash = md5.createHash(String(var_experiment_id));

      //Convert the first four hex numbers to a decimal
      return parseInt(hash.substring(0, 4), 16);
    };

    var getVariationFromQuery = function(experimentId, variationCount) {
      for (var i = 0; i < variationCount; i++) {
        if (wfWindowLocation.hasQueryNameValue('e' + experimentId, i)) {
          return i;
        }
      }
    };

    return {
      hasCookie: function() {
        return $cookies.get(EXPERIMENT_COOKIE) !== undefined;
      },

      getVariation: function(experimentId, variationCount) {
       /**
        * p(control) = 0.5
        * p(variation) = 0.5
        */
        var variationIndex = getVariationFromQuery(experimentId, variationCount);
        if (typeof variationIndex !== 'undefined') {
          return variationIndex;
        }

        var randomIndex = getRandomIndex(experimentId);
        return (randomIndex % variationCount);
      },

      getBiasedVariation: function(experimentId, controlWeight, variationWeight) {
       /**
        * p(control) = controlWeight / (controlWeight + variationWeight)
        * p(variation) = variationWeight / (controlWeight + variationWeight)
        *
        * ie getBiasedVariation(123, 1, 9)
        *
        * p(control) = 1 / 10 = 10%, p(variation) = 9 / 10 = 90%
        */
        var variationIndex = getVariationFromQuery(experimentId, 2);
        if (typeof variationIndex !== 'undefined') {
          return variationIndex;
        }

        if (!variationWeight) {
          variationWeight = 1;
        }

        var k = controlWeight / (controlWeight + variationWeight);
        var randomIndex = getRandomIndex(experimentId);
        if (randomIndex < k * Math.pow(2, 16)) {
          return 0;
        } else {
          return 1;
        }
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  /**
   * @ngdoc factory
   * @name wfManager.wfTrackingCookie
   *
   * @description
   * Provide a cookie that has an expiry of 20mins.
   *
   */
  .service('WfTrackingCookie', ["$cookies", "WF_TRACKING_COOKIE", "BASE_DOMAIN", function($cookies, WF_TRACKING_COOKIE, BASE_DOMAIN) {
    var EXPIRY_MIN = 20;

    var getExpiryDate = function() {
      var offset = EXPIRY_MIN * 60 * 1000;
      return new Date(Date.now() + offset);
    };

    var setCookie = function() {
      $cookies.put(WF_TRACKING_COOKIE, true, {
        domain: BASE_DOMAIN,
        expires: getExpiryDate()
      });
    };

    return {
      init: function() {
        setCookie();
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('wfMath', function() {
    return {
      randomInt: function(n) {
        return Math.floor(Math.random() * n);
      }
    };
  });

'use strict';

angular.module('warriorUtils')
  .service('TopicList', function() {

    var self = [
      {id: 1, name: 'Internet Marketing', forum_id: 12, seo_url: 'main-internet-marketing-discussion-forum'},
      {id: 2, name: 'Growth Hacking', forum_id: 101, seo_url: 'growth-hacking'},
      {id: 3, name: 'eCommerce', forum_id: 91, seo_url: 'ecommerce-sites-wholesaling-drop-shipping'},
      {id: 5, name: 'Social Networks', forum_id: 93, seo_url: 'social-media'},
      {id: 6, name: 'Personal Development', forum_id: 25, seo_url: 'mind-warriors'},
      {id: 7, name: 'SEO', forum_id: 22, seo_url: 'search-engine-optimization'},
      {id: 8, name: 'CRO', forum_id: 102, seo_url: 'conversion-rate-optimization'},
      {id: 9, name: 'Product Reviews', forum_id: 28, seo_url: 'internet-marketing-product-reviews-ratings'},
      {id: 10, name: 'Ad Networks', forum_id: 33, seo_url: 'ad-networks-cpm-cpl-display-sem'},
      {id: 11, name: 'Offline Marketing', forum_id: 76, seo_url: 'offline-marketing'},
      {id: 12, name: 'Programming', forum_id: 44, seo_url: 'programming'},
      {id: 13, name: 'Mobile Marketing', forum_id: 85, seo_url: 'mobile-marketing'},
      {id: 14, name: 'Web Design', forum_id: 45 , seo_url: 'website-design'},
      {id: 15, name: 'Email Marketing', forum_id: 103, seo_url: 'email-marketing'},
      {id: 16, name: 'Copywriting', forum_id: 29, seo_url: 'copywriting'},
      {id: 17, name: 'Local Events', forum_id: 57, seo_url: 'local-meetups-mastermind-groups-warrior-events'},
      {id: 18, name: 'PPC/SEM', forum_id: 104, seo_url: 'pay-per-click-search-engine-marketing-ppc-sem'}
    ];

    return self;
  })
  .service('TopicUtils', ["TopicList", function(TopicList) {
    return {
      getFeedLink: function(topic_id) {
        var topic = TopicList.filter(function(t) {
          return t.id === parseInt(topic_id, 10);
        });
        if (topic[0]) {
          return '/feed/forum/' + topic[0].seo_url;
        }
        return '';
      },
      getAll: function() {
        var otherTopics = [
          {id: 19, name: 'Articles', forum_id: 83, seo_url: 'articles'},
          {id: 20, name: 'Member Contests', forum_id: 84, seo_url: 'member-contests-challenges'},
          {id: 21, name: 'Freemarket', forum_id: 105, seo_url: 'freemarket-com-discussion'},
          {id: 22, name: 'Reciprocal Links', forum_id: 23, seo_url: 'reciprocal-links'},
          {id: 23, name: 'Joint Ventures', forum_id: 13, seo_url: 'joint-ventures-articles-ebooks'},
          {id: 24, name: 'Off Topic', forum_id: 18, seo_url: 'off-topic-forum'},
          {id: 25, name: 'Forum News', forum_id: 62, seo_url: 'warrior-forum-news'},
          {id: 26, name: 'Forum Help', forum_id: 106, seo_url: 'warrior-forum-help'},
          {id: 27, name: 'Suggestion Forum', forum_id: 96, seo_url: 'suggestion-forum'},
        ];

        return TopicList.concat(otherTopics);
      }
    };
  }]);

'use strict';

angular.module('warriorUtils')
  /**
   * @description
   * Trying to mock $window.location.search for testing will drive you mad
   * (shame on AngularJS). This class provides services for querying the
   * $window.location and other $window functions in a testable way.
   */
  .service('wfWindowLocation', ["$window", function($window) {
      var _addUrlQueryParameter = function(url, name, value) {
        if (url.indexOf('?') >= 0) {
          return url + '&' + name + '=' + value;
        } else {
          return url + '?' + name + '=' + value;
        }
      };

      var _isHttp = function() {
        return $window.location.href.indexOf('http://') !== -1;
      };

    return {
      redirect: function(url) {
        $window.location.href = url;
      },
      redirectWithParameter: function(name, value) {
        $window.location.href = _addUrlQueryParameter($window.location.href, name, value);
      },
      hasQueryNameValue: function(name, value) {
        return $window.location.search.indexOf(name + '=' + value) > 0;
      },
      isHttp: _isHttp,
      addUrlQueryParameter: _addUrlQueryParameter
    };
  }]);

'use strict';

angular.module('warriorUtils')
  .service('Validator', function() {
    return {
      isEmail: function(string) {
          var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return regex.test(string);
      }
    };
  });

'use strict';

angular.module('warriorUtils')
  .service('NewsletterSubscribe', ["$resource", "URLGenerator", function ($resource, URLGenerator) {

    var NewsletterApi = $resource(
      URLGenerator.getAPIURL('newsletter', 'newsletter/subscribe'), {
      }, {
        'add': {
          'method': 'POST',
        }
      }
    );

    return {
      subscribe: function (email, origin_name) {
        var getPromise = NewsletterApi.add({'email': email, 'origin_name': origin_name});

        return getPromise.$promise;
      }
    };
  }]);

'use strict';

angular.module('warriorUtils').service('ConfirmationModal', ["$uibModal", function($uibModal){
  var _openModal = function(options){
    var animationEnabled = angular.isDefined(options.animation) ? options.animation : true;

    var modalInstance = $uibModal.open({
      animation: animationEnabled,
      windowTemplateUrl: '/views/warrior/nibiru/modalV2_template.html',
      windowClass: 'ModalV2-wrapper',
      component: 'confirmationModalComponent',
      resolve: {
        options: function () {
          return options;
        }
      }
    });
    return modalInstance.result;
  };

  return{
    open:_openModal
  };

}]).component('confirmationModalComponent', {
  templateUrl: '/views/warrior/nibiru/confirmation_modal.html',
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller: function(){
    var ctrl = this;

    ctrl.$onInit = function(){
      ctrl.options = ctrl.resolve.options;
    };

    ctrl.choosePositive = function(){
      ctrl.close({$value: ctrl.options.positiveCTA});
    };

    ctrl.chooseNegative = function(){
      ctrl.close({$value: ctrl.options.negativeCTA});
  };

    ctrl.dismissModal = function(){
      ctrl.dismiss({$value: 'cancel'});
    };
  }
});

'use strict';

angular.module('warriorUtils')
  .controller('NewsletterSubscriptionCtrl', ["$scope", "NewsletterSubscribe", "Signup", function ($scope, NewsletterSubscribe, Signup) {
    $scope.subscribe = function(email) {
      $scope.serverError = '';
      if (!email) {
        return;
      }

      function success() {
        Signup.openSignupModal({
          'email': email
        });
      }

      function error() {
        $scope.serverError = 'Oops! Something went wrong!';
      }

      NewsletterSubscribe.subscribe(email, '/guide/digital-email-marketing').then(success, error);
    };
  }]);
'use strict';

angular.module('warriorUtils')
  .directive('wfNewsletterSubscription', function () {
    return {
      scope: {
        originName: '@'
      },
      replace: true,
      templateUrl: '/views/wf/footer-newsletter-subscription.html',
      controller: ["$scope", "$uibModal", "$cookies", "NewsletterSubscribe", "Signup", function($scope, $uibModal, $cookies, NewsletterSubscribe, Signup) {
        $scope.options = {};
        var cookieName = 'forum_newsletter';

        $scope.state = {};
        $scope.state.showFooter = $cookies.get(cookieName) ? false : true;

        $scope.subscribe = function (email) {
          $scope.serverError = '';
          if (!email) {
            return;
          }

          function success() {
            $cookies.put(cookieName, 'subscribed');
            Signup.openSignupModal({
              'email': email,
              'templateUrl': '/views/warrior/NewsletterSubscriptionModal.html'
            });
            $scope.state.showFooter = false;
          }

          function error() {
            $scope.serverError = 'Oops! Something went wrong!';
          }

          NewsletterSubscribe.subscribe(email, $scope.originName).then(success, error);
        };

        $scope.close = function() {
          $cookies.put(cookieName, 'dismissed');
          $scope.state.showFooter = false;
        };
      }]
    };
  });
'use strict';

angular.module('warriorUtils')
  .directive('wfCompile', ['$compile', function ($compile) {
      return function(scope, element, attrs) {
          scope.$watch(
              function(scope) {
                  // watch the 'compile' expression for changes
                  return scope.$eval(attrs.wfCompile);
              },
              function(value) {
                  // when the 'compile' expression changes
                  // assign it into the current DOM
                  element.html(value);

                  // compile the new DOM and link it to the current
                  // scope.
                  // NOTE: we only compile .childNodes so that
                  // we don't get into infinite loop compiling ourselves
                  $compile(element.contents())(scope);
              }
          );
      };
  }]);

angular.module('warriorUtils').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/icons/warrior-logo-small.svg',
    "<svg viewBox=\"0 0 44 44\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"wf-logo\"><defs/><g id=\"Page-1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"motif-logo\"><g transform=\"translate(4.000000, 9.000000)\"><path d=\"M27.448,16.472 C27.229,16.837 26.937,17.057 26.572,17.057 L24.528,17.057 C24.09,17.057 23.798,16.837 23.579,16.472 L17.593,3.624 L11.242,16.472 C11.169,16.618 11.023,16.764 10.877,16.91 C10.658,17.057 10.512,17.057 10.293,17.057 L8.176,17.057 C7.738,17.057 7.446,16.837 7.227,16.472 L0,0.997 L2.19,0.997 L8.833,15.085 L9.636,15.085 L16.644,0.997 L18.469,0.997 L25.039,15.012 L25.769,15.012 L32.85,0.923 L35.186,0.923 L27.448,16.472\" id=\"Fill-1\" fill=\"#FFFFFF\"/><path d=\"M26.572,26.043 L18.469,11.296 C18.323,11.004 17.958,10.858 17.593,10.858 C17.228,10.858 16.936,11.004 16.717,11.296 L8.614,26.043 L26.572,26.043\" id=\"Fill-2\" fill=\"#CC0000\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-accordion-toggle.svg',
    "<svg width=\"15px\" height=\"14px\" viewBox=\"0 0 15 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\" class=\"WFIcon-plus\"><g id=\"Jump-Topic\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\"><g id=\"02.-JT-active\" sketch:type=\"MSArtboardGroup\" transform=\"translate(-819.000000, -203.000000)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><g id=\"active\" sketch:type=\"MSLayerGroup\" transform=\"translate(220.000000, 135.000000)\"><g id=\"ico-plus\" transform=\"translate(606.000000, 75.000000) rotate(-270.000000) translate(-606.000000, -75.000000) translate(594.000000, 63.000000)\" sketch:type=\"MSShapeGroup\"><path d=\"M12,5 L12,18\" class=\"Accordion-icon-horizontal\"/><path d=\"M5.5,11.5 L18.5,11.5\" class=\"Accordion-icon-vertical\"/></g></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-ad-network.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"ad-network\" stroke=\"#212121\"><g id=\"ico-ad-network\"><path d=\"M4.5,4.5 L4.5,19.5 L19.5,19.5\" id=\"Line\"/><path d=\"M6.5,17.5 L19.5,4.5\" id=\"Line\"/><path d=\"M8.5,19.5 L8.5,18.5\" id=\"Line\"/><path d=\"M12.5,19.5 L12.5,14.5\" id=\"Line-Copy\"/><path d=\"M16.5,19.5 L16.5,10.5\" id=\"Line-Copy-2\"/><path d=\"M17.5,4.5 L19.5,4.5\" id=\"Line\"/><path d=\"M19.5,4.5 L19.5,6.5\" id=\"Line\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-amex.svg',
    "<svg width=\"29\" height=\"20\" viewBox=\"0 0 29 20\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><path id=\"a\" d=\"M0 .108h25.588v9.38H0V.107z\"/></defs><g fill=\"none\" fill-rule=\"evenodd\"><rect fill=\"#0079AA\" x=\".429\" width=\"28.571\" height=\"20\" rx=\"2\"/><path d=\"M2.57 9.305H3.8l.276-.668h.62l.277.668H7.39v-.51l.218.512h1.254l.217-.52v.518h6.008l-.004-1.097h.117c.082.003.107.01.107.145v.952h3.106V9.05c.253.134.642.255 1.155.255h1.31l.276-.668h.62l.275.668h2.518V8.67l.382.635h2.02V5.108h-2v.495l-.28-.495h-2.05v.495l-.255-.495h-2.772c-.463 0-.87.065-1.2.246v-.246h-1.91v.246c-.21-.186-.495-.246-.812-.246H8.71l-.47 1.084-.482-1.084h-2.2v.495l-.24-.495H3.44l-.87 1.996v2.2zm23.76-.59h-1.02l-1.364-2.26v2.26H22.48l-.28-.672h-1.492l-.273.67h-.84c-.352 0-.793-.076-1.045-.33-.252-.257-.383-.603-.383-1.15 0-.446.08-.854.387-1.177.232-.24.596-.35 1.09-.35h.698v.643h-.68c-.263 0-.412.038-.555.178-.123.127-.206.367-.206.682 0 .323.064.555.198.706.11.12.312.156.502.156h.322l1.015-2.367h1.077L23.23 8.55V5.706h1.097L25.592 7.8V5.706h.737v3.01zm-8.515 0h-.734v-3.01h.735v3.01zm-1.152-2.2c0 .48-.32.728-.508.803.158.06.293.165.356.253.103.15.12.284.12.553v.59h-.725l-.002-.378c0-.18.018-.442-.114-.587-.106-.105-.265-.128-.525-.128h-.772v1.094h-.72v-3.01h1.655c.368 0 .64.01.87.145.228.134.365.33.365.666zm-3.39 2.2h-2.4v-3.01h2.4v.626h-1.68v.544h1.642v.617h-1.643v.602h1.682v.622zm-2.937 0H9.6l-.004-2.358-1.042 2.357h-.632L6.876 6.356v2.358H5.412l-.275-.67H3.64l-.28.67h-.78l1.288-3.01h1.068l1.223 2.85v-2.85h1.173l.94 2.043.866-2.042h1.196v3.01zm11.62-1.3l-.5-1.2-.494 1.2h.994zm-6.234-.477c-.1.06-.216.062-.355.062h-.874v-.67h.886c.124 0 .253.008.34.056.093.044.15.137.15.266 0 .13-.054.237-.148.286zm-10.844.478l-.493-1.2-.49 1.2h.983z\" fill=\"#FFF\"/><g transform=\"translate(2.57 5)\"><mask id=\"amex-b\" fill=\"#fff\"><use xlink:href=\"#a\"/></mask><path d=\"M13.94 6.876c0 .836-.624 1.01-1.25 1.01h-.9v1.008h-1.397l-.886-.996-.92.996h-2.85v-3.01H8.63l.886.987.914-.985h2.298c.572 0 1.212.158 1.212.99zm-5.718 1.39H6.454V7.67h1.58v-.614h-1.58v-.547h1.803l.788.877-.823.883zm2.852.354L9.97 7.394l1.104-1.187V8.62zm1.647-1.347h-.93v-.766h.938c.26 0 .44.106.44.37 0 .26-.17.396-.447.396zm4.852-1.388h2.4v.622H18.29v.547h1.64v.614h-1.64v.6h1.683v.626h-2.4v-3.01zm-.907 1.61c.16.06.29.165.35.253.103.147.118.284.122.55v.596h-.725v-.376c0-.18.018-.45-.115-.59-.106-.107-.265-.133-.528-.133H15v1.1h-.72v-3.01h1.66c.363 0 .63.015.864.142.228.136.37.324.37.668 0 .48-.32.725-.51.8zm-.435-.374c-.097.058-.216.063-.356.063H15v-.676h.887c.127 0 .257.002.343.054.092.05.15.143.15.272 0 .13-.058.233-.15.29zm6.49.187c.14.144.214.328.214.638 0 .647-.404.95-1.128.95h-1.4v-.646H21.8c.137 0 .232-.02.293-.076.05-.047.085-.114.085-.196 0-.088-.037-.157-.087-.2-.054-.045-.13-.066-.257-.066-.67-.023-1.513.02-1.513-.932 0-.436.273-.895 1.027-.895h1.443v.64h-1.32c-.13 0-.216.005-.29.054-.076.048-.106.12-.106.216 0 .113.067.19.158.224.075.026.157.035.28.035l.388.01c.39.01.657.077.82.242zM25.59 8.51c-.174.255-.514.384-.975.384h-1.39V8.25h1.385c.137 0 .232-.02.29-.076.05-.047.086-.114.086-.196 0-.088-.036-.157-.09-.2-.05-.045-.125-.066-.253-.066-.674-.023-1.515.02-1.515-.932 0-.436.276-.895 1.03-.895h1.433v-.6h-1.33c-.402 0-.694.096-.9.246v-.244h-1.97c-.314 0-.683.078-.86.245v-.244h-3.514v.245c-.28-.2-.752-.244-.97-.244h-2.32v.245c-.22-.213-.713-.244-1.014-.244h-2.594l-.595.642-.554-.642H5.088v4.2h3.805l.612-.654.577.653 2.344.002V8.5h.23c.31.005.678-.01 1.002-.15v1.135h1.935V8.39h.093c.118 0 .13.005.13.124v.97h5.876c.373 0 .763-.094.98-.268v.27h1.862c.387 0 .767-.056 1.054-.195v-.78zm0-1.985h-1.31c-.13 0-.218.004-.29.054-.077.048-.107.12-.107.216 0 .113.066.19.16.224.075.026.157.034.276.034l.39.01c.393.01.656.078.817.243.028.023.046.05.065.074v-.855z\" fill=\"#FFF\" mask=\"url(#amex-b)\"/></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-attach.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"attach\" stroke=\"#212121\"><g id=\"ico-attach\"><path d=\"M10.5,7.5 L10.5,14.9936024 C10.5,15.8255628 11.1657972,16.5 12,16.5 L12,16.5 C12.8284271,16.5 13.5,15.8204455 13.5,15.0044548 L13.5,7.00098635 C13.5,5.61972973 12.3903379,4.5 11,4.5 L11,4.5 C9.61928813,4.5 8.5,5.62743795 8.5,6.99378313 L8.5,16.0020973 C8.5,17.9339356 10.0709366,19.5 12,19.5 L12,19.5 C13.9329966,19.5 15.5,17.9312096 15.5,15.9968446 L15.5,7.5\" id=\"Path-60\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-bell.svg',
    "<svg class=\"Icon-image\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M18 14V9c0-3.314-2.686-6-6-6S6 5.686 6 9v5c0 1.657-1.344 3-3 3v1h18v-1c-1.656 0-3-1.343-3-3zM8.555 19c.693 1.19 1.97 2 3.445 2s2.752-.81 3.445-2h-6.89z\"/></svg>"
  );


  $templateCache.put('/icons/wfIcon-browser.svg',
    "<svg class=\"wfIcon-browser\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"icons\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"internet-marketing\"><g id=\"ico-internet-marketing\"><rect id=\"Rectangle-23\" x=\"3.5\" y=\"7.5\" width=\"17\" height=\"13\" rx=\"1\"/><path d=\"M6.5,3.5 L17.5,3.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M5.5,5.5 L18.5,5.5\" id=\"Line-Copy\" stroke-linecap=\"round\"/><path d=\"M5.5,11.5 L18.5,11.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M5.5,9.5 L5.5,9.5\" id=\"Line-Copy-2\" stroke-linecap=\"round\"/><path d=\"M7.5,9.5 L7.5,9.5\" id=\"Line-Copy-3\" stroke-linecap=\"round\"/><path d=\"M9.5,9.5 L9.5,9.5\" id=\"Line-Copy-4\" stroke-linecap=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-bump.svg',
    "<svg viewBox=\"0 0 36 32\" xmlns=\"http://www.w3.org/2000/svg\" class=\"WFIcon-bump\"><g stroke-linecap=\"round\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M3 31V15M9 31V11M15 31V13M21 31V15M27 31V17M33 31V11M1 9s3.03-5 9-5c5.97 0 7.24 5 14 5 6.274 0 11-8 11-8M35 1v4M35 1h-4\"/></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-check--light.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"check\" stroke=\"#fff\"><g id=\"ico-check\"><path d=\"M14.9246212,2.4246212 L14.9246212,18.4246212 L9.9246212,18.4246212\" id=\"Path-16\" transform=\"translate(12.424621, 10.424621) rotate(-315.000000) translate(-12.424621, -10.424621) \"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-check.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"check\" stroke=\"#212121\"><g id=\"ico-check\"><path d=\"M14.9246212,2.4246212 L14.9246212,18.4246212 L9.9246212,18.4246212\" id=\"Path-16\" transform=\"translate(12.424621, 10.424621) rotate(-315.000000) translate(-12.424621, -10.424621) \"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-chevron-down.svg',
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 24 24\" enable-background=\"new 0 0 24 24\" xml:space=\"preserve\" class=\"wf-chevron-down\"><polyline fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" points=\"0.5,5.429\n" +
    "    12,18.571 23.5,5.429 \"/></svg>"
  );


  $templateCache.put('/icons/wfIcon-chevron-up.svg',
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 24 24\" enable-background=\"new 0 0 24 24\" xml:space=\"preserve\" class=\"wf-chevron-up\"><polyline fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" points=\"\n" +
    "    23.5,18.571 12,5.429 0.5,18.571 \"/></svg>"
  );


  $templateCache.put('/icons/wfIcon-close.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"close\"><g id=\"ico-close\"><path d=\"M17.6915966,6.30840337 L6.30840337,17.6915966\" id=\"Path-15\"/><path d=\"M6.33934081,6.33934081 L17.6606592,17.6606592\" id=\"Path-16\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-conversion-rate-optimization.svg',
    "<svg class=\"wfIcon-conversion rate optimization\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke-width=\"1\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"conversion-rate-optimization\"><g id=\"ico-CRO\"><path d=\"M19.4836239,11.5003981 C19.2265255,7.59119396 15.9742563,4.5 12,4.5 C8.92803685,4.5 6.28744342,6.34691337 5.12804,8.99091986\" id=\"Oval-12\"/><path d=\"M4.5,9.5 L6.5,9.5\" id=\"Line\"/><path d=\"M4.5,9.5 L4.5,7.5\" id=\"Line\"/><path d=\"M18.87196,19.5 C18.6148616,15.5907958 15.3625923,12.4996019 11.3883361,12.4996019 C8.31637293,12.4996019 5.67577951,14.3465153 4.51637608,16.9905217\" id=\"Oval-12-Copy\" transform=\"translate(11.694168, 15.999801) scale(-1, -1) translate(-11.694168, -15.999801) \"/><path d=\"M17.5,14.5 L19.5,14.5\" id=\"Line-Copy\" transform=\"translate(18.500000, 14.500000) scale(-1, -1) translate(-18.500000, -14.500000) \"/><path d=\"M19.5,16.5 L19.5,14.5\" id=\"Line-Copy-2\" transform=\"translate(19.500000, 15.500000) scale(-1, -1) translate(-19.500000, -15.500000) \"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-copywriting.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"copywriting\" stroke=\"#212121\"><g id=\"ico-writing\"><rect id=\"Rectangle-38\" x=\"3.5\" y=\"9.5\" width=\"17\" height=\"8\"/><path d=\"M12,9.5 L12,6.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M5.5,11.5 L6.5,11.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M8.5,11.5 L9.5,11.5\" id=\"Line-Copy\" stroke-linecap=\"round\"/><path d=\"M11.5,11.5 L12.5,11.5\" id=\"Line-Copy-2\" stroke-linecap=\"round\"/><path d=\"M14.5,11.5 L15.5,11.5\" id=\"Line-Copy-3\" stroke-linecap=\"round\"/><path d=\"M17.5,11.5 L18.5,11.5\" id=\"Line-Copy-4\" stroke-linecap=\"round\"/><path d=\"M5.5,13.5 L6.5,13.5\" id=\"Line-Copy-9\" stroke-linecap=\"round\"/><path d=\"M8.5,13.5 L9.5,13.5\" id=\"Line-Copy-5\" stroke-linecap=\"round\"/><path d=\"M11.5,13.5 L12.5,13.5\" id=\"Line-Copy-6\" stroke-linecap=\"round\"/><path d=\"M14.5,13.5 L15.5,13.5\" id=\"Line-Copy-7\" stroke-linecap=\"round\"/><path d=\"M17.5,13.5 L18.5,13.5\" id=\"Line-Copy-8\" stroke-linecap=\"round\"/><path d=\"M5.5,15.5 L6.5,15.5\" id=\"Line-Copy-19\" stroke-linecap=\"round\"/><path d=\"M9.5,15.5 L14.5,15.5\" id=\"Line-Copy-16\" stroke-linecap=\"round\"/><path d=\"M17.5,15.5 L18.5,15.5\" id=\"Line-Copy-18\" stroke-linecap=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-cro.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"conversion-rate-optimization\" stroke=\"#212121\"><g id=\"ico-CRO\"><path d=\"M19.4836239,11.5003981 C19.2265255,7.59119396 15.9742563,4.5 12,4.5 C8.92803685,4.5 6.28744342,6.34691337 5.12804,8.99091986\" id=\"Oval-12\"/><path d=\"M4.5,9.5 L6.5,9.5\" id=\"Line\"/><path d=\"M4.5,9.5 L4.5,7.5\" id=\"Line\"/><path d=\"M18.87196,19.5 C18.6148616,15.5907958 15.3625923,12.4996019 11.3883361,12.4996019 C8.31637293,12.4996019 5.67577951,14.3465153 4.51637608,16.9905217\" id=\"Oval-12-Copy\" transform=\"translate(11.694168, 15.999801) scale(-1, -1) translate(-11.694168, -15.999801) \"/><path d=\"M17.5,14.5 L19.5,14.5\" id=\"Line-Copy\" transform=\"translate(18.500000, 14.500000) scale(-1, -1) translate(-18.500000, -14.500000) \"/><path d=\"M19.5,16.5 L19.5,14.5\" id=\"Line-Copy-2\" transform=\"translate(19.500000, 15.500000) scale(-1, -1) translate(-19.500000, -15.500000) \"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-cross.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"close\" stroke=\"#212121\"><g id=\"ico-close\"><path d=\"M17.6915966,6.30840337 L6.30840337,17.6915966\" id=\"Path-15\"/><path d=\"M6.33934081,6.33934081 L17.6606592,17.6606592\" id=\"Path-16\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-ecommerce.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"ecommerce\" stroke=\"#212121\"><g id=\"ico-ecommerce\"><circle id=\"Oval-12-Copy\" cx=\"18\" cy=\"18\" r=\"1.5\"/><circle id=\"Oval-12-Copy-2\" cx=\"11\" cy=\"18\" r=\"1.5\"/><path d=\"M8.66190815,8.48314823 C8.56097301,7.94017046 8.92506286,7.5 9.48860534,7.5 L18.8447045,7.5 C19.4022119,7.5 19.7571782,7.93476315 19.6348393,8.48319565 L18.9359814,11.6161008 C18.8148534,12.1591048 18.2777474,12.6484864 17.7254762,12.7103807 L10.6078337,13.5080715 C10.0604181,13.5694216 9.53484383,13.1790812 9.43389086,12.6360075 L8.66190815,8.48314823 Z\" id=\"Rectangle-40\"/><path d=\"M4.5,4.5 L7.5,16.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M4.5,4.5 L3.5,4.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M18.5,16.5 L7.5,16.5\" id=\"Line\" stroke-linecap=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-email-marketing.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"email-marketing\" stroke=\"#212121\"><g id=\"ico-email-marketing\"><path d=\"M4.5,17.5 L7.44834625,15.5\" id=\"Path-3\" stroke-linecap=\"round\"/><circle id=\"Oval-8\" cx=\"17.5\" cy=\"8.5\" r=\"4\"/><path d=\"M13.5,17.5 L16.4483463,15.5\" id=\"Path-3-Copy\" stroke-linecap=\"round\" transform=\"translate(14.974173, 16.500000) scale(-1, 1) translate(-14.974173, -16.500000) \"/><path d=\"M4.5,10.5 L9.73553368,14.4024347 C10.1782991,14.7324609 10.8926877,14.7317431 11.3401949,14.3940171 C11.3401949,14.3940171 12.5147697,13.5075854 13,13.0648232\" id=\"Path-2\" stroke-linecap=\"round\"/><path d=\"M18.5,15.5 L18.5,18.5051929 C18.5,19.0546097 18.0553691,19.5 17.4991283,19.5 L3.50087166,19.5 C2.9481055,19.5 2.5,19.055163 2.5,18.5044225 L2.5,9.4955775 C2.5,8.94573523 2.94376523,8.5 3.50770254,8.5 L10.5,8.5\" id=\"Rectangle-3\" stroke-linecap=\"round\"/><path d=\"M15.5,8.5 L19.5,8.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M17.5,6.5 L17.5,10.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M6.5,6.5 L11.5,6.5\" id=\"Line-Copy\" stroke-linecap=\"round\"/><path d=\"M3.5,4.5 L8.5,4.5\" id=\"Line-Copy-2\" stroke-linecap=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-email.svg',
    "<svg class=\"Icon-image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M12 10.823l8.965-5.563C20.677 5.1 20.352 5 20 5H4c-.352 0-.678.1-.965.26L12 10.823z\"/><path d=\"M12.527 12.85c-.16.1-.344.15-.527.15s-.366-.05-.527-.15l-9.47-5.877C2.003 6.983 2 6.99 2 7v9c0 1.1.897 2 2 2h16c1.103 0 2-.9 2-2V7c0-.01-.003-.02-.003-.028l-9.47 5.877z\"/></svg>"
  );


  $templateCache.put('/icons/wfIcon-facebook-square.svg',
    "<?xml version=\"1.0\" ?><!DOCTYPE svg  PUBLIC '-//W3C//DTD SVG 1.0//EN'  'http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd'><svg enable-background=\"new 0 0 32 32\" height=\"32px\" id=\"Layer_1\" version=\"1.0\" viewBox=\"0 0 32 32\" width=\"32px\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g><path d=\"M32,30c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2c0-1.104,0.896-2,2-2h28c1.104,0,2,0.896,2,2V30z\" fill=\"#3B5998\"/><path d=\"M22,32V20h4l1-5h-5v-2c0-2,1.002-3,3-3h2V5c-1,0-2.24,0-4,0c-3.675,0-6,2.881-6,7v3h-4v5h4v12H22z\" fill=\"#FFFFFF\" id=\"f\"/></g><g/><g/><g/><g/><g/><g/></svg>"
  );


  $templateCache.put('/icons/wfIcon-facebook.svg',
    "<svg width=\"11\" height=\"25\" viewBox=\"0 0 11 25\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g transform=\"translate(0 .72)\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M10.995 7.662H7.25V5.206c0-.922.612-1.137 1.042-1.137h2.642V.013L7.294 0c-4.04 0-4.958 3.024-4.958 4.96V7.66H0v4.177h2.336v11.82H7.25V11.84h3.316l.43-4.178z\" fill=\"#FFF\" mask=\"url(#facebook-b)\"/></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-favourite.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"favourite\" stroke=\"#212121\"><g id=\"ico-favourite\"><path d=\"M11.9975968,7.88639236 C11.0704267,6.38169961 9.57198204,5.5 7.89619006,5.5 C5.73079139,5.5 3.52495914,7.11097217 3.50013852,10.1902783 C3.47972156,12.6815517 5.72038274,14.8611134 7.52107847,15.808888 C7.83934284,15.9759984 8.14920022,16.1389135 8.43583831,16.3032271 C10.3133979,17.3768589 11.8738941,18.5 12.0076052,18.5 C12.1469209,18.498252 13.8247145,17.3492403 15.5737674,16.2686164 C15.9172527,16.0560576 16.2931649,15.8515396 16.6914958,15.6351351 C18.4861865,14.6600914 20.5194755,12.5549953 20.4998592,10.1619605 C20.4750386,6.99805029 18.2083558,5.55733495 16.1122146,5.55733495 C14.4388246,5.55733495 12.906752,6.43693694 11.9975968,7.88639236 Z\" id=\"Path-Copy\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-feed.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"feed\" stroke=\"#212121\"><g id=\"ico-feed\"><polygon id=\"Line\" stroke-linecap=\"round\" points=\"5.5 12.5 8.5 15.5 5.5 15.5 \"/><polygon id=\"Path\" stroke-linecap=\"round\" points=\"15.5 12.5 18.5 15.5 15.5 15.5 \"/><path d=\"M12,20.5 L12,17.5\" id=\"Path\" stroke-linecap=\"round\"/><path d=\"M15,19.5 L15,17.5\" id=\"Line-Copy\" stroke-linecap=\"round\"/><path d=\"M9,19.5 L9,17.5\" id=\"Line-Copy-2\" stroke-linecap=\"round\"/><polygon id=\"Polygon-1\" points=\"12.0267115 3.02646384 15.5 7.80601093 15.5 15.5 8.5 15.5 8.5 7.80601093 \"/><circle id=\"Oval-6\" cx=\"12\" cy=\"8\" r=\"0.5\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-filter.svg',
    "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M14.5 6c0-.346.047-.678.12-1H2v2h12.62c-.073-.324-.12-.656-.12-1zM14.5 18c0-.346.047-.678.12-1H2v2h12.62c-.073-.324-.12-.656-.12-1zM4.5 12c0-.346.047-.678.12-1H2v2h2.62c-.073-.324-.12-.656-.12-1zM13.38 11c.073.322.12.654.12 1 0 .344-.047.676-.12 1H22v-2h-8.62z\"/><circle cx=\"19\" cy=\"5.999\" r=\"3\"/><circle cx=\"9\" cy=\"11.999\" r=\"3\"/><circle cx=\"19\" cy=\"17.999\" r=\"3\"/></svg>"
  );


  $templateCache.put('/icons/wfIcon-freemarket-com.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"freemarket.com\" stroke=\"#212121\"><g id=\"ico-freemarket.com\"><rect id=\"Rectangle-25\" x=\"4.5\" y=\"4.5\" width=\"15\" height=\"15\" rx=\"1\"/><path d=\"M10.5,7.5 L8.5,16.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M15.5,7.5 L13.5,16.5\" id=\"Line-Copy\" stroke-linecap=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-freemarket.com.svg',
    "<svg class=\"wfIcon-freemarket\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke-width=\"1\" fill-rule=\"evenodd\"><g id=\"freemarket.com\"><g id=\"ico-freemarket.com\"><rect id=\"Rectangle-25\" x=\"4.5\" y=\"4.5\" width=\"15\" height=\"15\" rx=\"1\"/><path d=\"M10.5,7.5 L8.5,16.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M15.5,7.5 L13.5,16.5\" id=\"Line-Copy\" stroke-linecap=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-full-screen.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"full-screen\" stroke=\"#212121\"><g id=\"ico-full-screen\"><path d=\"M19.5,19.5 L19.5,16.5\" id=\"Line\"/><path d=\"M19.5,19.5 L16.5,19.5\" id=\"Line\"/><path d=\"M19.5,19.5 L15.5,15.5\" id=\"Line\"/><path d=\"M19.5,7.5 L19.5,4.5\" id=\"Line\" transform=\"translate(19.500000, 6.000000) scale(1, -1) translate(-19.500000, -6.000000) \"/><path d=\"M19.5,4.5 L16.5,4.5\" id=\"Line\" transform=\"translate(18.000000, 4.500000) scale(1, -1) translate(-18.000000, -4.500000) \"/><path d=\"M19.5,8.5 L15.5,4.5\" id=\"Line\" transform=\"translate(17.500000, 6.500000) scale(1, -1) translate(-17.500000, -6.500000) \"/><path d=\"M4.5,19.5 L4.5,16.5\" id=\"Line\" transform=\"translate(4.500000, 18.000000) scale(-1, 1) translate(-4.500000, -18.000000) \"/><path d=\"M7.5,19.5 L4.5,19.5\" id=\"Line\" transform=\"translate(6.000000, 19.500000) scale(-1, 1) translate(-6.000000, -19.500000) \"/><path d=\"M8.5,19.5 L4.5,15.5\" id=\"Line\" transform=\"translate(6.500000, 17.500000) scale(-1, 1) translate(-6.500000, -17.500000) \"/><path d=\"M4.5,7.5 L4.5,4.5\" id=\"Line\" transform=\"translate(4.500000, 6.000000) scale(-1, -1) translate(-4.500000, -6.000000) \"/><path d=\"M7.5,4.5 L4.5,4.5\" id=\"Line\" transform=\"translate(6.000000, 4.500000) scale(-1, -1) translate(-6.000000, -4.500000) \"/><path d=\"M8.5,8.5 L4.5,4.5\" id=\"Line\" transform=\"translate(6.500000, 6.500000) scale(-1, -1) translate(-6.500000, -6.500000) \"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-google.svg',
    "<svg width=\"16px\" height=\"17px\" viewBox=\"0 0 16 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"WF_FeedRedesignDesktop\" transform=\"translate(-915.000000, -286.000000)\"><rect id=\"Background\" x=\"0\" y=\"65\" width=\"1680\" height=\"2387\"/><g id=\"Group-10\" transform=\"translate(276.000000, 115.000000)\" fill=\"#191919\"><g id=\"Group-6\" transform=\"translate(574.000000, 170.000000)\"><path d=\"M80.6381615,11.9681551 C80.2651242,13.2537156 79.5602603,14.4493617 78.5722733,15.3576032 C77.6378068,16.2203524 76.4673153,16.8112178 75.2304584,17.0959464 C73.8614061,17.4074353 72.4136787,17.4159985 71.0537249,17.0509893 C69.9758236,16.764655 68.9594709,16.250859 68.087088,15.5556288 C67.1627904,14.8207934 66.4006596,13.8836509 65.8692019,12.8292986 C65.0514099,11.2145876 64.7998639,9.32371118 65.1605915,7.5505797 C65.3040263,6.83875812 65.5432625,6.14727431 65.8702723,5.49860683 C66.8100908,3.6173641 68.5045473,2.12896124 70.4949717,1.44764631 C72.2611455,0.836443122 74.2397954,0.849823227 75.9941948,1.49581469 C76.9688016,1.85333108 77.8604518,2.41957712 78.6215121,3.12337063 C78.3667549,3.4000712 78.0905896,3.65750441 77.8278043,3.92617692 C77.3268532,4.42659283 76.8275077,4.92807916 76.3260214,5.42742467 C75.8293519,4.95323376 75.2229655,4.59304134 74.5657348,4.39341017 C73.7923647,4.15899074 72.9590518,4.12687849 72.1685552,4.29546781 C71.2458632,4.49349336 70.3895365,4.97571233 69.7307001,5.65006961 C69.1965663,6.19062585 68.7903464,6.85534945 68.545758,7.57466388 C68.1935937,8.59529828 68.1962697,9.73207198 68.5441524,10.7537768 C68.8845423,11.7578198 69.5471251,12.6505404 70.4152263,13.2606732 C70.9584585,13.6433442 71.580901,13.9152279 72.2327797,14.0452826 C72.8739543,14.174802 73.5381427,14.1608867 74.180923,14.0511698 C74.8199568,13.9393121 75.439188,13.7038223 75.9786738,13.341489 C76.836071,12.7682854 77.4413869,11.8375653 77.6131874,10.8201421 C76.1301366,10.8196069 74.6470858,10.8196069 73.164035,10.8201421 C73.1624294,9.75829698 73.164035,8.69591666 73.1634998,7.63407155 C75.7244518,7.63353635 78.2854039,7.63300114 80.8458208,7.63407155 C81.1011131,9.06948919 81.0449167,10.5659201 80.6381615,11.9681551\" id=\"Fill-1\"/></g></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-graph.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"graph\" stroke=\"#212121\"><g id=\"ico-graph\"><path d=\"M6.5,4.5 L6.5,17.5\" id=\"Line\"/><path d=\"M3.5,4.5 L4.5,4.5\" id=\"Line\"/><path d=\"M3.5,6.5 L4.5,6.5\" id=\"Line-Copy\"/><path d=\"M3.5,8.5 L4.5,8.5\" id=\"Line-Copy-2\"/><path d=\"M3.5,10.5 L4.5,10.5\" id=\"Line-Copy-3\"/><path d=\"M3.5,12.5 L4.5,12.5\" id=\"Line-Copy-4\"/><path d=\"M3.5,14.5 L4.5,14.5\" id=\"Line-Copy-5\"/><path d=\"M3.5,16.5 L4.5,16.5\" id=\"Line-Copy-6\"/><path d=\"M6.5,17.5 L19.5,17.5\" id=\"Line\"/><path d=\"M7.5,19.5 L7.5,20.5\" id=\"Line\"/><path d=\"M9.5,19.5 L9.5,20.5\" id=\"Line-Copy-7\"/><path d=\"M11.5,19.5 L11.5,20.5\" id=\"Line-Copy-8\"/><path d=\"M13.5,19.5 L13.5,20.5\" id=\"Line-Copy-9\"/><path d=\"M15.5,19.5 L15.5,20.5\" id=\"Line-Copy-10\"/><path d=\"M17.5,19.5 L17.5,20.5\" id=\"Line-Copy-11\"/><path d=\"M19.5,19.5 L19.5,20.5\" id=\"Line-Copy-12\"/><path d=\"M9.5,13.5 L9.5,7.49810135 C9.5,6.39458045 10.3877296,5.5 11.5,5.5 L11.5,5.5 C12.6045695,5.5 13.5,6.38743329 13.5,7.49961498 L13.5,13.500385 C13.5,14.6047419 14.3877296,15.5 15.5,15.5 L15.5,15.5 C16.6045695,15.5 17.5,14.6134452 17.5,13.4940809 L17.5,8.5\" id=\"Path-174\"/><path d=\"M17.5,7.5 L18.5,8.5\" id=\"Line\"/><path d=\"M17.5,7.5 L16.5,8.5\" id=\"Line\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-growth-hacking.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"growth-hacker\" stroke=\"#212121\"><g id=\"ico-growth-hacker\"><ellipse id=\"Oval-9\" cx=\"8\" cy=\"6.5\" rx=\"3.5\" ry=\"2\"/><ellipse id=\"Oval-9-Copy\" cx=\"16\" cy=\"10.5\" rx=\"3.5\" ry=\"2\"/><path d=\"M12,6.49041444 L12,19.5356684\" id=\"Line\" stroke-linecap=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-hamberger.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"hamburger\" stroke=\"#212121\"><g id=\"ico-hamburger-menu\"><path d=\"M7.5,12 L17.5,12\" id=\"Line\"/><path d=\"M7.5,9 L13.5,9\" id=\"Line-Copy\"/><path d=\"M7.5,15 L17.5,15\" id=\"Line-Copy-2\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-hamburger.svg',
    "<svg class=\"wfIcon-hamburger\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.5 12h10m-10-3h6m-6 6h10\"/></svg>"
  );


  $templateCache.put('/icons/wfIcon-help.svg',
    "<svg class=\"wfIcon-help\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke-width=\"1\" fill-rule=\"evenodd\"><g id=\"help\"><g id=\"ico-help\"><circle id=\"Oval-20\" cx=\"12\" cy=\"12\" r=\"3.5\"/><circle id=\"Oval-20-Copy\" cx=\"12\" cy=\"12\" r=\"7.5\"/><path d=\"M6.8527832,6.8527832 L9.53771973,9.53771973\" id=\"Path\" stroke-linecap=\"round\"/><path d=\"M14.5654907,14.5654907 L17.225708,17.1976318\" id=\"Path\" stroke-linecap=\"round\"/><path d=\"M17.1951904,6.80480957 L14.4584961,9.54150391\" id=\"Path\" stroke-linecap=\"round\"/><path d=\"M9.42773438,14.5722656 L6.89339828,17.1066017\" id=\"Path\" stroke-linecap=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-html.svg',
    "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\"><path d=\"M14 18l-2-2-6 6 6 6 2-2-4-4zm4 8l2 2 6-6-6-6-2 2 4 4zM28.232 6.232l-4.465-4.464C22.795.796 20.874 0 19.5 0h-15C3.123 0 2 1.125 2 2.5v27C2 30.875 3.123 32 4.5 32h23c1.374 0 2.5-1.125 2.5-2.5v-19c0-1.375-.797-3.296-1.77-4.268zm-1.414 1.414c.098.098.195.218.29.354H22V2.892c.136.095.256.192.354.29l4.465 4.464zM28 29.5c0 .27-.23.5-.5.5h-23c-.27 0-.5-.23-.5-.5v-27c0-.27.23-.5.5-.5h15c.15 0 .32.02.5.053V10h7.947c.034.18.053.35.053.5v19z\"/></svg>"
  );


  $templateCache.put('/icons/wfIcon-internet-marketing.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"internet-marketing\" stroke=\"#212121\"><g id=\"ico-internet-marketing\"><rect id=\"Rectangle-23\" x=\"3.5\" y=\"7.5\" width=\"17\" height=\"13\" rx=\"1\"/><path d=\"M6.5,3.5 L17.5,3.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M5.5,5.5 L18.5,5.5\" id=\"Line-Copy\" stroke-linecap=\"round\"/><path d=\"M5.5,11.5 L18.5,11.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M5.5,9.5 L5.5,9.5\" id=\"Line-Copy-2\" stroke-linecap=\"round\"/><path d=\"M7.5,9.5 L7.5,9.5\" id=\"Line-Copy-3\" stroke-linecap=\"round\"/><path d=\"M9.5,9.5 L9.5,9.5\" id=\"Line-Copy-4\" stroke-linecap=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-key.svg',
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"-486.3 471.8 41 40\" style=\"enable-background:new -486.3 471.8 41 40;\" xml:space=\"preserve\"><g><path class=\"st1\" d=\"M-452.7,499.5h3.5l0-6.1h3.5v-5.2l-23.2,0c-0.4-1.1-1-2-1.8-2.9l-0.1-0.1c-3.3-3.3-8.7-3.4-12.1-0.1\n" +
    "\t\tc-1.7,1.6-2.6,3.7-2.7,6.1c-0.1,2.3,0.8,4.5,2.4,6.2l0.1,0.1c3.3,3.3,8.7,3.4,12.1,0.1c1.2-1.2,2-2.6,2.4-4.2l9.1,0l0,6.1l3.5,0\n" +
    "\t\tl0-6.1l3.5,0L-452.7,499.5z M-479.6,493.8c-1.4-1.4-1.4-3.5,0-4.9c1.4-1.4,3.5-1.4,4.9,0c1.4,1.4,1.4,3.5,0,4.9\n" +
    "\t\tC-476.1,495.2-478.2,495.2-479.6,493.8z\"/></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-local-events.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"social-media\" stroke=\"#212121\"><g id=\"ico-social-media\" transform=\"translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) \"><circle id=\"Oval-14\" cx=\"5\" cy=\"5\" r=\"1.5\"/><path d=\"M15.5,5.5 L6.5,10.5\" id=\"Line\" stroke-linecap=\"round\" transform=\"translate(11.000000, 8.000000) scale(-1, 1) translate(-11.000000, -8.000000) \"/><path d=\"M10.5,13.5 L15.5,15.5\" id=\"Line\" stroke-linecap=\"round\" transform=\"translate(13.000000, 14.500000) scale(-1, 1) translate(-13.000000, -14.500000) \"/><circle id=\"Oval-14-Copy-2\" cx=\"18\" cy=\"12\" r=\"2.5\"/><circle id=\"Oval-14-Copy\" cx=\"7\" cy=\"17\" r=\"3.5\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-local-meetup.svg',
    "<svg class=\"wfIcon-local-meetup\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke-width=\"1\" fill-rule=\"evenodd\"><g id=\"local-meetup\"><g id=\"ico-local-meetup\"><circle id=\"Oval-11\" cx=\"12\" cy=\"8\" r=\"2.5\"/><path d=\"M7.5,18.5 L8.00585926,15.4648445 C8.27876565,13.8274061 9.84967041,12.5 11.5092545,12.5 L12.4907455,12.5 C14.1527109,12.5 15.7219324,13.8315945 15.9941407,15.4648445 L16.5,18.5\" id=\"Rectangle-32\" stroke-linecap=\"round\"/><path d=\"M16.5079004,9.37681472 C16.7078296,9.45630171 16.9258746,9.5 17.154126,9.5 C18.1206243,9.5 18.904126,8.71649831 18.904126,7.75 C18.904126,6.78350169 18.1206243,6 17.154126,6 C16.7687636,6 16.4124936,6.12455938 16.1233806,6.33561353\" id=\"Oval-11-Copy\" stroke-linecap=\"round\"/><path d=\"M16.5092545,11.5 L17.4907455,11.5 C19.1527109,11.5 20.7219324,12.8315945 20.9941407,14.4648445 L21.5,17.5\" id=\"Rectangle-32-Copy\" stroke-linecap=\"round\"/><path d=\"M5.50790039,9.37681472 C5.70782959,9.45630171 5.92587464,9.5 6.15412598,9.5 C7.12062429,9.5 7.90412598,8.71649831 7.90412598,7.75 C7.90412598,6.78350169 7.12062429,6 6.15412598,6 C5.76876357,6 5.41249355,6.12455938 5.12338056,6.33561353\" id=\"Oval-11-Copy-2\" stroke-linecap=\"round\" transform=\"translate(6.513753, 7.750000) scale(-1, 1) translate(-6.513753, -7.750000) \"/><path d=\"M2.50925446,11.5 L3.49074554,11.5 C5.15271089,11.5 6.72193241,12.8315945 6.99414074,14.4648445 L7.5,17.5\" id=\"Rectangle-32-Copy-2\" stroke-linecap=\"round\" transform=\"translate(5.004627, 14.500000) scale(-1, 1) translate(-5.004627, -14.500000) \"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-location.svg',
    "<svg width=\"14\" height=\"20\" viewBox=\"0 0 14 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 0C3.134 0 0 3.134 0 7c0 5 7 13 7 13s7-8 7-13c0-3.866-3.134-7-7-7zm0 9.5C5.62 9.5 4.5 8.38 4.5 7S5.62 4.5 7 4.5 9.5 5.62 9.5 7 8.38 9.5 7 9.5z\" fill=\"#FFF\" fill-rule=\"evenodd\"/></svg>"
  );


  $templateCache.put('/icons/wfIcon-mastercard.svg',
    "<svg width=\"30\" height=\"20\" viewBox=\"0 0 30 20\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><path id=\"a\" d=\"M0 .078h20.488v12.27H0\"/></defs><g fill=\"none\" fill-rule=\"evenodd\"><rect fill=\"#003473\" x=\".714\" width=\"28.571\" height=\"20\" rx=\"2\"/><path d=\"M17.26 9.784c0 3.39-2.746 6.135-6.13 6.135C7.743 15.92 5 13.172 5 9.783 5 6.396 7.744 3.65 11.13 3.65c3.384 0 6.13 2.746 6.13 6.134\" fill=\"#ED1B2D\"/><g transform=\"translate(5 3.57)\"><mask id=\"b\" fill=\"#fff\"><use xlink:href=\"#a\"/></mask><path d=\"M14.358.078c-1.584 0-3.027.6-4.114 1.588-.222.2-.428.418-.62.65h1.24c.168.205.323.422.466.65H9.157c-.13.208-.248.425-.353.65h2.88c.098.21.184.426.26.648h-3.4c-.07.212-.13.428-.178.65h3.754c.09.42.14.853.14 1.3 0 .68-.112 1.336-.317 1.948H8.545c.074.222.16.44.26.65h2.88c-.107.224-.224.44-.355.65H9.157c.142.226.298.443.468.648h1.238c-.19.232-.397.45-.62.65 1.088.987 2.53 1.588 4.115 1.588 3.386 0 6.13-2.747 6.13-6.135S17.744.078 14.358.078\" fill=\"#FBB130\" mask=\"url(#b)\"/></g><path d=\"M8.25 11.397h-.665l.382-2.392-.85 2.392H6.66L6.606 9.02l-.4 2.377H5.58l.52-3.11h.958l.027 1.925.644-1.926h1.036l-.515 3.11zM10.373 11.397h-.55l.012-.26c-.168.206-.393.304-.698.304-.36 0-.607-.28-.607-.69 0-.616.43-.976 1.167-.976.076 0 .173.008.272.02.02-.084.025-.12.025-.164 0-.168-.116-.23-.426-.23-.327-.004-.596.077-.707.113.008-.042.093-.57.093-.57.33-.096.55-.132.796-.132.572 0 .874.258.874.742 0 .13-.02.29-.054.502-.057.366-.18 1.153-.2 1.343M9.89 10.27c-.07-.008-.1-.01-.15-.01-.376 0-.567.13-.567.385 0 .157.093.258.24.258.27 0 .465-.258.477-.633M19.298 8.37l-.108.675c-.238-.12-.41-.168-.594-.168-.498 0-.846.48-.846 1.166 0 .472.234.758.62.758.165 0 .345-.05.566-.16l-.117.71c-.246.067-.405.09-.59.09-.715 0-1.162-.514-1.162-1.342 0-1.113.618-1.89 1.5-1.89.29 0 .633.123.73.162M20.856 11.397h-.55l.012-.26c-.168.206-.393.304-.698.304-.36 0-.607-.28-.607-.69 0-.616.43-.976 1.168-.976.076 0 .173.008.272.02.02-.084.026-.12.026-.164 0-.168-.116-.23-.427-.23-.324-.004-.593.077-.704.113l.093-.57c.33-.096.55-.132.795-.132.572 0 .875.258.874.742 0 .13-.022.29-.055.502-.058.366-.18 1.153-.2 1.343m-.483-1.127c-.07-.008-.1-.01-.148-.01-.377 0-.568.13-.568.385 0 .157.093.258.24.258.27 0 .465-.258.476-.633M13.33 11.36c-.18.056-.323.08-.477.08-.34 0-.526-.194-.526-.555-.005-.11.05-.406.09-.674l.29-1.726h.66l-.076.383h.34l-.09.608h-.34c-.078.482-.187 1.08-.19 1.16 0 .13.07.188.23.188.076 0 .134-.008.18-.024l-.09.56zM14.987 9.838c.003-.052.07-.45-.307-.45-.21 0-.362.16-.424.45h.73zm.372 1.5c-.23.07-.448.104-.68.103-.74 0-1.126-.386-1.126-1.127 0-.866.49-1.502 1.158-1.502.544 0 .892.357.892.916 0 .186-.023.367-.08.623h-1.317c-.045.366.19.52.574.52.238 0 .45-.05.69-.16l-.11.63zM10.772 9.667c0 .32.155.54.508.707.27.126.31.164.31.28 0 .157-.118.227-.382.227-.198 0-.383-.03-.596-.098 0 0-.088.558-.09.584.15.034.285.064.69.075.703 0 1.028-.266 1.028-.845 0-.347-.136-.55-.47-.705-.28-.128-.31-.156-.31-.275 0-.136.11-.206.325-.206.13 0 .308.013.478.036l.095-.586c-.172-.027-.434-.05-.586-.05-.744 0-1.002.39-1 .857M23.396 10.813c.31 0 .528-.352.528-.853 0-.32-.124-.496-.352-.496-.302 0-.517.352-.517.85 0 .33.115.5.34.5zm.982.584h-.63l.032-.235c-.182.195-.37.28-.613.28-.484 0-.804-.418-.804-1.05 0-.842.496-1.552 1.083-1.552.258 0 .453.105.635.345l.15-.9h.656l-.508 3.112zM21.456 8.867c-.083.783-.232 1.577-.347 2.36l-.032.17h.666c.238-1.547.295-1.85.67-1.81.058-.318.17-.596.25-.735-.277-.058-.434.1-.637.4.016-.13.046-.256.04-.385h-.61zM15.978 8.867c-.084.783-.232 1.577-.347 2.36l-.03.17h.666c.24-1.547.295-1.85.668-1.81.06-.318.17-.596.253-.735-.278-.058-.434.1-.638.4.016-.13.045-.256.04-.385h-.612z\" fill=\"#FFF\"/></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-mobile-marketing.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"mobile-marketing\" stroke=\"#212121\"><g id=\"ico-offline-marketing\"><rect id=\"Rectangle-35\" x=\"6.5\" y=\"4.5\" width=\"11\" height=\"15\" rx=\"1\"/><rect id=\"Rectangle-35-Copy\" x=\"8.5\" y=\"6.5\" width=\"7\" height=\"9\" rx=\"1\"/><path d=\"M11.5,17.5 L12.5,17.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M11.5,10.5 L13.5,8.5\" id=\"Line-Copy-2\" stroke-linecap=\"round\"/><path d=\"M11.5,12.5 L13.5,10.5\" id=\"Line-Copy\" stroke-linecap=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-more.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"more\" stroke=\"#212121\"><g id=\"ico-more\" transform=\"translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) \"><circle id=\"Oval-17\" cx=\"12\" cy=\"12\" r=\"1.5\"/><circle id=\"Oval-17-Copy\" cx=\"6\" cy=\"12\" r=\"1.5\"/><circle id=\"Oval-17-Copy-2\" cx=\"18\" cy=\"12\" r=\"1.5\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-new-thread.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"new-thread\" stroke=\"#212121\"><g id=\"ico-new-thread\"><path d=\"M15.5,15.0004883 L15.5,18.4929446 C15.5,19.0491259 15.044239,19.5 14.4975267,19.5 L5.50247329,19.5 C4.94882258,19.5 4.5,19.0510798 4.5,18.492516 L4.5,5.50748397 C4.5,4.95106594 4.95576096,4.5 5.50247329,4.5 L14.4975267,4.5 C15.0511774,4.5 15.5,4.95440134 15.5,5.50134981 L15.5,7.99487305\" id=\"Rectangle-11\"/><path d=\"M15.5,11.5 L19.5,11.5\" id=\"Line\"/><path d=\"M6.5,7.5 L11.5,7.5\" id=\"Line-Copy-2\"/><path d=\"M6.5,10.5 L12.5,10.5\" id=\"Line-Copy-3\"/><path d=\"M6.5,13.5 L13.5,13.5\" id=\"Line-Copy-4\"/><path d=\"M6.5,16.5 L10.5,16.5\" id=\"Line-Copy-5\"/><path d=\"M17.5,13.5 L17.5,9.5\" id=\"Line-Copy\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-next.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"next\" stroke=\"#212121\"><g id=\"ico-next\"><path d=\"M10,4.5 L14,11.9957275 L10,19.5\" id=\"Line\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-notifications.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"notifications\" stroke=\"#212121\"><g id=\"ico-notifications\"><circle id=\"Oval-5\" cx=\"12\" cy=\"4\" r=\"0.5\"/><path d=\"M11,19.5 C11,20.0522847 11.4477153,20.5 12,20.5 L12,20.5 C12.5522847,20.5 13,20.0522847 13,19.5\" id=\"Oval-6\" stroke-linecap=\"round\"/><path d=\"M17.5,9.50361046 C17.5,6.74019271 15.2607271,4.5 12.4989013,4.5 L11.5010987,4.5 C8.73906814,4.5 6.5,6.73659668 6.5,9.50361046 L6.5,16.1 L4.65684557,18.2380591 C4.29407978,18.6588675 4.44463086,19 5.00087166,19 L18.9991283,19 C19.5518945,19 19.7132182,18.6673331 19.3431544,18.2380591 L17.5,16.1 L17.5,9.50361046 Z\" id=\"Rectangle-12\"/><path d=\"M8.5,9.5 L10.5,7.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M8.5,11.5 L10.5,9.5\" id=\"Line-Copy\" stroke-linecap=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-offline-marketing.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"offline-marketing\" stroke=\"#212121\"><g id=\"ico-offline-marketing\"><path d=\"M18.5000015,13.5 L11.5,11.5 C11.5,11.5 11.5003405,10.1266675 11.5003882,9.5 C11.500564,9.02796797 11.5009156,7.5 11.5009156,7.5 L18.5000015,5.5 L18.5000015,13.5 Z\" id=\"Path-Copy-2\" stroke-linejoin=\"round\"/><path d=\"M18.5,9.5 L19.5,9.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M11.4899998,7.5 L11.5,18.5 L9.5,18.5 L9.5,12.5 L6.5048815,12.5 C5.39761602,12.5 4.5,11.6061002 4.5,10.4951185 L4.5,9.5048815 C4.5,8.39761602 5.39951029,7.5 6.50305339,7.5 L11.4899998,7.5 Z\" id=\"Path-Copy-3\" stroke-linejoin=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-password.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"password\" stroke=\"#212121\"><g id=\"ico-password\"><path d=\"M12,17.5 L12,14.5\" id=\"Line\" stroke-linecap=\"round\" transform=\"translate(12.000000, 16.000000) scale(-1, -1) translate(-12.000000, -16.000000) \"/><path d=\"M16,6.5 C16,4.290861 14.209139,2.5 12,2.5 C9.790861,2.5 8,4.290861 8,6.5\" id=\"Oval-9\" stroke-linecap=\"round\"/><circle id=\"Oval-1\" cx=\"12\" cy=\"15\" r=\"0.5\"/><circle id=\"Oval-3\" cx=\"12\" cy=\"15.5\" r=\"6\"/><path d=\"M16,7.5 L16,6.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M8,7.5 L8,6.5\" id=\"Line-Copy\" stroke-linecap=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-paypal.svg',
    "<svg width=\"78px\" height=\"21px\" viewBox=\"0 0 78 21\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><path id=\"path-1\" d=\"M0,0 L77.2390244,0 L77.2390244,20.325765 L0,20.325765 L0,0 Z\"/><path id=\"path-3\" d=\"M0,0 L77.2390244,0 L77.2390244,20.325765 L0,20.325765 L0,0 Z\"/><path id=\"path-5\" d=\"M0,0 L45,0 L45,15 L0,15 L0,0 Z\"/></defs><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"return-sticky\" transform=\"translate(-602.000000, -533.000000)\"><g id=\"Group-21\" transform=\"translate(550.000000, 512.000000)\"><g id=\"Page-1\" transform=\"translate(52.000000, 21.000000)\"><path d=\"M60.2962256,11.297212 C60.0715662,12.3569903 59.2181432,12.8188971 58.1843333,12.8649947 C57.2852248,12.9106266 56.4756032,12.1265024 57.0600944,11.2050169 C57.5103551,10.4213583 58.7688244,10.2369681 59.5327605,10.2369681 L60.521827,10.2369681 C60.431398,10.6057486 60.3852416,10.9288971 60.2962256,11.297212 M60.0268227,3.18357562 C58.0939043,3.18357562 56.5660322,3.69064879 55.3975208,3.92160222 L55.037218,6.82528293 C55.6217092,6.54869757 57.4641987,6.04209003 58.9930128,5.99552684 C60.521827,5.94942927 61.4204645,6.2721122 61.1063181,7.56284391 C56.5660322,7.56284391 53.5088749,8.48479513 52.8796402,11.3894071 C51.9800608,16.3684093 57.5103551,16.2301166 59.7126764,14.0630656 L59.4428026,15.2620679 L63.4880843,15.2620679 L65.2420288,7.3323561 C65.9602794,3.96676852 62.8583787,3.13794369 60.0268227,3.18357562\" id=\"Fill-1\" fill=\"#FFFFFF\"/><path d=\"M69.0024558,0 L65.6551724,15.2140576 L69.764979,15.2140576 L73.153709,0 L69.0024558,0 Z\" id=\"Fill-3\" fill=\"#FFFFFF\"/><path d=\"M49.988203,5.16292683 C49.7173872,6.31583149 48.5455789,7.23778271 47.4189851,7.23778271 L45.3918699,7.23778271 L46.2933333,3.08853659 L48.456092,3.08853659 C49.5826857,3.08853659 50.2580768,4.0104878 49.988203,5.16292683 M50.1224334,0 L42.5989347,0 L39.2643678,15.1670288 L43.6346285,15.1670288 L44.7612223,10.141929 L47.8701878,10.141929 C50.9334679,10.141929 53.4565293,8.29802661 54.1328623,5.16292683 C54.8982114,1.61341463 52.285192,0 50.1224334,0\" id=\"Fill-5\" fill=\"#FFFFFF\"/><path d=\"M20.9406743,11.297212 C20.7188409,12.3569903 19.830565,12.8188971 18.8094717,12.8649947 C17.9211958,12.9106266 17.1662084,12.1265024 17.7436348,11.2050169 C18.1873018,10.4213583 19.4306996,10.2369681 20.1414145,10.2369681 L21.1629788,10.2369681 C21.0739628,10.6057486 20.9854178,10.9288971 20.9406743,11.297212 M20.6302959,3.18357562 C18.7209267,3.18357562 17.2104809,3.69064879 16.1003716,3.92160222 L15.7452496,6.82528293 C16.2779325,6.54869757 18.0992278,6.04209003 19.6082606,5.99552684 C21.1187063,5.94942927 22.0069822,6.2721122 21.7399342,7.56284391 C17.2552244,7.56284391 14.2357458,8.48479513 13.6140469,11.3894071 C12.7257711,16.3684093 18.1873018,16.2301166 20.3185045,14.0630656 L20.0528695,15.2620679 L24.0934414,15.2620679 L25.8252496,7.3323561 C26.5359645,3.96676852 23.42747,3.13794369 20.6302959,3.18357562\" id=\"Fill-7\" fill=\"#FFFFFF\"/><g id=\"Group-11\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"/></mask><g id=\"Clip-10\"/><path d=\"M27.6944884,3.81818182 L31.7350603,3.81818182 L32.3864312,10.8818182 L36.340342,3.81818182 L40.5104345,3.81818182 L30.9094253,20.7234146 L26.3908046,20.7234146 L29.3448164,15.7532594 L27.6944884,3.81818182 Z\" id=\"Fill-9\" fill=\"#FFFFFF\" mask=\"url(#mask-2)\"/></g><path d=\"M10.7502103,5.16292683 C10.4793944,6.31583149 9.34997477,7.23778271 8.22055509,7.23778271 L6.14304458,7.23778271 L7.09160639,3.08853659 L9.25954584,3.08853659 C10.3437511,3.08853659 11.0662405,4.0104878 10.7502103,5.16292683 M10.8858537,0 L3.34257359,0 L0,15.1670288 L4.42677881,15.1670288 L5.51098402,10.141929 L8.67222876,10.141929 C11.6987721,10.141929 14.2284272,8.29802661 14.9057023,5.16292683 C15.6734062,1.61341463 13.0990076,0 10.8858537,0\" id=\"Fill-12\" fill=\"#FFFFFF\"/><g id=\"Group-16\"><mask id=\"mask-4\" fill=\"white\"><use xlink:href=\"#path-3\"/></mask><g id=\"Clip-15\"/><path d=\"M74.0561144,2.03388027 L74.0561144,0.240266075 L73.3793103,0.240266075 L73.3793103,0 L75.009386,0 L75.009386,0.240266075 L74.3292851,0.240266075 L74.3292851,2.03388027 L74.0561144,2.03388027 Z\" id=\"Fill-14\" fill=\"#FFFFFF\" mask=\"url(#mask-4)\"/></g><g id=\"Group-19\" transform=\"translate(32.758621, 0.000000)\"><mask id=\"mask-6\" fill=\"white\"><use xlink:href=\"#path-5\"/></mask><g id=\"Clip-18\"/><path d=\"M42.5517241,2.03388027 L42.5517241,0 L42.9591253,0 L43.4470648,1.43973392 C43.4922792,1.57337029 43.5247771,1.67394678 43.5455004,1.74053215 C43.5690496,1.66649667 43.6057864,1.55800443 43.6552397,1.4145898 L44.1493019,0 L44.5152565,0 L44.5152565,2.03388027 L44.2533894,2.03388027 L44.2533894,0.331064302 L43.6533558,2.03388027 L43.4079731,2.03388027 L42.8135913,0.303592018 L42.8135913,2.03388027 L42.5517241,2.03388027 Z\" id=\"Fill-17\" fill=\"#FFFFFF\" mask=\"url(#mask-6)\"/></g></g></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-pen.svg',
    "<svg width=\"22\" height=\"23\" viewBox=\"0 0 22 23\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0-.5h24v24H0z\"/><g fill=\"#757575\"><path d=\"M21.7 6.083l-4.287-4.285c-.39-.39-1.024-.39-1.414 0l-.722.722-1.436-1.436C13.654.896 13.4.79 13.135.79c-.265 0-.52.106-.707.294l-6.43 6.428 1.415 1.415 5.722-5.72 6.428 6.427L21.7 7.498c.39-.39.39-1.023 0-1.415z\"/><path d=\"M18.15 11.048l-8.602 8.6-5.7-5.7 8.6-8.6zM7.865 20.794l-5.843 1.948c-.36.12-.756.026-1.022-.242-.27-.266-.36-.664-.242-1.022l1.947-5.843 5.16 5.16z\"/></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-pencil.svg',
    "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\"><path d=\"M27 0c2.76 0 5 2.24 5 5 0 1.126-.372 2.164-1 3l-2 2-7-7 2-2c.836-.628 1.874-1 3-1zM2 23l-2 9 9-2 18.5-18.5-7-7L2 23zm20.362-11.638l-14 14-1.724-1.724 14-14 1.724 1.724z\"/></svg>"
  );


  $templateCache.put('/icons/wfIcon-personal-development.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"personal-development\" stroke=\"#212121\"><g id=\"ico-personal-development\"><path d=\"M8.5,12 L15.5,12\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M19.5,12 L20.5,12\" id=\"Line-Copy\" stroke-linecap=\"round\"/><path d=\"M3.5,12 L4.5,12\" id=\"Line-Copy-2\" stroke-linecap=\"round\"/><rect id=\"Rectangle-46\" x=\"4.5\" y=\"7.5\" width=\"4\" height=\"9\" rx=\"1\"/><rect id=\"Rectangle-46-Copy\" x=\"15.5\" y=\"7.5\" width=\"4\" height=\"9\" rx=\"1\"/><path d=\"M6.5,9.5 L6.5,14.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M17.5,9.5 L17.5,14.5\" id=\"Line-Copy-3\" stroke-linecap=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-ppc-sem.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"PPC-SEM\" stroke=\"#212121\"><g id=\"ico-ppc-sem\"><path d=\"M4.5,19.5 L4.5,11.5\" id=\"Line\"/><path d=\"M7.5,19.5 L7.5,9.5\" id=\"Line-Copy\"/><path d=\"M10.5,19.5 L10.5,10.5\" id=\"Line-Copy-2\"/><path d=\"M13.5,19.5 L13.5,11.5\" id=\"Line-Copy-3\"/><path d=\"M16.5,19.5 L16.5,12.5\" id=\"Line-Copy-4\"/><path d=\"M19.5,19.5 L19.5,9.5\" id=\"Line-Copy-5\"/><path d=\"M3.5,8.5 C3.5,8.5 5.015625,6 8,6 C10.984375,6 11.6198386,8.5 15,8.5 C18.1372415,8.5 20.5,4.5 20.5,4.5\" id=\"Path-102\"/><path d=\"M20.5,4.5 L20.5,6.5\" id=\"Line\"/><path d=\"M20.5,4.5 L18.5,4.5\" id=\"Line\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-previously.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"previously\" stroke=\"#212121\"><g id=\"ico-previously\"><path d=\"M10,4.5 L14,11.9957275 L10,19.5\" id=\"Line\" transform=\"translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) \"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-product-reviews.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"product-reviews\" stroke=\"#212121\"><g id=\"ico-product-review\"><rect id=\"Rectangle-48\" x=\"5.5\" y=\"9.5\" width=\"10.5\" height=\"11\" rx=\"1\"/><path d=\"M14.5,7.5 C14.5,5.290861 12.709139,3.5 10.5,3.5 C8.290861,3.5 6.5,5.290861 6.5,7.5\" id=\"Oval-9\" stroke-linecap=\"round\"/><path d=\"M17.5,7.5 C17.5,5.84314575 16.1568542,4.5 14.5,4.5 C12.8431458,4.5 11.5,5.84314575 11.5,7.5\" id=\"Oval-9-Copy\" stroke-linecap=\"round\"/><path d=\"M18.5,10.5 L18.5,18.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M18.5,18.5 L15.5,20.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M18.5,10.5 L15.5,9.5\" id=\"Line\" stroke-linecap=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-programming.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"programming\" stroke=\"#212121\"><g id=\"ico-programming\"><path d=\"M16.5,5.5 L20.5,11.9957275 L16.5,18.5\" id=\"Line\"/><path d=\"M3.5,5.5 L7.5,11.9957275 L3.5,18.5\" id=\"Line-Copy\" transform=\"translate(5.500000, 12.000000) scale(-1, 1) translate(-5.500000, -12.000000) \"/><path d=\"M13.5,3.5 L10.5,20.5\" id=\"Line\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-pushpin.svg',
    "<svg viewBox=\"0 0 27 44\" xmlns=\"http://www.w3.org/2000/svg\" class=\"WFIcon-pushpin\"><path d=\"M22 22V4.4h2.2V0h-22v4.4h2.2V22L0 26.4v4.4h11.44V44h3.52V30.8H26.4v-4.4L22 22z\" fill-rule=\"evenodd\" stroke=\"none\"/></svg>"
  );


  $templateCache.put('/icons/wfIcon-question.svg',
    "<svg width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Login---Desktop-\" transform=\"translate(-1067.000000, -642.000000)\" fill=\"#CCCCCC\"><g id=\"Group-2\" transform=\"translate(583.000000, 363.000000)\"><path d=\"M494,279 C488.486,279 484,283.487 484,289 C484,294.515 488.486,299 494,299 C499.514,299 504,294.515 504,289 C504,283.487 499.514,279 494,279 L494,279 Z M494,295.25 C493.31,295.25 492.75,294.691 492.75,294 C492.75,293.31 493.31,292.75 494,292.75 C494.69,292.75 495.25,293.31 495.25,294 C495.25,294.691 494.69,295.25 494,295.25 L494,295.25 Z M495,290.875 L495,292 L493,292 L493,289 L494,289 C495.104,289 496,288.103 496,287 C496,285.896 495.104,285 494,285 C492.896,285 492,285.896 492,287 L490,287 C490,284.795 491.795,283 494,283 C496.205,283 498,284.795 498,287 C498,288.861 496.723,290.429 495,290.875 L495,290.875 Z\" id=\"Shape\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-quote.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"quote\" stroke=\"#212121\"><g id=\"ico-quote\"><rect id=\"Rectangle-53\" x=\"3.5\" y=\"8.5\" width=\"3\" height=\"3\"/><path d=\"M3.5,8.5 L3.5,6.99182129 L6.5,4.5\" id=\"Line\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><rect id=\"Rectangle-53-Copy\" x=\"8.5\" y=\"8.5\" width=\"3\" height=\"3\"/><path d=\"M8.5,8.5 L8.5,6.99182129 L11.5,4.5\" id=\"Line-Copy\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><rect id=\"Rectangle-53-Copy-2\" transform=\"translate(18.888361, 14.000000) scale(-1, -1) translate(-18.888361, -14.000000) \" x=\"17.3883611\" y=\"12.5\" width=\"3\" height=\"3\"/><path d=\"M17.6116389,19.5 L17.6116389,17.9918213 L20.6116389,15.5\" id=\"Line-Copy-2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(19.000000, 17.500000) scale(-1, -1) translate(-19.000000, -17.500000) \"/><rect id=\"Rectangle-53-Copy-3\" transform=\"translate(13.888361, 14.000000) scale(-1, -1) translate(-13.888361, -14.000000) \" x=\"12.3883611\" y=\"12.5\" width=\"3\" height=\"3\"/><path d=\"M12.6116389,19.5 L12.6116389,17.9918213 L15.6116389,15.5\" id=\"Line-Copy-3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(14.000000, 17.500000) scale(-1, -1) translate(-14.000000, -17.500000) \"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-reddit.svg',
    "<svg width=\"22px\" height=\"19px\" viewBox=\"0 0 22 19\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"WF_FeedRedesignDesktop\" transform=\"translate(-946.000000, -285.000000)\"><rect id=\"Background\" x=\"0\" y=\"65\" width=\"1680\" height=\"2387\"/><g id=\"Group-10\" transform=\"translate(276.000000, 115.000000)\" stroke-width=\"0.5\" stroke=\"#191919\" fill=\"#191919\"><g id=\"Group-6\" transform=\"translate(574.000000, 170.000000)\"><g id=\"Group-5\" transform=\"translate(97.000000, 1.000000)\"><g id=\"Group\"><path d=\"M20,8.30170602 C20,7.03430093 18.9765234,6.00336111 17.7185938,6.00336111 C17.1498047,6.00336111 16.6294141,6.21460185 16.2294141,6.56282639 C14.6803516,5.54994907 12.6751953,4.9586875 10.5292578,4.87478935 L11.6629688,1.15064815 L14.96125,1.89447685 C14.9611719,1.90344907 14.9599609,1.91210648 14.9599609,1.9210787 C14.9599609,2.96834954 15.8058203,3.82043519 16.8453516,3.82043519 C17.8848828,3.82043519 18.7307422,2.96838889 18.7307422,1.9210787 C18.7307422,0.873768519 17.8849609,0.0217615741 16.8453516,0.0217615741 C16.0641016,0.0217615741 15.3925781,0.50299537 15.1068359,1.18661574 L11.4958594,0.372268519 C11.3128906,0.330988426 11.1293359,0.438418981 11.0744141,0.619043981 L9.78121094,4.86684028 C7.51882813,4.90339815 5.39417969,5.50127083 3.77058594,6.56290509 C3.37066406,6.21471991 2.85015625,6.00343981 2.28140625,6.00343981 C1.02347656,6.00343981 7.81250001e-05,7.03441898 7.81250001e-05,8.30178472 C7.81250001e-05,9.13297454 0.440351563,9.86243981 1.09824219,10.2661505 C1.06464844,10.481956 1.04695313,10.7002407 1.04695313,10.9206898 C1.04695313,12.5677616 1.99832031,14.1055926 3.72574219,15.2502986 C5.406875,16.3644676 7.63503906,16.9782384 10,16.9782384 C12.3647656,16.9782384 14.5930859,16.3643495 16.2742188,15.2502986 C18.0016797,14.1054745 18.9529688,12.5677616 18.9529688,10.9206898 C18.9529688,10.7002407 18.9353516,10.4820741 18.9016797,10.2661505 C19.5596484,9.86240046 20,9.13285648 20,8.30170602 L20,8.30170602 Z M16.8452734,0.744576389 C17.4891797,0.744576389 18.0130859,1.27228472 18.0130859,1.92103935 C18.0130859,2.56963657 17.4891797,3.09750231 16.8452734,3.09750231 C16.2014453,3.09750231 15.6774609,2.56963657 15.6774609,1.92103935 C15.6774219,1.27232407 16.2013281,0.744576389 16.8452734,0.744576389 L16.8452734,0.744576389 Z M0.7175,8.30170602 C0.7175,7.43297454 1.41902344,6.72621528 2.28132813,6.72621528 C2.60785156,6.72621528 2.91109375,6.82786111 3.16210938,7.0008125 C2.24367188,7.7318912 1.60613281,8.58984028 1.285625,9.51555324 C0.938945313,9.22639583 0.7175,8.78966898 0.7175,8.30170602 L0.7175,8.30170602 Z M10,16.2553056 C5.45890625,16.2553056 1.76449219,13.8622014 1.76449219,10.9206111 C1.76449219,10.7941736 1.77179688,10.6689167 1.78519531,10.5446042 C1.81125,10.304125 1.86160156,10.0678565 1.93542969,9.83697917 C2.21128906,8.97462269 2.809375,8.18778241 3.64445313,7.53186574 C3.82964844,7.38622454 4.02695313,7.2473912 4.23453125,7.11540509 C5.72128906,6.17017361 7.75710938,5.58615278 10,5.58615278 C12.2427734,5.58615278 14.2786719,6.17025231 15.7653125,7.11540509 C15.9728906,7.2473912 16.1702734,7.38626389 16.3554297,7.53186574 C17.1905469,8.18774306 17.7886719,8.97462269 18.0644922,9.83697917 C18.1383594,10.0678565 18.1887109,10.304125 18.2147266,10.5446042 C18.2282422,10.6687986 18.2353906,10.7941736 18.2353906,10.9206111 C18.2353906,13.8622407 14.5410156,16.2553056 10,16.2553056 L10,16.2553056 Z M18.714375,9.51563194 C18.3939453,8.58995833 17.7562891,7.7318912 16.8378516,7.00085185 C17.0888672,6.82790046 17.3920703,6.72625463 17.7185937,6.72625463 C18.5809375,6.72625463 19.2824609,7.43297454 19.2824609,8.30174537 C19.2824609,8.78966898 19.0611328,9.22639583 18.714375,9.51563194 L18.714375,9.51563194 Z\" id=\"Shape\"/><path d=\"M12.7333984,13.2322963 C12.0534766,13.7938472 11.2104297,14.0442431 10,14.0442431 C8.78949219,14.0442431 7.94648438,13.7938472 7.26644531,13.2322963 C7.105625,13.0994838 6.86820313,13.1232523 6.73640625,13.2851852 C6.60449219,13.4472755 6.62800781,13.6863773 6.78890625,13.8192685 C7.60179688,14.4906505 8.62210938,14.8032222 10,14.8032222 C11.3778906,14.8032222 12.3981641,14.4906505 13.2110938,13.8192685 C13.3719141,13.6863773 13.3955078,13.4472755 13.2635938,13.2851852 C13.1314844,13.1229375 12.8942188,13.0994838 12.7333984,13.2322963 L12.7333984,13.2322963 Z\" id=\"Shape\"/><path d=\"M8.36398438,9.83835648 C8.36398438,9.08343056 7.75652344,8.47150926 7.00714844,8.47150926 C6.25765625,8.47150926 5.65011719,9.08343056 5.65011719,9.83835648 C5.65011719,10.5934792 6.25769531,11.2055185 7.00714844,11.2055185 C7.75652344,11.2054398 8.36398438,10.5934792 8.36398438,9.83835648 L8.36398438,9.83835648 Z\" id=\"Shape\"/><path d=\"M13.0571094,8.47150926 C12.3075391,8.47150926 11.7,9.08343056 11.7,9.83835648 C11.7,10.5934792 12.3075391,11.2055185 13.0571094,11.2055185 C13.8064844,11.2055185 14.4140625,10.5934792 14.4140625,9.83835648 C14.4140625,9.08343056 13.8064844,8.47150926 13.0571094,8.47150926 L13.0571094,8.47150926 Z\" id=\"Shape\"/></g></g></g></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-search.svg',
    "<svg width=\"22\" height=\"23\" viewBox=\"0 0 22 23\" xmlns=\"http://www.w3.org/2000/svg\" class=\"Icon-image\"><title>Seach</title><path d=\"M21.414 19.085l-3.96-3.96c.986-1.52 1.52-3.288 1.52-5.14C18.97 4.743 14.728.5 9.485.5 4.244.5 0 4.74 0 9.984c0 5.24 4.243 9.486 9.486 9.486 1.853 0 3.622-.532 5.14-1.516l3.958 3.958c.784.786 2.05.784 2.83 0 .78-.78.78-2.048 0-2.827zM2 9.985C2 5.848 5.348 2.5 9.486 2.5c4.135 0 7.486 3.347 7.486 7.485 0 2-.78 3.88-2.194 5.292-1.414 1.415-3.293 2.193-5.293 2.193C5.35 17.47 2 14.122 2 9.985z\" fill=\"#8B8B8B\" fill-rule=\"evenodd\"/></svg>"
  );


  $templateCache.put('/icons/wfIcon-seo.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"SEO\" stroke=\"#212121\"><g id=\"ico-seo\"><path d=\"M13.8888889,5.6626632 L13.8888889,4.44426263 C13.8888889,3.91906572 13.4620851,3.5 12.935596,3.5 L11.064404,3.5 C10.5298336,3.5 10.1111111,3.92276078 10.1111111,4.44426263 L10.1111111,5.6626632 C9.67143581,5.79351697 9.25092927,5.96887884 8.8548163,6.18352401 L7.95185761,5.28056533 C7.57385926,4.90256697 6.97598196,4.90828132 6.60369794,5.28056533 L5.28056533,6.60369794 C4.90256697,6.9816963 4.90828132,7.5795736 5.28056533,7.95185761 L6.18352401,8.8548163 C5.96887884,9.25092927 5.79351697,9.67143581 5.6626632,10.1111111 L4.44426263,10.1111111 C3.91906572,10.1111111 3.5,10.5379149 3.5,11.064404 L3.5,12.935596 C3.5,13.4701664 3.92276078,13.8888889 4.44426263,13.8888889 L5.6626632,13.8888889 C5.79351697,14.3285642 5.96887884,14.7490707 6.18352401,15.1451837 L5.28056533,16.0481424 C4.90256697,16.4261407 4.90828132,17.024018 5.28056533,17.3963021 L6.60369794,18.7194347 C6.9816963,19.097433 7.5795736,19.0917187 7.95185761,18.7194347 L8.8548163,17.816476 C9.25092927,18.0311212 9.67143581,18.206483 10.1111111,18.3373368 L10.1111111,19.5557374 C10.1111111,20.0809343 10.5379149,20.5 11.064404,20.5 L12.935596,20.5 C13.4701664,20.5 13.8888889,20.0772392 13.8888889,19.5557374 L13.8888889,18.3373368 C14.3285642,18.206483 14.7490707,18.0311212 15.1451837,17.816476 L16.0481424,18.7194347 C16.4261407,19.097433 17.024018,19.0917187 17.3963021,18.7194347 L18.7194347,17.3963021 C19.097433,17.0183037 19.0917187,16.4204264 18.7194347,16.0481424 L17.816476,15.1451837 C18.0311212,14.7490707 18.206483,14.3285642 18.3373368,13.8888889 L19.5557374,13.8888889 C20.0809343,13.8888889 20.5,13.4620851 20.5,12.935596 L20.5,11.064404 C20.5,10.5298336 20.0772392,10.1111111 19.5557374,10.1111111 L18.3373368,10.1111111 C18.206483,9.67143581 18.0311212,9.25092927 17.816476,8.8548163 L18.7194347,7.95185761 C19.097433,7.57385926 19.0917187,6.97598196 18.7194347,6.60369794 L17.3963021,5.28056533 C17.0183037,4.90256697 16.4204264,4.90828132 16.0481424,5.28056533 L15.1451837,6.18352401 C14.7490707,5.96887884 14.3285642,5.79351697 13.8888889,5.6626632 L13.8888889,5.6626632 Z\" id=\"Rectangle-46\"/><circle id=\"Oval-18-Copy\" cx=\"12\" cy=\"12\" r=\"3.5\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-setting.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"Setting\" stroke=\"#212121\"><g id=\"ico-setting\"><path d=\"M10.5,12 L13.5,12\" id=\"Line\"/><path d=\"M12,9.5 L12,4.5\" id=\"Line\"/><path d=\"M12,19.5 L12,14.5\" id=\"Line-Copy\"/><path d=\"M16.5,10 L19.5,10\" id=\"Line-Copy-7\"/><path d=\"M18,7.5 L18,4.5\" id=\"Line-Copy-5\"/><path d=\"M18,19.5 L18,12.5\" id=\"Line-Copy-6\"/><path d=\"M4.5,14 L7.5,14\" id=\"Line-Copy-4\"/><path d=\"M6,11.5 L6,4.5\" id=\"Line-Copy-2\"/><path d=\"M6,19.5 L6,16.5\" id=\"Line-Copy-3\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-small-screen.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"small-screen\" stroke=\"#212121\"><g id=\"ico-small-screen\"><path d=\"M16.5,19.5 L16.5,16.5\" id=\"Line\" transform=\"translate(16.500000, 18.000000) scale(-1, -1) translate(-16.500000, -18.000000) \"/><path d=\"M19.5,16.5 L16.5,16.5\" id=\"Line\" transform=\"translate(18.000000, 16.500000) scale(-1, -1) translate(-18.000000, -16.500000) \"/><path d=\"M20.5,20.5 L16.5,16.5\" id=\"Line\" transform=\"translate(18.500000, 18.500000) scale(-1, -1) translate(-18.500000, -18.500000) \"/><path d=\"M16.5,7.5 L16.5,4.5\" id=\"Line\" transform=\"translate(16.500000, 6.000000) scale(-1, 1) translate(-16.500000, -6.000000) \"/><path d=\"M19.5,7.5 L16.5,7.5\" id=\"Line\" transform=\"translate(18.000000, 7.500000) scale(-1, 1) translate(-18.000000, -7.500000) \"/><path d=\"M20.5,7.5 L16.5,3.5\" id=\"Line\" transform=\"translate(18.500000, 5.500000) scale(-1, 1) translate(-18.500000, -5.500000) \"/><path d=\"M7.5,19.5 L7.5,16.5\" id=\"Line\" transform=\"translate(7.500000, 18.000000) scale(1, -1) translate(-7.500000, -18.000000) \"/><path d=\"M7.5,16.5 L4.5,16.5\" id=\"Line\" transform=\"translate(6.000000, 16.500000) scale(1, -1) translate(-6.000000, -16.500000) \"/><path d=\"M7.5,20.5 L3.5,16.5\" id=\"Line\" transform=\"translate(5.500000, 18.500000) scale(1, -1) translate(-5.500000, -18.500000) \"/><path d=\"M7.5,7.5 L7.5,4.5\" id=\"Line\"/><path d=\"M7.5,7.5 L4.5,7.5\" id=\"Line\"/><path d=\"M7.5,7.5 L3.5,3.5\" id=\"Line\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-social-media.svg',
    "<svg class=\"wfIcon-social-media\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke-width=\"1\" fill-rule=\"evenodd\"><g id=\"social-media\"><g id=\"ico-social-media\" transform=\"translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) \"><circle id=\"Oval-14\" cx=\"5\" cy=\"5\" r=\"1.5\"/><path d=\"M15.5,5.5 L6.5,10.5\" id=\"Line\" stroke-linecap=\"round\" transform=\"translate(11.000000, 8.000000) scale(-1, 1) translate(-11.000000, -8.000000) \"/><path d=\"M10.5,13.5 L15.5,15.5\" id=\"Line\" stroke-linecap=\"round\" transform=\"translate(13.000000, 14.500000) scale(-1, 1) translate(-13.000000, -14.500000) \"/><circle id=\"Oval-14-Copy-2\" cx=\"18\" cy=\"12\" r=\"2.5\"/><circle id=\"Oval-14-Copy\" cx=\"7\" cy=\"17\" r=\"3.5\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-social-networks.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"local-meetup\" stroke=\"#212121\"><g id=\"ico-local-meetup\"><circle id=\"Oval-11\" cx=\"12\" cy=\"8\" r=\"2.5\"/><path d=\"M7.5,18.5 L8.00585926,15.4648445 C8.27876565,13.8274061 9.84967041,12.5 11.5092545,12.5 L12.4907455,12.5 C14.1527109,12.5 15.7219324,13.8315945 15.9941407,15.4648445 L16.5,18.5\" id=\"Rectangle-32\" stroke-linecap=\"round\"/><path d=\"M16.5079004,9.37681472 C16.7078296,9.45630171 16.9258746,9.5 17.154126,9.5 C18.1206243,9.5 18.904126,8.71649831 18.904126,7.75 C18.904126,6.78350169 18.1206243,6 17.154126,6 C16.7687636,6 16.4124936,6.12455938 16.1233806,6.33561353\" id=\"Oval-11-Copy\" stroke-linecap=\"round\"/><path d=\"M16.5092545,11.5 L17.4907455,11.5 C19.1527109,11.5 20.7219324,12.8315945 20.9941407,14.4648445 L21.5,17.5\" id=\"Rectangle-32-Copy\" stroke-linecap=\"round\"/><path d=\"M5.50790039,9.37681472 C5.70782959,9.45630171 5.92587464,9.5 6.15412598,9.5 C7.12062429,9.5 7.90412598,8.71649831 7.90412598,7.75 C7.90412598,6.78350169 7.12062429,6 6.15412598,6 C5.76876357,6 5.41249355,6.12455938 5.12338056,6.33561353\" id=\"Oval-11-Copy-2\" stroke-linecap=\"round\" transform=\"translate(6.513753, 7.750000) scale(-1, 1) translate(-6.513753, -7.750000) \"/><path d=\"M2.50925446,11.5 L3.49074554,11.5 C5.15271089,11.5 6.72193241,12.8315945 6.99414074,14.4648445 L7.5,17.5\" id=\"Rectangle-32-Copy-2\" stroke-linecap=\"round\" transform=\"translate(5.004627, 14.500000) scale(-1, 1) translate(-5.004627, -14.500000) \"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-startcon-logo.svg',
    "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"506\" height=\"472\" viewBox=\"0 0 506 472\"><image width=\"506\" height=\"472\" xlink:href=\"data:img/png;base64,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\"/></svg>"
  );


  $templateCache.put('/icons/wfIcon-stats.svg',
    "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"32\" height=\"32\"><defs><path class=\"path1\" d=\"M0 26h32v4H0zm4-8h4v6H4zm6-8h4v14h-4zm6 6h4v8h-4zm6-12h4v20h-4z\" id=\"a\"/></defs><use xlink:href=\"#a\"/></svg>"
  );


  $templateCache.put('/icons/wfIcon-tags.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"tags\" stroke=\"#212121\"><g id=\"ico-tags\"><polygon id=\"Polygon-2\" transform=\"translate(10.961170, 10.995838) rotate(-45.000000) translate(-10.961170, -10.995838) \" points=\"10.9611702 3.0845086 15.4611702 8.95186434 15.4611702 18.4454454 6.46117024 18.4454454 6.46117024 8.95186434 \"/><circle id=\"Oval-7\" transform=\"translate(9.511324, 9.545992) rotate(-45.000000) translate(-9.511324, -9.545992) \" cx=\"9.51132355\" cy=\"9.54599152\" r=\"0.5\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-topics.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"topics\" stroke=\"#212121\"><g id=\"ico-topics\"><path d=\"M5.89919393,15.0973584 C4.41420655,13.9725474 3.5,12.4383911 3.5,10.7472995 C3.5,7.29701126 7.30557963,4.5 12,4.5 C16.6944204,4.5 20.5,7.29701126 20.5,10.7472995 C20.5,14.1975878 16.6944204,16.994599 12,16.994599 C10.8431813,16.994599 9.7403374,16.8247509 8.73511452,16.5171336 L6.63188026,18.8388649 C5.88760624,19.6604587 5.38930703,19.4331675 5.51690391,18.348151 L5.89919393,15.0973584 L5.89919393,15.0973584 Z\" id=\"Oval-8\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-topicsx2.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"topicsX2\" stroke=\"#212121\"><g id=\"ico-topicsX2\"><path d=\"M5.12298413,14.2713962 C4.11843385,13.4465347 3.5,12.3214868 3.5,11.081353 C3.5,8.55114159 6.07436269,6.5 9.25,6.5 C12.4256373,6.5 15,8.55114159 15,11.081353 C15,13.6115644 12.4256373,15.6627059 9.25,15.6627059 C8.46744619,15.6627059 7.72140471,15.5381506 7.041401,15.3125646 L5.34858839,17.3383139 C4.99424594,17.7623473 4.75601373,17.6542235 4.81408474,17.1189101 L5.12298413,14.2713962 L5.12298413,14.2713962 Z\" id=\"Oval-8\"/><path d=\"M15.75,14.9967594 C16.3964575,14.9967594 17.0127526,14.8948505 17.5744948,14.7102801 L18.8563003,16.2295083 C19.2134171,16.6527721 19.4536622,16.5461923 19.3930986,15.993244 L19.159274,13.858415 C19.9891199,13.1835284 20.5,12.2630347 20.5,11.2483797 L20.5,11.2483797 C20.5,9.17820676 18.3733526,7.5 15.75,7.5\" id=\"Oval-8-Copy\" stroke-linecap=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-trash.svg',
    "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\"><path d=\"M29.98 6.82c-.096-1.57-1.387-2.817-2.98-2.817h-3V3c0-1.656-1.344-3-3-3H11C9.343 0 8 1.345 8 3v1.002H5c-1.595 0-2.885 1.246-2.98 2.816H2V9c0 1.105.896 2 2 2v17c0 2.21 1.79 4 4 4h16c2.21 0 4-1.79 4-4V11c1.104 0 2-.895 2-2V6.82h-.02zM10 3c0-.553.447-1 1-1h10c.553 0 1 .447 1 1v1H10V3zm16 25c0 1.102-.898 2-2 2H8c-1.103 0-2-.898-2-2V11h20v17zm2-20v1H4V7c0-.553.447-1 1-1h22c.553 0 1 .447 1 1v1zM9 28.005h2c.553 0 1-.447 1-1v-13c0-.553-.447-1-1-1H9c-.553 0-1 .447-1 1v13c0 .553.447 1 1 1zm0-14h2v13H9v-13zm6 14h2c.553 0 1-.447 1-1v-13c0-.553-.447-1-1-1h-2c-.553 0-1 .447-1 1v13c0 .553.447 1 1 1zm0-14h2v13h-2v-13zm6 14h2c.553 0 1-.447 1-1v-13c0-.553-.447-1-1-1h-2c-.553 0-1 .447-1 1v13c0 .553.447 1 1 1zm0-14h2v13h-2v-13z\"/></svg>"
  );


  $templateCache.put('/icons/wfIcon-trophy.svg',
    "<svg width=\"15\" height=\"22\" viewBox=\"0 0 15 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-5-2h26v26H-5z\"/><g fill=\"#757575\"><path d=\"M2.024 1.775l4.597 1.97L9.904.463 9.463 5.7 14.5 7.684 9.047 8.797 7.933 14.25 5.95 9.213l-5.24.44 3.285-3.28-1.97-4.598zM2.584 19.667h10.833v2.167H2.584z\"/><path d=\"M12.333 18.583v-3.25c0-.598-.484-1.083-1.083-1.083h-6.5c-.6 0-1.083.485-1.083 1.083v3.25h8.666z\"/></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-twitter-square.svg',
    "<?xml version=\"1.0\" ?><!DOCTYPE svg  PUBLIC '-//W3C//DTD SVG 1.0//EN'  'http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd'><svg enable-background=\"new 0 0 32 32\" height=\"32px\" id=\"Layer_1\" version=\"1.0\" viewBox=\"0 0 32 32\" width=\"32px\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g><path d=\"M32,30c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2c0-1.104,0.896-2,2-2h28c1.104,0,2,0.896,2,2V30z\" fill=\"#55ACEE\"/><path d=\"M25.987,9.894c-0.736,0.322-1.525,0.537-2.357,0.635c0.85-0.498,1.5-1.289,1.806-2.231   c-0.792,0.461-1.67,0.797-2.605,0.978C22.083,8.491,21.017,8,19.838,8c-2.266,0-4.1,1.807-4.1,4.038   c0,0.314,0.036,0.625,0.104,0.922c-3.407-0.172-6.429-1.779-8.452-4.221c-0.352,0.597-0.556,1.29-0.556,2.032   c0,1.399,0.726,2.635,1.824,3.36c-0.671-0.022-1.304-0.203-1.856-0.506c-0.001,0.017-0.001,0.034-0.001,0.052   c0,1.955,1.414,3.589,3.29,3.96c-0.343,0.09-0.705,0.142-1.081,0.142c-0.264,0-0.52-0.024-0.77-0.072   c0.52,1.604,2.034,2.771,3.828,2.805C10.67,21.594,8.9,22.24,6.979,22.24c-0.33,0-0.658-0.018-0.979-0.056   c1.814,1.145,3.971,1.813,6.287,1.813c7.541,0,11.666-6.154,11.666-11.491c0-0.173-0.005-0.35-0.012-0.521   C24.741,11.414,25.438,10.703,25.987,9.894z\" fill=\"#FFFFFF\"/></g><g/><g/><g/><g/><g/><g/></svg>"
  );


  $templateCache.put('/icons/wfIcon-twitter.svg',
    "<svg width=\"24\" height=\"20\" viewBox=\"0 0 24 20\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M23.646 2.275c-.87.386-1.805.647-2.786.763 1.002-.6 1.77-1.55 2.133-2.684-.937.556-1.975.96-3.08 1.178C19.027.59 17.766 0 16.37 0c-2.677 0-4.85 2.172-4.85 4.85 0 .38.043.752.126 1.107-4.032-.202-7.607-2.133-10-5.07-.417.718-.657 1.55-.657 2.44 0 1.683.856 3.168 2.157 4.038-.794-.025-1.543-.243-2.197-.607v.06c0 2.35 1.672 4.312 3.892 4.758-.407.11-.836.17-1.278.17-.313 0-.617-.03-.913-.087.618 1.926 2.41 3.33 4.532 3.368-1.66 1.302-3.752 2.077-6.025 2.077-.39 0-.777-.023-1.157-.067 2.147 1.376 4.697 2.18 7.437 2.18 8.923 0 13.803-7.393 13.803-13.804 0-.21-.005-.42-.014-.628.948-.684 1.77-1.538 2.42-2.51\" fill=\"#FFF\" mask=\"url(#twitter-b)\"/></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-user-alt.svg',
    "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" class=\"WFIcon-user\"><g fill-rule=\"evenodd\"><path d=\"M13.927 12.533c1.673-.813 2.84-2.654 2.84-4.795 0-2.893-2.13-5.238-4.76-5.238S7.243 4.845 7.243 7.738c0 2.173 1.202 4.036 2.915 4.83v.435c0 1.048-.847 2.018-1.88 2.166l-1.03.146c-2.08.296-3.227 2.154-2.56 4.144l.698 2.088H18.71l.712-2.088c.68-1.992-.466-3.847-2.545-4.142l-1.06-.15c-1.043-.147-1.89-1.113-1.89-2.165v-.47z\"/><path d=\"M7.238 7.778c.583.28 1.228.436 1.905.436 1.732 0 3.248-1.017 4.08-2.537.536 1.662 1.813 2.94 3.394 3.35.095-.412.145-.844.145-1.29C16.762 4.846 14.63 2.5 12 2.5c-2.63 0-4.762 2.345-4.762 5.238v.04z\"/></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-user.svg',
    "<svg class=\"Icon-image\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M12.002 12.006c2.206 0 4-1.795 4-4s-1.794-4-4-4-4 1.795-4 4 1.795 4 4 4zM12.002 13.006c-4.71 0-8 2.467-8 6v1h16v-1c0-3.533-3.29-6-8-6z\"/></svg>"
  );


  $templateCache.put('/icons/wfIcon-username.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"username\" stroke=\"#212121\"><g id=\"ico-username\"><path d=\"M13.926702,12.5326275 C15.5999886,11.7203471 16.7678877,9.87924875 16.7678877,7.73809524 C16.7678877,4.84517512 14.6359103,2.5 12.005983,2.5 C9.37605559,2.5 7.2440782,4.84517512 7.2440782,7.73809524 C7.2440782,9.91051369 8.44633344,11.7740502 10.1588848,12.5675497 L10.1588848,13.0028059 C10.1588848,14.0509802 9.31331172,15.0213132 8.28136278,15.1685191 L7.24993216,15.3156511 C5.16921814,15.6124618 4.02349264,17.4696703 4.68943482,19.4595162 L5.3882607,21.5476192 L18.7096331,21.5476192 L19.4223327,19.4595162 C20.1021568,17.4677334 18.9558677,15.6127485 16.8770696,15.3184216 L15.8183248,15.1685191 C14.7736104,15.0206031 13.926702,14.0553271 13.926702,13.0028059 L13.926702,12.5326275 L13.926702,12.5326275 Z\" id=\"Oval-1\"/><path d=\"M7.23823393,7.77849708 C7.82149483,8.05879393 8.46566824,8.21428571 9.14285714,8.21428571 C10.8747105,8.21428571 12.3906301,7.19731142 13.2239981,5.6766425 L13.2239981,5.6766425 C13.7589949,7.33944966 15.0356963,8.61656313 16.6167034,9.02684427 C16.7115258,8.61455728 16.7619048,8.18279791 16.7619048,7.73809524 C16.7619048,4.84517512 14.6299274,2.5 12,2.5 C9.37007262,2.5 7.23809524,4.84517512 7.23809524,7.73809524 C7.23809524,7.75157447 7.23814152,7.76504181 7.23823393,7.77849708 L7.23823393,7.77849708 Z\" id=\"Oval-1-Copy-5\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-visa.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"29px\" height=\"20px\" viewBox=\"0 0 29 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><!--Generator: Sketch 3.6.1 (26313) - http://www.bohemiancoding.com/sketch--><title>Group 6</title><desc>Created with Sketch.</desc><defs><path id=\"visa-path-1\" d=\"M0,0.0238765838 L20.4268477,0.0238765838 L20.4268477,7.14673256 L0,7.14673256\"/><path id=\"visa-path-3\" d=\"M0,0.0238765838 L20.4268477,0.0238765838 L20.4268477,7.14673256 L0,7.14673256 L0,0.0238765838 Z\"/></defs><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"firstTime-CC\" transform=\"translate(-736.000000, -598.000000)\"><g id=\"Group-15\" transform=\"translate(736.000000, 598.000000)\"><g id=\"Group-6\"><rect id=\"Rectangle-956\" fill=\"#FFFFFF\" x=\"0\" y=\"0\" width=\"28.5714286\" height=\"20\" rx=\"2\"/><g id=\"Page-1\" transform=\"translate(4.285714, 6.428571)\"><path d=\"M5.80375566,0.150211324 L4.18429864,4.85341105 L4.01099548,3.89802285 C3.61944193,2.75649475 2.85745098,1.71567061 1.72034691,1.01756478 L3.20043741,7.04096092 L4.95126697,7.04096092 L7.55503771,0.150211324 L5.80375566,0.150211324\" id=\"Fill-1\" fill=\"#0057A0\"/><path d=\"M7.19082956,7.04359221 L8.2252187,0.144234057 L9.88057315,0.144234057 L8.84497738,7.04359221 L7.19082956,7.04359221 Z\" id=\"Fill-3\" fill=\"#0057A0\"/><g id=\"Group-7\"><mask id=\"visa-mask-2\" fill=\"white\"><use xlink:href=\"#visa-path-1\"/></mask><g id=\"Clip-6\"/><path d=\"M14.8450679,0.314911025 C14.5185219,0.174737611 14.0022323,0.0238440986 13.3637707,0.0238440986 C11.7266667,0.0238440986 10.5761388,0.959903638 10.5664857,2.29910386 C10.5560784,3.29347424 11.3885068,3.84523448 12.0155053,4.17625814 C12.6601508,4.51426611 12.8765913,4.73061719 12.874178,5.03289149 C12.8681448,5.49320604 12.3578884,5.7037098 11.8830769,5.7037098 C11.221991,5.7037098 10.8698039,5.60089431 10.3280241,5.34198768 L10.1127903,5.23364971 L9.88171946,6.77669424 C10.2684465,6.97192998 10.9817195,7.13630483 11.7260633,7.14670007 C13.4622624,7.14670007 14.5915234,6.22006123 14.6049472,4.78860318 C14.6127903,4.0024626 14.1707089,3.40587286 13.2141478,2.91339801 C12.6382805,2.59439386 12.2800603,2.38259069 12.2862443,2.05855134 C12.2866968,1.77203234 12.5859427,1.46585982 13.2354148,1.46585982 C13.7765913,1.45400274 14.1646757,1.58865368 14.4729713,1.73028892 L14.6206335,1.81068966 L14.8450679,0.314911025\" id=\"Fill-5\" fill=\"#0057A0\" mask=\"url(#visa-mask-2)\"/></g><g id=\"Group-10\"><mask id=\"visa-mask-4\" fill=\"white\"><use xlink:href=\"#visa-path-3\"/></mask><g id=\"Clip-9\"/><path d=\"M17.047632,4.59733063 C17.185641,4.2014991 17.7075113,2.66949952 17.7075113,2.66949952 C17.6965008,2.68817848 17.8412971,2.26895765 17.9269683,2.01070072 L18.0370739,2.60729046 C18.0370739,2.60729046 18.3550226,4.25298806 18.4207843,4.59733063 L17.047632,4.59733063 Z M19.0866968,0.150925998 L17.8090196,0.150925998 C17.4124887,0.150925998 17.1164103,0.274856837 16.9406938,0.723151879 L14.4850377,7.04459925 L16.2236501,7.04459925 C16.2236501,7.04459925 16.5076621,6.19511263 16.5708597,6.00783576 C16.76181,6.00783576 18.4474811,6.0118964 18.688356,6.0118964 C18.7399397,6.25326105 18.8915234,7.04459925 18.8915234,7.04459925 L20.4269683,7.04459925 L19.0866968,0.150925998 L19.0866968,0.150925998 Z\" id=\"Fill-8\" fill=\"#0057A0\" mask=\"url(#visa-mask-4)\"/></g><path d=\"M2.68297134,0.147937364 L0.0146455505,0.147937364 L1.50829563e-05,0.266833006 C2.07301659,0.836784927 3.44179487,2.24176758 4.01102564,3.89932225 L3.43214178,0.729746365 C3.33244344,0.291684144 3.04179487,0.163692661 2.68297134,0.147937364\" id=\"Fill-11\" fill=\"#FAA519\"/></g></g></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-warrior-logo-light.svg',
    "<svg viewBox=\"0 0 182 60\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\" class=\"WFLogo\"><g id=\"Introduction\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\" sketch:type=\"MSPage\"><g id=\"Project-Cover\" sketch:type=\"MSArtboardGroup\" transform=\"translate(-309.000000, -217.000000)\"><g id=\"logo\" sketch:type=\"MSLayerGroup\" transform=\"translate(309.000000, 217.000000)\"><rect id=\"Rectangle-path\" fill=\"#CC0000\" sketch:type=\"MSShapeGroup\" x=\"0\" y=\"31.113378\" width=\"181.664224\" height=\"28.8745694\" rx=\"2\"/><path d=\"M83.2438367,35.4615805 L87.242449,35.4615805 C89.4235102,35.4615805 90.7866735,35.5518136 91.6045714,35.7322796 C92.7859796,36.0029787 93.6947551,36.6346099 94.4217755,37.5369402 C95.1487959,38.4392705 95.5123061,39.6122999 95.5123061,40.8755623 C95.5123061,41.9583587 95.2396735,42.950922 94.7852857,43.8532523 C94.330898,44.6653495 93.6038776,45.2969807 92.695102,45.7481459 C91.7863265,46.199311 90.5140408,46.3797771 88.8782449,46.3797771 L95.7849388,55.8542452 L93.3312449,55.8542452 L86.424551,46.3797771 L85.424898,46.3797771 L85.424898,55.9444782 L83.3347143,55.9444782 L83.2438367,35.4615805 L83.2438367,35.4615805 Z M85.2431429,37.5369402 L85.2431429,44.4848835 L88.5147347,44.4848835 C89.7870204,44.4848835 90.7866735,44.3946505 91.3319388,44.1239514 C91.9680816,43.8532523 92.3315918,43.3118541 92.695102,42.7704559 C93.0586122,42.2290578 93.2403673,41.5974265 93.2403673,40.8755623 C93.2403673,40.1536981 93.0586122,39.5220669 92.695102,38.9806687 C92.3315918,38.4392705 91.9680816,38.0783384 91.4228163,37.8978723 C90.877551,37.6271733 89.877898,37.5369402 88.6056122,37.5369402 L85.2431429,37.5369402 L85.2431429,37.5369402 Z\" id=\"Shape\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"/><path d=\"M120.321878,35.2811145 L122.412061,35.2811145 L122.412061,47.6430395 C122.412061,49.086768 122.412061,49.9890983 122.502939,50.3500304 C122.593816,51.1621277 122.866449,51.7937589 123.320837,52.335157 C123.775224,52.8765552 124.411367,53.3277204 125.320143,53.6886525 C126.228918,54.0495846 127.137694,54.2300507 128.046469,54.2300507 C128.864367,54.2300507 129.591388,54.0495846 130.409286,53.7788855 C131.136306,53.5081864 131.772449,53.0570213 132.226837,52.6058561 C132.681224,52.064458 133.044735,51.5230598 133.317367,50.7109625 C133.499122,50.1695643 133.59,49.086768 133.59,47.5528065 L133.59,35.2811145 L135.680184,35.2811145 L135.680184,47.6430395 C135.680184,49.4477001 135.589306,50.8914286 135.225796,52.064458 C134.771408,53.1472543 134.135265,54.2300507 132.86298,55.0421479 C131.590694,55.8542452 130.045776,56.3054103 128.228224,56.3054103 C126.228918,56.3054103 124.593122,55.9444782 123.139082,55.132381 C121.775918,54.3202837 121.048898,53.3277204 120.503633,51.9742249 C120.231,51.1621277 120.231,49.7183992 120.231,47.6430395 L120.321878,35.2811145 L120.321878,35.2811145 Z\" id=\"Shape\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"/><path d=\"M6.45230612,35.4615805 L16.8123469,35.4615805 L16.8123469,37.4467072 L8.5424898,37.4467072 L8.5424898,43.8532523 L16.8123469,43.8532523 L16.8123469,45.8383789 L8.5424898,45.8383789 L8.5424898,55.9444782 L6.45230612,55.9444782 L6.45230612,35.4615805 L6.45230612,35.4615805 Z\" id=\"Shape\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"/><path d=\"M49.800898,35.0104154 C52.8907347,35.0104154 55.5261837,36.0029787 57.6163673,38.0783384 C59.706551,40.1536981 60.7970816,42.6802229 60.7970816,45.7481459 C60.7970816,48.7258359 59.706551,51.2523607 57.6163673,53.3277204 C55.5261837,55.40308 52.9816122,56.4858764 49.9826531,56.4858764 C46.8928163,56.4858764 44.3482449,55.40308 42.2580612,53.3277204 C40.1678776,51.2523607 39.0773469,48.7258359 39.0773469,45.7481459 C39.0773469,43.7630193 39.5317347,41.9583587 40.5313878,40.2439311 C41.5310408,38.5295035 42.8033265,37.2662411 44.4391224,36.2736778 C46.0749184,35.4615805 47.8924694,35.0104154 49.800898,35.0104154 L49.800898,35.0104154 Z M49.8917755,36.995542 C48.3468571,36.995542 46.8928163,37.3564742 45.5296531,38.1685714 C44.1664898,38.9806687 43.0759592,40.063465 42.3489388,41.3267275 C41.6219184,42.6802229 41.1675306,44.1239514 41.1675306,45.8383789 C41.1675306,48.2746707 41.9854286,50.3500304 43.712102,51.9742249 C45.4387755,53.6886525 47.4380816,54.5007497 49.8917755,54.5007497 C51.5275714,54.5007497 52.9816122,54.1398176 54.3447755,53.3277204 C55.7079388,52.5156231 56.7984694,51.5230598 57.5254898,50.1695643 C58.2525102,48.8160689 58.706898,47.3723404 58.706898,45.7481459 C58.706898,44.1239514 58.3433878,42.6802229 57.5254898,41.3267275 C56.7984694,39.973232 55.7079388,38.9806687 54.3447755,38.1685714 C52.8907347,37.3564742 51.4366939,36.995542 49.8917755,36.995542 L49.8917755,36.995542 Z\" id=\"Shape\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"/><path d=\"M154.147188,55.9444782 L158.054922,35.4615805 L158.600188,35.4615805 L165.779514,52.244924 L172.867963,35.4615805 L173.322351,35.4615805 L177.230086,55.9444782 L175.139902,55.9444782 L172.504453,41.5974265 L166.143024,55.9444782 L165.234249,55.9444782 L158.87282,41.4169605 L156.237371,55.9444782 L154.147188,55.9444782 L154.147188,55.9444782 Z\" id=\"Shape\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"/><path d=\"M35.8057551,20.3926646 C35.5331224,20.8438298 35.1696122,21.1145289 34.7152245,21.1145289 L32.1706531,21.1145289 C31.6253878,21.1145289 31.2618776,20.8438298 30.9892449,20.3926646 L23.5372857,4.51165147 L15.6309388,20.3926646 C15.5400612,20.5731307 15.3583061,20.7535968 15.176551,20.9340628 C14.9039184,21.1145289 14.7221633,21.1145289 14.4495306,21.1145289 L11.8140816,21.1145289 C11.2688163,21.1145289 10.9053061,20.8438298 10.6326735,20.3926646 L1.63579592,1.26326241 L4.36212245,1.26326241 L12.6319796,18.6782371 L13.6316327,18.6782371 L22.3558776,1.26326241 L24.6278163,1.26326241 L32.8067959,18.5880041 L33.7155714,18.5880041 L42.5306939,1.17302938 L45.4387755,1.17302938 L35.8057551,20.3926646 L35.8057551,20.3926646 Z\" id=\"Shape\" fill=\"#FFF\" sketch:type=\"MSShapeGroup\"/><path d=\"M66.5223673,21.1145289 L56.071449,3.42885512 L53.436,3.42885512 L42.9850816,21.1145289 L40.077,21.1145289 L51.7093265,1.62419453 C51.8002041,1.44372847 51.9819592,1.26326241 52.1637143,1.17302938 C52.3454694,1.08279635 52.5272245,0.992563323 52.7998571,0.992563323 L56.8893469,0.992563323 C57.071102,0.992563323 57.3437347,1.08279635 57.5254898,1.17302938 C57.7072449,1.26326241 57.889,1.44372847 57.9798776,1.62419453 L69.5213265,21.2047619 L66.5223673,21.2047619 L66.5223673,21.1145289 Z\" id=\"Shape\" fill=\"#FFF\" sketch:type=\"MSShapeGroup\"/><path d=\"M95.0579184,10.6474975 C95.1487959,10.0158663 95.2396735,9.11353597 95.2396735,7.85027356 C95.2396735,7.03817629 95.1487959,6.31631206 95.0579184,5.59444782 C94.9670408,4.96281662 94.7852857,4.33118541 94.5126531,3.88002026 C93.6947551,2.25582573 92.3315918,1.35349544 90.3322857,1.08279635 C89.7870204,0.992563323 88.9691224,0.902330294 87.9694694,0.902330294 C86.8789388,0.812097264 85.6066531,0.812097264 84.0617347,0.812097264 L72.065898,0.812097264 C71.248,0.812097264 70.7936122,1.17302938 70.7936122,2.07535968 L70.7936122,21.0242958 L73.3381837,21.0242958 L73.3381837,14.0763526 C76.7006531,14.1665856 91.3319388,14.0763526 91.3319388,14.0763526 C91.7863265,14.0763526 92.4224694,15.339615 92.4224694,18.407538 L92.4224694,21.1145289 L94.9670408,21.1145289 L94.9670408,18.407538 C94.9670408,17.5954407 94.9670408,16.8735765 94.8761633,16.2419453 C94.8761633,15.7005471 94.7852857,15.249382 94.7852857,14.9786829 C94.6035306,14.1665856 94.2400204,13.5349544 93.7856327,12.9935562 C94.330898,12.4521581 94.8761633,11.6400608 95.0579184,10.6474975 L95.0579184,10.6474975 Z M92.6042245,10.1060993 C92.5133469,10.5572644 91.7863265,11.6400608 91.3319388,11.6400608 C90.0596531,11.6400608 76.6097755,11.5498278 73.3381837,11.6400608 L73.3381837,3.42885512 L83.9708571,3.42885512 C87.0606939,3.42885512 89.06,3.51908815 89.9687755,3.6995542 C90.5140408,3.78978723 91.0593061,3.97025329 91.4228163,4.15071935 C91.7863265,4.42141844 92.1498367,4.69211753 92.3315918,5.14328267 C92.695102,5.77491388 92.7859796,6.7674772 92.7859796,7.94050659 C92.695102,8.93306991 92.695102,9.65493414 92.6042245,10.1060993 L92.6042245,10.1060993 Z\" id=\"Shape\" fill=\"#FFF\" sketch:type=\"MSShapeGroup\"/><path d=\"M121.503286,10.6474975 C121.594163,10.0158663 121.685041,9.11353597 121.685041,7.85027356 C121.685041,7.03817629 121.594163,6.31631206 121.503286,5.59444782 C121.412408,4.96281662 121.230653,4.33118541 120.95802,3.88002026 C120.140122,2.25582573 118.776959,1.35349544 116.777653,1.08279635 C116.232388,0.992563323 115.41449,0.902330294 114.414837,0.902330294 C113.324306,0.812097264 112.05202,0.812097264 110.507102,0.812097264 L98.6021429,0.812097264 C97.7842449,0.812097264 97.3298571,1.17302938 97.3298571,2.07535968 L97.3298571,21.0242958 L99.8744286,21.0242958 L99.8744286,14.0763526 C103.782163,14.1665856 117.868184,13.9861196 117.868184,13.9861196 C118.322571,13.9861196 118.958714,15.249382 118.958714,18.317305 L118.958714,21.0242958 L121.503286,21.0242958 L121.503286,18.317305 C121.503286,17.5052077 121.503286,16.7833435 121.412408,16.1517123 C121.412408,15.6103141 121.321531,15.1591489 121.321531,14.8884498 C121.139776,14.0763526 120.776265,13.4447214 120.321878,12.9033232 C120.867143,12.4521581 121.321531,11.6400608 121.503286,10.6474975 L121.503286,10.6474975 Z M119.049592,10.1060993 C118.958714,10.5572644 118.231694,11.6400608 117.777306,11.6400608 C116.595898,11.6400608 103.600408,11.5498278 99.783551,11.6400608 L99.783551,3.42885512 L110.416224,3.42885512 C113.506061,3.42885512 115.505367,3.51908815 116.414143,3.6995542 C116.959408,3.78978723 117.504673,3.97025329 117.868184,4.15071935 C118.231694,4.42141844 118.595204,4.69211753 118.776959,5.14328267 C119.140469,5.77491388 119.231347,6.7674772 119.231347,7.94050659 C119.231347,8.93306991 119.140469,9.65493414 119.049592,10.1060993 L119.049592,10.1060993 Z\" id=\"Shape\" fill=\"#FFF\" sketch:type=\"MSShapeGroup\"/><rect id=\"Rectangle-path\" fill=\"#FFF\" sketch:type=\"MSShapeGroup\" x=\"123.95698\" y=\"0.992563323\" width=\"2.54457143\" height=\"20.1219656\"/><path d=\"M154.764469,17.2345086 C154.491837,18.7684701 154.037449,19.9414995 153.310429,20.5731307 C152.583408,21.2949949 151.492878,21.8363931 149.857082,22.1070922 C149.130061,22.1973252 148.312163,22.2875583 147.221633,22.3777913 C146.22198,22.4680243 144.858816,22.4680243 143.313898,22.4680243 L140.678449,22.4680243 L138.497388,22.4680243 L136.407204,22.4680243 C135.952816,22.4680243 135.407551,22.3777913 134.953163,22.3777913 C133.044735,22.1973252 131.590694,21.7461601 130.772796,21.1145289 C129.86402,20.3926646 129.318755,19.2196353 128.955245,17.4149747 C128.682612,16.2419453 128.682612,14.3470517 128.682612,11.7302938 C128.682612,10.1963323 128.77349,8.84283688 128.864367,7.6698075 C128.955245,6.49677812 129.137,5.59444782 129.409633,4.87258359 C130.045776,2.88745694 131.590694,1.71442756 133.862633,1.35349544 C134.680531,1.17302938 135.861939,1.08279635 137.31598,1.08279635 C138.77002,0.992563323 140.496694,0.992563323 142.405122,0.992563323 C145.767592,0.992563323 148.130408,1.08279635 149.493571,1.26326241 C151.402,1.5339615 152.674286,1.98512665 153.310429,2.70699088 C154.037449,3.42885512 154.491837,4.96281662 154.764469,7.03817629 C154.855347,7.6698075 154.855347,8.3014387 154.946224,9.11353597 C154.946224,9.92563323 155.037102,10.7377305 155.037102,11.7302938 C155.12798,14.0763526 155.037102,15.9712462 154.764469,17.2345086 L154.764469,17.2345086 Z M152.401653,7.30887538 C152.219898,5.95537994 151.947265,5.05304965 151.583755,4.6018845 C151.129367,4.15071935 150.311469,3.88002026 149.220939,3.60932118 C148.584796,3.51908815 147.766898,3.42885512 146.676367,3.33862209 C145.585837,3.24838906 144.222673,3.24838906 142.586878,3.24838906 C138.77002,3.24838906 135.952816,3.42885512 134.407898,3.60932118 C133.135612,3.78978723 132.317714,4.42141844 131.954204,5.41398176 C131.772449,6.04561297 131.590694,6.7674772 131.499816,7.76004053 C131.408939,8.75260385 131.318061,10.0158663 131.318061,11.4595947 C131.318061,13.9861196 131.408939,15.7005471 131.590694,16.6931104 C131.772449,17.6856738 132.226837,18.497771 132.772102,18.8587031 C133.317367,19.2196353 134.135265,19.4903343 135.407551,19.5805674 C135.680184,19.5805674 136.134571,19.6708004 136.770714,19.6708004 C137.406857,19.6708004 138.043,19.7610334 138.77002,19.7610334 L141.678102,19.7610334 L143.495653,19.7610334 C146.312857,19.7610334 148.403041,19.6708004 149.584449,19.4903343 C150.493224,19.3098683 151.220245,19.0391692 151.583755,18.5880041 C152.038143,18.2270719 152.310776,17.5052077 152.492531,16.6028774 C152.674286,15.5200811 152.765163,13.8056535 152.765163,11.5498278 C152.674286,10.0158663 152.583408,8.57213779 152.401653,7.30887538 L152.401653,7.30887538 Z\" id=\"Shape\" fill=\"#FFF\" sketch:type=\"MSShapeGroup\"/><path d=\"M181.573347,10.6474975 C181.664224,10.0158663 181.755102,9.11353597 181.755102,7.85027356 C181.755102,7.03817629 181.664224,6.31631206 181.573347,5.59444782 C181.482469,4.96281662 181.300714,4.33118541 181.028082,3.88002026 C180.210184,2.25582573 178.84702,1.35349544 176.847714,1.08279635 C176.302449,0.992563323 175.484551,0.902330294 174.484898,0.902330294 C173.394367,0.812097264 172.122082,0.812097264 170.577163,0.812097264 L158.672204,0.812097264 C157.854306,0.812097264 157.399918,1.17302938 157.399918,2.07535968 L157.399918,21.0242958 L159.94449,21.0242958 L159.94449,14.0763526 C163.488714,14.1665856 177.938245,14.0763526 177.938245,14.0763526 C178.392633,14.0763526 179.028776,15.339615 179.028776,18.407538 L179.028776,21.1145289 L181.573347,21.1145289 L181.573347,18.407538 C181.573347,17.5954407 181.573347,16.8735765 181.482469,16.2419453 C181.482469,15.7005471 181.391592,15.249382 181.391592,14.9786829 C181.209837,14.1665856 180.846327,13.5349544 180.391939,12.9935562 C180.937204,12.4521581 181.391592,11.6400608 181.573347,10.6474975 L181.573347,10.6474975 Z M179.119653,10.1060993 C179.028776,10.5572644 178.301755,11.6400608 177.847367,11.6400608 C176.665959,11.6400608 163.306959,11.5498278 159.853612,11.6400608 L159.853612,3.42885512 L170.486286,3.42885512 C173.576122,3.42885512 175.575429,3.51908815 176.484204,3.6995542 C177.029469,3.78978723 177.574735,3.97025329 177.938245,4.15071935 C178.301755,4.42141844 178.665265,4.69211753 178.84702,5.14328267 C179.210531,5.77491388 179.301408,6.7674772 179.301408,7.94050659 C179.210531,8.93306991 179.210531,9.65493414 179.119653,10.1060993 L179.119653,10.1060993 Z\" id=\"Shape\" fill=\"#FFF\" sketch:type=\"MSShapeGroup\"/><path d=\"M65.977102,28.5136373 L55.8896939,10.2865653 C55.7079388,9.92563323 55.253551,9.74516717 54.7991633,9.74516717 C54.3447755,9.74516717 53.9812653,9.92563323 53.7086327,10.2865653 L43.6212245,28.5136373 L65.977102,28.5136373 L65.977102,28.5136373 Z\" id=\"Shape\" fill=\"#CC0000\" sketch:type=\"MSShapeGroup\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-warrior-logo-small--dark.svg',
    "<svg viewBox=\"0 0 44 44\" xmlns=\"http://www.w3.org/2000/svg\" class=\"wf-logo\"><g fill=\"none\"><path d=\"M31.448 25.472c-.22.365-.51.585-.876.585h-2.044c-.438 0-.73-.22-.95-.585l-5.985-12.848-6.35 12.848c-.074.146-.22.292-.366.438-.22.147-.365.147-.584.147h-2.117c-.438 0-.73-.22-.95-.585L4 9.997h2.19l6.643 14.088h.803l7.008-14.088h1.825l6.57 14.015h.73l7.08-14.09h2.336l-7.738 15.55\" fill=\"#212121\"/><path d=\"M30.572 35.043L22.47 20.296c-.147-.292-.512-.438-.877-.438s-.657.146-.876.438l-8.103 14.747h17.958\" fill=\"#c00\"/></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-warrior-logo-small.svg',
    "<svg viewBox=\"0 0 44 44\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"wf-logo\"><defs/><g id=\"Page-1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"motif-logo\"><g transform=\"translate(4.000000, 9.000000)\"><path d=\"M27.448,16.472 C27.229,16.837 26.937,17.057 26.572,17.057 L24.528,17.057 C24.09,17.057 23.798,16.837 23.579,16.472 L17.593,3.624 L11.242,16.472 C11.169,16.618 11.023,16.764 10.877,16.91 C10.658,17.057 10.512,17.057 10.293,17.057 L8.176,17.057 C7.738,17.057 7.446,16.837 7.227,16.472 L0,0.997 L2.19,0.997 L8.833,15.085 L9.636,15.085 L16.644,0.997 L18.469,0.997 L25.039,15.012 L25.769,15.012 L32.85,0.923 L35.186,0.923 L27.448,16.472\" id=\"Fill-1\" fill=\"#FFFFFF\"/><path d=\"M26.572,26.043 L18.469,11.296 C18.323,11.004 17.958,10.858 17.593,10.858 C17.228,10.858 16.936,11.004 16.717,11.296 L8.614,26.043 L26.572,26.043\" id=\"Fill-2\" fill=\"#CC0000\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-warrior-logo.svg',
    "<svg viewBox=\"0 0 182 60\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\" class=\"WFLogo\"><g id=\"Introduction\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\" sketch:type=\"MSPage\"><g id=\"Project-Cover\" sketch:type=\"MSArtboardGroup\" transform=\"translate(-309.000000, -217.000000)\"><g id=\"logo\" sketch:type=\"MSLayerGroup\" transform=\"translate(309.000000, 217.000000)\"><rect id=\"Rectangle-path\" fill=\"#CC0000\" sketch:type=\"MSShapeGroup\" x=\"0\" y=\"31.113378\" width=\"181.664224\" height=\"28.8745694\" rx=\"2\"/><path d=\"M83.2438367,35.4615805 L87.242449,35.4615805 C89.4235102,35.4615805 90.7866735,35.5518136 91.6045714,35.7322796 C92.7859796,36.0029787 93.6947551,36.6346099 94.4217755,37.5369402 C95.1487959,38.4392705 95.5123061,39.6122999 95.5123061,40.8755623 C95.5123061,41.9583587 95.2396735,42.950922 94.7852857,43.8532523 C94.330898,44.6653495 93.6038776,45.2969807 92.695102,45.7481459 C91.7863265,46.199311 90.5140408,46.3797771 88.8782449,46.3797771 L95.7849388,55.8542452 L93.3312449,55.8542452 L86.424551,46.3797771 L85.424898,46.3797771 L85.424898,55.9444782 L83.3347143,55.9444782 L83.2438367,35.4615805 L83.2438367,35.4615805 Z M85.2431429,37.5369402 L85.2431429,44.4848835 L88.5147347,44.4848835 C89.7870204,44.4848835 90.7866735,44.3946505 91.3319388,44.1239514 C91.9680816,43.8532523 92.3315918,43.3118541 92.695102,42.7704559 C93.0586122,42.2290578 93.2403673,41.5974265 93.2403673,40.8755623 C93.2403673,40.1536981 93.0586122,39.5220669 92.695102,38.9806687 C92.3315918,38.4392705 91.9680816,38.0783384 91.4228163,37.8978723 C90.877551,37.6271733 89.877898,37.5369402 88.6056122,37.5369402 L85.2431429,37.5369402 L85.2431429,37.5369402 Z\" id=\"Shape\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"/><path d=\"M120.321878,35.2811145 L122.412061,35.2811145 L122.412061,47.6430395 C122.412061,49.086768 122.412061,49.9890983 122.502939,50.3500304 C122.593816,51.1621277 122.866449,51.7937589 123.320837,52.335157 C123.775224,52.8765552 124.411367,53.3277204 125.320143,53.6886525 C126.228918,54.0495846 127.137694,54.2300507 128.046469,54.2300507 C128.864367,54.2300507 129.591388,54.0495846 130.409286,53.7788855 C131.136306,53.5081864 131.772449,53.0570213 132.226837,52.6058561 C132.681224,52.064458 133.044735,51.5230598 133.317367,50.7109625 C133.499122,50.1695643 133.59,49.086768 133.59,47.5528065 L133.59,35.2811145 L135.680184,35.2811145 L135.680184,47.6430395 C135.680184,49.4477001 135.589306,50.8914286 135.225796,52.064458 C134.771408,53.1472543 134.135265,54.2300507 132.86298,55.0421479 C131.590694,55.8542452 130.045776,56.3054103 128.228224,56.3054103 C126.228918,56.3054103 124.593122,55.9444782 123.139082,55.132381 C121.775918,54.3202837 121.048898,53.3277204 120.503633,51.9742249 C120.231,51.1621277 120.231,49.7183992 120.231,47.6430395 L120.321878,35.2811145 L120.321878,35.2811145 Z\" id=\"Shape\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"/><path d=\"M6.45230612,35.4615805 L16.8123469,35.4615805 L16.8123469,37.4467072 L8.5424898,37.4467072 L8.5424898,43.8532523 L16.8123469,43.8532523 L16.8123469,45.8383789 L8.5424898,45.8383789 L8.5424898,55.9444782 L6.45230612,55.9444782 L6.45230612,35.4615805 L6.45230612,35.4615805 Z\" id=\"Shape\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"/><path d=\"M49.800898,35.0104154 C52.8907347,35.0104154 55.5261837,36.0029787 57.6163673,38.0783384 C59.706551,40.1536981 60.7970816,42.6802229 60.7970816,45.7481459 C60.7970816,48.7258359 59.706551,51.2523607 57.6163673,53.3277204 C55.5261837,55.40308 52.9816122,56.4858764 49.9826531,56.4858764 C46.8928163,56.4858764 44.3482449,55.40308 42.2580612,53.3277204 C40.1678776,51.2523607 39.0773469,48.7258359 39.0773469,45.7481459 C39.0773469,43.7630193 39.5317347,41.9583587 40.5313878,40.2439311 C41.5310408,38.5295035 42.8033265,37.2662411 44.4391224,36.2736778 C46.0749184,35.4615805 47.8924694,35.0104154 49.800898,35.0104154 L49.800898,35.0104154 Z M49.8917755,36.995542 C48.3468571,36.995542 46.8928163,37.3564742 45.5296531,38.1685714 C44.1664898,38.9806687 43.0759592,40.063465 42.3489388,41.3267275 C41.6219184,42.6802229 41.1675306,44.1239514 41.1675306,45.8383789 C41.1675306,48.2746707 41.9854286,50.3500304 43.712102,51.9742249 C45.4387755,53.6886525 47.4380816,54.5007497 49.8917755,54.5007497 C51.5275714,54.5007497 52.9816122,54.1398176 54.3447755,53.3277204 C55.7079388,52.5156231 56.7984694,51.5230598 57.5254898,50.1695643 C58.2525102,48.8160689 58.706898,47.3723404 58.706898,45.7481459 C58.706898,44.1239514 58.3433878,42.6802229 57.5254898,41.3267275 C56.7984694,39.973232 55.7079388,38.9806687 54.3447755,38.1685714 C52.8907347,37.3564742 51.4366939,36.995542 49.8917755,36.995542 L49.8917755,36.995542 Z\" id=\"Shape\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"/><path d=\"M154.147188,55.9444782 L158.054922,35.4615805 L158.600188,35.4615805 L165.779514,52.244924 L172.867963,35.4615805 L173.322351,35.4615805 L177.230086,55.9444782 L175.139902,55.9444782 L172.504453,41.5974265 L166.143024,55.9444782 L165.234249,55.9444782 L158.87282,41.4169605 L156.237371,55.9444782 L154.147188,55.9444782 L154.147188,55.9444782 Z\" id=\"Shape\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"/><path d=\"M35.8057551,20.3926646 C35.5331224,20.8438298 35.1696122,21.1145289 34.7152245,21.1145289 L32.1706531,21.1145289 C31.6253878,21.1145289 31.2618776,20.8438298 30.9892449,20.3926646 L23.5372857,4.51165147 L15.6309388,20.3926646 C15.5400612,20.5731307 15.3583061,20.7535968 15.176551,20.9340628 C14.9039184,21.1145289 14.7221633,21.1145289 14.4495306,21.1145289 L11.8140816,21.1145289 C11.2688163,21.1145289 10.9053061,20.8438298 10.6326735,20.3926646 L1.63579592,1.26326241 L4.36212245,1.26326241 L12.6319796,18.6782371 L13.6316327,18.6782371 L22.3558776,1.26326241 L24.6278163,1.26326241 L32.8067959,18.5880041 L33.7155714,18.5880041 L42.5306939,1.17302938 L45.4387755,1.17302938 L35.8057551,20.3926646 L35.8057551,20.3926646 Z\" id=\"Shape\" fill=\"#000\" sketch:type=\"MSShapeGroup\"/><path d=\"M66.5223673,21.1145289 L56.071449,3.42885512 L53.436,3.42885512 L42.9850816,21.1145289 L40.077,21.1145289 L51.7093265,1.62419453 C51.8002041,1.44372847 51.9819592,1.26326241 52.1637143,1.17302938 C52.3454694,1.08279635 52.5272245,0.992563323 52.7998571,0.992563323 L56.8893469,0.992563323 C57.071102,0.992563323 57.3437347,1.08279635 57.5254898,1.17302938 C57.7072449,1.26326241 57.889,1.44372847 57.9798776,1.62419453 L69.5213265,21.2047619 L66.5223673,21.2047619 L66.5223673,21.1145289 Z\" id=\"Shape\" fill=\"#000\" sketch:type=\"MSShapeGroup\"/><path d=\"M95.0579184,10.6474975 C95.1487959,10.0158663 95.2396735,9.11353597 95.2396735,7.85027356 C95.2396735,7.03817629 95.1487959,6.31631206 95.0579184,5.59444782 C94.9670408,4.96281662 94.7852857,4.33118541 94.5126531,3.88002026 C93.6947551,2.25582573 92.3315918,1.35349544 90.3322857,1.08279635 C89.7870204,0.992563323 88.9691224,0.902330294 87.9694694,0.902330294 C86.8789388,0.812097264 85.6066531,0.812097264 84.0617347,0.812097264 L72.065898,0.812097264 C71.248,0.812097264 70.7936122,1.17302938 70.7936122,2.07535968 L70.7936122,21.0242958 L73.3381837,21.0242958 L73.3381837,14.0763526 C76.7006531,14.1665856 91.3319388,14.0763526 91.3319388,14.0763526 C91.7863265,14.0763526 92.4224694,15.339615 92.4224694,18.407538 L92.4224694,21.1145289 L94.9670408,21.1145289 L94.9670408,18.407538 C94.9670408,17.5954407 94.9670408,16.8735765 94.8761633,16.2419453 C94.8761633,15.7005471 94.7852857,15.249382 94.7852857,14.9786829 C94.6035306,14.1665856 94.2400204,13.5349544 93.7856327,12.9935562 C94.330898,12.4521581 94.8761633,11.6400608 95.0579184,10.6474975 L95.0579184,10.6474975 Z M92.6042245,10.1060993 C92.5133469,10.5572644 91.7863265,11.6400608 91.3319388,11.6400608 C90.0596531,11.6400608 76.6097755,11.5498278 73.3381837,11.6400608 L73.3381837,3.42885512 L83.9708571,3.42885512 C87.0606939,3.42885512 89.06,3.51908815 89.9687755,3.6995542 C90.5140408,3.78978723 91.0593061,3.97025329 91.4228163,4.15071935 C91.7863265,4.42141844 92.1498367,4.69211753 92.3315918,5.14328267 C92.695102,5.77491388 92.7859796,6.7674772 92.7859796,7.94050659 C92.695102,8.93306991 92.695102,9.65493414 92.6042245,10.1060993 L92.6042245,10.1060993 Z\" id=\"Shape\" fill=\"#000\" sketch:type=\"MSShapeGroup\"/><path d=\"M121.503286,10.6474975 C121.594163,10.0158663 121.685041,9.11353597 121.685041,7.85027356 C121.685041,7.03817629 121.594163,6.31631206 121.503286,5.59444782 C121.412408,4.96281662 121.230653,4.33118541 120.95802,3.88002026 C120.140122,2.25582573 118.776959,1.35349544 116.777653,1.08279635 C116.232388,0.992563323 115.41449,0.902330294 114.414837,0.902330294 C113.324306,0.812097264 112.05202,0.812097264 110.507102,0.812097264 L98.6021429,0.812097264 C97.7842449,0.812097264 97.3298571,1.17302938 97.3298571,2.07535968 L97.3298571,21.0242958 L99.8744286,21.0242958 L99.8744286,14.0763526 C103.782163,14.1665856 117.868184,13.9861196 117.868184,13.9861196 C118.322571,13.9861196 118.958714,15.249382 118.958714,18.317305 L118.958714,21.0242958 L121.503286,21.0242958 L121.503286,18.317305 C121.503286,17.5052077 121.503286,16.7833435 121.412408,16.1517123 C121.412408,15.6103141 121.321531,15.1591489 121.321531,14.8884498 C121.139776,14.0763526 120.776265,13.4447214 120.321878,12.9033232 C120.867143,12.4521581 121.321531,11.6400608 121.503286,10.6474975 L121.503286,10.6474975 Z M119.049592,10.1060993 C118.958714,10.5572644 118.231694,11.6400608 117.777306,11.6400608 C116.595898,11.6400608 103.600408,11.5498278 99.783551,11.6400608 L99.783551,3.42885512 L110.416224,3.42885512 C113.506061,3.42885512 115.505367,3.51908815 116.414143,3.6995542 C116.959408,3.78978723 117.504673,3.97025329 117.868184,4.15071935 C118.231694,4.42141844 118.595204,4.69211753 118.776959,5.14328267 C119.140469,5.77491388 119.231347,6.7674772 119.231347,7.94050659 C119.231347,8.93306991 119.140469,9.65493414 119.049592,10.1060993 L119.049592,10.1060993 Z\" id=\"Shape\" fill=\"#000\" sketch:type=\"MSShapeGroup\"/><rect id=\"Rectangle-path\" fill=\"#000\" sketch:type=\"MSShapeGroup\" x=\"123.95698\" y=\"0.992563323\" width=\"2.54457143\" height=\"20.1219656\"/><path d=\"M154.764469,17.2345086 C154.491837,18.7684701 154.037449,19.9414995 153.310429,20.5731307 C152.583408,21.2949949 151.492878,21.8363931 149.857082,22.1070922 C149.130061,22.1973252 148.312163,22.2875583 147.221633,22.3777913 C146.22198,22.4680243 144.858816,22.4680243 143.313898,22.4680243 L140.678449,22.4680243 L138.497388,22.4680243 L136.407204,22.4680243 C135.952816,22.4680243 135.407551,22.3777913 134.953163,22.3777913 C133.044735,22.1973252 131.590694,21.7461601 130.772796,21.1145289 C129.86402,20.3926646 129.318755,19.2196353 128.955245,17.4149747 C128.682612,16.2419453 128.682612,14.3470517 128.682612,11.7302938 C128.682612,10.1963323 128.77349,8.84283688 128.864367,7.6698075 C128.955245,6.49677812 129.137,5.59444782 129.409633,4.87258359 C130.045776,2.88745694 131.590694,1.71442756 133.862633,1.35349544 C134.680531,1.17302938 135.861939,1.08279635 137.31598,1.08279635 C138.77002,0.992563323 140.496694,0.992563323 142.405122,0.992563323 C145.767592,0.992563323 148.130408,1.08279635 149.493571,1.26326241 C151.402,1.5339615 152.674286,1.98512665 153.310429,2.70699088 C154.037449,3.42885512 154.491837,4.96281662 154.764469,7.03817629 C154.855347,7.6698075 154.855347,8.3014387 154.946224,9.11353597 C154.946224,9.92563323 155.037102,10.7377305 155.037102,11.7302938 C155.12798,14.0763526 155.037102,15.9712462 154.764469,17.2345086 L154.764469,17.2345086 Z M152.401653,7.30887538 C152.219898,5.95537994 151.947265,5.05304965 151.583755,4.6018845 C151.129367,4.15071935 150.311469,3.88002026 149.220939,3.60932118 C148.584796,3.51908815 147.766898,3.42885512 146.676367,3.33862209 C145.585837,3.24838906 144.222673,3.24838906 142.586878,3.24838906 C138.77002,3.24838906 135.952816,3.42885512 134.407898,3.60932118 C133.135612,3.78978723 132.317714,4.42141844 131.954204,5.41398176 C131.772449,6.04561297 131.590694,6.7674772 131.499816,7.76004053 C131.408939,8.75260385 131.318061,10.0158663 131.318061,11.4595947 C131.318061,13.9861196 131.408939,15.7005471 131.590694,16.6931104 C131.772449,17.6856738 132.226837,18.497771 132.772102,18.8587031 C133.317367,19.2196353 134.135265,19.4903343 135.407551,19.5805674 C135.680184,19.5805674 136.134571,19.6708004 136.770714,19.6708004 C137.406857,19.6708004 138.043,19.7610334 138.77002,19.7610334 L141.678102,19.7610334 L143.495653,19.7610334 C146.312857,19.7610334 148.403041,19.6708004 149.584449,19.4903343 C150.493224,19.3098683 151.220245,19.0391692 151.583755,18.5880041 C152.038143,18.2270719 152.310776,17.5052077 152.492531,16.6028774 C152.674286,15.5200811 152.765163,13.8056535 152.765163,11.5498278 C152.674286,10.0158663 152.583408,8.57213779 152.401653,7.30887538 L152.401653,7.30887538 Z\" id=\"Shape\" fill=\"#000\" sketch:type=\"MSShapeGroup\"/><path d=\"M181.573347,10.6474975 C181.664224,10.0158663 181.755102,9.11353597 181.755102,7.85027356 C181.755102,7.03817629 181.664224,6.31631206 181.573347,5.59444782 C181.482469,4.96281662 181.300714,4.33118541 181.028082,3.88002026 C180.210184,2.25582573 178.84702,1.35349544 176.847714,1.08279635 C176.302449,0.992563323 175.484551,0.902330294 174.484898,0.902330294 C173.394367,0.812097264 172.122082,0.812097264 170.577163,0.812097264 L158.672204,0.812097264 C157.854306,0.812097264 157.399918,1.17302938 157.399918,2.07535968 L157.399918,21.0242958 L159.94449,21.0242958 L159.94449,14.0763526 C163.488714,14.1665856 177.938245,14.0763526 177.938245,14.0763526 C178.392633,14.0763526 179.028776,15.339615 179.028776,18.407538 L179.028776,21.1145289 L181.573347,21.1145289 L181.573347,18.407538 C181.573347,17.5954407 181.573347,16.8735765 181.482469,16.2419453 C181.482469,15.7005471 181.391592,15.249382 181.391592,14.9786829 C181.209837,14.1665856 180.846327,13.5349544 180.391939,12.9935562 C180.937204,12.4521581 181.391592,11.6400608 181.573347,10.6474975 L181.573347,10.6474975 Z M179.119653,10.1060993 C179.028776,10.5572644 178.301755,11.6400608 177.847367,11.6400608 C176.665959,11.6400608 163.306959,11.5498278 159.853612,11.6400608 L159.853612,3.42885512 L170.486286,3.42885512 C173.576122,3.42885512 175.575429,3.51908815 176.484204,3.6995542 C177.029469,3.78978723 177.574735,3.97025329 177.938245,4.15071935 C178.301755,4.42141844 178.665265,4.69211753 178.84702,5.14328267 C179.210531,5.77491388 179.301408,6.7674772 179.301408,7.94050659 C179.210531,8.93306991 179.210531,9.65493414 179.119653,10.1060993 L179.119653,10.1060993 Z\" id=\"Shape\" fill=\"#000\" sketch:type=\"MSShapeGroup\"/><path d=\"M65.977102,28.5136373 L55.8896939,10.2865653 C55.7079388,9.92563323 55.253551,9.74516717 54.7991633,9.74516717 C54.3447755,9.74516717 53.9812653,9.92563323 53.7086327,10.2865653 L43.6212245,28.5136373 L65.977102,28.5136373 L65.977102,28.5136373 Z\" id=\"Shape\" fill=\"#CC0000\" sketch:type=\"MSShapeGroup\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-warrior.svg',
    "<svg viewBox=\"0 0 44 44\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"wfIcon-warrior\"><defs/><g id=\"Page-1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"motif-logo\"><g transform=\"translate(4.000000, 9.000000)\"><path d=\"M27.448,16.472 C27.229,16.837 26.937,17.057 26.572,17.057 L24.528,17.057 C24.09,17.057 23.798,16.837 23.579,16.472 L17.593,3.624 L11.242,16.472 C11.169,16.618 11.023,16.764 10.877,16.91 C10.658,17.057 10.512,17.057 10.293,17.057 L8.176,17.057 C7.738,17.057 7.446,16.837 7.227,16.472 L0,0.997 L2.19,0.997 L8.833,15.085 L9.636,15.085 L16.644,0.997 L18.469,0.997 L25.039,15.012 L25.769,15.012 L32.85,0.923 L35.186,0.923 L27.448,16.472\" id=\"Fill-1\" fill=\"#FFFFFF\"/><path d=\"M26.572,26.043 L18.469,11.296 C18.323,11.004 17.958,10.858 17.593,10.858 C17.228,10.858 16.936,11.004 16.717,11.296 L8.614,26.043 L26.572,26.043\" id=\"Fill-2\" fill=\"#CC0000\"/></g></g></g></svg>"
  );


  $templateCache.put('/icons/wfIcon-web-design.svg',
    "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs/><g id=\"icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"webdesign\" stroke=\"#212121\"><g id=\"ico-web-design\"><path d=\"M9.5411377,15.5 L5.49596659,15.5 C4.94590943,15.5 4.5,15.0443356 4.5,14.5046024 L4.5,6.49539757 C4.5,5.94565467 4.94748943,5.5 5.49850233,5.5 L16.5014977,5.5 C17.0529553,5.5 17.5,5.94662506 17.5,6.49557801 L17.5,8.44067383\" id=\"Rectangle-49\"/><path d=\"M7.5,17.5 L9.5,17.5\" id=\"Line\" stroke-linecap=\"round\"/><path d=\"M12,11.5456543 L12,9.49726113 C12,8.94648901 12.4466987,8.5 12.9959421,8.5 L18.5040579,8.5 C19.0541015,8.5 19.5,8.9463114 19.5,9.49754465 L19.5,16.5024554 C19.5,17.053384 19.0499119,17.5 18.4912152,17.5 L14,17.5\" id=\"Rectangle-49-Copy\"/><rect id=\"Rectangle-49-Copy-2\" x=\"9.5\" y=\"11.5\" width=\"5\" height=\"7\" rx=\"1\"/><path d=\"M12,17 L12,17\" id=\"Line\" stroke-linecap=\"round\"/></g></g></g></svg>"
  );


  $templateCache.put('/views/warriorUtils/wfNotifications.html',
    "<span class=\"Header-notificationWrapper\" tabindex=\"0\">\n" +
    "    <div class=\"Header-notification\">\n" +
    "        <a ng-click=\"$ctrl.toggleDropdown(); $ctrl.initialize();\">\n" +
    "            <span class=\"Header-notificationIcon\">\n" +
    "                <span class=\"Icon Icon--light\">\n" +
    "                    <wf-icon src=\"bell\"></wf-icon>\n" +
    "                </span>\n" +
    "            </span>\n" +
    "            <span ng-show=\"$ctrl.totalUnread > 0\" class=\"Header-notificationVal\" ng-cloak>\n" +
    "                {{ $ctrl.totalUnread | andMore }}\n" +
    "            </span>\n" +
    "        </a>\n" +
    "    </div>\n" +
    "    <article class=\"SideBar\" ng-if=\"$ctrl.state.showDropdown\" wf-deep-blur=\"$ctrl.hideDropdown()\">\n" +
    "        <div class=\"SideBar-header\">\n" +
    "            <h5 class=\"SideBar-title\">\n" +
    "                Notifications <span ng-show=\"$ctrl.hasUnread()\">({{$ctrl.totalUnread}})</span>\n" +
    "            </h5>\n" +
    "            <div class=\"Notifications-headerAction\">\n" +
    "                <a ng-show=\"$ctrl.hasUnread()\" ng-click=\"$ctrl.markAllAsRead()\">Mark all as read</a>\n" +
    "            </div>\n" +
    "            <button class=\"CloseBtn\" ng-click=\"$ctrl.hideDropdown()\">\n" +
    "                <wf-icon class=\"WFIcon-cross\" src=\"cross\"></wf-icon>\n" +
    "            </button>\n" +
    "        </div>\n" +
    "        <span class=\"is-loading\" ng-show=\"$ctrl.state.loading\"></span>\n" +
    "        <div class=\"Notifications-placeholder\" ng-show=\"$ctrl.isEmpty()\" ng-style=\"{'opacity': $ctrl.state.loading ? 0.4 : 1}\">\n" +
    "            <div class=\"Notifications-placeholder-title\">\n" +
    "                <wf-icon class=\"notification-icon\" src=\"notifications\"></wf-icon>\n" +
    "                <h3>No Notifications</h3>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <ul infinite-scroll=\"$ctrl.nextBatch()\"\n" +
    "            infinite-scroll-distance=\"1\"\n" +
    "            infinite-scroll-immediate-check=\"$ctrl.isEmpty() || $ctrl.state.loading\"\n" +
    "            fl-analytics-section=\"wf-notifications\"\n" +
    "            ng-hide=\"$ctrl.isEmpty()\"\n" +
    "            ng-style=\"{'opacity': $ctrl.state.loading ? 0.4 : 1}\"\n" +
    "            class=\"Notification-list\">\n" +
    "            <li class=\"Notification-item\"\n" +
    "                ng-class=\"{'is-unread': !notification.is_read, 'is-last': $last}\"\n" +
    "                ng-repeat=\"notification in $ctrl.data.notifications\">\n" +
    "                <div class=\"Notification\" ng-class=\"{'is-Notification-active': !notification.is_read}\">\n" +
    "                    <div class=\"Notification-figure\">\n" +
    "                        <div class=\"Notification-icon\">\n" +
    "                        <wf-icon class=\"wfIcon-notifications\" src=\"{{notification.sub_icon}}\"></wf-icon>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <span class=\"Notification-content\">\n" +
    "                        <p class=\"Notification-msg\" ng-bind-html=\"notification.template\"></p>\n" +
    "                        <time class=\"Notification-time\">{{notification.created_at | ago}}</time>\n" +
    "                    </span>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </article>\n" +
    "</span>\n"
  );

}]);

'use strict';

angular.module('wfManager', [
  'warriorUtils',
  'wfOnboarding',
  'textAngular',
  'ui.bootstrap',
  'ui.bootstrap.modal',
  'nvd3'
])
.run(["$cookies", "$rootScope", "$timeout", "$window", "Analytics", "DeviceClassifier", "GreetingModal", "Signup", "SignupWall", "Login", "LocalStorage", "RequestHeader", "ForumAuthentication", "DIRECT_ACCESSED_STORAGE", "LOGIN_WELCOME_COOKIE", "LAST_LOGGED_IN_STORAGE", "Auth", "WfTrackingCookie", function (
  $cookies,
  $rootScope,
  $timeout,
  $window,
  Analytics,
  DeviceClassifier,
  GreetingModal,
  Signup,
  SignupWall,
  Login,
  LocalStorage,
  RequestHeader,
  ForumAuthentication,
  DIRECT_ACCESSED_STORAGE,
  LOGIN_WELCOME_COOKIE,
  LAST_LOGGED_IN_STORAGE,
  Auth,
  WfTrackingCookie) {

  WfTrackingCookie.init();

  if (ForumAuthentication.isAuthenticated()) {
    LocalStorage.set(LAST_LOGGED_IN_STORAGE);
  }

  // remember if the user ever entered warriorforum directly into the browser
  if (!RequestHeader.getReferrer(document)) {
    LocalStorage.set(DIRECT_ACCESSED_STORAGE);
  }

  function shouldShowSignup() {
    if (SignupWall.shouldShowModal()) {
      Analytics.trackAction('signup-wall', 'showSignupModal', 'SUCCESS');
      return true;
    }

    return false;
  }

  function shouldShowLogin() {
    if (ForumAuthentication.isAuthenticated()) {
      return false;
    }

    return $window.location.search.indexOf('login=1') > 0;
  }

  Auth.checkAuthenticated();

  if (shouldShowSignup()) {
    Signup.openSignupModal();
  } else if (shouldShowLogin()) {
    Login.openLoginModal();
  } else if ($cookies.get(LOGIN_WELCOME_COOKIE)) {
    if(DeviceClassifier.isMobileScreen()) {
      return false;
    }
    GreetingModal.fetchMessageAndOpenModal();
  }

  $rootScope.$on('user.refreshlogin.ok', function() {
    $timeout(function() {
      $window.location.reload();
    });
  });
}]);

'use strict';

angular.module('wfManager').component('addCuratedThreadForm', {
  templateUrl: '/views/wfManager/addCuratedThreadForm.html',
  controller: ["$window", "CuratedThread", function($window, CuratedThread) {
    var ctrl = this;
    ctrl.state = {
      sucess: false,
      loading: false
    };

    ctrl.submit = function() {
      ctrl.state.loading = true;
      CuratedThread.create(ctrl.threadId).then(function() {
        ctrl.state.success = true;
        $window.location.reload();
      }).catch(function(response) {
        $window.alert(response.data.message);
        ctrl.threadId = null;
      }).finally(function() {
        ctrl.state.loading = false;
      });
    };
  }]
});

'use strict';

angular.module('wfManager').component('bumpCuratedThread', {
  bindings: {
    threadId: '@'
  },
  templateUrl: '/views/wfManager/bumpCuratedThread.html',
  controller: ["$window", "CuratedThread", function($window, CuratedThread) {
    var ctrl = this;
    ctrl.state = {
      loading: false
    };

    ctrl.bump = function() {
      ctrl.state.loading = true;
      CuratedThread.bump(ctrl.threadId).then(function() {
        $window.location.reload();
      }).catch(function(response) {
        $window.alert(response.data.message);
      }).finally(function() {
        ctrl.state.loading = false;
      });
    };
  }]
});

'use strict';

angular.module('wfManager').component('cancelMembershipButton', {
  bindings: {
    type: '@'
  },
  templateUrl: '/views/wfManager/cancelMembershipButton.html',
  controller: ["ConfirmationModal", "Membership", function(ConfirmationModal, Membership){
    var ctrl = this;

    ctrl.state = {
      ready: false,
      loading: false,
      success: false,
      error: false
    };

    var modalOptions = {
      positiveCTA: 'Confirm',
      negativeCTA: 'Keep',
      modalTitle: 'Cancel Membership',
      content: 'Do you really want to cancel your subscription? Once done, you will be able to keep your subscription until its expiration date and we won\'t renew anymore until you re-activate it.'
    };

    Membership.getActiveByType(ctrl.type).then(function(response) {
      ctrl.membership = response.membership;
    }).finally(function() {
      ctrl.state.ready = true;
    });

    ctrl.openConfirmationModal = function(){
      ctrl.state.loading = true;
      ctrl.state.success = false;
      ctrl.state.error = false;

      ConfirmationModal.open(modalOptions).then(function(response){
        if(response === modalOptions.positiveCTA) {
          Membership.cancelByType(ctrl.type).then(function() {
            ctrl.state.success = true;
          }).catch(function(response) {
            ctrl.state.error = true;
            ctrl.errorMessage = response.message;
          }).finally(function() {
            ctrl.state.loading = false;
          });
        }
      });
    };
  }]
});

'use strict';

angular.module('wfManager').component('createLinkTypeThreadForm', {
 templateUrl: '/views/wfManager/linkTypeThreadForm.html',
 controller: ["Thread", "LINK_TYPE_THREADS_FORUMID", "$window", function(Thread, LINK_TYPE_THREADS_FORUMID, $window) {
    var ctrl = this;

    ctrl.state = {
      loading: false,
    };

    ctrl.thread = {
      forumId: LINK_TYPE_THREADS_FORUMID,
      type: 'link'
    };

    ctrl.submit = function() {
      ctrl.thread.forumId = LINK_TYPE_THREADS_FORUMID;
      ctrl.thread.type = 'link';
      ctrl.thread.subject = ctrl.thread.title;
      ctrl.state.loading = true;
      Thread.create(ctrl.thread).then(function(){
        $window.location.reload();
      }).catch(function(response){
        $window.alert(response.data.message);
      }).finally(function(){
        ctrl.state.loading = false;
      });
    };
  }]
});

'use strict';

angular.module('wfManager').component('createThreadForm', {
  templateUrl: '/views/wfManager/createThreadForm.html',
  bindings: {
    forumId: '@',
    focusOnForm: '<'
  },
  controller: ["$element", "$window", "$timeout", "AVATAR_PLACEHOLDER", "ForumURLGenerator", "Thread", "TopicUtils", "Users", function($element, $window, $timeout, AVATAR_PLACEHOLDER, ForumURLGenerator, Thread, TopicUtils, Users) {
    var ctrl = this;

    ctrl.fallbackAvatar = AVATAR_PLACEHOLDER;
    ctrl.forumId = parseInt(ctrl.forumId, 10);

    Users.get().then(function(user) {
      Users.getPublicInfoByUsername(user.username).then(function(response) {
        ctrl.user = response;
      });
    });

    ctrl.newThread = {
      subject: '',
      message: ''
    };

    ctrl.state = {
      submitted: false,
      isSubmitting: false
    };

    ctrl.topicList = TopicUtils.getAll();
    ctrl.selectedTopic = ctrl.topicList.filter(function(topic) {
      return topic.forum_id === ctrl.forumId;
    })[0];

    ctrl.$onChanges = function() {
      if(!ctrl.focusOnForm) {
        return;
      }

      $timeout(function() {
        $element.find('input[name=subject]').focus();
      });
    };

    var postThread = function (newThread) {
      Thread.create(newThread).then(function(response) {
        $window.location.href = ForumURLGenerator.getThread(response.data.thread.id);
      }).catch(function(response) {
        ctrl.nonFieldError = '' + response.data.message;
      }).finally(function() {
        ctrl.state.isSubmitting = false;
      });
    };

    ctrl.submit = function() {
      ctrl.state.submitted = true;
      ctrl.state.isSubmitting = true;
      ctrl.nonFieldError = null;

      ctrl.newThread.forumId = ctrl.selectedTopic.forum_id;
      postThread(ctrl.newThread);
    };
  }]
});

'use strict';

angular.module('wfManager').component('createWsoButton', {
  bindings: {
    source: '@',
    cssClass: '@'
  },
  template : '<a class="{{$ctrl.cssClass}}" ng-click="$ctrl.openModal()">Create a new WSO</a>',
  controller: ["ConfirmationModal", "$window", "ForumURLGenerator", "$httpParamSerializer", "URLGenerator", function(ConfirmationModal, $window, ForumURLGenerator, $httpParamSerializer, URLGenerator){
    var ctrl = this;

    var modalOptions = {
      positiveCTA: 'Create new product',
      negativeCTA: 'List existing product',
      modalTitle: 'Create a new WSO',
      content: 'Are you listing a current product or a new product?'
    };

    var utmParams = {
      'utm_medium': 'create_wso_button',
      'utm_source': ctrl.source,
      'utm_campaign': 'post_wso'
    };

    ctrl.openModal = function(){
      ConfirmationModal.open(modalOptions).then(function(response){
        if(response === modalOptions.positiveCTA){
          URLGenerator.setUtmParams(utmParams);
          $window.location.href = URLGenerator.getPostProductUrl();
        }else{
          ForumURLGenerator.setParams(utmParams);
          $window.location.href = ForumURLGenerator.getNewOfferUrl();
        }
      });
    };
  }]
});
'use strict';

angular.module('wfManager').component('editLinkTypeThreadForm', {
  bindings: {
    threadId: '<'
  },
  templateUrl: '/views/wfManager/linkTypeThreadForm.html',
  controller: ["Thread", "Comment", "$window", function(Thread, Comment, $window) {
    var ctrl = this;

    ctrl.state = {
      loading: false,
    };

    ctrl.$onChanges = function() {
      ctrl.state.loading = true;
      var threadInfo = {
        thread_type: true,
        thread_id: ctrl.threadId
      };

      ctrl.thread = {
        id: ctrl.threadId
      };

      Thread.get(threadInfo).then(function(result){
        var thread = result.data.thread;
        ctrl.thread.title = thread.title;
        ctrl.thread.destinationUrl = thread.destination_url;
        ctrl.thread.main_post_id = thread.main_post_id;

        Comment.get(thread.main_post_id).then(function(result) {
          ctrl.thread.message = result.data.post.bb_content;
        });
      }).finally(function() {
        ctrl.state.loading = false;
      });
    };

    ctrl.submit = function() {
      ctrl.state.loading = true;
      var main_post = {
        id: ctrl.thread.main_post_id,
        title: ctrl.thread.title,
        bb_content: ctrl.thread.message
      };

      Comment.update(main_post).then(function() {
        Thread.updateLinkTypeThread(ctrl.thread).then(function() {
          $window.location.reload();
        });
      }).catch(function(response) {
        $window.alert(response.data.message);
      }).finally(function() {
        ctrl.state.loading = false;
      });
    };
  }]
});

'use strict';

angular.module('wfManager').component('postModerationControls', {
    templateUrl : '/views/wfManager/postModerationControls.html',
    bindings: {
      postId: '@',
      threadId: '@',
      userId: '@'
    },
    controller: ["Comment", "ForumURLGenerator", "$window", function(Comment, ForumURLGenerator, $window) {
      var ctrl = this;
      ctrl.postApproved = false;

      ctrl.approvePost = function(){
        Comment.approve(ctrl.postId).then(function(result) {
          ctrl.postApproved = result.data.approved;
        }, function(error) {
          $window.alert('Cannot approve. Error encountered: ' + error.data.message);
        });
      };

      ctrl.launchDecimator = function() {
        var params = {
          'userid': ctrl.userId,
          'threadid': ctrl.threadId,
          'postid': ctrl.postId
        };

        ForumURLGenerator.setParams(params);

        $window.open(ForumURLGenerator.getSpamDecimatorUrl(),
          'spam_decimator',
          'statusbar=yes,menubar=yes,toolbar=yes,scrollbars=yes,resizable=yes,width=800,height=600'
        );
      };
    }]
});

'use strict';

angular.module('wfManager').component('referralInput', {
  templateUrl: '/views/wfManager/referralInput.html',
  bindings: {
    type: '@'
  },
  controller: ["Referral", "Validator", function(Referral, Validator) {
    var ctrl = this;

    ctrl.state = {
      loading: false,
      success: false
    };

    ctrl.referral = {};
    ctrl.referral.type = ctrl.type;

    ctrl.invite = function() {
      ctrl.state.loading = true;
      ctrl.state.success = false;
      ctrl.errorMessage = '';

      Referral.create(ctrl.referral).then(function() {
        ctrl.state.success = true;
      }).catch(function(response) {
        ctrl.errorMessage = response.data.message;
      }).finally(function() {
        ctrl.state.loading = false;
      });
    };

    ctrl.isValidEmail = function() {
      return Validator.isEmail(ctrl.referral.email);
    };
  }],
});

'use strict';

angular.module('wfManager').component('removeCuratedThread', {
  bindings: {
    threadId: '@'
  },
  templateUrl: '/views/wfManager/removeCuratedThread.html',
  controller: ["$window", "CuratedThread", function($window, CuratedThread) {
    var ctrl = this;
    ctrl.state = {
      loading: false
    };

    ctrl.remove = function() {
      ctrl.state.loading = true;
      CuratedThread.delete(ctrl.threadId).then(function() {
        $window.location.reload();
      }).catch(function(response) {
        $window.alert(response.data.message);
      }).finally(function() {
        ctrl.state.loading = false;
      });
    };
  }]
});

'use strict';

angular.module('wfManager').component('replyForm', {
  templateUrl: '/views/wfManager/replyForm.html',
  bindings: {
    threadId: '=',
    parentId: '=',
    open: '@',
    placeholder: '@'
  },
  controller: ["$element", "$scope", "$timeout", "$window", "AVATAR_PLACEHOLDER", "Analytics", "Comment", "LocalStorage", "Signup", function($element, $scope, $timeout, $window, AVATAR_PLACEHOLDER, Analytics, Comment, LocalStorage, Signup) {
    var ctrl = this;

    ctrl.avatarPlaceholder = AVATAR_PLACEHOLDER;
    ctrl.author = $window.CURRENT_USER;

    ctrl.open = ctrl.open || false;
    ctrl.placeholder = ctrl.placeholder || 'Join the conversation...';

    ctrl.state = {
      posting: false,
      postingFailed: false,
      showMessageEditor: false,
      showHelpText: false
    };

    var storageKey = ctrl.threadId + '/' + ctrl.parentId;

    ctrl.newPost = {
      content: LocalStorage.get(storageKey) || '',
      thread_id: ctrl.threadId,
      parent_id: ctrl.parentId
    };

    ctrl.isInvalidPost = function() {
      return ctrl.newPost.content.length < 10;
    };

    var removeHiddenElements = function() {
      ctrl.state.showHelpText = false;
      ctrl.state.showMessageEditor = false;
    };

    ctrl.postComment = function() {
      if (ctrl.isInvalidPost()) {
        return false;
      }

      ctrl.state.posting = true;
      ctrl.state.postingFailed = false;

      Comment.create(ctrl.newPost).then(
        function(result) {
          removeHiddenElements();
          LocalStorage.remove(storageKey);
          ctrl.state.posting = false;
          ctrl.newPost.content = '';

          result.data.post.is_new = true;
          $scope.$emit('newComment', result.data.post);
          Analytics.trackEvent('discussion-board', 'reply-form', 'submit-reply', 'submit-reply', 'success', 'status');
        },
        function(result) {
          ctrl.state.posting = false;
          ctrl.state.postingFailed = true;
          if (result.data && result.data.message) {
            ctrl.errorMessage = result.data.message;
          }

          //temporary solution since ForumAuthenticaton is unreliable
          if(result.code === 'AUTH.FAILED') {
            Signup.openSignupModal();
          }

          Analytics.trackEvent('discussion-board', 'reply-form', 'submit-reply', 'submit-reply', 'failed', 'status');
        }
      );
    };

    ctrl.displayHiddenElements = function() {
      Analytics.trackEvent('discussion-board', 'reply-form', 'click-reply', 'click-reply', ctrl.parentId, 'Parent Id');
      ctrl.state.showHelpText = true;
      ctrl.state.showMessageEditor = true;
      $timeout(function() {
        $element.find('textarea').focus();
      });
    };

    if (ctrl.open) {
      ctrl.displayHiddenElements();
    }

    ctrl.unfocus = function() {
      if (ctrl.newPost.content.length === 0) {
        LocalStorage.remove(storageKey);
      } else {
        LocalStorage.set(storageKey, ctrl.newPost.content);
      }

      ctrl.state.showMessageEditor = false;
      $scope.$emit('hideReplyForm', {'close':true});
    };
  }]
});

'use strict';

angular.module('wfManager').component('signUpForm', {
  templateUrl : '/views/wfManager/signUpForm.html',
  controller: ["$timeout", "$window", "Forum", "URLGenerator", "vcRecaptchaService", function($timeout, $window, Forum, URLGenerator, vcRecaptchaService){
    var ctrl = this;
    ctrl.state = {
      loading: false,
      signup: true
    };

    ctrl.fbLoginUrl = URLGenerator.fbLoginUrl;
    ctrl.googleLoginUrl = URLGenerator.googleLoginUrl;

    var initialize = function() {
      ctrl.state.error = false;
      ctrl.errorMessage = '';
    };

    initialize();

    $timeout(function() {
      ctrl.state.ready = true;
    });

    ctrl.createAccount = function(user) {
      ctrl.state.loading = true;
      initialize();
      user.confirmPassword = user.password;
      Forum.createAccount(user).then(function() {
        $window.location.reload();
      }).catch(function(response) {
        ctrl.state.error = true;
        ctrl.errorMessage = response.data.message;
        vcRecaptchaService.reload();
      }).finally(function() {
        ctrl.state.loading = false;
      });
    };

    ctrl.loginUser = function(user) {
      ctrl.state.loading = true;
      initialize();
      Forum.login(user).then(function() {
        $window.location.reload();
      }).catch(function(response) {
        ctrl.state.error = true;
        ctrl.errorMessage = response.data.message.message;
        ctrl.login.password = '';
      }).finally(function() {
        ctrl.state.loading = false;
      });
    };

    ctrl.toggleForm = function() {
      initialize();
      ctrl.state.signup = !ctrl.state.signup;
    };
  }]
});

'use strict';

angular.module('wfManager').component('threadPublishButton', {
  templateUrl: '/views/wfManager/threadPublishButton.html',
  bindings: {
    id: '@'
  },
  controller: ["$window", "Thread", function($window, Thread) {
    var ctrl = this;
    ctrl.launch = function() {
      Thread.setAsVisible(ctrl.id).then(function() {
        $window.location.reload();
      });
    };
  }],
});

'use strict';

angular.module('wfManager').component('userTitle', {
  bindings: {
    userRole: '@',
  },
  template: '<span class="UserTitle" ng-class="{ \'is-admin\':  $ctrl.isFlared() }">{{ $ctrl.userRole }}</span>',
  controller: function(){
    var ctrl = this;

    ctrl.isFlared = function(){
      if(ctrl.userRole === 'Administrator' || ctrl.userRole === 'Moderator'){
        return true;
      }
      return false;
    };
  }
});
'use strict';

angular.module('wfManager')
.controller('IncrementUpvoteModalCtrl', ["$scope", "$log", "$uibModal", function($scope, $log, $uibModal) {
  $scope.openModal = function () {
    $scope.adminvote = 0;
    var modalInstance = $uibModal.open({
      windowClass: 'ModalV2-wrapper',
      templateUrl: '/views/wf/IncrementUpvoteModal.html',
      size: 'sm',
      backdrop: 'static',
      controller: ["$rootScope", "$scope", "threadid", "ThreadUpvote", function($rootScope, $scope, threadid, ThreadUpvote ) {
        $scope.submitIncrement = function () {
          modalInstance.close($scope.adminvote);
          ThreadUpvote.incrementVotes(threadid, $scope.adminvote).then(function(response) {
            $rootScope.$broadcast('upvote', threadid, false, response.data.score);
          });
        };

        $scope.cancel = function () {
          modalInstance.dismiss('cancel');
        };
      }],
      resolve: {
        threadid: function () {
          return $scope.threadid;
        }
      }
    });

    modalInstance.result.then(function (selectedItem) {
      $scope.selected = selectedItem;
    }, function () {
      $log.info('Modal dismissed at: ' + new Date());
    });
  };

  $scope.incrementUpvote=function() {
    $scope.openModal();
  };
}]);

'use strict';

angular.module('wfManager')
  .controller('EditMainPostContentCtrl', ["$scope", "Comment", function($scope, Comment) {
    $scope.initVars = function() {
      if($scope.post.edit_log.dateline !== null && $scope.post.edit_log.dateline !== 0){
        $scope.post.edit_log.dateline = $scope.post.edit_log.dateline * 1000;
      }
      $scope.isShowEditForm = false;
      $scope.isFormSubmitted = false;
    };

    $scope.initInputs = function(){
      $scope.subjectInput = $scope.post.title;
      $scope.messageInput = $scope.post.bb_content;
      $scope.reasonInput = $scope.post.edit_log.reason;
    };

    $scope.update = function() {
      $scope.isFormSubmitted = true;
      if ($scope.editPostForm.$valid) {
        $scope.post.title = $scope.subjectInput;
        $scope.post.content = $scope.messageInput;
        $scope.post.reason = $scope.reasonInput;
        Comment.update($scope.post).then(
          function(response){
            $scope.post = response.data.post;
            $scope.initVars();
          }
        );
      }
    };

    $scope.hideEditForm = function(){
      $scope.isShowEditForm = false;
    };

    $scope.showEditForm = function(){
      $scope.initInputs();
      $scope.isShowEditForm = true;
    };

}]);

'use strict';

angular.module('wfManager')
  .controller('FeedTourCtrl',
    ["$scope", "UserSetting", "ForumAuthentication", "LocalStorage", "FEED_TOUR_STORAGE", function($scope, UserSetting, ForumAuthentication, LocalStorage, FEED_TOUR_STORAGE) {
      var hideTour = -1;

      if (ForumAuthentication.isAuthenticated()) {
        $scope.currentStep = LocalStorage.get(FEED_TOUR_STORAGE, 0);
      }
      else {
        $scope.currentStep = hideTour;
      }

      $scope.saveStep = function() {
        /* angular-tour caveat; saveStep is being run even before the first step displays */
        if ($scope.currentStep === true){
          $scope.currentStep = 0;
        }
        LocalStorage.set(FEED_TOUR_STORAGE, $scope.currentStep);
      };

      $scope.finishTour = function() {
        var setting_name = 'feed_tour_introduction';
        UserSetting.change(setting_name, 1).then(function() {
          LocalStorage.remove(FEED_TOUR_STORAGE);
        });
      };
    }]);

'use strict';

angular.module('wfManager')
  .controller('HeroLandingCtrl', ["$scope", "$document", "wfCookieExperiment", "wfWindowLocation", "RequestHeader", "ForumAuthentication", function($scope, $document, wfCookieExperiment, wfWindowLocation, RequestHeader, ForumAuthentication) {
    var experimentId = 10;

    $scope.state = {};
    $scope.state.tab = 'threads';
    $scope.state.heroVisible = false;
    $scope.setTab = function(tabName) {
      $scope.state.tab = tabName;
    };

    function referredFromGoogle() {
      var referrer = RequestHeader.getReferrer($document);
      if (!referrer) {
        return false;
      }

      return referrer.indexOf('//www.google') > -1;
    }

    function inExperiment() {
      if (!referredFromGoogle()) {
        return false;
      }

      if (ForumAuthentication.isAuthenticated()) {
        return false;
      }

      return true;
    }

    function getVariationFromUrl() {
      if (wfWindowLocation.hasQueryNameValue('h' + experimentId, 0)) {
        return 0;
      }

      if (wfWindowLocation.hasQueryNameValue('h' + experimentId, 1)) {
        return 1;
      }

      if (wfWindowLocation.hasQueryNameValue('e' + experimentId, 0)) {
        return 0;
      }

      if (wfWindowLocation.hasQueryNameValue('e' + experimentId, 1)) {
        return 1;
      }

      return undefined;
    }

    // require variation to be defined in the url for easy analytics tracking
    var variation = getVariationFromUrl();
    if (variation === undefined) {
      if (inExperiment()) {
        // show HeroLanding 5% of the time
        var redirectVariation = wfCookieExperiment.getBiasedVariation(experimentId, 19, 1);
        wfWindowLocation.redirectWithParameter('h' + experimentId, redirectVariation);
      }
    } else {
      $scope.state.heroVisible = (variation === 1);
    }
  }]);
'use strict';

angular.module('wfManager')
  .controller('HoodiePaymentCtrl', ["$scope", "$uibModal", function($scope, $uibModal) {
    $scope.variation = 'b';

    $scope.openPayNow = function() {
        var config = {
          'name': '',
          'desc': '',
          'price': 0,
          'item': {
            'itemClass': 'dailydeal.wfhoodie',
            'itemId': 0,
            'itemType': 'wfhoodie'
          }
        };

        $uibModal.open({
          windowClass: 'default-modal payment-modal',
          templateUrl: '/views/wf/HoodieModal.html',
          controller: 'HoodiePaymentModalCtrl',
          backdrop: 'static',
          size: 'sm',
          resolve: {
            paymentChoiceConfig: function() {
              return config;
            }
          }
        });
    };
  }]);

'use strict';

angular.module('wfManager').controller('LinkTypeThreadsCtrl', ["$scope", function($scope) {
  $scope.state = null;
  $scope.threadId = null;

  $scope.show_create_form = function() {
    $scope.state = 'new';
  };

  $scope.show_edit_form = function(threadId) {
    $scope.state = 'edit';
    $scope.threadId = threadId;
  };
}]);

'use strict';

angular.module('wfManager')
  .controller('MainLayoutCtrl', ["$rootScope", "$scope", function($rootScope, $scope) {
    $scope.isMobileNavigation = false;
    $scope.sideBarOpen = false;

    var toggleIsMobileNavigation = function() {
      $scope.isMobileNavigation = !$scope.isMobileNavigation;
    };

    $scope.toggleIsMobileNavigation = toggleIsMobileNavigation;
    $rootScope.$on('ui.mobileNavigation', function() {
      toggleIsMobileNavigation();
    });

    $rootScope.$on('sideBarOpen', function(event, data){
      $scope.sideBarOpen = data;
    });

    $scope.$on('feed.openPostThreadModal', function(){
      $scope.$broadcast('feed.openPostThreadModalBroadcast');
    });

    $scope.closeMobileNavigation = function() {
      $scope.isMobileNavigation = false;
    };
  }]);

'use strict';

angular.module('wfManager')
  .controller('NewThreadCtrl', ["$anchorScroll", "$attrs", "$scope", "$window", "$uibModal", "ForumURLGenerator", "Thread", "Users", function(
    $anchorScroll,
    $attrs,
    $scope,
    $window,
    $uibModal,
    ForumURLGenerator,
    Thread,
    Users) {

    $scope.newThreadData = {
      subject: '',
      message: '',
      forumId: $attrs.forumId,
    };

    $scope.state = {
      authenticated: true,
      emailConfirmed: true,
      modalHidden: true,
      submitting: false
    };

    $scope.errorMessage = '';

    $scope.sticky = false;
    $scope.bumped = true;
    $scope.total = 74;

    var _stickyCost = 100;
    var _bumpCost = 54;
    var _threadId = null;
    var _redirUrl = null;
    var backdropClass = 'Modal-backdrop';
    var backdropString = '<div class=' + backdropClass + '></div>';

    Users.get().then(function(user) {
      $scope.state.authenticated = true;
      $scope.state.emailConfirmed = user.is_email_confirmed;
      if(!$scope.state.emailConfirmed) {
        $scope.errorMessage = 'Make sure to verify your email first before posting an offer';
      }
    }).catch(function(){
      $scope.state.authenticated = false;
    });

    $scope.showPostThreadModal = function() {
      if ($scope.state.modalHidden) {
        $scope.state.modalHidden = false;
        angular.element('.PostWidget.Card').append(backdropString);
        angular.element('body').addClass('is-Modal-open');
      }
    };

    $scope.hidePostThreadModal = function() {
      $scope.state.modalHidden = true;
      angular.element('body').removeClass('is-Modal-open');
      angular.element('.PostWidget.Card .' + backdropClass).remove();
    };

    $scope.submit = function(formData) {
      $scope.state.submitting = true;
      $scope.errorMessage = '';

      if ($scope.newThreadForm.$valid) {
        $scope.postThread(formData);
      } else {
        $scope.state.submitting = false;
      }
    };

    $scope.preview = function(formData) {
      $scope.state.submitting = true;
      Thread.getPreview(formData).then(function(response) {
        $scope.newThreadData.preview = response.data.thread.preview;
      }).catch(function(response) {
        $scope.errorMessage = response.data.message.message;
      }).then(function(){
        $scope.state.submitting = false;
        $anchorScroll();
      });
    };

    var openPaymentChoiceModal = function(config) {
      var modal = $uibModal.open({
        windowClass: 'default-modal payment-modal',
        templateUrl: '/views/warrior/nibiru/payment_modal.html',
        controller: 'PaymentChoiceModalCtrl',
        backdrop: 'static',
        size: 'sm',
        resolve: {
          paymentChoiceConfig: function() {
            return config;
          }
        }
      });

      var onclosed = function() {
        if (_redirUrl) {
          $window.location.href = _redirUrl;
        }
      };

      modal.result.then(onclosed, onclosed);
    };

    var _getFixedCharge = function(is_sticky, is_bumped) {
        if (is_sticky && is_bumped) {
            return 'new.3bump.sticky';
        }

        if (is_sticky && !is_bumped) {
            return 'new.sticky';
        }

        if (!is_sticky && is_bumped) {
            return 'new.3bump';
        }

        if (!is_sticky && !is_bumped) {
            return 'new';
        }
    };

    var _handlePayment = function() {
      var itemClass = _getFixedCharge($scope.sticky, $scope.bumped);
      var cost = $scope.total;
      var threadId = _threadId;
      var config = {
        'name': '',
        'desc': '',
        'price': cost,
        'redirectUrl': _redirUrl,
        'item': {
          'itemId': threadId,
          'itemType': itemClass,
          'itemClass': 'thread'
        }
      };

      if ($scope.bumped) {
        config.item.isAutoBump = true;
        config.item.isUnlimited = false;
        config.item.bumpCount = 3;
      }

      openPaymentChoiceModal(config);
    };

    $scope.postThread = function(formData) {
      var postThreadSuccess = function(response) {
        $scope.state.submitted = false;
        var thread = response.data.thread;
        var thread_url = ForumURLGenerator.getThread(thread.id);
        var tracking_code = '&utm_source=internal&utm_medium=simplified-newthread&utm_campaign=post-wso';
        var url = thread_url + tracking_code;

        _redirUrl = url;
        _threadId = thread.id;
        _handlePayment();
      };

      var postThreadFail = function(response) {
        $scope.state.submitted = false;
        $scope.errorMessage = '' + response.data.message;
      };

      Thread.create(formData).then(postThreadSuccess, postThreadFail);
    };

    var _addSticky = function() {
      $scope.total += _stickyCost;
    };

    var _addBump = function() {
      $scope.total += _bumpCost;
    };

    var _removeBump = function() {
      $scope.total -= _bumpCost;
    };

    var _removeSticky = function() {
      $scope.total -= _stickyCost;
    };

    $scope.toggleSticky = function() {
      $scope.sticky = !$scope.sticky;
      if ($scope.sticky) {
        _addSticky();
      } else {
        _removeSticky();
      }
    };

    $scope.toggleBump = function() {
      $scope.bumped = !$scope.bumped;
      if ($scope.bumped) {
        _addBump();
      } else {
        _removeBump();
      }
    };
}]);

'use strict';

angular.module('wfManager').controller('OfferTextCtrl', ["$scope", "DeviceClassifier", "$window", function($scope, DeviceClassifier, $window) {
  $scope.showToggle = false;
  $scope.showAll = true;

  if(DeviceClassifier.isMobileScreen()) {
    var maxHeight = Math.round(angular.element($window).height() * 0.6);
    var offerTextHeight = angular.element('#offertext').height();

    if(offerTextHeight > maxHeight) {
      $scope.showToggle = true;
      $scope.showAll = false;
    }
  }

  $scope.toggle = function() {
    $scope.showAll = !$scope.showAll;
  };
}]);

'use strict';

angular.module('wfManager')
  .controller('OfferViewCtrl', ["$scope", "$attrs", "Comment", function($scope, $attrs, Comment) {
    $scope.state = {
      loadingDiscussionBoard: true,
      loadingTotalStats: true,
      loadingAnalytics: true,
      hideActionChart: false
    };

    $scope.threadId = $attrs.threadId;
    $scope.mainPostId = $attrs.mainPostId;

    Comment.get($scope.mainPostId).then(function(result) {
      $scope.mainPost = result.data.post;
    });

    $scope.$on('discussionBoardLoaded', function() {
      $scope.state.loadingDiscussionBoard = false;
    });

    $scope.$on('totalStatsLoaded', function() {
      $scope.state.loadingTotalStats = false;
    });

    $scope.$on('threadAnalyticsLoaded', function() {
      $scope.state.loadingAnalytics = false;
    });

    $scope.$on('threadAnalyticsLoaded', function() {
      $scope.state.loadingAnalytics = false;
    });

    $scope.$on('actionChartEmpty', function() {
      $scope.state.hideActionChart = true;
    });
  }]);

'use strict';

angular.module('wfManager')
  .controller('ThreadApprovalModalCtrl',
  ["$scope", "$uibModalInstance", "$rootScope", "options", "Thread", function($scope, $uibModalInstance, $rootScope, options, Thread) {
    $scope.state = {
      isLoading: false,
      success: false,
      error: false
    };

    $scope.rank = 1;

    $scope.confirmApproval = function() {
      $scope.state.isLoading = true;

      var done = function () {
        $scope.state.success = true;
        $scope.state.isLoading = false;
      };

      var displayError = function(response) {
        $scope.state.error = true;
        $scope.state.isLoading = false;
        $scope.errorMessage = response.data.message;
      };

      Thread.approve(options.threadId, $scope.rank).then(done, displayError);
    };

    $scope.cancel = function() {
      $uibModalInstance.close($scope.state);
    };
  }]);

'use strict';

angular.module('wfManager')
  .controller('ThreadDeletionModalCtrl',
  ["$scope", "$uibModalInstance", "$rootScope", "options", "Thread", function($scope, $uibModalInstance, $rootScope, options, Thread) {
    $scope.state = {
      'isLoading': false,
      'success': false,
      'error': false,
    };

    $scope.confirmDeletion = function() {
      $scope.state.isLoading = true;

      var done = function () {
        $scope.state.success = true;
        $scope.state.isLoading = false;
      };

      var displayError = function(response) {
        $scope.state.error = true;
        $scope.error_message = response.data.message;
        $scope.state.isLoading = false;
      };

      Thread.softDelete(options.threadId, $scope.reason).then(done, displayError);
    };

    $scope.cancel = function() {
      $uibModalInstance.close($scope.state);
    };
  }]);

'use strict';

angular.module('wfManager')
  .controller('ThreadNukeCtrl', ["$scope", "ThreadUpvote", "ForumAuthentication", "$window", function($scope, ThreadUpvote, ForumAuthentication, $window) {
    $scope.toggleNuke = function(threadid) {
      if (!ForumAuthentication.isAuthenticated()) {
        return;
      }

      if ($scope.nuked) {
        $scope.nuked = false;
        ThreadUpvote.removeThreadNuke(threadid);
      } else {
        if ($window.confirm('With extreme prejudice?')) {
          $scope.nuked = true;
          ThreadUpvote.addThreadNuke(threadid);
        }
      }
    };
  }]);
'use strict';

angular.module('wfManager')
  .controller('ThreadSubscriptionCtrl', ["$scope", "ThreadSubscription", "ForumAuthentication", "Signup", function ($scope, ThreadSubscription, ForumAuthentication, Signup)
  {
    $scope.subscribed = false;

    $scope.submit = function()
    {
      if (ForumAuthentication.isAuthenticated())
      {
        if ($scope.subscribed)
        {
          $scope.subscribed = false;
          ThreadSubscription.unsubscribe($scope.threadid).then(null, function() {
            $scope.subscribed = true;
          });
        }
        else
        {
          $scope.subscribed = true;
          ThreadSubscription.subscribe($scope.threadid).then(null, function() {
            $scope.subscribed = false;
          });
        }
      }
      else
      {
        Signup.openSignupModal();
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .controller('ThreadUpvoteCtrl', ["$rootScope", "$scope", "ThreadUpvote", "Signup", "ForumAuthentication", function($rootScope, $scope, ThreadUpvote, Signup, ForumAuthentication) {
    $scope.state = {
      loaded: true
    };

    $scope.toggleUpvote = function() {
      if(!ForumAuthentication.isAuthenticated()) {
        Signup.openSignupModal();
        return;
      }

      if($scope.upvoted) {
        ThreadUpvote.removeThreadUpvote($scope.threadid).then(
          function() {
            $scope.upvoted = false;
            $scope.upvoteCount -= 1;
            $rootScope.$broadcast('upvote', $scope.threadid, $scope.upvoted, $scope.upvoteCount);
          }
        );
      } else {
        ThreadUpvote.addThreadUpvote($scope.threadid).then(
          function() {
            $scope.upvoted = true;
            $scope.upvoteCount += 1;
            $rootScope.$broadcast('upvote', $scope.threadid, $scope.upvoted, $scope.upvoteCount);
          }
        );
      }
    };

    $scope.$on('upvote', function (event, threadid, upvoted, upvoteCount) {
      if(threadid === $scope.threadid) {
        $scope.upvoted = upvoted;
        $scope.upvoteCount = upvoteCount;
      }
    });
  }]);

'use strict';

angular.module('wfManager')
  .controller('ThreadViewCtrl', ["$scope", "$attrs", "Comment", function($scope, $attrs, Comment) {
    $scope.state = {
      hideServerRenderedDiscussion: false,
      hideServerRenderedMainPost: false,
      showMainPostEditor: false
    };

    $scope.threadId = $attrs.threadId;
    $scope.mainPostId = $attrs.mainPostId;

    Comment.get($scope.mainPostId).then(function(result) {
      $scope.mainPost = result.data.post;
    });

    $scope.toggleMainPostEditor = function() {
      $scope.state.showMainPostEditor = !$scope.state.showMainPostEditor;
    };

    $scope.$on('discussionBoardLoaded', function() {
      $scope.state.hideServerRenderedDiscussion = true;
    });

    $scope.$on('hideMainPostEditor', function() {
      $scope.state.showMainPostEditor = false;
    });

    $scope.$on('updateMainPost', function(event, updatedPost) {
      $scope.mainPost.content = updatedPost.content;
      $scope.state.hideServerRenderedMainPost = true;
      $scope.state.showMainPostEditor = false;
      event.stopPropagation();
    });
  }]);

'use strict';

angular.module('wfManager')
  .controller('WelcomeBannerCtrl', ["$scope", "LocalStorage", function($scope, LocalStorage) {
    $scope.visible = !LocalStorage.isSet('feedwelcome_dismissed');
    $scope.hide = function() {
      $scope.visible = false;
      LocalStorage.set('feedwelcome_dismissed', true);
    };
  }]);
'use strict';

angular.module('wfManager')
  .controller('wfTopicSelectorModalCtrl', ["$scope", "$uibModalInstance", "Onboarding", "TopicList", function($scope, $uibModalInstance, Onboarding, TopicList) {
      var getIconName = function(name) {
        return name.toLowerCase().replace(/\s/g, '-').replace(/\//g, '-');
      };
      $scope.topics = TopicList.map(function(t) {
        t.iconName = getIconName(t.name);
        return t;
      });
      $scope.encourage = function() {
        if ($scope.selectedTopics.length < $scope.minTopicCount) {
          return encouragementPhrases[$scope.selectedTopics.length];
        } else {
          return encouragementPhrases[$scope.minTopicCount];
        }
      };
      $scope.minTopicCount = 5;
      var encouragementPhrases = [
        'Select your first topic',
        'Follow more topics',
        'Good topic!',
        'Go further, select more topics',
        'Nice choice',
        'Go go go customize feed!'
      ];

      Onboarding.getInterests().then(function(res) {
        res.map(function(t) {
          for (var i = 0; i < $scope.topics.length; i++) {
            if ($scope.topics[i].id === t.topic_id) {
              $scope.selectedTopics.push($scope.topics[i]);
              $scope.topics[i].selected = true;
              break;
            }
          }
        });
      });
      $scope.dismiss = function() {
          $uibModalInstance.close();
      };

      $scope.selectedTopics = [];
      $scope.select = function(topic) {
        var idx = $scope.selectedTopics.indexOf(topic);
        if (idx < 0) {
          $scope.selectedTopics.push(topic);
          Onboarding.saveInterest({tagId: topic.id});
          topic.selected = true;
        } else {
          $scope.selectedTopics.splice(idx, 1);
          Onboarding.deleteInterest({tagId: topic.id});
          topic.selected = false;
        }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfAbtestCreateWsoButton', function() {
    return {
      scope: {
        trackingName0:'@',
        trackingName1:'@',
        imageUrl: '@'
      },
      templateUrl: '/views/forum/abtest-button-create-wso.html',
    };
  });

'use strict';

angular.module('wfManager')
  .directive('wfAlerts', ["$timeout", "Notifications", "Random", function ($timeout, Notifications, Random) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        since: '=',
        ending: '='
      },
      templateUrl: '/views/wf/alerts.html',
      link: function (scope) {
        var maxNotification = 3;
        var minDelay = 100; // 0.1s
        var maxDelay = 10000; // 10s
        var fadeOutDelay = 5000; // 5s
        var fadeOutDuration = 1500; // 1.5s

        scope.visibleAlerts = [];

        var insertToVisibleAlerts = function (notification) {
          notification.template = angular.fromJson(notification.template);
          var delay = Random.getInteger(minDelay, maxDelay);
          $timeout(function () {
            scope.visibleAlerts.push(notification);

            $timeout(function () {
              notification.fadeOut = true;
            }, fadeOutDelay);

            $timeout(function () {
              scope.closeVisibleAlert(notification);
            }, fadeOutDelay + fadeOutDuration);
          }, delay);
        };

        Notifications.getByTypeWithin('alert', scope.since, scope.ending, maxNotification).then(function (response) {
          var notifications = [];
          response.notifications.forEach(function(notification) {
            for(var i = 0; i < notifications.length; i++) {
              if(notifications[i].item_id === notification.item_id && notifications[i].event_name === notification.event_name) {
                return;
              }
            }
            notifications.push(notification);
          });

          notifications.forEach(insertToVisibleAlerts);
        });

        scope.closeVisibleAlert = function (alert) {
          var index = scope.visibleAlerts.indexOf(alert);
          scope.visibleAlerts.splice(index, 1);
        };
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfBlackFridayWelcomeModal', ["$cookies", "DeviceClassifier", "ForumAuthentication", "GreetingModal", "LOGIN_WELCOME_COOKIE", function(
    $cookies,
    DeviceClassifier,
    ForumAuthentication,
    GreetingModal,
    LOGIN_WELCOME_COOKIE) {
    return {
      restrict: 'E',
      link: function () {
        if(DeviceClassifier.isMobileScreen()) {
          return false;
        }

        var blackFridayWelcomedNotLoggedInCookie = 'black_friday_welcomed_not_logged_in';
        if ($cookies.get(LOGIN_WELCOME_COOKIE)) {
          GreetingModal.fetchMessageAndOpenModal();
        } else if (ForumAuthentication.isAuthenticated() === undefined && $cookies.get(blackFridayWelcomedNotLoggedInCookie) === undefined) {
          GreetingModal.fetchMessageAndOpenModal(true);
          $cookies.put(blackFridayWelcomedNotLoggedInCookie, 'welcomed');
        }
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfComment', ["$window", "$timeout", "Comment", "Signup", "Thank", "ForumAuthentication", "ForumURLGenerator", "RecursionHelper", "AVATAR_PLACEHOLDER", function(
    $window,
    $timeout,
    Comment,
    Signup,
    Thank,
    ForumAuthentication,
    ForumURLGenerator,
    RecursionHelper,
    AVATAR_PLACEHOLDER) {

    return {
      restrict: 'E',
      scope: {
        post: '=',
        thread: '=',
        depth: '=',
        signature: '='
      },
      replace: true,
      compile: function(element) {
        return RecursionHelper.compile(element, function(){});
      },
      templateUrl: '/views/wf/showthread/comment.html',
      controller: ["$scope", function($scope) {
        if (!$scope.post.replies) {
          $scope.post.replies = [];
        }

        var hasMoreReplies = function() {
          return $scope.post.replies.length < $scope.post.reply_count;
        };

        $scope.state = {
          initializing: true,
          loadingReplies: false,
          loadingMoreReplies: false,
          showReplyForm: false,
          showEditForm: false,
          showSignatures: $scope.signature,
          hasMoreReplies: hasMoreReplies()
        };

        $scope.avatarPlaceholder = AVATAR_PLACEHOLDER;
        $scope.authorUrl = ForumURLGenerator.getProfile($scope.post.author_username);

        var currentUser = $window.CURRENT_USER;

        var getLastReply = function() {
          return $scope.post.replies[$scope.post.replies.length - 1];
        };

        var addToReplies = function (replies) {
          if (replies.length === 0) {
            $scope.state.hasMoreReplies = false;
            return;
          }

          $scope.post.replies = $scope.post.replies.concat(replies);
          $scope.state.hasMoreReplies = hasMoreReplies();
        };

        var neededReplyCount = 10;
        var maxDepth = 6;
        $scope.seeReplies = function() {
          if ($scope.depth > maxDepth) {
            $window.open(ForumURLGenerator.getPost($scope.post.id), '_blank');
            return;
          }

          if ($scope.state.loadingReplies) {
            return;
          }

          $scope.post.replies = [];
          $scope.state.loadingReplies = true;
          Comment.getReplies($scope.post.id, neededReplyCount).then(
            function(result) {
              addToReplies(result.data.posts);
              $scope.state.loadingReplies = false;
            },
            function() {
              $scope.state.loadingReplies = false;
            }
          );
        };

        $scope.loadMoreReplies = function() {
          if ($scope.state.loadingMoreReplies) {
            return;
          }

          $scope.state.loadingMoreReplies = true;

          var lastReply = getLastReply();
          if (lastReply.is_new) {
            $scope.seeReplies();
            return;
          }

          Comment.getNext(lastReply.id, $scope.post.id, neededReplyCount).then(
            function(result) {
              addToReplies(result.data.posts);
              $scope.state.loadingMoreReplies = false;
            },
            function() {
              $scope.state.loadingMoreReplies = false;
            }
          );
        };

        $scope.thanks = function() {
          if (!ForumAuthentication.isAuthenticated()) {
            Signup.openSignupModal();
            return;
          }

          if ($scope.post.thanked) {
            Thank.removeThank($scope.post.id);
            $scope.post.thanked = false;
            $scope.post.thanks--;
          } else {
            Thank.addThank($scope.post.id).then(null, function(result) {
              $scope.post.thanked = false;
              $scope.post.thanks--;
              $scope.error = result.code;
              $scope.errorMessage = result.data.message;

              $timeout(function() {
                $scope.error = false;
              }, 2000);
            });

            $scope.post.thanked = true;
            $scope.post.thanks++;
          }
        };

        $scope.isEditEligible = function() {
          return currentUser.id === $scope.post.author_id || currentUser.is_moderator === '1';
        };

        $scope.toggleReplyForm = function() {
          if ($scope.depth > maxDepth) {
            $window.open(ForumURLGenerator.getPost($scope.post.id), '_blank');
            return;
          }

          $scope.state.showReplyForm = !$scope.state.showReplyForm;
        };

        $scope.toggleEditForm = function() {
          $scope.state.showEditForm = !$scope.state.showEditForm;
        };

        $scope.isVisible = function(post) {
          return post.visible === 1;
        };

        $scope.$on('newComment', function(event, newPost) {
          $scope.post.replies.unshift(newPost);
          $scope.post.reply_count = $scope.post.reply_count + 1;
          event.stopPropagation();
        });

        $scope.$on('updatePost', function(event, updatedPost) {
          $scope.post.content = updatedPost.content;
          $scope.state.showEditForm = false;
          event.stopPropagation();
        });

        $scope.$on('hidePostEditor', function(event) {
          $scope.state.showEditForm = false;
          event.stopPropagation();
        });

        $scope.$on('hideReplyForm', function(event) {
          $scope.state.showReplyForm = false;
          event.stopPropagation();
        });
      }]
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfCountdownProgressBar', function () {
    return {
      scope: {
        startDate: '@',
        endDate: '@'
      },
      replace: true,
      templateUrl: '/views/wf/countdown-progress-bar.html',
      controller: ["$scope", function($scope) {
        $scope.options = {};
        $scope.state = {};

        var wsoStartDate = new Date($scope.startDate);
        var wsoStartDateUTC = new Date(Date.UTC(
                                  wsoStartDate.getFullYear(),
                                  wsoStartDate.getMonth(),
                                  wsoStartDate.getDate(),
                                  wsoStartDate.getHours(),
                                  wsoStartDate.getMinutes(),
                                  wsoStartDate.getSeconds()
                            ));
        var wsoEndDate = new Date($scope.endDate);
        var wsoEndDateUTC = new Date(Date.UTC(
                              wsoEndDate.getFullYear(),
                              wsoEndDate.getMonth(),
                              wsoEndDate.getDate(),
                              wsoEndDate.getHours(),
                              wsoEndDate.getMinutes(),
                              wsoEndDate.getSeconds()
                          ));

        var now = new Date();
        var maxDaysDiff = 0;
        var maxDaysCount = 0;

        var getTimeRemaining = function (endtime, now){
          var t = endtime - now;
          var seconds = Math.floor( (t/1000) % 60 );
          var minutes = Math.floor( (t/1000/60) % 60 );
          var hours = Math.floor( (t/(1000*60*60)) % 24 );
          var days = Math.floor( t/(1000*60*60*24) );
          return {
            'total': t,
            'days': days,
            'hours': hours,
            'minutes': minutes,
            'seconds': seconds,
          };
        };

        var timeRemaining = getTimeRemaining(wsoEndDateUTC, now);

        $scope.daysLeft = timeRemaining.days;
        $scope.hoursLeft = timeRemaining.hours;
        $scope.minutesLeft = timeRemaining.minutes;
        $scope.secondsLeft = timeRemaining.seconds;
        $scope.tPercentageInDay = timeRemaining.tPercentageInDay;

        if (wsoEndDateUTC instanceof Date && wsoStartDateUTC instanceof Date) {
          maxDaysDiff = wsoEndDateUTC - wsoStartDateUTC;
          maxDaysCount = Math.ceil(maxDaysDiff/ (1000 * 3600 * 24));
          if (maxDaysCount > 0) {
            $scope.percentDays = 100 - (($scope.daysLeft / maxDaysCount) * 100);
            if ($scope.hoursLeft > 0 || $scope.minutesLeft > 0 || $scope.minutesLeft > 0) {
              $scope.percentDays = 95;
            }
          }
          // end date is in the past OR start and end date is the same
          if (wsoEndDateUTC < now || maxDaysCount === 0) {
            $scope.percentDays = 100;
          }
          $scope.state.showCountdown = $scope.percentDays !== undefined ? true : false;
          $scope.state.showInputValidationErrors = false;
        } else {
          $scope.state.showCountdown = false;
          $scope.state.showInputValidationErrors = true;
        }

      }]
    };
  });

'use strict';

angular.module('wfManager')
  .directive('wfDealsWidget', ["$interval", "$window", "DailyDeals", function($interval, $window, DailyDeals) {
  return {
    restrict: 'E',
    scope: {
      autoPlay: '=',
      autoPlayTimeout: '=',
      entryCount: '=',
    },
    templateUrl: '/views/wf/deals-widget.html',
    controller: ["$scope", function($scope) {
      $scope.selectedIndex = Math.floor(Math.random() * 4);
      $scope.dailyDeals = DailyDeals.getFromWindow();
    }],
    link: function($scope) {
      var playInterval;
      $scope.slideDirection = 'right';

      function getCorrectIndex(index) {
        var imageCount = $scope.dailyDeals.length;

        if (index < 0) {
          var absModulo = Math.abs(index % imageCount);
          return (imageCount - absModulo) % imageCount;
        }

        return index % imageCount;
      }

      function playImageSlider() {
        if (playInterval) {
          $interval.cancel(playInterval);
        }

        if ($scope.autoPlay === true) {
          playInterval = $interval(function() {
            $scope.selectedIndex++;
          }, $scope.autoPlayTimeout);
        }
      }

      $scope.isCurrentIndex = function(index) {
        return getCorrectIndex($scope.selectedIndex) === index;
      };

      $scope.setIndex = function(index) {
        $scope.selectedIndex = index;
        playImageSlider();
      };

      $scope.do_cta = function(deal) {
        $window.open(deal.cta_url, '_blank');
      };

      function setBufferedImages() {
        var bufferImages = [];
        var imageCount = $scope.dailyDeals.length;
        var initialValue;
        var limitValue;

        if (imageCount > $scope.entryCount) {
          var bufferSize = Math.floor($scope.entryCount / 2);
          initialValue = $scope.selectedIndex - bufferSize;
          limitValue = $scope.selectedIndex + bufferSize;
        } else {
          initialValue = 0;
          limitValue = imageCount - 1;
        }

        for (var i = initialValue; i <= limitValue; i++) {
          $scope.dailyDeals[getCorrectIndex(i)].index = getCorrectIndex(i);
          bufferImages.push($scope.dailyDeals[getCorrectIndex(i)]);
        }

        $scope.bufferImages = bufferImages;
      }

      $scope.$watch('autoPlay', function() {
        playImageSlider();
      });

      $scope.$watch('selectedIndex', function(newIndex, oldIndex) {
        if (newIndex >= oldIndex) {
          $scope.slideDirection = 'right';
        } else {
          $scope.slideDirection = 'left';
        }

        setBufferedImages();
      });

      $scope.$watch('dailyDeals', function() {
        setBufferedImages();
      });

      $scope.$on('$destroy', function() {
        if (playInterval) {
          $interval.cancel(playInterval);
        }
      });

      playImageSlider();
    }
  };
}]);

'use strict';

angular.module('wfManager')
  .directive('wfDiscussionBoard', ["Comment", "Thread", function(Comment, Thread) {
    return {
      restrict: 'E',
      scope: {
        threadId: '=',
        postId: '=',
        replyCount: '=',
        allowSignatures: '=',
        neededReplyCount: '=',
        sorter: '@'
      },
      replace: true,
      templateUrl: '/views/wf/showthread/discussion-board.html',
      link: function(scope) {
        scope.state = {
          initializing: true,
          loadingMore: false,
          hasMoreReplies: false,
          showSignatures: false
        };

        scope.replies = [];
        scope.visibleReplyCount = 0;
        var allowSignatures = scope.allowSignatures === undefined ? true : scope.allowSignatures;
        var neededReplyCount = scope.neededReplyCount || 20;

        var addToReplies = function(posts) {
          scope.replies = scope.replies.concat(posts);
          scope.visibleReplyCount = scope.replies.length;
          scope.state.hasMoreReplies = scope.visibleReplyCount < scope.replyCount;
        };

        var threadInfo = {
          thread_id: scope.threadId
        };

        Thread.get(threadInfo).then(function(response) {
          scope.thread = response.data.thread;
          scope.state.showSignatures = allowSignatures && response.data.show_signatures;
          Comment.getReplies(scope.postId, neededReplyCount, scope.sorter).then(
            function(result) {
              addToReplies(result.data.posts);
              scope.state.initializing = false;
              scope.$emit('discussionBoardLoaded');
            },
            function() {
              scope.state.initializing = false;
            }
          );
        });

        scope.loadMoreReplies = function() {
          scope.state.loadingMore = true;

          var lastPost = null;
          if (scope.replies.length > 0) {
            lastPost = scope.replies[scope.replies.length - 1];
          }

          Comment.getNext(lastPost.id, scope.postId, neededReplyCount).then(
            function(result) {
              addToReplies(result.data.posts);
              scope.state.loadingMore = false;
            },
            function() {
              scope.state.loadingMore = false;
            }
          );
        };

        scope.sort = function(sorter) {
          scope.sorter = sorter;

          if(sorter ===  'old') {
            scope.replies.sort(function(a, b) {
              return a.id - b.id;
            });
          } else if(sorter === 'new') {
            scope.replies.sort(function(a, b) {
              return b.id - a.id;
            });
          }
        };

        scope.$on('newComment', function(e, newPost) {
          scope.replies.unshift(newPost);
          scope.visibleReplyCount = scope.visibleReplyCount + 1;
          scope.replyCount = scope.replyCount + 1;
        });
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfExperiment', function() {
    return {
      scope: {
        experimentId: '@',
        variationCount: '@',
        variation: '='
      },
      controller: ["$scope", "wfCookieExperiment", function($scope, wfCookieExperiment) {
        $scope.variation = wfCookieExperiment.getVariation(parseInt($scope.experimentId, 10), parseInt($scope.variationCount, 10));
      }]
    };
  });

'use strict';

angular.module('wfManager')
  .directive('wfFeedOfferWidget', ["Thread", "ForumURLGenerator", function(Thread, ForumURLGenerator) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        userId: '=',
        count: '='
      },
      templateUrl: '/views/wf/feed-offer-widget.html',
      link: function (scope) {
        scope.paidThreads = [];
        scope.newOfferUrl = ForumURLGenerator.getOfferUrl('new');

        Thread.getPaid(scope.userId, scope.count).then(function(result) {
          scope.paidThreads = result.data.threads;
        });

        scope.getThreadUrl = function (threadId) {
          return ForumURLGenerator.getThread(threadId);
        };
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfFeedPreferenceBar', ["$window", "$document", "$cookies", "WfFeedPreference", "ForumURLGenerator", function(
    $window,
    $document,
    $cookies,
    WfFeedPreference,
    ForumURLGenerator) {

    return {
      replace: true,
      restrict: 'E',
      scope: {
        username: '@'
      },
      templateUrl: '/views/wf/feedPreferenceBar.html',
      link: function link(scope) {
        scope.showBanner = true;

        scope.hideFeed = function() {
          WfFeedPreference.hideFeedByDefault();
          scope.showBanner = false;
          $window.location = ForumURLGenerator.getAbsoluteUrl();
        };

        scope.hideBar = function() {
          WfFeedPreference.showFeedByDefault();
          scope.showBanner = false;
        };

        scope.closeBar = function() {
          scope.showBanner = false;
        };
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfFeedThreadModeration', function() {
    return {
      replace: true,
      restrict: 'E',
      scope: {
        threadId: '=',
        threadVisible: '='
      },
      templateUrl: '/views/wf/feedThreadModeration.html',
      link: function link(scope) {
        scope.isPending = function () {
          return scope.threadVisible === 0;
        };

        scope.isApproved = function () {
          return scope.threadVisible === 1;
        };

        scope.isDeleted = function () {
          return scope.threadVisible === 2;
        };
      }
    };
  });

'use strict';

angular.module('wfManager')
  .directive('wfForumNavigator', ["Forum", function(Forum) {
    return {
      restrict: 'E',
      templateUrl: '/views/wf/forum-navigator.html',
      replace: true,
      controller: ["$scope", function($scope) {
        $scope.state = {};
        $scope.state.showNavigation = false;
        $scope.forums = [];
      }],
      link: function(scope) {
        Forum.getRoots().then(function(result) {
          scope.forums = result.data.forums;
          scope.forums[0].showSubforums = true;
        });

        scope.hideDropdown = function() {
          scope.state.showNavigation = false;
        };

        scope.showDropdown = function() {
          scope.state.showNavigation = true;
        };

        scope.toggleDropdown = function() {
          scope.state.showNavigation = !scope.state.showNavigation;
        };

        scope.toggleAccordion = function(forum) {
          forum.showSubforums = !forum.showSubforums;
        };
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfHeaderCta', function() {
    return {
      scope: true,
      templateUrl: '/views/wf/header-cta.html',
    };
  });

'use strict';

angular.module('wfManager')
  .directive('wfHoodieAbtest', function() {
    return {
      templateUrl: '/views/wf/hoodie-abtest.html',
    };
  });

'use strict';

angular.module('wfManager')
  .directive('wfImpressionIncrement', ["Thread", function(Thread) {
    return {
      restrict: 'E',
      scope: {
        type: '=',
        ids: '=',
        pageType: '='
      },
      link: function (scope) {
        if (scope.type === 'wso') {
          Thread.incrementImpressions(scope.ids, scope.pageType);
        }
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfMainPostEditor', ["Comment", function(Comment) {
    return {
      restrict: 'E',
      scope: {
        post: '='
      },
      replace: true,
      templateUrl: '/views/wf/showthread/main-post-editor.html',
      link: function(scope) {
        scope.state = {
          formSubmitting: false
        };

        scope.isPostValid = function() {
          if (!scope.post.title || scope.post.title.length < 5) {
            return false;
          }

          if (!scope.post.bb_content || scope.post.bb_content.length < 10) {
            return false;
          }

          return true;
        };

        scope.updatePost = function() {
          scope.state.formSubmitting = true;
          Comment.update(scope.post).then(
            function(result) {
              scope.$emit('updateMainPost', result.data.post);
              scope.state.formSubmitting = false;
            },
            function(error) {
              scope.error = error.code;
              scope.errorMessage = error.data.message;
              scope.state.formSubmitting = false;
            }
          );
        };

        scope.hideForm = function() {
          scope.$emit('hideMainPostEditor', scope.post);
        };
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfOfferTotalStats', ["Thread", function (Thread) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        threadId: '='
      },
      templateUrl: '/views/wf/offer-total-stats.html',
      link: function (scope) {
        Thread.getThreadTotalStats(scope.threadId).then(function(result) {
          scope.totalStats = result.data.thread_total_stats;
          scope.$emit('totalStatsLoaded');
        });
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfPostEditor', ["Comment", function(Comment) {
    return {
      restrict: 'E',
      scope: {
        post: '='
      },
      replace: true,
      templateUrl: '/views/wf/showthread/post-editor.html',
      link: function(scope) {
        scope.state = {
          formSubmitting: false
        };

        scope.isPostValid = function() {
          return scope.post.bb_content && scope.post.bb_content.length >= 10;
        };

        scope.updatePost = function() {
          scope.state.formSubmitting = true;
          scope.post.reason = null;
          Comment.update(scope.post).then(
            function(result) {
              scope.$emit('updatePost', result.data.post);
              scope.state.formSubmitting = false;
            },
            function(error) {
              scope.error = error.code;
              scope.errorMessage = error.data.message;
              scope.state.formSubmitting = false;
            }
          );
        };

        scope.hideForm = function() {
          scope.$emit('hidePostEditor', scope.post);
        };
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfRecentActivityCard', function () {
  return {
    restrict: 'E',
    templateUrl: '/views/wf/recent-activity-card.html'
  };
});

'use strict';

angular.module('wfManager')
  .directive('wfStuckSidebarContainer', function() {
    var parentElement;
    var getheight = function(elem) {
      if (elem) {
        return elem.offsetHeight;
      }
      return null;
    };
    return {
      restrict: 'A',
      controller: function() {
        this.getHeight = function() {
          return getheight(parentElement);
        };
      },
      link: function(scope, element) {
        parentElement = element[0];
      }
    };
  });

'use strict';

angular.module('wfManager')
  .directive('wfStuckSidebar', ["$window", function($window) {
    return {
      restrict: 'A',
      require: '^^wfStuckSidebarContainer',
      link: function(scope, element, attrs, stuckSidebarContainerCtrl) {
        var checkBottom = function() {
          var bottom = (_isSticky()) && ($window.pageYOffset > (stuckSidebarContainerCtrl.getHeight() - element[0].offsetHeight));
          if (bottom) {
            element.addClass('is-ClusteredContent-side-bottom');
          } else {
            element.removeClass('is-ClusteredContent-side-bottom');
          }
        };

        var _isSticky = function() {
          return stuckSidebarContainerCtrl.getHeight() > element[0].offsetHeight;
        };

        var checkSticky = function() {
          var sticky = _isSticky();
          if (sticky) {
            element.addClass('is-ClusteredContent-side-sticky');
          } else {
            element.removeClass('is-ClusteredContent-side-sticky');
          }
        };

        angular.element($window).bind('scroll resize', checkBottom);
        angular.element($window).bind('load', checkSticky);
        angular.element(element).bind('resize', checkSticky);
        angular.element(element).bind('resize', checkSticky);
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfThreadAnalytics', ["$window", "Thread", "ThreadAnalyticsChartData", function($window, Thread, ThreadAnalyticsChartData) {
    return {
      restrict: 'E',
      scope: {
        'threadId': '='
      },
      templateUrl: '/views/wf/showthread/thread_analytics.html',
      link: function (scope) {
        scope.state = {
          showActionChartTooltip: false,
          actionChartDataLoaded: false,
        };

        var actionLimit = 5;

        Thread.getThreadActionsWithStats(scope.threadId, actionLimit).then(function(result) {
          var recentActions = result.data.thread_actions_with_stats;
          scope.actionChartData = ThreadAnalyticsChartData.getActionChartData(recentActions);

          if(scope.actionChartData.length === 0) {
            scope.$emit('actionChartEmpty');
            scope.$emit('threadAnalyticsLoaded');
            return;
          }

          scope.maxActionChartValue = ThreadAnalyticsChartData.getMaxActionChartValue(scope.actionChartData);

          scope.state.actionChartDataLoaded = true;
          scope.$emit('threadAnalyticsLoaded');
        });

        scope.actionChartX = function(d, i) {
          return i;
        };

        scope.actionChartY = function(d) {
          return d.y;
        };

        scope.actionChartXFormat = function(d) {
          var xLabel;
          if ($window.Math.floor(d) === d && scope.actionChartData[0].values[d]) {
            xLabel = scope.actionChartData[0].values[d].xLabel;
          } else {
            xLabel = '';
          }
          return xLabel;
        };

        scope.actionChartYFormat = function(d) {
          return $window.Math.floor(d);
        };

        scope.actionChartTooltipContent = function(d) {
          var tooltipMessage = '<h3>+' + d.point.y + ' ' + scope.actionChartData[d.seriesIndex].key;

          if((d.pointIndex + 1) === scope.actionChartData[0].values.length) {
            tooltipMessage = tooltipMessage + ' (Ongoing)';
          }

          tooltipMessage = tooltipMessage + '</h3>';
          return tooltipMessage;
        };
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfThreadApproval', ["$uibModal", function($uibModal) {
    return {
      replace: true,
      restrict: 'E',
      scope: {
        threadId: '='
      },
      templateUrl: '/views/wf/thread-approval.html',
      link: function(scope) {
        scope.label = 'Approve';
        scope.approved = false;

        scope.openApprovalModal = function () {
          var opt = {
            threadId: scope.threadId,
            closable: true
          };

          var modalInstance = $uibModal.open({
            windowClass: 'default-modal payment-modal',
            templateUrl: '/views/wf/thread-approval-modal.html',
            controller: 'ThreadApprovalModalCtrl',
            backdrop: 'static',
            size: 'sm',
            resolve: {
              options: function () {
                return opt;
              }
            }
          });

          modalInstance.result.then(function (state) {
            if (state.error) {
              scope.label = 'Try Again';
              scope.approved = false;
            }

            if (state.success) {
              scope.label = 'Approved';
              scope.approved = true;
            }
          });
        };
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfThreadDeletion', ["$uibModal", function($uibModal) {
    return {
      replace: true,
      restrict: 'E',
      scope: {
        threadId: '='
      },
      templateUrl: '/views/wf/thread-deletion.html',
      link: function(scope) {
        scope.label = 'Delete';
        scope.deleted = false;

        scope.openDeletionModal = function () {
          var opt = {
            'threadId': scope.threadId,
            'closable': true
          };

          var modalInstance = $uibModal.open({
            windowClass: 'default-modal payment-modal',
            templateUrl: '/views/wf/thread-deletion-modal.html',
            controller: 'ThreadDeletionModalCtrl',
            backdrop: 'static',
            size: 'sm',
            resolve: {
              options: function () {
                return opt;
              }
            }
          });

          modalInstance.result.then(function (state) {
            if (state.error) {
              scope.label = 'Try Again';
              scope.deleted = false;
            }

            if (state.success) {
              scope.label = 'Deleted';
              scope.deleted = true;
            }
          });
        };
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfThreadIncrementUpvote', function(){
    return {
      scope: {
        threadid: '=',
        upvotecount: '=upvotecount',
        upvoted: '=?'
      },
      controller: 'IncrementUpvoteModalCtrl',
      templateUrl: '/views/wf/thread-increment-upvote.html',
    };
  });

'use strict';

angular.module('wfManager')
  .directive('wfThreadStatsLineAreaChart', ["$window", function($window) {
    return {
      restrict: 'E',
      scope: {
        'chartData': '=',
        'x': '=',
        'y': '=',
        'minY': '=',
        'maxY': '=',
        'tickFormatXAxis': '=',
        'tickFormatYAxis': '=',
        'tooltipContent': '='
      },
      templateUrl: '/views/wf/showthread/thread_stats_line_area_chart.html',
      link: function (scope) {
        var redColorCode = '#cc0000';
        var greyColorCode = '#979797';
        scope.colorArray = [redColorCode, greyColorCode];

        scope.maxY = $window.Math.max(100, scope.maxY + $window.Math.ceil(scope.maxY*0.2));

        scope.chartOptions = {
          chart: {
            type: 'lineChart',
            width: 650,
            height: 300,
            margin : {
              top: 20,
              right: 50,
              bottom: 20,
              left: 50
            },
            color: scope.colorArray,
            showLegend: false,
            clipEdge: false,
            x: scope.x,
            y: scope.y,
            useInteractiveGuideline: false,
            xAxis: {
              tickFormat: scope.tickFormatXAxis
            },
            yAxis: {
              tickFormat: scope.tickFormatYAxis
            },
            yDomain: [scope.minY, scope.maxY],
            interactive: true,
            tooltip: {
              contentGenerator: scope.tooltipContent
            }
          },
      };
    }
  };
}]);

'use strict';

angular.module('wfManager')
  .directive('wfThreadSubscription', ["ThreadSubscription", "ForumAuthentication", "Signup", function(
    ThreadSubscription,
    ForumAuthentication,
    Signup) {

    return {
      replace: true,
      restrict: 'A',
      scope: {
        threadId: '=threadid',
        isSubscribed: '=?subscribed'
      },
      templateUrl: '/views/wf/thread-subscription.html',
      link: function(scope) {
        function subscribedChanged()
        {
          if (scope.isSubscribed) {
            scope.text = 'Subscribed';
          }
          else {
            scope.text = 'Subscribe';
          }
        }

        subscribedChanged();

        scope.submit = function() {
          if (ForumAuthentication.isAuthenticated()) {
            if (scope.isSubscribed) {
              scope.isSubscribed = false;
              subscribedChanged();
              ThreadSubscription.unsubscribe(scope.threadId).then(null, function() {
                scope.isSubscribed = true;
                subscribedChanged();
              });
            }
            else {
              scope.isSubscribed = true;
              subscribedChanged();
              ThreadSubscription.subscribe(scope.threadId).then(null, function() {
                scope.isSubscribed = false;
                subscribedChanged();
              });
            }
          }
          else {
            Signup.openSignupModal();
          }
        };
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfThreadUpvote', ["$document", "ThreadUpvote", "ForumAuthentication", "Signup", function($document, ThreadUpvote, ForumAuthentication, Signup) {
    return {
      replace: true,
      restrict: 'A',
      scope: {
        threadId: '=threadid',
        upvoteCount: '=upvotecount',
        upvoted: '=?upvoted'
      },

      templateUrl: '/views/wf/thread-upvote.html',


      link: function link(scope) {
        ThreadUpvote.getVotes(scope.threadId).then(function(data){
          scope.count = parseInt(data.data.score, 10);
        });
        if (!scope.count) {
          scope.count = 0;
        }

        var upvotedChanged = function () {
          if (scope.upvoted) {
            scope.text = 'Upvoted';
          } else {
            scope.text = 'Upvote';
          }
        };

        upvotedChanged();

        scope.toggleUpvote = function() {
          if (ForumAuthentication.isAuthenticated())
          {
            if (scope.upvoted) {
              scope.upvoted = false;
              upvotedChanged();
              ThreadUpvote.removeThreadUpvote(scope.threadId).then(function(data){
                scope.count = parseInt(data.data.score, 10);
              });
            } else {
              scope.upvoted = true;
              upvotedChanged();
              ThreadUpvote.addThreadUpvote(scope.threadId).then(function(data){
                scope.count = parseInt(data.data.score, 10);
              });
            }
          }
          else
          {
            // todo bjb listen for login and send of vote
            Signup.openSignupModal();
          }

          upvotedChanged();
        };
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfToggleMobileNavigation', function() {
    return {
      scope: true,
      controller: ["$element", "$rootScope", function($element, $rootScope) {
        $element.click(function() {
          $rootScope.$emit('ui.mobileNavigation');
        });
      }]
    };
  });
'use strict';

angular.module('wfManager')
  .directive('wfTopicSelector', ["wfTopicSelectorModal", function(wfTopicSelectorModal) {
    return {
      restrict: 'A',
      link: function(scope, element) {
        var nullifyModalInstance = function() {
          scope.$broadcast('reloadTopics', {});
        };
        element.on('click', function() {
          var modalInstance = wfTopicSelectorModal.openModal();
          modalInstance.then(nullifyModalInstance, nullifyModalInstance);
        });
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .directive('wfTopics', function() {
    return {
      restrict: 'E',
      templateUrl: '/views/wf/wftopics.html',
      replace: true,
      controller: ["$scope", "Onboarding", "TopicUtils", function($scope, Onboarding, TopicUtils) {
        $scope.loaded = false;
        var load = function() {
          $scope.loaded = false;
          $scope.topics = [];
          Onboarding.getInterests().then(function(res) {
            $scope.topics = res.map(function(t) {
              t.feedUrl = TopicUtils.getFeedLink(t.topic_id);
              return t;
            });
            $scope.loaded = true;
          });
        };
        load();
        $scope.$on('reloadTopics', load);
      }]
    };
  });

'use strict';

angular.module('wfManager')
  .directive('wfViewIncrement', ["Thread", function(Thread) {
    return {
      restrict: 'E',
      scope: {
        type: '=',
        id: '=',
        count: '=?'
      },
      link: function (scope) {
        if (!scope.count) {
          scope.count = 1;
        }

        if (scope.type === 'thread') {
          Thread.incrementViews(scope.id, scope.count);
        }
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .service('Comment', ["$window", "$http", "ForumURLGenerator", function($window, $http, ForumURLGenerator) {
    var securityToken = $window.SECURITYTOKEN;
    var baseUrl = ForumURLGenerator.getApiUrl('posts_api.php');

    var post = function(params) {
      params.securitytoken = securityToken;

      var config = {};
      config.method = 'POST';
      config.headers = {'Content-Type': 'application/x-www-form-urlencoded'};
      config.url = baseUrl;

      config.data = $.param(params);
      return $http(config);
    };

    var get = function(params) {
      return $http.get(baseUrl, {params: params});
    };

    return {
      create: function(newPost) {
        return post(newPost);
      },

      get: function(postId) {
        var params = {
          id: postId
        };

        return get(params);
      },

      getNext: function(lastPostId, parentPostId, count) {
        if (!count){
          count = 10;
        }

        var params = {
          id: lastPostId,
          parent_id: parentPostId,
          limit: count,
          action: 'get_next'
        };

        return get(params);
      },

      getReplies: function(postId, replyCount, sorter) {
        if (!replyCount) {
          replyCount = 10;
        }

        sorter = sorter || 'old';

        var params = {
          id: postId,
          limit: replyCount,
          action: 'get_replies',
          sorter: sorter
        };

        return get(params);
      },

      update: function(updatedPost) {
        var params = {
          action: 'update',
          id: updatedPost.id,
          title: updatedPost.title,
          bb_content: updatedPost.bb_content,
          update_reason: updatedPost.reason
        };

        return post(params);
      },

      approve: function(postId) {
        var params = {
          action: 'approve',
          id: postId
        };
        return post(params);
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .service('CuratedThread', ["$window", "$http", "ForumURLGenerator", function($window, $http, ForumURLGenerator) {
    var CuratedThreadsEndpoint = function(action, data) {
      var params = {};
      params.data = data;
      params.securitytoken = $window.SECURITYTOKEN;
      params.action = action;

      var config = {};
      config.url = ForumURLGenerator.getApiUrl('curated_threads_api.php');
      config.method = 'POST';
      config.headers = {'Content-Type': 'application/x-www-form-urlencoded'};
      config.data = $.param(params);

      return $http(config);
    };

    return {
      create: function(threadId) {
        var data = {curated_thread: {thread_id: threadId}};
        return CuratedThreadsEndpoint('create', data);
      },
      delete: function(threadId) {
        var data = {thread_id: threadId};
        return CuratedThreadsEndpoint('delete', data);
      },
      bump: function(threadId) {
        var data = {thread_id: threadId};
        return CuratedThreadsEndpoint('bump', data);
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .service('DailyDeals', ["$window", function($window){
      return {
        getFromWindow: function() {
          return $window.daily_deals;
        }
      };
  }]);

'use strict';

angular.module('wfManager')
  .service('ForumAuthentication', ["$cookies", "FORUM_LOGGED_IN_COOKIE", function($cookies, FORUM_LOGGED_IN_COOKIE) {
    return {
      isAuthenticated: function() {
        if($cookies.get(FORUM_LOGGED_IN_COOKIE)) {
          return true;
        }

        return false;
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .service('Referral', ["$window", "$http", "ForumURLGenerator", function($window, $http, ForumURLGenerator) {
    var ReferralsEndpoint = function(action, data) {
      var params = {};
      params.data = data;
      params.securitytoken = $window.SECURITYTOKEN;
      params.action = action;

      var config = {};
      config.url = ForumURLGenerator.getApiUrl('referrals_api.php');
      config.method = 'POST';
      config.headers = {'Content-Type': 'application/x-www-form-urlencoded'};
      config.data = $.param(params);

      return $http(config);
    };

    return {
      create: function(params) {
        var data = {referral: {}};
        data.referral.type = params.type;
        data.referral.email = params.email;

        return ReferralsEndpoint('create', data);
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .service('Thank', ["$window", "$http", "ForumURLGenerator", function($window, $http, ForumURLGenerator) {
    var securityToken = $window.SECURITYTOKEN;

    var ThanksEnd = function(post_id, action) {
      var config = {};
      config.url = ForumURLGenerator.getThanks();
      config.method = 'POST';
      config.headers = { 'Content-Type': 'application/x-www-form-urlencoded' };

      var params = {};
      params.p = post_id;
      params.modern = 1;
      params.do = action;
      params.securitytoken = securityToken;
      config.data = $.param(params);

      return $http(config);
    };

    return {
      addThank: function (post_id) {
        return ThanksEnd(post_id, 'post_thanks_add');
      },
      removeThank: function (post_id) {
        return ThanksEnd(post_id, 'post_thanks_remove_user');
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .service('Thread', ["$http", "$window", "ForumURLGenerator", function ($http, $window, ForumURLGenerator) {
    var threadsApiUrl = ForumURLGenerator.getApiUrl('threads_api.php');

    var post = function(url, args) {
      args.securitytoken = $window.SECURITYTOKEN;

      var config = {};
      config.url = url;
      config.method = 'POST';
      config.headers = {'Content-Type': 'application/x-www-form-urlencoded'};
      config.data = $.param(args);

      return $http(config);
    };

    var get = function(url, params) {
      return $http.get(url, {params: params});
    };

    var createThread = function(threadData) {
      var params = {
        'action': 'create',
        'forum_id': threadData.forumId,
        'subject': threadData.subject,
        'message': threadData.message,
        'type': threadData.type,
        'destination_url': threadData.destinationUrl,
      };

      return post(threadsApiUrl, params);
    };

    var getThreadPreview = function(threadData) {
      var params = {
        'action': 'get_preview',
        'forum_id': threadData.forumId,
        'subject': threadData.subject,
        'message': threadData.message
      };

      return post(threadsApiUrl, params);
    };

    var approveThread = function (threadId, rank) {
      if (rank === undefined) {
        rank = 1;
      }

      var args = {
        action: 'approve',
        thread_id: threadId,
        rank: rank
      };

      return post(threadsApiUrl, args);
    };

    var softDeleteThread = function (threadId, reason) {
      if (!reason) {
        reason = '';
      }

      var args = {
        action: 'delete',
        thread_id: threadId,
        reason: reason
      };

      return post(threadsApiUrl, args);
    };

    var incrementViewCount = function (threadId, count) {
      if (count === undefined) {
        count = 1;
      }

      var args = {
        action: 'increment_views',
        thread_id: threadId,
        count: count
      };

      return post(threadsApiUrl, args);
    };

    var incrementImpressionCount = function (threadIds, pageType) {
      var args = {
        action: 'increment_impressions',
        thread_ids: threadIds,
        page_type: pageType
      };

      return post(threadsApiUrl, args);
    };

    var setAsVisible = function (threadId) {
      var args = {
        action: 'set_as_visible',
        thread_id: threadId
      };

      return post(threadsApiUrl, args);
    };

    var getThread = function (params) {
      return get(threadsApiUrl, params);
    };

    var getPaidThreads = function (userId, count) {
      if (count === undefined) {
        count = 3;
      }

      var params = {
        'paid': true,
        'user_id': userId,
        'limit': count,
        'action': 'get_paid',
      };

      return get(threadsApiUrl, params);
    };

    var getMyThreadsByForum = function (forumId, fromThreadId, count) {
      if (fromThreadId === undefined) {
        fromThreadId = 0;
      }

      if (count === undefined) {
        count = 30;
      }

      var params = {
        'action': 'get_my_forum_threads',
        'forum_id': forumId,
        'from_thread_id': fromThreadId,
        'limit': count
      };

      return get(threadsApiUrl, params);
    };

    var getThreadTotalStats = function (threadId) {
      var params = {
        'action': 'get_total_stats',
        'thread_id': threadId,
      };

      return get(threadsApiUrl, params);
    };

    var getThreadActionsWithStats = function (threadId, actionLimit) {
      var params = {
        'action': 'get_actions_with_stats',
        'thread_id': threadId,
        'action_limit': actionLimit,
      };

      return get(threadsApiUrl, params);
    };

    var updateLinkTypeThread = function(threadData) {
      var params = {
        action: 'update',
        thread_id: threadData.id,
        destination_url: threadData.destinationUrl
      };

      return post(threadsApiUrl, params);
    };

    return {
      create: createThread,
      approve: approveThread,
      softDelete: softDeleteThread,
      incrementViews: incrementViewCount,
      incrementImpressions: incrementImpressionCount,
      setAsVisible: setAsVisible,
      get: getThread,
      getPaid: getPaidThreads,
      getPreview: getThreadPreview,
      getMyThreadsByForum: getMyThreadsByForum,
      getThreadTotalStats: getThreadTotalStats,
      getThreadActionsWithStats: getThreadActionsWithStats,
      updateLinkTypeThread: updateLinkTypeThread
    };
  }]);

'use strict';

angular.module('wfManager')
  .service('ThreadAnalyticsChartData', ["Formatter", function (Formatter) {
    var statTitleDict = {
      'listing_impressions': 'Impressions',
      'visitors': 'Offer impressions'
    };

    var statDescriptionDict = {
      'Impressions': 'Listing impressions from the marketplace. The number of people that could have clicked through to your Offer. Showing data from Oct 19, 2016 AEST Onwards.',
      'Offer impressions': 'Total number of page views of your offer.'
    };

    var initializeActionChartData = function(recentActions) {
      var chartData = [];

      recentActions[0].stats.forEach(function(stat) {
        var formattedStatTitle = statTitleDict[stat.title];
        var chartDataSeries = {
          key: formattedStatTitle,
          values: [],
          area: true,
          maxDataValue: 0,
          description: statDescriptionDict[formattedStatTitle],
          showTooltip: false
        };
        chartData.push(chartDataSeries);
      });

      return chartData;
    };

    var getChartDataWithNoZeroValueDataSeries = function (chartData){
      var chartDataWithNoZeroValueDataSeries = [];
      chartData.forEach(function(dataSeries){
        if(dataSeries.maxDataValue !== 0){
          chartDataWithNoZeroValueDataSeries.push(dataSeries);
        }
      });

      return chartDataWithNoZeroValueDataSeries;
    };

    var getActionChartData = function(recentActions) {
      if(recentActions.length === 0) {
        return [];
      }
      var chartData = initializeActionChartData(recentActions);

      recentActions.forEach(function(action) {
        var formattedDate = Formatter.formatUnixDate(action.created_at, 'DD-MMM-YY');
        var capitalizedActionTitle = Formatter.formatThreadActionTitle(action.title);
        var xLabel = formattedDate + ': ' + capitalizedActionTitle;

        for (var i = 0; i < chartData.length; i++) {
          chartData[i].values.push({
            xLabel: xLabel,
            y: action.stats[i].contribution_value
          });

          if(action.stats[i].contribution_value > chartData[i].maxDataValue) {
            chartData[i].maxDataValue = action.stats[i].contribution_value;
          }
        }
      });

      chartData = getChartDataWithNoZeroValueDataSeries(chartData);
      return chartData;
    };

    var getMaxActionChartValue = function(chartData) {
      var maxChartValue = 0;

      chartData.forEach(function(dataSeries) {
        if(dataSeries.maxDataValue > maxChartValue) {
          maxChartValue = dataSeries.maxDataValue;
        }
      });

      return maxChartValue;
    };

    return {
      getActionChartData: getActionChartData,
      getMaxActionChartValue: getMaxActionChartValue
    };
  }]);

'use strict';

angular.module('wfManager')
  .service('ThreadSubscription', ["$window", "$http", "WF_API_BASE_URL", function($window, $http, WF_API_BASE_URL) {
    var realTimeEmail = 1;

    var isHttp = function() {
      var idx = $window.location.href.indexOf('http://');
      if (idx > -1) {
        return true;
      } else {
        return false;
      }
    };

    var ForumSubscriptionEnd = function(data) {
      var config = {};
      config.url = WF_API_BASE_URL + 'subscription.php';

      if (isHttp()) {
       config.url = config.url.replace('https://', 'http://');
      }

      config.method = 'POST';
      config.headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json;q=0.9,image/webp,*/*;q=0.8'
      };

      var post_data = {};
      post_data.securitytoken = $window.SECURITYTOKEN;
      post_data.do = data.action;
      post_data.threadid = data.threadid;
      post_data.emailupdate = data.emailupdate;
      config.data = $.param(post_data);
      return $http(config);
    };

    return {
      subscribe: function(threadid) {
        var args = {
          action: 'doaddsubscription',
          threadid: threadid,
          emailupdate: realTimeEmail
        };

        return ForumSubscriptionEnd(args);
      },

      unsubscribe: function(threadid) {
        var args = {
          action: 'removesubscription',
          threadid: threadid
        };

        return ForumSubscriptionEnd(args);
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .service('ThreadUpvote', ["$http", "$window", "WF_API_BASE_URL", function ($http, $window, WF_API_BASE_URL) {
    var securitytoken = $window.SECURITYTOKEN;

    function doUpvote(threadid, action) {
      var args = {
        threadid: threadid,
        do: action,
        securitytoken: securitytoken
      };

      return $http.post(
        WF_API_BASE_URL + 'threadupvote.php',
        args, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded' },
          transformRequest: function(obj) {
            var str = [];
            for (var p in obj) {
              str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
            }
            return str.join('&');
          }
      });
    }

    function incrementUpvote(threadid, action, adminvote) {
      var args = {
        threadid: threadid,
        do: action,
        score: adminvote,
        securitytoken: securitytoken
      };

      return $http.post(
        WF_API_BASE_URL + 'threadupvote.php',
        args, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded' },
          transformRequest: function(obj) {
            var str = [];
            for (var p in obj) {
              str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
            }
            return str.join('&');
          }
      });
    }

    return {
      removeThreadUpvote: function(threadid) {
        return doUpvote(threadid, 'remove_upvote');
      },

      addThreadUpvote: function(threadid) {
        return doUpvote(threadid, 'add_upvote');
      },

      removeThreadDownvote: function(threadid) {
        return doUpvote(threadid, 'remove_downvote');
      },

      addThreadDownvote: function(threadid) {
        return doUpvote(threadid, 'add_downvote');
      },

      addThreadNuke: function(threadid) {
        return doUpvote(threadid, 'add_nuke');
      },

      removeThreadNuke: function(threadid) {
        return doUpvote(threadid, 'remove_nuke');
      },

      getVotes: function(threadid) {
        return doUpvote(threadid, 'get_votes');
      },

      incrementVotes: function (threadid, adminvote) {
        return incrementUpvote(threadid, 'increment_upvote', adminvote);
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .service('UserSetting', ["$window", "$http", "ForumURLGenerator", function($window, $http, ForumURLGenerator) {
    var securitytoken = $window.SECURITYTOKEN;

    var UserSettingEnd = function(setting_data) {
      var config = {};
      config.url = ForumURLGenerator.getApiUrl('user_settings_api.php');
      config.method = 'POST';
      config.headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      };

      setting_data.securitytoken = securitytoken;
      config.data = $.param(setting_data);
      return $http(config);
    };

    return {
      change: function(settingName, settingValue) {
        var data = {user_setting: {}};
        data.user_setting.setting_name = settingName;
        data.user_setting.setting_value = settingValue;

        var setting_data = {
          action: 'create',
          data: data
        };

        return UserSettingEnd(setting_data);
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .service('WfFeedPreference', ["$window", "TopicList", "$http", "ForumURLGenerator", function($window, TopicList, $http, ForumURLGenerator) {
    var securitytoken = $window.SECURITYTOKEN;

    var _saveFeedPreference = function(preference) {
      var config = {};
      config.url = ForumURLGenerator.getApiUrl('set_feed_preference.php');
      config.method = 'POST';
      config.headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      };

      config.data = $.param({
        'redirect_to_feed_on_login': preference,
        'securitytoken': securitytoken
      });

      return $http(config);
    };
    return {
      hideFeedByDefault: function() {
        return _saveFeedPreference(false);
      },
      showFeedByDefault: function() {
        return _saveFeedPreference(true);
      }
    };
  }]);

'use strict';

angular.module('wfManager')
  .service('wfTopicSelectorModal', ["$uibModal", function($uibModal) {
    var modalInstance;

    return {
      openModal: function(options) {
        // already open
        if (modalInstance) {
          return;
        }

        var nullifyModalInstance = function() {
          modalInstance = null;
        };

      var opt = {
          'closable': true
        };

        angular.extend(opt, options);

        modalInstance = $uibModal.open({
          windowTemplateUrl: '/views/warrior/FeedModalWindow.html',
          templateUrl: '/views/warrior/WarriorTopicChoice.html',
          controller: 'wfTopicSelectorModalCtrl',
          backdrop: 'true',
          size: 'lg',
          resolve: {
            options: function() {
              return opt;
            }
          }
        });

        modalInstance.result.then(nullifyModalInstance, nullifyModalInstance);
        return modalInstance.result;
      }
    };
  }]);

angular.module('wfManager').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/views/wf/alerts.html',
    "<ul class=\"ToastList\" fl-analytics-section=\"toaster-alerts\">\n" +
    "    <li class=\"ToastList-item Toast fade-in\"\n" +
    "        fl-analytics=\"alert-item\"\n" +
    "        ng-repeat=\"alert in visibleAlerts\"\n" +
    "        ng-class=\"{'fade-out': alert.fadeOut}\">\n" +
    "        <span class=\"Toast-close\" ng-click=\"closeVisibleAlert(alert)\">x</span>\n" +
    "\n" +
    "        <div ng-if=\"alert.event_name == 'alert/new_wso'\" ng-cloak>\n" +
    "            <span class=\"Toast-title\">\n" +
    "                <a href=\"/showthread.php?t={{alert.template.thread.id}}&utm_source=warriorforum&utm_medium=toaster&utm_campaign=notification\" target=\"_blank\"\n" +
    "                    class=\"Toast-link\"\n" +
    "                    fl-analytics=\"toaster-title\">New Warrior Special Offer\n" +
    "                </a>\n" +
    "            </span>\n" +
    "            <p class=\"Toast-desc\" fl-analytics=\"toaster-description\">\n" +
    "                <a href=\"/members/{{alert.template.author.username}}.html?utm_source=warriorforum&utm_medium=toaster&utm_campaign=notification\" target=\"_blank\">\n" +
    "                    {{ alert.template.author.username }}\n" +
    "                </a>just posted <a href=\"/showthread.php?t={{alert.template.thread.id}}\" target=\"_blank\" ng-bind-html=\"alert.template.thread.title\"></a> in the marketplace\n" +
    "            </p>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ng-if=\"alert.event_name == 'alert/new_excellent_thread'\" ng-cloak>\n" +
    "            <span class=\"Toast-title\">\n" +
    "                <a href=\"/showthread.php?t={{alert.template.thread.id}}&utm_source=warriorforum&utm_medium=toaster&utm_campaign=notification\" target=\"_blank\"\n" +
    "                    class=\"Toast-link\"\n" +
    "                    fl-analytics=\"toaster-title\">Join the Conversation\n" +
    "                </a>\n" +
    "            </span>\n" +
    "            <p class=\"Toast-desc\" fl-analytics=\"toaster-description\">\n" +
    "                A <strong>Warrior Member</strong> is replying to <a href=\"/showthread.php?t={{alert.template.thread.id}}\" target=\"_blank\" ng-bind-html=\"alert.template.thread.title\"></a>...\n" +
    "            </p>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "</ul>\n"
  );


  $templateCache.put('/views/wf/countdown-progress-bar.html',
    "<div ng-cloak>\n" +
    "    <div ng-show=\"state.showCountdown\" class=\"progress-bar-box\">\n" +
    "        <div class=\"progress-bar-text-left\">\n" +
    "            Deal time remaining\n" +
    "        </div>\n" +
    "        <div class=\"progress-bar-container\">\n" +
    "            <div class=\"progress-bar\">\n" +
    "                <span style=\"width: {{percentDays}}%\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"progress-bar-text-right\">\n" +
    "            <ng-pluralize count=\"daysLeft\"\n" +
    "                     when=\"{'0': '0 Days',\n" +
    "                         'one': '1 Day',\n" +
    "                         'other': '{} Days'}\">\n" +
    "            </ng-pluralize></br>\n" +
    "            {{hoursLeft}}h: {{minutesLeft}}m: {{secondsLeft}}s Left\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-show=\"state.showInputValidationErrors\" class=\"progress-bar-box\">\n" +
    "        <div class=\"progress-bar-text-left\">\n" +
    "            Invalid Date Input\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wf/deals-widget.html',
    "<header class=\"Card-header\" ng-cloak>\n" +
    "    <h3 class=\"Card-title\">Daily Deals</h3>\n" +
    "    <nav class=\"Slider-nav Slider-nav--adjoined\">\n" +
    "        <ul class=\"Slider-nav-list\" role=\"listbox\">\n" +
    "          <li class=\"Slider-nav-item\" role=\"option\" ng-repeat=\"deal in dailyDeals\">\n" +
    "            <a ng-click=\"setIndex(deal.index)\" class=\"Slider-bullet\" ng-class=\"{'is-Slider-bullet-active': isCurrentIndex(deal.index) }\"></a>\n" +
    "          </li>\n" +
    "        </ul>\n" +
    "    </nav>\n" +
    "</header>\n" +
    "\n" +
    "<div fl-analytics-subsection=\"daily-deal-slideshow\" class=\"Slider-view Card-content\">\n" +
    "    <ul class=\"Slider-slides\" role=\"listbox\">\n" +
    "        <li class=\"Slider-slide\" role=\"option\" ng-repeat=\"deal in dailyDeals\" ng-show=\"isCurrentIndex(deal.index)\">\n" +
    "            <figure class=\"DealsBlurb\">\n" +
    "                <a href=\"{{ deal.url }}?utm_source=internal&utm_medium=slideshow&utm_campaign=daily-deal&utm_term=picture\" target=\"_blank\" fl-analytics=\"picture\" fl-analytics-label=\"{{ deal.title }}\">\n" +
    "                  <img ng-src=\"{{ deal.image_url }}\" alt=\"Go for {{ deal.title }} deal\" class=\"DealsBlurb-img\">\n" +
    "                </a>\n" +
    "                <figcaption>\n" +
    "                    <h4 class=\"DealsBlurb-title\">\n" +
    "                        <a href=\"{{ deal.url }}?utm_source=internal&utm_medium=slideshow&utm_campaign=daily-deal&utm_term=title\" target=\"_blank\" fl-analytics=\"title\" >{{ deal.title }}</a>\n" +
    "                    </h4>\n" +
    "                    <p class=\"DealsBlurb-desc\" ng-bind-html=\"deal.description\"></p>\n" +
    "                    <button ng-if=\"!deal.cta_text && deal.price > 0\" ng-click=\"do_cta(deal)\" class=\"DealsBlurb-btn Btn\" fl-analytics=\"purchase-cta\">Buy for only ${{ deal.price }}</button>\n" +
    "                    <button ng-if=\"deal.cta_text\" ng-click=\"do_cta(deal)\" class=\"DealsBlurb-btn Btn\" fl-analytics=\"purchase-cta\">{{deal.cta_text}}</button>\n" +
    "                </figcaption>\n" +
    "            </figure>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wf/feed-offer-widget.html',
    "<div class=\"BlurbOffers Card\">\n" +
    "    <header class=\"Card-header\">\n" +
    "        <h3 class=\"Card-title\">My Offers</h3>\n" +
    "    </header>\n" +
    "    <div class=\"Card-content\">\n" +
    "        <ul class=\"BlurbOffers-list\">\n" +
    "            <li class=\"BlurbOffers-item\" ng-repeat=\"thread in paidThreads\">\n" +
    "                <h4 class=\"BlurbOffers-title\">\n" +
    "                    <a href=\"{{ getThreadUrl(thread.id) }}?utm_source=internal&utm_medium=my-offers-widget&utm_campaign=paid-thread&utm_term=title\"\n" +
    "                        ng-bind-html=\"thread.title\">\n" +
    "                    </a>\n" +
    "                </h4>\n" +
    "                <span class=\"BlurbOffers-btnContainer\">\n" +
    "                    <button class=\"BlurbOffers-btn Btn Btn--small Btn--hollow\"\n" +
    "                        wf-payment-choice\n" +
    "                        fixed-charge-item-id=2\n" +
    "                        item-id=\"{{ thread.id }}\"\n" +
    "                        item-class='thread'\n" +
    "                        autoOpen=1>Bump</button>\n" +
    "                </span>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "        <div class=\"BlurbOffers-upsell\" ng-hide=\"paidThreads.length > 0\">\n" +
    "            <h4 class=\"BlurbOffers-upsell-title\">No Offers</h4>\n" +
    "            <p class=\"BlurbOffers-upsell-desc\">Create an Offer to start earning Money NOW!</p>\n" +
    "        </div>\n" +
    "        <a href=\"{{ newOfferUrl }}?utm_source=internal&utm_medium=sidebar-widget&utm_campaign=post-wso\"\n" +
    "        class=\"BlurbOffers-cta Btn\" fl-analytics=\"post-wso\">Create New Offer</a>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wf/feedPreferenceBar.html',
    "<aside class=\"Announcement Announcement--feedback\" ng-show=\"showBanner\">\n" +
    "    <div class=\"Announcement-inner\" fl-analytics-section=\"nibiru-feed-main-content\" fl-analytics-subsection=\"set-default-option\">\n" +
    "        <div class=\"Announcement-content\">\n" +
    "            <h3 class=\"Announcement-heading\">Like what you see?</h3>\n" +
    "            <p class=\"Announcement-desc\">Click 'Yes' to keep this modern design as your default</p>\n" +
    "            <p class=\"Announcement-desc\">Click 'No' to keep the classic design as your default</p>\n" +
    "            <span class=\"Announcement-note\"><a href=\"mailto:support@warriorforum.com\" class=\"Announcement-content-link\">Leave us feedback</a> -or- <a href=\"#\" class=\"Announcement-content-link\" ng-click=\"hideFeed()\">Make classic your default</a></span>\n" +
    "        </div>\n" +
    "        <ul class=\"Announcement-actions\">\n" +
    "            <li class=\"Announcement-actions-item\">\n" +
    "                <button class=\"Announcement-actions-btn Btn Btn--small Btn--monoLight Btn--hollow\" ng-click=\"hideBar()\" fl-analytics=\"feed\">Yes</button>\n" +
    "            </li>\n" +
    "            <li class=\"Announcement-actions-item\">\n" +
    "                <button class=\"Announcement-actions-btn Btn Btn--small Btn--monoLight Btn--hollow\" ng-click=\"hideFeed()\" fl-analytics=\"classic\">No</button>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "    <button class=\"Announcement-closeBtn CloseBtn CloseBtn--light\" ng-click=\"closeBar()\">\n" +
    "        <wf-icon src=\"close\" class=\"WFIcon-cross\"></wf-icon>\n" +
    "    </button>\n" +
    "</aside>\n"
  );


  $templateCache.put('/views/wf/feedThreadModeration.html',
    "<div class=\"ArticleSnapshot-action\">\n" +
    "    <div class=\"ArticleSnapshot-action-item\" ng-show=\"isPending() || isDeleted()\">\n" +
    "        <wf-thread-approval thread-id=\"threadId\"></wf-thread-approval>\n" +
    "    </div>\n" +
    "    <div class=\"ArticleSnapshot-action-item\" ng-show=\"!isDeleted()\">\n" +
    "        <wf-thread-deletion thread-id=\"threadId\"></wf-thread-deletion>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wf/footer-newsletter-subscription.html',
    "<div ng-cloak>\n" +
    "    <div ng-show=\"state.showFooter\" class=\"footer-newsletter-signup\" fl-analytics-section=\"signup\" fl-analytics-subsection=\"frictionless\" fl-analytics-name=\"bottom-bar\">\n" +
    "        <div class=\"content\">\n" +
    "            <a ng-click=\"close()\" class=\"close\">&times;</a>\n" +
    "            <p class=\"footer-newsletter-description\">\n" +
    "                Get only the best Internet Marketing posts straight to your inbox\n" +
    "            </p>\n" +
    "            <form class=\"footer-newsletter-form\" name=\"newsletterform\" ng-submit=\"newsletterform.$valid && subscribe(state.email)\" novalidate>\n" +
    "                <span class=\"form-group\">\n" +
    "                    <input type=\"email\" name=\"email\" ng-model=\"state.email\" placeholder=\"you@email.com\" size=\"40\" required fl-analytics=\"input.email\" fl-analytics-value=\"state.email\"/>\n" +
    "                    <span class=\"input-error\">\n" +
    "                        <span class=\"wf-alert-error\" ng-if=\"newsletterform.email.$touched || newsletterform.$submitted\" ng-messages=\"newsletterform.email.$error\">\n" +
    "                            <span ng-message=\"email\">Please enter a valid email</span>\n" +
    "                            <span ng-message=\"required\">Please enter a valid email</span>\n" +
    "                        </span>\n" +
    "                        <span class=\"wf-alert-error\" ng-if=\"serverError\">\n" +
    "                            {{serverError}}\n" +
    "                        </span>\n" +
    "                    </span>\n" +
    "                </span>\n" +
    "                <button type=\"submit\" class=\"btn btn-primary\" fl-analytics=\"submit.subscribe\" fl-analytics-value=\"state.email\">Subscribe</button>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wf/forum-navigator.html',
    "<div id=\"forum-navigator\" class=\"Card TopicsNav\" wf-deep-blur=\"hideDropdown()\">\n" +
    "    <div class=\"TopicsNav-content\" ng-click=\"toggleDropdown()\">\n" +
    "        <span class=\"TopicsNav-logo\">\n" +
    "            <wf-icon src=\"warrior-logo-small--dark\"></wf-icon>\n" +
    "        </span>\n" +
    "        <h3 class=\"TopicsNav-title\">Jump To Topics (Previously The Forum)</h3>\n" +
    "        <span class=\"TopicsNav-trigger\">\n" +
    "            <span class=\"Dropdown-trigger\"></span>\n" +
    "        </span>\n" +
    "    </div>\n" +
    "\n" +
    "    <nav class=\"Card TopicsNav-expandedContent\" ng-show=\"state.showNavigation\" ng-cloak>\n" +
    "        <div class=\"TopicsNav-content\" ng-click=\"toggleDropdown()\">\n" +
    "            <span class=\"TopicsNav-logo\">\n" +
    "                <wf-icon src=\"warrior-logo-small--dark\"></wf-icon>\n" +
    "            </span>\n" +
    "            <h3 class=\"TopicsNav-title\">Jump To... </h3>\n" +
    "            <span class=\"TopicsNav-trigger\">\n" +
    "                <span class=\"Dropdown-trigger Dropdown-trigger--open\"></span>\n" +
    "            </span>\n" +
    "        </div>\n" +
    "\n" +
    "        <ul class=\"TopicsNav-accordion Accordion\" ng-show=\"forums\">\n" +
    "            <li class=\"Accordion-group\"\n" +
    "                ng-class=\"{'is-Accordion-group-collapsed': !forum.showSubforums}\"\n" +
    "                ng-repeat=\"forum in forums\"\n" +
    "                ng-if=\"forum.is_active\">\n" +
    "                <a class=\"Accordion-header\" ng-click=\"toggleAccordion(forum)\">\n" +
    "                    <h4 class=\"Accordion-title\" ng-bind-html=\"forum.title\"></h4>\n" +
    "                    <span class=\"Accordion-icon\">\n" +
    "                        <wf-icon src=\"accordion-toggle\"></wf-icon>\n" +
    "                    </span>\n" +
    "                </a>\n" +
    "                <ul class=\"Accordion-list\" ng-show=\"forum.showSubforums\" ng-cloak>\n" +
    "                    <li class=\"Accordion-item\"\n" +
    "                        ng-repeat=\"subforum in forum.subforums\"\n" +
    "                        ng-if=\"subforum.is_active && !subforum.is_private && !subforum.is_paid\">\n" +
    "                        <a ng-href=\"{{ subforum.feed_url }}\" ng-bind-html=\"subforum.title\"></a>\n" +
    "                    </li>\n" +
    "                </ul>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </nav>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wf/header-cta.html',
    "<div ng-cloak fl-analytics-section=\"signup\" fl-analytics-subsection=\"header-cta\">\n" +
    "    <button fl-analytics=\"btn-striking-orange\" class=\"btn btn-header-register\" wf-signup >Sign Up To Learn From The Best Internet Marketers</button>\n" +
    "</div>"
  );


  $templateCache.put('/views/wf/hoodie-abtest.html',
    "<div wf-experiment experiment-prime=\"1451\" variation-count=\"2\" variation=\"variation\" ng-switch=\"variation\" ng-cloak fl-analytics-section=\"signup\" fl-analytics-subsection=\"header-cta\">\n" +
    "    <div align=\"center\" ng-switch-when=\"0\">\n" +
    "        <a href=\"https://tracking.warriorforum.com/c/et-your-official-warrior-forum-hoodies-here-free-worldwide-shipping\" rel=\"nofollow\" target=\"_blank\">\n" +
    "            <img src=\"https://dtqn2osro0nhk.cloudfront.net/static/warrior/2015-07-07/WarriorForumHoodies.png\" border=\"0\" alt=\"\">\n" +
    "        </a>\n" +
    "    </div>\n" +
    "    <div align=\"center\" ng-switch-when=\"1\">\n" +
    "        <a ng-controller=\"HoodiePaymentCtrl\" ng-click=\"openPayNow()\" rel=\"nofollow\" style=\"cursor:pointer\">\n" +
    "            <img src=\"https://dtqn2osro0nhk.cloudfront.net/static/warrior/2015-07-07/WarriorForumHoodies.png\" border=\"0\" alt=\"\">\n" +
    "        </a>\n" +
    "    </div>\n" +
    "</div>"
  );


  $templateCache.put('/views/wf/HoodieModal.html',
    "<div ng-multi-template=\"/views/warrior/PaymentModal.html\">\n" +
    "</div>"
  );


  $templateCache.put('/views/wf/IncrementUpvoteModal.html',
    "<div class=\"Nibiru\" fl-analytics-section=\"wf-payment-nibiru-modal\" wf-deep-blur=\"cancel()\">\n" +
    "    <div class=\"Modal-wrapper\">\n" +
    "        <div class=\"UpvoteModal Modal\">\n" +
    "            <div class=\"Modal-header\">\n" +
    "                <span class=\"Modal-title\">Add to thread's upvote...</span>\n" +
    "            </div>\n" +
    "            <div class=\"Modal-body\">\n" +
    "                <form class=\"UpvoteModal-form Form\">\n" +
    "                    <fieldset class=\"Form-fieldset\">\n" +
    "                        <ol class=\"Form-steps\">\n" +
    "                            <li class=\"Form-step--group\">\n" +
    "                                <label for=\"\" class=\"Form-label\">\n" +
    "                                    Value\n" +
    "                                </label>\n" +
    "                                <input type=\"number\" ng-model=\"adminvote\" class=\"Input\">\n" +
    "                            </li>\n" +
    "                        </ol>\n" +
    "                    </fieldset>\n" +
    "                </form>\n" +
    "            </div>\n" +
    "            <div class=\"Modal-action\">\n" +
    "                <button class=\"PostWidget-btn Btn Btn--small\" type=\"button\"  ng-click=\"submitIncrement()\">Increment</button>\n" +
    "                <button class=\"PostWidget-btn Btn Btn--small\" type=\"button\" data-dismiss=\"modal\" ng-click=\"cancel()\">Cancel</button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wf/offer-total-stats.html',
    "<div class=\"stats-summary\">\n" +
    "    <div class=\"stats-overview\">\n" +
    "        <div class=\"stats-value\">\n" +
    "            {{ totalStats.listing_impressions | number }}\n" +
    "            <span class=\"stats-value-label\">Impressions</span>\n" +
    "        </div>\n" +
    "        <div class=\"stats-value\">\n" +
    "            {{ totalStats.visitors | number }}\n" +
    "            <span class=\"stats-value-label\">Offer Impressions</span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wf/post-thread.html',
    "<div class=\"PostWidget Card\">\n" +
    "    <figure class=\"PostWidget-figure\">\n" +
    "        <img src=\"{{user_info.avatar}}\" alt=\"\" class=\"Avatar Avatar--small\">\n" +
    "    </figure>\n" +
    "    <form id=\"Post-thread-form\">\n" +
    "        <div class=\"InputCombo\">\n" +
    "            <span class=\"Input-wrapper Input-wrapper--hasIconEdge\">\n" +
    "                <input data-modal-target=\"PostWidget-modal\" type=\"text\" class=\"PostWidget-inputTrigger--prolonged Input Input--dark\" placeholder=\"What do you want to know about?\" ng-focus=\"showPostThreadModal()\">\n" +
    "                <!-- <span class=\"Input-icon\">\n" +
    "                    ${ PhotoIcon.icon() }\n" +
    "                </span> -->\n" +
    "            </span>\n" +
    "            <button class=\"Btn Btn--small\" ng-click=\"showPostThreadModal()\">Ask</button>\n" +
    "        </div>\n" +
    "    </form>\n" +
    "\n" +
    "    <div id=\"PostWidget-modal\" class=\"Modal is-Modal-hidden\" wf-deep-blur=\"hidePostThreadModal()\">\n" +
    "        <div class=\"PostWidget\">\n" +
    "            <figure class=\"PostWidget-figure\">\n" +
    "    <!--             <img src=\"${ userinfo.avatar.url }\" alt=\"${ userinfo.username }\" class=\"Avatar Avatar--small\"> -->\n" +
    "            </figure>\n" +
    "            <form name=\"newThreadForm\" class=\"PostWidget-form Form\" ng-submit=\"submit(newThreadData)\" novalidate>\n" +
    "                <aside class=\"Alert Alert--error\">Please activate your account before posting a thread.</aside>\n" +
    "                <fieldset class=\"Form-fieldset\">\n" +
    "                    <ol class=\"Form-steps\">\n" +
    "                        <li class=\"Form-step\">\n" +
    "                            <span class=\"Input-wrapper Input-wrapper--hasPointer\">\n" +
    "                                <input type=\"text\" class=\"Input\" name=\"subject\" ng-model=\"newThreadData.subject\" required placeholder=\"What do you want to know about?\">\n" +
    "                                <aside ng-show=\"newThreadForm.subject.$error.required && !newThreadForm.subject.$pristine\" ng-minlength=\"5\" class=\"Alert Alert--error\">Please enter a subject</aside>\n" +
    "                            </span>\n" +
    "                        </li>\n" +
    "                        <li class=\"Form-step\">\n" +
    "                            <textarea rows=\"6\" name=\"message\" ng-model=\"newThreadData.message\" required ng-minlength=\"10\" placeholder=\"Enter question details (Optional)\"></textarea>\n" +
    "                            <aside ng-show=\"newThreadForm.message.$error.required && !newThreadForm.message.$pristine\" class=\"Alert Alert--error\">Please enter thread message</aside>\n" +
    "                        </li>\n" +
    "                        <li class=\"PostWidget-submitStep Form-step\">\n" +
    "                            <select class=\"PostWidget-selectTopic\"\n" +
    "                                ng-options=\"topic as topic.name for topic in topicList\"\n" +
    "                                name=\"selectedTopic\"\n" +
    "                                ng-model=\"selectedTopic\"\n" +
    "                                required>\n" +
    "                                <option value=\"\">Choose a topic?</option>\n" +
    "                            </select>\n" +
    "                            <aside ng-show=\"newThreadForm.selectedTopic.$error.required && !newThreadForm.selectedTopic.$pristine\" class=\"Alert Alert--error\">Please choose a topic</aside>\n" +
    "                            <input type='submit' class=\"PostWidget-btn Btn Btn--small\" value=\"Ask\"></input>\n" +
    "                        </li>\n" +
    "                    </ol>\n" +
    "                </fieldset>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "<!--     <div class=\"Modal-backdrop\">\n" +
    "    </div> -->\n" +
    "<!--     {%include 'feed/parts/nibiru/PostWidgetModal.twig'%} -->\n" +
    "</div>"
  );


  $templateCache.put('/views/wf/recent-activity-card.html',
    "<div class=\"Card-content\">\n" +
    "    <h3 class=\"Card-title\">Recent Activity</h3>\n" +
    "    <ul class=\"TopicList\">\n" +
    "        <li class=\"TopicList-item\">\n" +
    "            <article class=\"ArticleSnapshot\" role=\"article\">\n" +
    "                <div class=\"ArticleSnapshot-content\">\n" +
    "                    <h3 class=\"ArticleSnapshot-title ArticleSnapshot-title--mono\">\n" +
    "                        <a>Coaching program promotion</a>\n" +
    "                    </h3>\n" +
    "                    <footer class=\"ArticleSnapshot-footer\">\n" +
    "                        <span class=\"ArticleSnapshot-details\">\n" +
    "                            <a>Username</a> &#8226; 1 day ago &#8226; <a>7 comments</a>\n" +
    "                        </span>\n" +
    "                    </footer>\n" +
    "                </div>\n" +
    "            </article>\n" +
    "        </li>\n" +
    "        <li class=\"TopicList-item\">\n" +
    "            <article class=\"ArticleSnapshot\" role=\"article\">\n" +
    "                <div class=\"ArticleSnapshot-content\">\n" +
    "                    <h3 class=\"ArticleSnapshot-title ArticleSnapshot-title--mono\">\n" +
    "                        <a>Coaching program promotion</a>\n" +
    "                    </h3>\n" +
    "                    <footer class=\"ArticleSnapshot-footer\">\n" +
    "                        <span class=\"ArticleSnapshot-details\">\n" +
    "                            <a>Username</a> &#8226; 1 day ago &#8226; <a>7 comments</a>\n" +
    "                        </span>\n" +
    "                    </footer>\n" +
    "                </div>\n" +
    "            </article>\n" +
    "        </li>\n" +
    "        <li class=\"TopicList-item\">\n" +
    "            <article class=\"ArticleSnapshot\" role=\"article\">\n" +
    "                <div class=\"ArticleSnapshot-content\">\n" +
    "                    <h3 class=\"ArticleSnapshot-title ArticleSnapshot-title--mono\">\n" +
    "                        <a>Coaching program promotion</a>\n" +
    "                    </h3>\n" +
    "                    <footer class=\"ArticleSnapshot-footer\">\n" +
    "                        <span class=\"ArticleSnapshot-details\">\n" +
    "                            <a>Username</a> &#8226; 1 day ago &#8226; <a>7 comments</a>\n" +
    "                        </span>\n" +
    "                    </footer>\n" +
    "                </div>\n" +
    "            </article>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "</div>\n" +
    "<footer class=\"Card-footer\">\n" +
    "    <a class=\"Card-expandLink\">View More</a>\n" +
    "</footer>\n"
  );


  $templateCache.put('/views/wf/showthread/comment.html',
    "<div id=\"post{{post.id}}\" class=\"DiscussionBoard-wrapper\">\n" +
    "    <figure class=\"DiscussionBoard-figure\">\n" +
    "        <img ng-src=\"{{ post.author_avatar ? post.author_avatar : avatarPlaceholder }}\"\n" +
    "             fallback-src=\"{{ avatarPlaceholder }}\"\n" +
    "             alt=\"Profile picture of the author {{ reply.author_username }}\"\n" +
    "             class=\"Avatar Avatar--small\"/>\n" +
    "    </figure>\n" +
    "\n" +
    "    <div class=\"DiscussionBoard-content\" ng-class=\"{'DiscussionBoard-content--invisible': !isVisible(post)}\">\n" +
    "        <div class=\"DiscussionBoard-header\" ng-hide=\"state.showEditForm\">\n" +
    "            <a href=\"{{ authorUrl }}\" class=\"DiscussionBoard-username\">{{ post.author_username }}</a>\n" +
    "            <user-title user-role=\"{{ post.author_role }}\"></user-title>\n" +
    "            <time class=\"DiscussionBoard-date\">{{ post.dateline * 1000 | ago }}</time>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"DiscussionBoard-message VBEditorContent\" ng-class=\"{'DiscussionBoard-message--invisible': !isVisible(post)}\" ng-bind-html=\"post.content\" ng-hide=\"state.showEditForm\"></div>\n" +
    "\n" +
    "        <div class=\"DiscussionBoard-message VBEditorContent\" ng-class=\"{'DiscussionBoard-message--invisible': !isVisible(post)}\" ng-show=\"state.showEditForm\" ng-cloak>\n" +
    "            <wf-post-editor post=\"post\"></wf-post-editor>\n" +
    "        </div>\n" +
    "        <ul class=\"DiscussionBoard-actionList\" ng-if=\"isVisible(post)\">\n" +
    "            <li class=\"DiscussionBoard-actionItem\">\n" +
    "                <a class=\"DiscussionBoard-actionLink\" ng-click=\"thanks()\">\n" +
    "                    <span class=\"DiscussionBoard-actionCount\" ng-show=\"post.thanks > 0\">\n" +
    "                        [&nbsp;{{ post.thanks }}&nbsp;]\n" +
    "                    </span>\n" +
    "                    {{ post.thanked ? 'Thanked' : 'Thanks' }}\n" +
    "                </a>\n" +
    "            </li>\n" +
    "            <li class=\"DiscussionBoard-actionItem\" ng-if=\"thread.open\">\n" +
    "                <a class=\"DiscussionBoard-actionLink\" ng-click=\"toggleReplyForm()\">Reply</a>\n" +
    "            </li>\n" +
    "            <li class=\"DiscussionBoard-actionItem\" ng-show=\"isEditEligible()\" ng-cloak>\n" +
    "                <a class=\"DiscussionBoard-actionLink\" ng-click=\"toggleEditForm()\">Edit</a>\n" +
    "            </li>\n" +
    "            <li class=\"DiscussionBoard-actionItem\" ng-show=\"post.reply_count > 0\">\n" +
    "                <a class=\"DiscussionBoard-actionLink\" ng-click=\"seeReplies()\">\n" +
    "                    <ng-pluralize count=\"post.reply_count\" when=\"{'one': '1 reply', 'other': '{} replies'}\"></ng-pluralize>\n" +
    "                </a>\n" +
    "            </li>\n" +
    "            <li class=\"DiscussionBoard-actionItem\">\n" +
    "                <a href=\"/report.php?p={{post.id}}\" class=\"DiscussionBoard-actionLink\">\n" +
    "                    Report\n" +
    "                </a>\n" +
    "            </li>\n" +
    "            <li class=\"DiscussionBoard-actionItem\" ng-show=\"state.loadingReplies\" ng-cloak>\n" +
    "                <div class=\"Loader Loader--small\"></div>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "\n" +
    "        <div class=\"DiscussionBoard-reply-form\" ng-if=\"state.showReplyForm\">\n" +
    "            <reply-form open=\"true\" thread-id=\"thread.id\" parent-id=\"post.id\" placeholder=\"Reply to {{ post.author_username }}\"></reply-form>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"DiscussionBoard-contentAlert Alert Alert--warning\"\n" +
    "            ng-class=\"{'ng-animate-fadeOut': !error}\"\n" +
    "            ng-show=\"error\">\n" +
    "            <strong>{{ errorMessage }}</strong>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"DiscussionBoard-signature\" ng-if=\"state.showSignatures && post.signature\" ng-cloak>\n" +
    "            <span class=\"DiscussionBoard-signature-label StatusLabel StatusLabel--ghost\">\n" +
    "                Signature\n" +
    "            </span>\n" +
    "            <div class=\"DiscussionBoard-signature-content\" ng-bind-html=\"post.signature.content\"></div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"DiscussionBoard-subLevel\" ng-if=\"post.replies.length > 0\">\n" +
    "            <ul class=\"DiscussionBoard-list DiscussionBoard-list--secondary\">\n" +
    "                <li class=\"DiscussionBoard-item\" ng-repeat=\"reply in post.replies\">\n" +
    "                    <wf-comment post=\"reply\" thread=\"thread\" depth=\"depth + 1\" signature=\"state.showSignatures\"></wf-comment>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "\n" +
    "            <footer class=\"DiscussionBoard-footer\" ng-if=\"state.hasMoreReplies\">\n" +
    "                <a class=\"DiscussionBoard-footerLink DiscussionBoard-footerLink--small\" ng-click=\"loadMoreReplies()\">\n" +
    "                    View more replies <span class=\"Arrow\">&#8595;</span>\n" +
    "                </a>\n" +
    "                <span class=\"DiscussionBoard-footerLabel\">\n" +
    "                    <div class=\"Loader Loader--small\" ng-show=\"state.loadingMoreReplies\"></div>\n" +
    "                </span>\n" +
    "            </footer>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wf/showthread/discussion-board.html',
    "<section id=\"comments\" class=\"DiscussionBoard\" ng-show=\"!state.initializing\" ng-cloak>\n" +
    "    <header class=\"DiscussionBoard-header\" ng-if=\"thread && thread.open\" ng-cloak>\n" +
    "        <reply-form thread-id=\"thread.id\" parent-id=\"postId\"></reply-form>\n" +
    "    </header>\n" +
    "    <div class=\"Sorter\" ng-if=\"sorter\" ng-show=\"replies.length > 0\">\n" +
    "        <div class=\"InputGroup\">\n" +
    "            <a class=\"Btn Btn--xsmall\" ng-class=\"{'Btn--hollow': sorter === 'old'}\" ng-click=\"sort('new')\">Newest First</a>\n" +
    "            <a class=\"Btn Btn--xsmall\" ng-class=\"{'Btn--hollow': sorter === 'new'}\" ng-click=\"sort('old')\">Oldest First</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <ul class=\"DiscussionBoard-list\">\n" +
    "        <li class=\"DiscussionBoard-item\" ng-repeat=\"reply in replies track by $index\">\n" +
    "            <wf-comment post=\"reply\" thread=\"thread\" depth=\"1\" signature=\"state.showSignatures\"></wf-comment>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "\n" +
    "    <footer class=\"DiscussionBoard-footer\" ng-if=\"state.hasMoreReplies\">\n" +
    "        <a href=\"#\" class=\"DiscussionBoard-footerLink\"\n" +
    "            ng-click=\"loadMoreReplies()\">\n" +
    "            View more comments <span class=\"Arrow\">&#8595;</span>\n" +
    "        </a>\n" +
    "        <span class=\"DiscussionBoard-footerLabel\">\n" +
    "            <span ng-show=\"!state.loadingMore\">{{ visibleReplyCount | number }} of {{  replyCount | number }}</span>\n" +
    "            <div class=\"Loader Loader--small\" ng-show=\"state.loadingMore\"></div>\n" +
    "        </span>\n" +
    "    </footer>\n" +
    "</section>\n"
  );


  $templateCache.put('/views/wf/showthread/main-post-editor.html',
    "<form name=\"MainPostEditor\" class=\"PostWidget-form Form\" ng-submit=\"updatePost()\" novalidate>\n" +
    "    <fieldset class=\"Form-fieldset\">\n" +
    "        <ol class=\"Form-steps\">\n" +
    "            <li class=\"Form-step\">\n" +
    "                <span class=\"Input-wrapper\">\n" +
    "                    Title:<br>\n" +
    "                    <input type=\"text\"\n" +
    "                        name=\"title\"\n" +
    "                        placeholder=\"What do you want to discuss or know about?\"\n" +
    "                        ng-model=\"post.title\">\n" +
    "                    <span class=\"Form-helpText\" ng-show=\"post.title.length < 5\">Title needs to be at least 5-character long</span>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "            <li class=\"Form-step VbEditorToolbar\">\n" +
    "                <div class=\"post-wso-editor\"\n" +
    "                    text-angular\n" +
    "                    name=\"bb_content\"\n" +
    "                    placeholder=\"Enter details here...\"\n" +
    "                    ng-model=\"post.bb_content\">\n" +
    "                </div>\n" +
    "                <span class=\"Form-helpText\" ng-show=\"post.bb_content.length < 10\">Content needs to be at least 10-character long</span>\n" +
    "            </li>\n" +
    "          <li class=\"Form-step\">\n" +
    "              <span class=\"Input-wrapper\">\n" +
    "                  Reason for Editing:<br>\n" +
    "                  <input type=\"text\" name=\"reason\" ng-model=\"post.reason\" placeholder=\"Why did you make this edit?\">\n" +
    "              </span>\n" +
    "          </li>\n" +
    "          <li class=\"Form-step Form-submit\">\n" +
    "            <div class=\"Form-action\">\n" +
    "              <div class=\"Form-action-item\">\n" +
    "                <button class=\"Btn Btn--small\" type=\"submit\" ng-disabled=\"!isPostValid()\">Save</button>\n" +
    "              </div>\n" +
    "              <div class=\"Form-action-item\">\n" +
    "                <button class=\"Btn Btn--small Btn--tone\" type=\"button\" ng-click=\"hideForm()\">Cancel</button>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </li>\n" +
    "        </ol>\n" +
    "    </fieldset>\n" +
    "    <div class=\"Loader-overlay\" ng-show=\"state.formSubmitting\" ng-cloak>\n" +
    "        <div class=\"Loader\">Loading...</div>\n" +
    "    </div>\n" +
    "</form>\n"
  );


  $templateCache.put('/views/wf/showthread/post-editor.html',
    "<form name=\"Post{{ post.id }}-editor\"\n" +
    "    class=\"PostWidget-form Form\"\n" +
    "    ng-submit=\"updatePost()\"\n" +
    "    novalidate>\n" +
    "    <fieldset class=\"Form-fieldset\">\n" +
    "        <ol class=\"Form-steps\">\n" +
    "            <li class=\"Form-step VbEditorToolbar\">\n" +
    "                <div class=\"post-wso-editor\"\n" +
    "                    text-angular\n" +
    "                    placeholder=\"Enter details here...\"\n" +
    "                    ng-model=\"post.bb_content\"></div>\n" +
    "                <p class=\"Form-helpText\" ng-show=\"isPostValid()\">\n" +
    "                    Minimum of 10 characters to post\n" +
    "                </p>\n" +
    "                <aside class=\"Alert Alert--error\" ng-show=\"error\" ng-cloak>\n" +
    "                    {{ errorMessage }}\n" +
    "                </aside>\n" +
    "                <div class=\"Loader-overlay\" ng-show=\"state.formSubmitting\" ng-cloak>\n" +
    "                    <div class=\"Loader\">Loading...</div>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "            <li class=\"Form-step Form-submit\">\n" +
    "                <div class=\"Form-action\">\n" +
    "                    <div class=\"Form-action-item\">\n" +
    "                        <button class=\"Btn Btn--small\" type=\"submit\" ng-disabled=\"!isPostValid()\">Save</button>\n" +
    "                    </div>\n" +
    "                    <div class=\"Form-action-item\">\n" +
    "                        <button class=\"Btn Btn--small Btn--tone\" type=\"button\"\n" +
    "                            ng-click=\"hideForm()\">Cancel</button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "        </ol>\n" +
    "    </fieldset>\n" +
    "</form>\n"
  );


  $templateCache.put('/views/wf/showthread/thread_analytics.html',
    "<div class=\"stats-graphs\">\n" +
    "    <h3 class=\"stats-graph-title\">\n" +
    "        Contributions of Recent Actions\n" +
    "        <div class=\"stats-graph-title-tooltipIcon\">\n" +
    "            <span ng-mouseover=\"state.showActionChartTooltip = true\" ng-mouseleave=\"state.showActionChartTooltip = false\">\n" +
    "                <wf-icon src=\"question\"></wf-icon>\n" +
    "            </span>\n" +
    "            <div class=\"Tooltip\" ng-show=\"state.showActionChartTooltip\" ng-cloak>\n" +
    "                <div class=\"Tooltip-title\">Contributions of Recent Actions</div>\n" +
    "                <p class=\"Tooltip-desc\">Shows the stats gained by each action since it was performed up until the next action. This table is updated every hour.</p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </h3>\n" +
    "    <wf-thread-stats-line-area-chart chart-data=\"actionChartData\"\n" +
    "        x=\"actionChartX\"\n" +
    "        y=\"actionChartY\"\n" +
    "        min-y=\"0\"\n" +
    "        max-y=\"maxActionChartValue\"\n" +
    "        tick-format-x-axis=\"actionChartXFormat\"\n" +
    "        tick-format-y-axis=\"actionChartYFormat\"\n" +
    "        tooltip-content=\"actionChartTooltipContent\"\n" +
    "        ng-if=\"state.actionChartDataLoaded\">\n" +
    "    </wf-thread-stats-line-area-chart>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wf/showthread/thread_stats_line_area_chart.html',
    "<ul class=\"LineChart-legend\">\n" +
    "    <li ng-repeat=\"dataSeries in chartData track by $index\">\n" +
    "        <div class=\"LineChart-legend-tooltipIcon\">\n" +
    "            <span class=\"Bullet\"\n" +
    "                style=\"background-color: {{ colorArray[$index] }}\"\n" +
    "                ng-mouseover=\"dataSeries.showTooltip = true\"\n" +
    "                ng-mouseleave=\"dataSeries.showTooltip = false\">\n" +
    "            </span>\n" +
    "            <div class=\"Tooltip\" ng-show=\"dataSeries.showTooltip\" ng-cloak>\n" +
    "                <div class=\"Tooltip-title\">{{ dataSeries.key }}</div>\n" +
    "                <p class=\"Tooltip-desc\">{{ dataSeries.description }}</p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        {{ dataSeries.key }}\n" +
    "    </li>\n" +
    "</ul>\n" +
    "<nvd3 options=\"chartOptions\" data=\"chartData\"></nvd3>\n"
  );


  $templateCache.put('/views/wf/sticky-sidebar.html',
    "<div class=\"ClusteredContent SectionInner\" ng-multi-transclude-controller>\n" +
    "    <section class=\"ClusteredContent-main\" role=\"main\" ng-multi-transclude=\"content\"></section>\n" +
    "    <aside class=\"ClusteredContent-side\" ng-class=\"{ 'is-ClusteredContent-side-bottom': bottom, 'is-ClusteredContent-side-sticky': sticky }\" role=\"complementary\">\n" +
    "        <div class=\"ClusteredContent-sideInner\" ng-multi-transclude=\"sidebar\"></div>\n" +
    "    </aside>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wf/thread-approval-modal.html',
    "<div class=\"Nibiru\" wf-deep-blur=\"cancel()\">\n" +
    "    <div class=\"ThreadActionModal modal-content\">\n" +
    "        <div class=\"Modal-header\">\n" +
    "            <span class=\"Modal-title\">Approve Thread</span>\n" +
    "        </div>\n" +
    "        <div class=\"Modal-body\">\n" +
    "            <form class=\"Form\">\n" +
    "                <fieldset class=\"Form-fieldset\">\n" +
    "                    <ol class=\"Form-steps\">\n" +
    "                        <li class=\"Form-step\">\n" +
    "                            <label class=\"Form-label\">Thread Quality</label>\n" +
    "                        </li>\n" +
    "                        <li class=\"Form-step\">\n" +
    "                            <ul class=\"ThreadActionModal-radio-list\">\n" +
    "                                <li class=\"ThreadActionModal-radio-item\">\n" +
    "                                    <input id=\"poor\" name=\"rank\" value=\"0\" type=\"radio\" class=\"CustomRadio\" ng-model=\"rank\">\n" +
    "                                    <label for=\"poor\" class=\"CustomRadio-text\">Poor</label>\n" +
    "                                </li>\n" +
    "                                <li class=\"ThreadActionModal-radio-item\">\n" +
    "                                    <input id=\"good\" name=\"rank\" value=\"1\" type=\"radio\" class=\"CustomRadio\" checked=\"checked\" ng-model=\"rank\">\n" +
    "                                    <label for=\"good\" class=\"CustomRadio-text\">Good</label>\n" +
    "                                </li>\n" +
    "                                <li class=\"ThreadActionModal-radio-item\">\n" +
    "                                    <input id=\"excellent\" name=\"rank\" value=\"2\" type=\"radio\" class=\"CustomRadio\" ng-model=\"rank\">\n" +
    "                                    <label for=\"excellent\" class=\"CustomRadio-text\">Excellent</label>\n" +
    "                                </li>\n" +
    "                            </ul>\n" +
    "                        </li>\n" +
    "                    </ol>\n" +
    "                    <div class=\"Loader Loader--large\" ng-show=\"state.isLoading\">Loading...</div>\n" +
    "                </fieldset>\n" +
    "            </form>\n" +
    "            <span class=\"Alert Alert--error\" ng-show=\"state.error\">{{ error_message }}</span>\n" +
    "            <span class=\"Alert Alert--success\" ng-show=\"state.success\">Thread Approved!</span>\n" +
    "        </div>\n" +
    "        <div class=\"Modal-action\">\n" +
    "            <button class=\"Btn Btn--small\" type=\"button\"\n" +
    "                ng-click=\"confirmApproval()\"\n" +
    "                ng-disabled=\"state.isLoading\"\n" +
    "                ng-hide=\"state.success\">Confirm</button>\n" +
    "\n" +
    "            <button class=\"Btn Btn--small Btn--tone\" type=\"button\" ng-click=\"cancel()\">Close</button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wf/thread-approval.html',
    "<button class=\"Btn Btn--small\"\n" +
    "    ng-class=\"{'Btn--success': approved}\"\n" +
    "    ng-click=\"openApprovalModal()\">\n" +
    "    {{ label }}\n" +
    "</button>\n"
  );


  $templateCache.put('/views/wf/thread-deletion-modal.html',
    "<div class=\"Nibiru\" wf-deep-blur=\"cancel()\">\n" +
    "    <div class=\"ThreadActionModal modal-content\">\n" +
    "        <div class=\"Modal-header\">\n" +
    "            <span class=\"Modal-title\">Delete Thread</span>\n" +
    "        </div>\n" +
    "        <div class=\"Modal-body\">\n" +
    "            <form class=\"Form\">\n" +
    "                <fieldset class=\"Form-fieldset\">\n" +
    "                    <label class=\"Form-label\">Reason for Deleting Thread</label>\n" +
    "                    <textarea class=\"Input\"\n" +
    "                        name=\"name\"\n" +
    "                        placeholder=\"My reason is...\"\n" +
    "                        rows=\"8\"\n" +
    "                        cols=\"40\"\n" +
    "                        ng-model=\"reason\"\n" +
    "                        ng-hide=\"state.isLoading\">\n" +
    "                    </textarea>\n" +
    "                    <div class=\"Loader Loader--large\" ng-show=\"state.isLoading\">Loading...</div>\n" +
    "                </fieldset>\n" +
    "            </form>\n" +
    "            <span class=\"Alert Alert--error\" ng-show=\"state.error\">{{ error_message }}</span>\n" +
    "            <span class=\"Alert Alert--success\" ng-show=\"state.success\">Thread deleted!</span>\n" +
    "        </div>\n" +
    "        <div class=\"Modal-action\">\n" +
    "            <button class=\"Btn Btn--small\" type=\"button\"\n" +
    "                ng-click=\"confirmDeletion()\"\n" +
    "                ng-disabled=\"state.isLoading\"\n" +
    "                ng-hide=\"state.success\">Confirm</button>\n" +
    "            <button class=\"Btn Btn--small Btn--tone\" type=\"button\" ng-click=\"cancel()\">Close</button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wf/thread-deletion.html',
    "<button class=\"Btn Btn--small Btn--tone\"\n" +
    "    ng-class=\"{'Btn--success': deleted}\"\n" +
    "    ng-click=\"openDeletionModal()\">\n" +
    "    {{ label }}\n" +
    "</button>\n"
  );


  $templateCache.put('/views/wf/thread-increment-upvote.html',
    "<button type=\"button\" class=\"Btn Btn--small Btn--hollow\"\n" +
    "      fl-analytics-section=\"thread\"\n" +
    "      ng-click=\"incrementUpvote()\"\n" +
    "      ng-cloak>\n" +
    "<span class=\"action-btn--value\">Upvote</span>\n" +
    "</button>\n"
  );


  $templateCache.put('/views/wf/thread-subscription.html',
    "<button type=\"button\" class=\"Btn Btn--small ThreadSubscription-btn\"\n" +
    "      ng-class=\"{'Btn--hollow': !isSubscribed}\"\n" +
    "      ng-click=\"submit()\"\n" +
    "      fl-analytics=\"subscription\"\n" +
    "      fl-analytics-section=\"thread\"\n" +
    "      ng-cloak>\n" +
    "{{ text }}\n" +
    "</button>\n"
  );


  $templateCache.put('/views/wf/thread-upvote.html',
    "<button type=\"button\" class=\"Btn Btn--small ThreadUpvote-btn\"\n" +
    "      ng-class=\"{'Btn--hollow': !upvoted}\"\n" +
    "      ng-click=\"toggleUpvote()\"\n" +
    "      fl-analytics=\"upvote\"\n" +
    "      fl-analytics-section=\"thread\"\n" +
    "      ng-cloak>\n" +
    "{{ text }}\n" +
    "</button>\n"
  );


  $templateCache.put('/views/wf/wftopics.html',
    "<div  class=\"Card\">\n" +
    "    <header class=\"Card-header\">\n" +
    "        <h3 class=\"Card-title\" id=\"followed-topics\">Topics You Follow</h3>\n" +
    "        <a class=\"Card-headerAction\" id=\"topics-you-follow-edit\" wf-topic-selector>Edit</a>\n" +
    "    </header>\n" +
    "    <div class=\"Card-content CategoryTag-wrapper\">\n" +
    "        <a ng-hide=\"loaded\" class=\"CategoryTag\">Fetching your selected topics...</a>\n" +
    "        <a ng-show=\"loaded\" ng-if=\"topics.length == 0\" class=\"CategoryTag\" wf-topic-selector>Customize feed now</a>\n" +
    "        <a ng-show=\"loaded\" ng-repeat=\"topic in topics\" class=\"CategoryTag\" href=\"{{topic.feedUrl}}\">{{topic.name}} </a>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/forum/abtest-button-create-wso.html',
    "<span wf-experiment experiment-prime=\"1459\" variation-count=\"2\" variation=\"variation\" ng-switch=\"variation\" ng-cloak fl-analytics-section=\"create-wso\" fl-analytics-subsection=\"create-cta\">\n" +
    "    <a ng-switch-when=\"0\" fl-analytics=\"{{trackingName0}}\" href=\"https://payments.warriorforum.com/post-wso?wf_track={{trackingName0}}\">\n" +
    "        <img ng-src=\"{{imageUrl}}\" alt=\"Post a WSO\" border=\"0\" title=\"Post a WSO\">\n" +
    "    </a>\n" +
    "    <a ng-switch-when=\"1\" fl-analytics=\"{{trackingName1}}\" href=\"//www.warriorforum.com/newthread.php?do=newthread&f=17&wf_track={{trackingName1}}\">\n" +
    "        <img ng-src=\"{{imageUrl}}\" alt=\"Post a WSO\" border=\"0\" title=\"Post a WSO\">\n" +
    "    </a>\n" +
    "</span>"
  );


  $templateCache.put('/views/warrior/blankmodal.html',
    "<div class=\"default-modal-header\">\n" +
    "\t<button ng-if=\"options.closable\" class=\"default-modal-close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\" fl-analytics=\"close\">&times;</button>\n" +
    "\t<div class=\"default-modal-logo\"></div>\n" +
    "\t<h1 class=\"default-modal-title\">\n" +
    "\t\tGet Access to the War Room\n" +
    "\t\t<span class=\"item-price\">$99</span>\n" +
    "\t</h1>\n" +
    "</div>\n" +
    "<div class=\"default-modal-body\">\n" +
    "\t<div class=\"default-modal-info-column\">\n" +
    "\t\t<img src=\"styles/warrior/images/logos/paypal-colour.png\" alt=\"PayPal\">\n" +
    "\t\t<img src=\"styles/warrior/images/paypal-screenshot.jpg\" alt=\"Pay with PayPal in a new window\" class=\"info-column-image-preview\">\n" +
    "\t\t<div class=\"info-column-text\">A new window will open asking you to complete payment using PayPal.</div>\n" +
    "\t</div>\n" +
    "\t<div class=\"default-modal-content-column\">\n" +
    "\t\t<form class=\"form default-form\" role=\"form\">\n" +
    "\t\t\t<ol class=\"form-fields\">\n" +
    "\t\t\t\t<li class=\"form-group btn-group\">\n" +
    "\t\t\t\t\t<label class=\"btn btn-secondary btn-small\">\n" +
    "\t\t\t\t\t\t<input type=\"radio\" name=\"user\"> I am a New User\n" +
    "\t\t\t\t\t</label>\n" +
    "\t\t\t\t\t<label class=\"btn btn-secondary btn-small\">\n" +
    "\t\t\t\t\t\t<input type=\"radio\" name=\"user\"> I’m an Existing User\n" +
    "\t\t\t\t\t</label>\n" +
    "\t\t\t\t</li>\n" +
    "\t\t\t\t<li class=\"form-group\">\n" +
    "\t\t\t\t\t<label class=\"form-label\">Email Address</label>\n" +
    "\t\t\t\t\t<div class=\"input-group\">\n" +
    "\t\t\t\t\t\t<div class=\"input-group-addon\">\n" +
    "\t\t\t\t\t\t\t<span class=\"icon-wf-email\"></span>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t<input class=\"input-group-field\" type=\"email\" name=\"email\">\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t<div class=\"form-error-message\">\n" +
    "\t\t\t\t\t\t<span>Please type in your desired username.</span>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</li>\n" +
    "\t\t\t\t<li class=\"form-group\">\n" +
    "\t\t\t\t\t<label class=\"form-label\">New Username</label>\n" +
    "\t\t\t\t\t<div class=\"input-group\">\n" +
    "\t\t\t\t\t\t<div class=\"input-group-addon\">\n" +
    "\t\t\t\t\t\t\t<span class=\"icon-wf-user\"></span>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t<input class=\"input-group-field\" type=\"text\" name=\"username\">\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</li>\n" +
    "\t\t\t\t<li class=\"form-group\">\n" +
    "\t\t\t\t\t<label class=\"form-label\">Password</label>\n" +
    "\t\t\t\t\t<div class=\"input-group\">\n" +
    "\t\t\t\t\t\t<div class=\"input-group-addon\">\n" +
    "\t\t\t\t\t\t\t<span class=\"icon-wf-lock\"></span>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t<input class=\"input-group-field\" type=\"password\" name=\"password\">\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</li>\n" +
    "\t\t\t\t<li class=\"form-group\">\n" +
    "\t\t\t\t\t<label class=\"form-label\">Re-enter Password</label>\n" +
    "\t\t\t\t\t<div class=\"input-group\">\n" +
    "\t\t\t\t\t\t<div class=\"input-group-addon\">\n" +
    "\t\t\t\t\t\t\t<span class=\"icon-wf-lock\"></span>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t<input class=\"input-group-field\" type=\"password\">\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</li>\n" +
    "\t\t\t</ol>\n" +
    "\t\t\t<div class=\"default-modal-paypal-cta\">\n" +
    "\t\t\t\t<a href=\"#\" class=\"btn btn-paypal\">Check out with <img src=\"styles/warrior/images/logos/paypal-simple.png\" alt=\"PayPal\" class=\"btn-paypal-logo\"></a>\n" +
    "\t\t\t</div>\n" +
    "\t\t</form>\n" +
    "\t</div>\n" +
    "</div>\n" +
    "<div class=\"default-modal-footer\">\n" +
    "</div>"
  );


  $templateCache.put('/views/warrior/CompleteRegistration.html',
    "<div class=\"FullscreenModal-dialog\" ng-style=\"{'z-index': 1050 + index*10}\" fl-analytics-section=\"wf-social-login-complete-modal\">\n" +
    "    <div class=\"FullscreenModal-dialogBody\">\n" +
    "        <div class=\"OnboardingForm-container\">\n" +
    "            <h1 class=\"OnboardingModal-title\">Complete your Warrior Forum Registration</h1>\n" +
    "            <p>You are one step closer to the secrets of Digital Marketing</p>\n" +
    "            <hr class=\"SectionDivider is-lightSectionDivider\">\n" +
    "            <form role=\"form\" class=\"OnboardingForm\" name=\"loginform\"  method=\"post\" novalidate ng-submit=\"loginform.$valid && submit(user)\" form-locator ng-if=\"step=='register'\">\n" +
    "                <fieldset >\n" +
    "                    <div class=\"form-group\"  ng-class=\"{'is-invalid':loginform.username.$invalid, 'is-valid':loginform.username.$valid, 'is-touched':loginform.username.$touched}\">\n" +
    "                        <wf-icon src=\"username\" class=\"wfIcon-user\"></wf-icon>\n" +
    "                        <input type=\"text\" class=\"form-control\"  name=\"username\" ng-model=\"user.username\" placeholder=\"Username\" id=\"username\" fl-ensure-unique=\"username\" tabindex=\"1\" required>\n" +
    "                        <p class=\"wf-alert-error\" ng-messages=\"loginform.username.$error\">\n" +
    "                            <span ng-message=\"required\" id=\"warning-username-missing\">Please enter a username</span>\n" +
    "                            <span ng-message=\"invalid\">Username is invalid</span>\n" +
    "                            <span ng-message=\"uniqueInvalid\">Invalid, please try a different username</span>\n" +
    "                            <span ng-message=\"unique\">Username is taken, please try a different username</span>\n" +
    "                        </p>\n" +
    "                        <wf-icon src=\"check\" class=\"wfIcon-check\"></wf-icon>\n" +
    "                        <wf-icon src=\"cross\" class=\"wfIcon-cross\"></wf-icon>\n" +
    "                    </div>\n" +
    "                    <button class=\"Button Button--primary OnboardingForm-cta\" fl-analytics=\"create\" fl-analytics-subsection=\"create\" type=\"submit\" ng-if=\"step=='register'\">Continue to Warrior Forum</button>\n" +
    "\n" +
    "                </fieldset>\n" +
    "            </form>\n" +
    "            <div ng-if=\"step=='notice'\" class=\"OnboardingForm\">\n" +
    "                <p>We have sent activation details to</p>\n" +
    "                <p class=\"signup-notice-email-sent\">{{email}}</p>\n" +
    "                <p>You'll need to activate your account before being able to contribute.</p>\n" +
    "                <button class=\"Button Button--primary OnboardingForm-cta\" fl-analytics=\"close\"  fl-analytics-subsection=\"done\" ng-click=\"$event.preventDefault(); ok()\">Close</button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>"
  );


  $templateCache.put('/views/warrior/FeedModalWindow.html',
    "<div class=\"Modal-backdrop\" ng-style=\"{'z-index': 10000*(index + 1)}\" ng-class=\"{in: animate}\" ng-click=\"close($event)\">\n" +
    "    <div modal-transclude></div>\n" +
    "</div>"
  );


  $templateCache.put('/views/warrior/forgotpasswordmodal.html',
    "<div class=\"wf-modal-header\">\n" +
    "    <a ng-if=\"options.closable\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</a>\n" +
    "    <h1 class=\"wf-modal-title\" ng-if=\"step!='notice'\">Forgot your password?</h1>\n" +
    "</div>\n" +
    "<div class=\"wf-modal-body\">\n" +
    "    <form role=\"form\" class=\"form wf-signup\" name=\"forgotpasswordform\"  method=\"post\" novalidate ng-submit=\"forgotpasswordform.$valid && submit(user)\" form-locator>\n" +
    "        <fieldset ng-if=\"step=='initial'\">\n" +
    "            <ol>\n" +
    "                <li class=\"wf-form-group\">\n" +
    "                    <label class=\"wf-form-label\" for=\"email\">Email</label>\n" +
    "                    <span class=\"icon-wf-email\">\n" +
    "                        <input class=\"wf-input\" type=\"email\" name=\"email\" ng-model=\"user.email\" placeholder=\"Email Address\" required>\n" +
    "                    </span>\n" +
    "                    <p class=\"wf-alert-error\" ng-if=\"forgotpasswordform.email.$touched || forgotpasswordform.$submitted\" ng-messages=\"forgotpasswordform.email.$error\">\n" +
    "                        <span ng-message=\"required\">Please enter your email address</span>\n" +
    "                        <span ng-message=\"email\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                        <span ng-message=\"invalid\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                        <span ng-message=\"format_incorrect\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                    </p>\n" +
    "                </li>\n" +
    "            </ol>\n" +
    "            <div class=\"signup-cta\">  \n" +
    "                <button class=\"wf-btn btn-primary\" type=\"submit\">Retrieve Password</button>\n" +
    "            </div>\n" +
    "        </fieldset>\n" +
    "        <fieldset ng-if=\"step=='notice'\" class='signup-notice'>\n" +
    "            <div class=\"wf-alert-default\">Your username and details about how to reset your password have been sent to you by email.</div>\n" +
    "        </fieldset>\n" +
    "    </form>\n" +
    "</div>\n" +
    "<div class=\"wf-modal-footer\">\n" +
    "    <p class=\"wf-modal-footer-text\"><a ng-click=\"login(options)\">Login</a></p>\n" +
    "    <p class=\"wf-modal-footer-text\">Don't have an account? <a ng-click=\"signup(options)\">Sign up</a></p>\n" +
    "</div>"
  );


  $templateCache.put('/views/warrior/FullScreenForgotPasswordModal.html',
    "<div class=\"FullscreenModal-dialog\" ng-style=\"{'z-index': 1050 + index*10}\" fl-analytics-section=\"new-wf-login-modal\">\n" +
    "    <button class=\"FullscreenModal-close\" ng-click=\"cancel()\"><wf-icon class=\"wfIcon-close white\" src=\"close\"></wf-icon></button>\n" +
    "    <div class=\"FullscreenModal-dialogBody\">\n" +
    "        <div class=\"AuthForm Card\" ng-if=\"step=='initial'\">\n" +
    "            <form role=\"form\" class=\"AuthForm-form Form\" name=\"forgotpasswordform\" method=\"post\" novalidate ng-submit=\"forgotpasswordform.$valid && submit(user)\" form-locator>\n" +
    "                <fieldset class=\"Form-fieldset\">\n" +
    "                    <ol class=\"Form-steps\">\n" +
    "                        <li class=\"Form-step\" ng-class=\"{'is-invalid': forgotpasswordform.$dirty && forgotpasswordform.$error}\">\n" +
    "                            <label for=\"email\" class=\"Form-label\">\n" +
    "                                Forgot your password\n" +
    "                            </label>\n" +
    "                            <input class=\"Input\" type=\"email\" name=\"email\" ng-model=\"user.email\" placeholder=\"me@email.com\" required novalidate>\n" +
    "                            <div class=\"Form-errorMsg\" ng-if=\"forgotpasswordform.email.$touched || forgotpasswordform.$submitted\" ng-messages=\"forgotpasswordform.email.$error\">\n" +
    "                                <span ng-message=\"required\">Please enter your email address</span>\n" +
    "                                <span ng-message=\"email\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                                <span ng-message=\"invalid\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                                <span ng-message=\"format_incorrect\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                            </div>\n" +
    "                        </li>\n" +
    "                        <li class=\"Form-step\">\n" +
    "                            <button type=\"submit\" class=\"Btn Btn--wide\" ng-disabled=\"forgotpasswordform.$invalid\">Retrieve Password</button>\n" +
    "                        </li>\n" +
    "                    </ol>\n" +
    "                </fieldset>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "        <div class=\"AuthForm Card\" ng-if=\"step=='notice'\">\n" +
    "            <div class=\"AuthForm-alert AuthForm-alert--success\">\n" +
    "                <h2 class=\"AuthForm-alert-title\">Account Recovered!</h2>\n" +
    "                <p class=\"AuthForm-alert-msg\">Your username and details about how to reset your password have been sent to you by email.</p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <footer class=\"AuthForm-footer\">\n" +
    "            <div class=\"AuthForm-footer-item\">\n" +
    "                <a class=\"AuthForm-footer-link\" fl-analytics=\"signup\" ng-click=\"signup(options)\">Don't have an account?</a>\n" +
    "            </div>\n" +
    "            <div class=\"AuthForm-footer-item\">\n" +
    "                <a class=\"AuthForm-footer-link\" ng-click=\"login(options)\">Login</a>\n" +
    "            </div>\n" +
    "        </footer>\n" +
    "    </div>\n" +
    "</div>"
  );


  $templateCache.put('/views/warrior/FullScreenLoginModal.html',
    "<div class=\"FullscreenModal-dialog\" ng-style=\"{'z-index': 1050 + index*10}\" fl-analytics-section=\"new-wf-login-modal\">\n" +
    "    <button class=\"FullscreenModal-close\" ng-click=\"cancel()\">\n" +
    "        <wf-icon class=\"wfIcon-close white\" src=\"close\"></wf-icon>\n" +
    "    </button>\n" +
    "    <div class=\"FullscreenModal-dialogBody\">\n" +
    "        <div class=\"AuthForm\">\n" +
    "            <header class=\"AuthForm-header\">\n" +
    "                <div class=\"AuthForm-logo\">\n" +
    "                    <wf-icon src=\"warrior-logo-small\"></wf-icon>\n" +
    "                </div>\n" +
    "                <div class=\"AuthForm-header-text\">\n" +
    "                    <span class=\"AuthForm-subTitle\">{{ options.welcomeMessage }}</span>\n" +
    "                    <h1 class=\"AuthForm-title Accented\">Warrior Forum</h1>\n" +
    "                    <p class=\"AuthForm-desc\">The world's number 1 internet marketing community and marketplace</p>\n" +
    "                </div>\n" +
    "            </header>\n" +
    "            <div class=\"AuthForm-main Card\">\n" +
    "                <div class=\"AuthForm-action\">\n" +
    "                    <div class=\"AuthForm-action-item\">\n" +
    "                        <a href=\"{{ fbLoginUrl }}\" class=\"AuthForm-action-btn Btn Btn--decent Btn--wide\" fl-analytics=\"login\" tabindex=\"1\">\n" +
    "                            Continue with Facebook\n" +
    "                        </a>\n" +
    "                    </div>\n" +
    "                    <div class=\"AuthForm-action-item\">\n" +
    "                        <a href=\"{{ googleLoginUrl }}\" class=\"AuthForm-action-btn Btn Btn--wide Btn--tertiary\" fl-analytics=\"login\" tabindex=\"2\">\n" +
    "                        Continue with Google\n" +
    "                        </a>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"AuthForm-divider Divider Divider--simple\">\n" +
    "                    <span class=\"Divider-title\">OR</span>\n" +
    "                </div>\n" +
    "                <form class=\"AuthForm-form Form\" role=\"form\" name=\"loginform\" method=\"post\" novalidate ng-submit=\"loginform.$valid && submit(user)\" form-locator>\n" +
    "                    <fieldset class=\"Form-fieldset\">\n" +
    "                        <div class=\"Alert Alert--error\" ng-if=\"login_error || unknown_error\" ng-cloak>\n" +
    "                            <span ng-if=\"login_error == 'exceeded' || remaining_strikes == 0\">\n" +
    "                                You have exceeded the maximum number of login attempts, please try again in 15 minutes\n" +
    "                            </span>\n" +
    "                            <span ng-if=\"login_error == 'failed' && remaining_strikes > 0\">\n" +
    "                              Oops! Your username or password is incorrect.\n" +
    "                              <span ng-if=\"remaining_strikes > 0\" ng-pluralize count=\"remaining_strikes\" when=\"{'one': '1 attempt remaining.', 'other': '{} attempts remaining.' }\"></span>\n" +
    "                            </span>\n" +
    "                            <span ng-if=\"unknown_error\">An unknown error occured, please try again later.</span>\n" +
    "                        </div>\n" +
    "                        <ol class=\"Form-steps\">\n" +
    "                            <li class=\"Form-step\" ng-class=\"{'is-invalid':loginform.username.$dirty && loginform.username.$invalid, 'is-valid':loginform.username.$valid, 'is-touched':loginform.username.$touched}\">\n" +
    "                                <label for=\"username\" class=\"Form-label\">\n" +
    "                                    Username\n" +
    "                                </label>\n" +
    "                                <input type=\"text\" placeholder=\"username\" class=\"Input\" name=\"username\" ng-model=\"user.username\" id=\"username\" autocomplete=\"off\" tabindex=\"3\" required>\n" +
    "                                <div class=\"Form-errorMsg\" ng-messages=\"loginform.username.$error\" ng-if=\"loginform.username.$touched || loginform.$submitted\">\n" +
    "                                    <span ng-message=\"required\">Please enter a username</span>\n" +
    "                                </div>\n" +
    "                            </li>\n" +
    "                            <li class=\"Form-step\" ng-class=\"{'is-invalid': loginform.password.$dirty && loginform.password.$invalid, 'is-valid':loginform.password.$valid, 'is-touched':loginform.password.$touched}\">\n" +
    "                                <label for=\"password\" class=\"Form-label\">Password</label>\n" +
    "                                <input type=\"password\" placeholder=\"********\" class=\"Input\" ng-model=\"user.password\" name=\"password\" id=\"password\" tabindex=\"4\" autocomplete=\"off\" required>\n" +
    "                                <div class=\"Form-errorMsg\" ng-if=\"loginform.password.$touched || loginform.$submitted\" ng-messages=\"loginform.password.$error\">\n" +
    "                                    <span ng-message=\"required\">Please type a password for your account</span>\n" +
    "                                </div>\n" +
    "                            </li>\n" +
    "                            <li class=\"Form-step\">\n" +
    "                                <button type=\"submit\" class=\"Btn Btn--wide\" tabindex=\"5\" ng-disabled=\"loginform.$invalid\">Log in</button>\n" +
    "                            </li>\n" +
    "                        </ol>\n" +
    "                    </fieldset>\n" +
    "                </form>\n" +
    "            </div>\n" +
    "            <footer class=\"AuthForm-footer\">\n" +
    "                <div class=\"AuthForm-footer-item\">\n" +
    "                    <a fl-analytics=\"signup\" ng-click=\"signup(options)\">Don't have an account?</a>\n" +
    "                </div>\n" +
    "                <div class=\"AuthForm-footer-item\">\n" +
    "                    <a ng-click=\"forgotpassword(options)\">Forgot password?</a>\n" +
    "                </div>\n" +
    "                <div class=\"AuthForm-footer-item\">\n" +
    "                    <p class=\"AuthForm-terms\">\n" +
    "                        By logging in you confirm that you accept the\n" +
    "                        <a class=\"AuthForm-terms-link\" target=\"_blank\" href=\"http://www.warriorforum.com/tos.html\">Terms and Conditions</a> and <a class=\"AuthForm-terms-link\" target=\"_blank\" href=\"http://www.warriorforum.com/privacy.html\">Privacy Policy</a>\n" +
    "                    </p>\n" +
    "                </div>\n" +
    "            </footer>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>"
  );


  $templateCache.put('/views/warrior/FullScreenSignupModal.html',
    "<div ng-multi-template='/views/warrior/FullScreenSignupModalBase.html'>\n" +
    "</div>"
  );


  $templateCache.put('/views/warrior/FullScreenSignupModalBase.html',
    "<div class=\"FullscreenModal-dialog\" ng-style=\"{'z-index': 1050 + index*10}\" fl-analytics-section=\"new-wf-login-modal\">\n" +
    "    <button class=\"FullscreenModal-close\" ng-click=\"cancel()\"><wf-icon class=\"wfIcon-close white\" src=\"close\"></wf-icon></button>\n" +
    "    <div class=\"FullscreenModal-dialogBody\">\n" +
    "        <div class=\"AuthForm\">\n" +
    "            <header class=\"AuthForm-header\">\n" +
    "                <div class=\"AuthForm-logo\">\n" +
    "                    <wf-icon src=\"warrior-logo-small\"></wf-icon>\n" +
    "                </div>\n" +
    "                <div class=\"AuthForm-header-text\">\n" +
    "                    <span class=\"AuthForm-subTitle\">\n" +
    "                        {{ options.welcomeMessage }}\n" +
    "                    </span>\n" +
    "                    <h1 class=\"AuthForm-title Accented\">\n" +
    "                        Warrior Forum\n" +
    "                    </h1>\n" +
    "                    <p class=\"AuthForm-desc\">\n" +
    "                        The world's number 1 internet marketing community and marketplace\n" +
    "                    </p>\n" +
    "                </div>\n" +
    "            </header>\n" +
    "            <div class=\"AuthForm-main Card\">\n" +
    "                <div class=\"AuthForm-action\">\n" +
    "                    <div class=\"AuthForm-action-item\">\n" +
    "                        <a href=\"{{fbLoginUrl}}\" class=\"AuthForm-action-btn Btn Btn--decent Btn--wide\" fl-analytics=\"login\" tabindex=\"1\">\n" +
    "                            Continue with Facebook\n" +
    "                        </a>\n" +
    "                    </div>\n" +
    "                    <div class=\"AuthForm-action-item\">\n" +
    "                        <a href=\"{{googleLoginUrl}}\" class=\"AuthForm-action-btn Btn Btn--wide Btn--tertiary\" fl-analytics=\"login\" tabindex=\"2\">\n" +
    "                            Continue with Google\n" +
    "                        </a>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"AuthForm-divider Divider Divider--simple\">\n" +
    "                    <span class=\"Divider-title\">\n" +
    "                        OR\n" +
    "                    </span>\n" +
    "                </div>\n" +
    "                <form class=\"AuthForm-form Form\" name=\"signupform\" method=\"post\" novalidate ng-submit=\"signupform.$valid && submit(user)\" form-locator>\n" +
    "                    <fieldset class=\"Form-fieldset\">\n" +
    "                        <div class=\"Alert Alert--error\" ng-if=\"signupform.$submitted && signupform.$invalid\">\n" +
    "                            <span>{{ signupErrorMessage(signupform) }}</span>\n" +
    "                        </div>\n" +
    "                        <ol class=\"Form-steps\">\n" +
    "                            <li class=\"Form-step\" id=\"signup-username\" ng-class=\"{'is-invalid':signupform.username.$dirty && signupform.username.$invalid, 'is-valid':signupform.username.$valid, 'is-touched':signupform.username.$touched}\">\n" +
    "                                <label for=\"username\" class=\"Form-label\">Username</label>\n" +
    "                                <input class=\"Input\" type=\"text\" placeholder=\"username\" name=\"username\" ng-model=\"user.username\" fl-ensure-unique=\"username\" id=\"username\" ng-minlength=\"2\" tabindex=\"3\" required>\n" +
    "                                <div class=\"Form-errorMsg\" ng-if=\"signupform.username.$touched || signupform.$submitted\" ng-messages=\"signupform.username.$error\">\n" +
    "                                    <span ng-message=\"required\" id=\"warning-username-missing\">Please enter a username</span>\n" +
    "                                    <span ng-message=\"invalid\">Username is invalid</span>\n" +
    "                                    <span ng-message=\"uniqueInvalid\">Invalid, please try a different username</span>\n" +
    "                                    <span ng-message=\"unique\">Username is taken, please try a different username</span>\n" +
    "                                </div>\n" +
    "                            </li>\n" +
    "                            <li class=\"Form-step\"  ng-class=\"{'is-invalid':signupform.email.$dirty && signupform.email.$invalid, 'is-valid':signupform.email.$valid, 'is-touched':signupform.email.$touched}\">\n" +
    "                                <label for=\"email\" class=\"Form-label\">Email</label>\n" +
    "                                <input class=\"Input\" type=\"email\" placeholder=\"me@email.com\" name=\"email\" ng-model=\"user.email\" fl-ensure-unique=\"email\" fl-guardpost id=\"email\" ng-model=\"email\" tabindex=\"4\" required>\n" +
    "                                <div class=\"Form-errorMsg\" ng-if=\"signupform.email.$touched || signupform.$submitted\" ng-messages=\"signupform.email.$error\">\n" +
    "                                    <span ng-message=\"required\">Please enter your email address</span>\n" +
    "                                    <span ng-message=\"email\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                                    <span ng-message=\"invalid\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                                    <span ng-message=\"uniqueInvalid\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                                    <span ng-message=\"format_incorrect\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                                    <span ng-message=\"guardpost\">Invalid email address. <span ng-if=\"signupform.email.suggestion\">Did you mean {{signupform.email.suggestion }}? </span></span>\n" +
    "                                    <span ng-message=\"unique\">Email already exists, please try a different email</span>\n" +
    "                                    <span ng-message=\"used\">Email already exists, please try a different email</span>\n" +
    "                                </div>\n" +
    "                            </li>\n" +
    "                            <li class=\"Form-step\" ng-class=\"{'is-invalid':signupform.password.$dirty && signupform.password.$invalid, 'is-valid':signupform.password.$valid, 'is-touched':signupform.password.$touched}\">\n" +
    "                                <label for=\"password\" class=\"Form-label\">Password</label>\n" +
    "                                <input class=\"Input\" type=\"password\" placeholder=\"********\" ng-model=\"user.password\" ng-pattern=\"/[0-9]/\" ng-minlength=\"6\" name=\"password\" id=\"password\" tabindex=\"5\" required>\n" +
    "                                <div class=\"Form-errorMsg\" ng-if=\"signupform.password.$touched || signupform.$submitted\" ng-messages=\"signupform.password.$error\">\n" +
    "                                    <span ng-message=\"required\" id=\"warning-password-missing\">Please type a password for your account</span>\n" +
    "                                    <span ng-message=\"minlength\">Your password must be at least 6 characters</span>\n" +
    "                                    <span ng-message=\"pattern\">Your password must contain at least 1 numeric character</span>\n" +
    "                                </div>\n" +
    "                            </li>\n" +
    "                            <li class=\"Form-step\">\n" +
    "                                <div class=\"AuthForm-captcha\" ng-model=\"user.captcha\" vc-recaptcha name=\"captcha\" required ></div>\n" +
    "                                <div class=\"Form-errorMsg\" ng-if=\"signupform.captcha.$touched || signupform.$submitted\" ng-messages=\"signupform.captcha.$error\">\n" +
    "                                    <span ng-message=\"required\" id=\"warning-captcha-missing\">Captcha is missing!</span>\n" +
    "                                </div>\n" +
    "                            </li>\n" +
    "                            <li class=\"Form-step\">\n" +
    "                                <button type=\"submit\" class=\"Btn Btn--wide\"\n" +
    "                                        fl-analytics=\"create\"\n" +
    "                                        fl-analytics-subsection=\"create\"\n" +
    "                                        ng-if=\"step=='initial'\"\n" +
    "                                        ng-disabled=\"signupform.$invalid\"\n" +
    "                                        tabindex=\"4\" >Sign up</button>\n" +
    "                            </li>\n" +
    "                        </ol>\n" +
    "                    </fieldset>\n" +
    "                </form>\n" +
    "            </div>\n" +
    "            <footer class=\"AuthForm-footer\">\n" +
    "                <div class=\"AuthForm-footer-item\">\n" +
    "                    <a class=\"AuthForm-footer-link\" fl-analytics=\"login\" ng-click=\"login(options)\">Already have an account?</a>\n" +
    "                </div>\n" +
    "                <div class=\"AuthForm-footer-item\">\n" +
    "                    <p class=\"AuthForm-terms\">\n" +
    "                        By registering you confirm that you accept the\n" +
    "                        <a class=\"AuthForm-terms-link\" target=\"_blank\" href=\"http://www.warriorforum.com/tos.html\">Terms and Conditions</a> and <a class=\"AuthForm-terms-link\" target=\"_blank\" href=\"http://www.warriorforum.com/privacy.html\">Privacy Policy</a>\n" +
    "                    </p>\n" +
    "                </div>\n" +
    "            </footer>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/warrior/FullScreenSignupModalWindow.html',
    "<div class=\"Nibiru FullscreenModal\" ng-style=\"{'z-index': 10000*(index + 1)}\" ng-class=\"{in: animate}\">\n" +
    "    <div uib-modal-transclude></div>\n" +
    "    <tmh/>\n" +
    "</div>"
  );


  $templateCache.put('/views/warrior/greetingmodal.html',
    "<div class=\"default-modal-header\" fl-analytics-section=\"{{trackingSection}}\" fl-analytics-subsection=\"{{trackingSubsection}}\">\n" +
    "\t<a class=\"default-modal-close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\" fl-analytics=\"cancel\">&times;</a>\n" +
    "</div>\n" +
    "<div class=\"default-modal-body\" fl-analytics-section=\"{{trackingSection}}\" fl-analytics-subsection=\"{{trackingSubsection}}\">\n" +
    "\t<div class=\"default-modal-content\" wf-compile=\"message\" fl-analytics-section=\"wf-welcome-modal\" fl-analytics-subsection=\"wf-welcome-modal\">\n" +
    "\t</div>\n" +
    "</div>\n" +
    "<div class=\"default-modal-footer\">\n" +
    "</div>\n"
  );


  $templateCache.put('/views/warrior/IncrementUpvoteModal.html',
    "<div class=\"Nibiru\" fl-analytics-section=\"wf-payment-nibiru-modal\" wf-deep-blur=\"cancel()\">\n" +
    "\t<div class=\"Modal-wrapper\">\n" +
    "    \t<div class=\"UpvoteModal Modal\">\n" +
    "    \t\t<div class=\"Modal-header\">\n" +
    "    \t\t\t<span class=\"Modal-title\">Add to thread's upvote...</span>\n" +
    "    \t\t</div>\n" +
    "    \t\t<div class=\"Modal-body\">\n" +
    "    \t\t\t<form class=\"Form\">\n" +
    "    \t  \t\t\t<input type=\"number\" ng-model=\"adminvote\">\n" +
    "    \t\t\t</form>\n" +
    "    \t\t</div>\n" +
    "    \t\t<div class=\"Modal-footer\">\n" +
    "\t        \t<button class=\"PostWidget-btn Btn Btn--small\" type=\"button\"  ng-click=\"ok()\">Increment</button>\n" +
    "\t    \t    <button class=\"PostWidget-btn Btn Btn--small\" type=\"button\" data-dismiss=\"modal\" ng-click=\"cancel()\">Cancel</button>\n" +
    "    \t    </div>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"Modal-backdrop\"></div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/warrior/inpagesignuplogin.html',
    "<!-- Login/Signup form & Connect with Facebook -->\n" +
    "<div class=\"form-login-container\" fl-analytics-section=\"inpage-signuplogin\">\n" +
    "    <div ng-if=\"!loggedin\" class=\"loading-wrapper\" ng-class=\"{loading: is-loading}\" > <!-- add 'is-loading' class when loading -->\n" +
    "        <div class=\"loading-overlay\"></div>\n" +
    "        <form ng-init=\"choice='signup'\" class=\"default-form form-login form-login-choice\">\n" +
    "            <ol>\n" +
    "                <li class=\"form-group user-select\">\n" +
    "                    <div class=\"btn-group\">\n" +
    "                        <label class=\"btn form-label-radio\" fl-analytics=\"choose-signup\">\n" +
    "                            <input type=\"radio\" ng-model=\"choice\" value=\"signup\"> I am a New User\n" +
    "                        </label>\n" +
    "                        <label class=\"btn form-label-radio\" fl-analytics=\"choose-login\">\n" +
    "                            <input type=\"radio\" ng-model=\"choice\" value=\"login\"> I am a Returning User\n" +
    "                        </label>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "            </ol>\n" +
    "        </form>\n" +
    "        <form ng-if=\"choice == 'signup'\" class=\"default-form form-login form-login-new-user\" name=\"signupform\" ng-submit=\"signupform.$valid && createAccountSubmit(user)\" form-locator novalidate>\n" +
    "            <ol class=\"Form-steps\">\n" +
    "                <li class=\"Form-step\">\n" +
    "                    <label class=\"form-label\" for=\"email\">Email address:</label>\n" +
    "                    <input name=\"email\" type=\"email\" ng-blur=\"signupform.$valid && onBlurSignup(user)\" ng-model=\"user.email\" placeholder=\"Email Address\" fl-ensure-unique=\"email\" fl-guardpost required>\n" +
    "                    <p class=\"alert-error\" ng-if=\"signupform.email.$touched || signupform.$submitted\" ng-messages=\"signupform.email.$error\">\n" +
    "                        <span ng-message=\"required\">Please enter your email address</span>\n" +
    "                        <span ng-message=\"email\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                        <span ng-message=\"invalid\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                        <span ng-message=\"format_incorrect\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                        <span ng-message=\"guardpost\">Invalid email address. <span ng-if=\"signupform.email.suggestion\">Did you mean {{signupform.email.suggestion }}? </span></span>\n" +
    "                        <span ng-message=\"unique\">Email already exists, please try a different email</span>\n" +
    "                        <span ng-message=\"used\">Email already exists, please try a different email</span>\n" +
    "                    </p>\n" +
    "                </li>\n" +
    "                <li class=\"Form-step\">\n" +
    "                    <label class=\"form-label\" for=\"username\">New username:</label>\n" +
    "                    <input type=\"text\" name=\"username\" ng-model=\"user.username\" ng-blur=\"signupform.$valid && onBlurSignup(user)\" placeholder=\"Username\" fl-ensure-unique=\"username\" id=\"username\" ng-minlength=\"2\" required>\n" +
    "                    <p class=\"alert-error\" ng-if=\"signupform.username.$touched || signupform.$submitted\" ng-messages=\"signupform.username.$error\">\n" +
    "                        <span ng-message=\"required\">Please enter a username</span>\n" +
    "                        <span ng-message=\"invalid\">Username is invalid</span>\n" +
    "                        <span ng-message=\"uniqueInvalid\">Invalid, please try a different username</span>\n" +
    "                        <span ng-message=\"unique\">Username is taken, please try a different username</span>\n" +
    "                    </p>\n" +
    "                </li>\n" +
    "\n" +
    "                <li class=\"Form-step\">\n" +
    "                    <label class=\"form-label\" for=\"password\">Password:</label>\n" +
    "                    <input type=\"password\" type=\"password\" ng-model=\"user.password\" ng-blur=\"signupform.$valid && onBlurSignup(user)\" ng-pattern=\"/[0-9]/\" ng-minlength=\"6\" placeholder=\"Type a password\" name=\"password\" required>\n" +
    "                    <p class=\"alert-error\" ng-if=\"signupform.password.$touched || signupform.$submitted\" ng-messages=\"signupform.password.$error\">\n" +
    "                        <span ng-message=\"required\">Please type a password for your account</span>\n" +
    "                        <span ng-message=\"minlength\">Your password must be at least 6 characters</span>\n" +
    "                        <span ng-message=\"pattern\">Your password must contain at least 1 numeric character</span>\n" +
    "                    </p>\n" +
    "                </li>\n" +
    "                <li class=\"Form-step\">\n" +
    "                    <label class=\"form-label\" for=\"password\">Re-enter password:</label>\n" +
    "                    <input type=\"password\" type=\"password\" name=\"confirmPassword\" ng-model=\"user.confirmPassword\" ng-blur=\"signupform.$valid && onBlurSignup(user)\" placeholder=\"Confirm your password\" fl-repeat-password=\"password\" required>\n" +
    "                    <p class=\"alert-error\" ng-if=\"signupform.confirmPassword.$touched || signupform.$submitted\" ng-messages=\"signupform.confirmPassword.$error\">\n" +
    "                        <span ng-message=\"required\">Please re-enter your password to confirm it</span>\n" +
    "                        <span ng-message=\"repeat\">Passwords do not match!</span>\n" +
    "                    </p>\n" +
    "                </li>\n" +
    "                <li class=\"Form-step\" align=\"center\">\n" +
    "                    <div class=\"AuthForm-captcha\" ng-model=\"user.captcha\" vc-recaptcha name=\"captcha\" required></div>\n" +
    "                    <p class=\"alert-error\" ng-if=\"signupform.captcha.$touched || signupform.$submitted\" ng-messages=\"signupform.captcha.$error\">\n" +
    "                        <span ng-message=\"required\">Capthca is missing!</span>\n" +
    "                    </p>\n" +
    "                </li>\n" +
    "                <li class=\"Form-step\" align=\"center\">\n" +
    "                    <div class=\"clearfix\"></div>\n" +
    "                    <input type=\"submit\" ng-hide=1 ng-if=\"config.submitOnBlur\">\n" +
    "                    <button class=\"Btn\" type=\"submit\" ng-if=\"!config.submitOnBlur\">Signup</button>\n" +
    "                </li>\n" +
    "            </ol>\n" +
    "\n" +
    "        </form>\n" +
    "        <form ng-if=\"choice == 'login'\" class=\"default-form form-login form-login-existing-user\" name=\"loginform\" ng-submit=\"loginform.$valid && loginSubmit(existinguser)\" form-locator novalidate>\n" +
    "            <ol class=\"Form-steps\">\n" +
    "                <li class=\"Form-step\">\n" +
    "                    <label class=\"form-label\" for=\"username\">Username:</label>\n" +
    "                    <input type=\"text\" name=\"username\" ng-blur=\"loginform.$valid && onBlurLogin(existinguser)\" ng-model=\"existinguser.username\" placeholder=\"Username\" required>\n" +
    "                    <p class=\"alert-error\" ng-if=\"loginform.username.$touched || loginform.$submitted\" ng-messages=\"loginform.username.$error\">\n" +
    "                        <span ng-message=\"required\">Please enter a username</span>\n" +
    "                    </p>\n" +
    "                </li>\n" +
    "                <li class=\"Form-step\">\n" +
    "                    <label class=\"form-label\" for=\"password\">Password:</label>\n" +
    "                    <input  type=\"password\" ng-blur=\"loginform.$valid && onBlurLogin(existinguser)\" ng-model=\"existinguser.password\" placeholder=\"Type a password\" name=\"password\" required>\n" +
    "                    <p class=\"alert-error\" ng-if=\"loginform.password.$touched || loginform.$submitted\" ng-messages=\"loginform.password.$error\">\n" +
    "                        <span ng-message=\"required\">Please type a password for your account</span>\n" +
    "                    </p>\n" +
    "                    <p class=\"alert-error\" ng-if=\"unknown_error\">\n" +
    "                        <span>An unknown error occured, please try again later.</span>\n" +
    "                    </p>\n" +
    "                    <p class=\"alert-error\" ng-if=\"login_error\">\n" +
    "                        <span ng-if=\"login_error == 'exceeded'\">You have exceeded the maximum number of login attempts, please try again in 15 minutes</span>\n" +
    "                        <span ng-if=\"login_error == 'failed'\">Your username or password is incorrect</span>\n" +
    "                    </p>\n" +
    "                </li>\n" +
    "                <li class=\"Form-step\" align=\"center\">\n" +
    "                    <div class=\"clearfix\"></div>\n" +
    "                    <input type=\"submit\" ng-hide=1 ng-if=\"config.submitOnBlur\">\n" +
    "                    <button class=\"Btn\" type=\"submit\" ng-if=\"!config.submitOnBlur\">Login</button>\n" +
    "                </li>\n" +
    "            </ol>\n" +
    "        </form>\n" +
    "    </div>\n" +
    "</div>"
  );


  $templateCache.put('/views/warrior/loginmodal.html',
    "<div class=\"wf-modal-header\" fl-analytics-section=\"wf-login-modal\">\n" +
    "    <a ng-if=\"options.closable\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\" fl-analytics=\"close\">&times;</a>\n" +
    "    <h1 class=\"wf-modal-title\" ng-if=\"step!='notice'\">Login to Warrior Forum</h1>\n" +
    "</div>\n" +
    "<div class=\"wf-modal-body\" fl-analytics-section=\"wf-login-modal\">\n" +
    "    <form role=\"form\" class=\"form wf-signup\" name=\"loginform\"  method=\"post\" novalidate ng-submit=\"loginform.$valid && submit(user)\" form-locator>\n" +
    "        <fieldset>\n" +
    "            <ol>\n" +
    "                <li class=\"wf-form-group\">\n" +
    "                    <label class=\"wf-form-label\" for=\"username\">Name</label>\n" +
    "                    <span class=\"icon-wf-user\">\n" +
    "                        <input class=\"wf-input\" type=\"text\" name=\"username\" ng-model=\"user.username\" placeholder=\"Username\" id=\"username\" required>\n" +
    "                    </span>\n" +
    "                    <p class=\"wf-alert-error\" ng-if=\"loginform.username.$touched || loginform.$submitted\" ng-messages=\"loginform.username.$error\">\n" +
    "                        <span ng-message=\"required\">Please enter a username</span>\n" +
    "                    </p>\n" +
    "                </li>\n" +
    "                <li class=\"wf-form-group\">\n" +
    "                    <label class=\"wf-form-label\" for=\"password\">Password</label>\n" +
    "                    <span class=\"icon-wf-pass\">\n" +
    "                        <input class=\"wf-input\" type=\"password\" ng-model=\"user.password\" placeholder=\"Type a password\" name=\"password\" id=\"password\" required>\n" +
    "                    </span>\n" +
    "                    <p class=\"wf-alert-error\" ng-if=\"loginform.password.$touched || loginform.$submitted\" ng-messages=\"loginform.password.$error\">\n" +
    "                        <span ng-message=\"required\">Please type a password for your account</span>\n" +
    "                    </p>\n" +
    "                    <p class=\"wf-alert-error\" ng-if=\"unknown_error\">\n" +
    "                        <span>An unknown error occured, please try again later.</span>\n" +
    "                    </p>\n" +
    "                    <p class=\"wf-alert-error\" ng-if=\"login_error\">\n" +
    "                      <span ng-if=\"login_error == 'exceeded' || remaining_strikes == 0\">You have exceeded the maximum number of login attempts, please try again in 15 minutes</span>\n" +
    "                      <span ng-if=\"login_error == 'failed' && remaining_strikes > 0\">\n" +
    "                        Your username or password is incorrect.\n" +
    "                        <span ng-if=\"remaining_strikes > 0\" ng-pluralize count=\"remaining_strikes\" when=\"{'one': '1 attempt remaining.', 'other': '{} attempts remaining.' }\"></span>\n" +
    "                      </span>\n" +
    "                    </p>\n" +
    "                </li>\n" +
    "            </ol>\n" +
    "        </fieldset>\n" +
    "        <div class=\"signup-cta\">\n" +
    "            <button class=\"wf-btn btn-primary\" fl-analytics=\"login\" type=\"submit\">Login</button>\n" +
    "            <a href=\"{{fbLoginUrl}}\" class=\"wf-btn btn-primary\" fl-analytics=\"login\" type=\"submit\">FB Login</a>\n" +
    "        </div>\n" +
    "    </form>\n" +
    "</div>\n" +
    "<div class=\"wf-modal-footer\" fl-analytics-section=\"wf-login-modal\">\n" +
    "    <p class=\"wf-modal-footer-text\">Don't have an account? <a fl-analytics=\"signup\" ng-click=\"signup(options)\">Sign up</a></p>\n" +
    "    <p class=\"wf-modal-footer-text\"><a ng-click=\"forgotpassword(options)\">Forgot password?</a></p>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/warrior/NewsletterSubscriptionModal.html',
    "<div ng-multi-template='/views/warrior/SignupModalBase.html'>\n" +
    "<span name=\"header\">\n" +
    "    <h1 class=\"wf-modal-title\" ng-if=\"step!='notice'\">Thank you for signing up to Warrior Forum. You're only one step away from the full Warrior Forum experience</h1>\n" +
    "</span>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/warrior/nibiru/_billing_payment_step.html',
    "<div class=\"PaymentModal-account\" ng-show=\"referenceAccount.type == 'Stripe'\" fl-analytics-subsection=\"billing-page\">\n" +
    "    <div class=\"PaymentModal-paymentDetail\">\n" +
    "        <span class=\"PaymentModal-paymentDetail-text\">{{ referenceAccount.name }}</span>\n" +
    "        <!-- <span class=\"PaymentMethod\">\n" +
    "            <span class=\"PaymentMethod-icon PaymentMethod-icon--large\">\n" +
    "                <wf-icon src=\"visa\"></wf-icon>\n" +
    "            </span>\n" +
    "        </span> -->\n" +
    "    </div>\n" +
    "    <a class=\"PaymentModal-editLink\"\n" +
    "        ng-click=\"removeStripeBillingAccount()\"\n" +
    "        fl-analytics=\"remove-credit-card\">Remove card</a>\n" +
    "\n" +
    "    <button class=\"PaymentModal-btn Btn Btn--large\"\n" +
    "        ng-click=\"payWithBillingAgreement(item, referenceAccount)\"\n" +
    "        ng-class=\"{'is-processing': processing}\"\n" +
    "        fl-analytics=\"purchase-by-credit-card\">Purchase Now</button>\n" +
    "    <div class=\"PaymentModal-coupon\" ng-show=\"state.couponEnabled && !state.couponApplied\">\n" +
    "        <a class=\"PaymentModal-couponLink\" ng-click=\"enterCoupon()\">Enter Coupon Code</a>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"PaymentModal-account\" ng-show=\"referenceAccount.type == 'PayPal'\" fl-analytics-subsection=\"billing-page\">\n" +
    "    <a class=\"PaypalBtn\"\n" +
    "        ng-click=\"payWithBillingAgreement(item, referenceAccount)\"\n" +
    "        ng-class=\"{'is-processing': processing}\"\n" +
    "        fl-analytics=\"purchase-by-paypal\">\n" +
    "        <span class=\"PaypalBtn-icon\"><wf-icon src=\"paypal\"></wf-icon></span>\n" +
    "        <!-- <span class=\"PaypalBtn-text\">{{ referenceAccount.name }}</span> -->\n" +
    "    </a>\n" +
    "    <div class=\"PaymentModal-coupon\" ng-show=\"state.couponEnabled && !state.couponApplied\">\n" +
    "        <a class=\"PaymentModal-couponLink\" ng-click=\"enterCoupon()\">Enter Coupon Code</a>\n" +
    "    </div>\n" +
    "    <a class=\"PaymentModal-editLink\"\n" +
    "        ng-click=\"removePaypalBillingAccount()\"\n" +
    "        fl-analytics=\"remove-paypal-account\">Remove PayPal Account</a>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/warrior/nibiru/_coupon_step.html',
    "<form class=\"Form\">\n" +
    "    <fieldset class=\"Form-fieldset\">\n" +
    "        <ol class=\"Form-steps\">\n" +
    "            <li class=\"Form-step Form-step--verify\" ng-class=\"{'is-invalid': state.validCoupon === false}\">\n" +
    "                <input class=\"Input Input--large\" type=\"text\" name=\"coupon_code\" placeholder=\"Your code here\"\n" +
    "                    ng-model=\"item.couponCode\"\n" +
    "                    ng-change=\"verifyCouponCode()\" />\n" +
    "                <div class=\"Form-step--verify-icon\" ng-show=\"state.validCoupon\" ng-cloak>\n" +
    "                    <wf-icon src=\"check\"></wf-icon>\n" +
    "                </div>\n" +
    "                <div class=\"Loader Loader--small\" ng-show=\"state.verifyingCode\" ng-cloak></div>\n" +
    "                <div class=\"Form-errorMsg\" ng-show=\"state.validCoupon === false\" ng-cloak>\n" +
    "                    Promo code not valid!\n" +
    "                </div>\n" +
    "            </li>\n" +
    "            <li class=\"Form-step\">\n" +
    "                <button class=\"Btn Btn--wide\"\n" +
    "                    ng-click=\"applyCouponCode()\"\n" +
    "                    ng-class=\"{'is-processing': processing}\"\n" +
    "                    ng-disabled=\"isCouponButtonDisabled()\"\n" +
    "                    fl-analytics=\"apply-coupon\">Apply\n" +
    "                </button>\n" +
    "                <div class=\"PaymentModal-coupon\">\n" +
    "                    <a class=\"PaymentModal-couponLink\" ng-click=\"backToPayment()\">No, I don't have one</a>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "        </ol>\n" +
    "    </fieldset>\n" +
    "</form>\n"
  );


  $templateCache.put('/views/warrior/nibiru/_initial_step.html',
    "<div class=\"ContentNav\" fl-analytics-subsection=\"initial-page\">\n" +
    "    <ul class=\"ContentNav-tabs\">\n" +
    "        <li class=\"ContentNav-tabs-item\">\n" +
    "            <a class=\"ContentNav-tabs-link\"\n" +
    "                ng-class=\"{'is-ContentNav-tabs-link-active': paymentchoice == 'stripe'}\"\n" +
    "                ng-hide=\"disableStripe\"\n" +
    "                ng-click=\"toggleChoice('stripe')\"\n" +
    "                fl-analytics=\"stripe-nav\">Credit Card</a>\n" +
    "        </li>\n" +
    "        <li class=\"ContentNav-tabs-item\">\n" +
    "            <a class=\"ContentNav-tabs-link\"\n" +
    "                ng-class=\"{'is-ContentNav-tabs-link-active': paymentchoice == 'paypal'}\"\n" +
    "                ng-click=\"toggleChoice('paypal')\"\n" +
    "                ng-hide=\"paypalDisabled\"\n" +
    "                fl-analytics=\"paypal-nav\">PayPal</a>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "\n" +
    "    <form class=\"ContentNav-tabContent Form\" novalidate\n" +
    "        role=\"form\"\n" +
    "        stripe-form=\"handleStripe\"\n" +
    "        name=\"stripeform\"\n" +
    "        ng-show=\"paymentchoice == 'stripe'\"\n" +
    "        fl-analytics=\"credit-card-form\">\n" +
    "        <fieldset class=\"PaymentModal-fieldset Form-fieldset CreditCardForm\">\n" +
    "            <ol class=\"Form-steps\">\n" +
    "                <li class=\"Form-step\">\n" +
    "                    <label class=\"CreditCardForm-label Form-label\" for=\"cc-number\">Card Number</label>\n" +
    "                    <input type=\"text\" required\n" +
    "                        name=\"card\"\n" +
    "                        id=\"cc-number\"\n" +
    "                        class=\"CreditCardForm-cardNumber Input--large\"\n" +
    "                        placeholder=\"XXXX - XXXX - XXXX - XXXX\"\n" +
    "                        payments-format=\"card\"\n" +
    "                        payments-validate=\"card\"\n" +
    "                        ng-model=\"number\"\n" +
    "                        ng-change=\"clearError()\"\n" +
    "                        fl-analytics=\"enter-credit-card-number\">\n" +
    "                        <div class=\"form-error-message\"\n" +
    "                            ng-if=\"(stripeform.card.$touched || stripeform.$submitted) && stripeform.card.$invalid\"\n" +
    "                            ng-messages=\"stripeform.card.$error\">\n" +
    "                            <span ng-message=\"required\">Please input your card number</span>\n" +
    "                            <span ng-message=\"card\">Invalid card</span>\n" +
    "                        </div>\n" +
    "                        <div class=\"form-error-message\" ng-show=\"stripeError\">\n" +
    "                            {{stripeError}}\n" +
    "                        </div>\n" +
    "                </li>\n" +
    "                <li class=\"CreditCardForm-inputGroup Form-step Form-step--group\">\n" +
    "                    <div class=\"Form-step-column\">\n" +
    "                        <label for=\"cc-exp\" class=\"CreditCardForm-label Form-label\">EXP Date</label>\n" +
    "                        <span class=\"InputGroup\">\n" +
    "                            <input type=\"text\" required\n" +
    "                                name=\"cc-exp\"\n" +
    "                                id=\"cc-exp\"\n" +
    "                                class=\"CreditCardForm-dateInput\"\n" +
    "                                placeholder=\"MM/YY\"\n" +
    "                                maxlength=\"7\"\n" +
    "                                payments-validate=\"expiry\"\n" +
    "                                payments-format=\"expiry\"\n" +
    "                                ng-model=\"expiry\"\n" +
    "                                autocomplete=\"cc-exp\"\n" +
    "                                ng-change=\"clearError()\"\n" +
    "                                fl-analytics=\"enter-credit-card-expiry\">\n" +
    "                        </span>\n" +
    "                        <div class=\"form-error-message\"\n" +
    "                            ng-if=\"(stripeform.expiry.$touched || stripeform.$submitted) && stripeform.expiry.$invalid\"\n" +
    "                            ng-messages=\"stripeform.expiry.$error\">\n" +
    "                            <span ng-message=\"required\">Please input your card expiry date</span>\n" +
    "                            <span ng-message=\"expiry\">Invalid date</span>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"Form-step-column\">\n" +
    "                        <label for=\"cvc\" class=\"CreditCardForm-label Form-label\">CVC</label>\n" +
    "                        <input type=\"text\" required\n" +
    "                            name=\"cvc\"\n" +
    "                            id=\"cvc\"\n" +
    "                            class=\"CreditCardForm-cvcInput\"\n" +
    "                            placeholder=\"XXX\"\n" +
    "                            maxlength=\"4\"\n" +
    "                            payments-validate=\"cvc\"\n" +
    "                            payments-format=\"cvc\"\n" +
    "                            payments-type-model=\"type\"\n" +
    "                            ng-model=\"cvc\"\n" +
    "                            ng-change=\"clearError()\"\n" +
    "                            fl-analytics=\"enter-credit-card-cvc\">\n" +
    "                        <div class=\"form-error-message\"\n" +
    "                            ng-if=\"(stripeform.cvc.$touched || stripeform.$submitted) && stripeform.cvc.$invalid\"\n" +
    "                            ng-messages=\"stripeform.cvc.$error\">\n" +
    "                            <span ng-message=\"required\">Please input your card cvc</span>\n" +
    "                            <span ng-message=\"cvc\">Invalid CVC</span>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "                <li class=\"Form-step\">\n" +
    "                    <div class=\"CreditCardForm-vendors Form-step-column\">\n" +
    "                        <ul class=\"PaymentMethod\">\n" +
    "                            <li class=\"PaymentMethod-icon\">\n" +
    "                                <wf-icon src=\"visa\"></wf-icon>\n" +
    "                            </li>\n" +
    "                            <li class=\"PaymentMethod-icon\">\n" +
    "                                <wf-icon src=\"mastercard\"></wf-icon>\n" +
    "                            </li>\n" +
    "                            <li class=\"PaymentMethod-icon\">\n" +
    "                                <wf-icon src=\"amex\"></wf-icon>\n" +
    "                            </li>\n" +
    "                        </ul>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "            </ol>\n" +
    "        </fieldset>\n" +
    "        <button class=\"PaymentModal-btn Btn\"\n" +
    "            type=\"submit\"\n" +
    "            ng-click=\"clickPurchase()\"\n" +
    "            ng-class=\"{'is-processing': processing}\"\n" +
    "            ng-hide=\"processing\"\n" +
    "            fl-analytics=\"add-new-card\">Purchase now</button>\n" +
    "        <div class=\"PaymentModal-coupon\" ng-show=\"state.couponEnabled && !state.couponApplied\">\n" +
    "            <a class=\"PaymentModal-couponLink\" ng-click=\"enterCoupon()\">Enter Coupon Code</a>\n" +
    "        </div>\n" +
    "        <wf-payment-choice-auto-bump item=\"{{ item }}\"></wf-payment-choice-auto-bump>\n" +
    "        <!--\n" +
    "        <input type=\"checkbox\" class=\"Checkbox\" id=\"test-checkbox3\">\n" +
    "        <label for=\"test-checkbox3\" class=\"PaymentModal-checkbox\n" +
    "        Checkbox\">\n" +
    "            <span class=\"Checkbox-text\">Make this as default payment</span>\n" +
    "        </label>\n" +
    "        -->\n" +
    "    </form>\n" +
    "\n" +
    "    <form class=\"ContentNav-tabContent\" ng-show=\"paymentchoice == 'paypal'\">\n" +
    "        <fieldset class=\"PaymentModal-fieldset\">\n" +
    "            <figure class=\"PaymentModal-figure\">\n" +
    "                <img src=\"https://static.warriorforum.com/static/images/paypal_screenshot.1a5f0f7c.png\" alt=\"Paypal screenshot\" class=\"PaymentModal-screenshot\">\n" +
    "            </figure>\n" +
    "            <aside class=\"PaymentModal-warning Alert Alert--warning\">A new window will open asking you to complete payment using PayPal</aside>\n" +
    "            <a class=\"PaypalBtn PaypalBtn--small\"\n" +
    "                target=\"_blank\"\n" +
    "                ng-click=\"selectPaypal()\"\n" +
    "                ng-class=\"{'is-processing': processing}\"\n" +
    "                fl-analytics=\"add-new-paypal\">\n" +
    "                <span class=\"PaypalBtn-text\">Check out with</span>\n" +
    "                <span class=\"PaypalBtn-icon\">\n" +
    "                    <wf-icon src=\"paypal\"></wf-icon>\n" +
    "                </span>\n" +
    "            </a>\n" +
    "            <div class=\"PaymentModal-coupon\" ng-show=\"state.couponEnabled && !state.couponApplied\">\n" +
    "                <a class=\"PaymentModal-couponLink\" ng-click=\"enterCoupon()\">Enter Coupon Code</a>\n" +
    "            </div>\n" +
    "            <wf-payment-choice-auto-bump item=\"{{ item }}\"></wf-payment-choice-auto-bump>\n" +
    "            <!--\n" +
    "            <input type=\"checkbox\" class=\"Checkbox\" id=\"test-checkbox\">\n" +
    "            <label for=\"test-checkbox1\" class=\"PaymentModal-checkbox\n" +
    "            Checkbox\">\n" +
    "                <span class=\"Checkbox-text\">Make this as default payment</span>\n" +
    "            </label>\n" +
    "            -->\n" +
    "        </fieldset>\n" +
    "    </form>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/warrior/nibiru/confirmation_modal.html',
    "<header class=\"ModalV2-header\">\n" +
    "    <h3 class=\"ModalV2-headerTitle\">\n" +
    "        {{$ctrl.options.modalTitle}}\n" +
    "    </h3>\n" +
    "</header>\n" +
    "<div class=\"ModalV2-body\">\n" +
    "    <p class=\"ModalV2-bodyTitle\">\n" +
    "        {{$ctrl.options.contentTitle}}\n" +
    "    </p>\n" +
    "    <p class=\"ModalV2-bodyDesc\">\n" +
    "        {{$ctrl.options.content}}\n" +
    "    </p>\n" +
    "</div>\n" +
    "<footer class=\"ModalV2-footer\">\n" +
    "    <div class=\"ModalV2-footerWrapper\">\n" +
    "        <div class=\"ModalV2-action\">\n" +
    "            <div class=\"ModalV2-actionItem\">\n" +
    "                <button class=\"Btn Btn--small\" ng-click=\"$ctrl.choosePositive()\">{{$ctrl.options.positiveCTA}}</button>\n" +
    "            </div>\n" +
    "            <div class=\"ModalV2-actionItem\">\n" +
    "                <a class=\"Btn Btn--small Btn--ghost Btn--tone\" ng-click=\"$ctrl.chooseNegative()\">{{$ctrl.options.negativeCTA}}</a>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</footer>\n" +
    "<span class=\"ModalV2-close\" ng-click=\"$ctrl.dismissModal()\">\n" +
    "    <wf-icon src=\"close\" ></wf-icon>\n" +
    "</span>\n"
  );


  $templateCache.put('/views/warrior/nibiru/modalV2_template.html',
    "<div class=\"Nibiru\">\n" +
    "  <div class=\"ModalV2\" uib-modal-transclude>\n" +
    "  </div>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/warrior/nibiru/payment_modal_startcon.html',
    "<div class=\"Nibiru\" fl-analytics-section=\"wf-payment-nibiru-modal\" wf-deep-blur=\"cancel()\">\n" +
    "    <div class=\"PaymentModal Modal\" ng-if=\"step == 'loading'\">\n" +
    "        <div class=\"Modal-loaderContainer\" >\n" +
    "            <div class=\"Loader Loader--large\">Loading...</div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "\n" +
    "    <div class='PaymentModal-Overlay' ng-show=\"processing\">\n" +
    "        <div class=\"spinner\"></div>\n" +
    "        <h1>Processing payment </h1>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"PaymentModal Modal\" ng-if=\"step != 'paid' && step != 'loading'\">\n" +
    "        <span class=\"PaymentModal-price\">${{ item.fixedChargeItemAmount | number:2 }}</span>\n" +
    "        <span class=\"PaymentModal-icon PaymentModal-icon--startcon\">\n" +
    "            <wf-icon src=\"startcon-logo\"></wf-icon>\n" +
    "        </span>\n" +
    "        <h4 class=\"PaymentModal-title\">{{ item.fixedChargeItemName }}</h4>\n" +
    "        <p class=\"PaymentModal-desc\">{{ item.fixedChargeItemDescription }}</p>\n" +
    "        <ng-include src=\"'/views/warrior/nibiru/_initial_step.html'\" ng-show=\"step == 'initial'\"></ng-include>\n" +
    "        <ng-include src=\"'/views/warrior/nibiru/_billing_payment_step.html'\" ng-show=\"step == 'billingPaymentPage'\"></ng-include>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"PaymentModal Modal\" ng-if=\"step == 'paid' && step != 'loading'\" fl-analytics-subsection=\"paid-page\">\n" +
    "        <span class=\"PaymentModal-icon\">\n" +
    "            <wf-icon src=\"check\"></wf-icon>\n" +
    "        </span>\n" +
    "        <h4 class=\"PaymentModal-title\">Thank you!</h4>\n" +
    "        <p class=\"PaymentModal-desc\">Payment Successful</p>\n" +
    "        <button class=\"PaymentModal-btn Btn\"\n" +
    "            data-dismiss=\"modal\"\n" +
    "            ng-click=\"cancel()\"\n" +
    "            fl-analytics=\"close-modal\">Close</button>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"PaymentModal Modal\" ng-if=\"step == 'error'\" fl-analytics-subsection=\"error-page\">\n" +
    "        <span class=\"PaymentModal-icon\">\n" +
    "            <wf-icon src=\"warrior-logo-small--dark\"></wf-icon>\n" +
    "        </span>\n" +
    "        <h4 class=\"PaymentModal-title\">Sorry!</h4>\n" +
    "        <p class=\"PaymentModal-desc\">{{ errorMessage }}</p>\n" +
    "        <button class=\"PaymentModal-btn Btn\"\n" +
    "            data-dismiss=\"modal\"\n" +
    "            ng-click=\"addNewPaymentMethod()\"\n" +
    "            fl-analytics=\"try-again\">Try again</button>\n" +
    "    </div>\n" +
    "    <tmh/>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/warrior/nibiru/payment_modal.html',
    "<div class=\"Nibiru\" fl-analytics-section=\"wf-payment-nibiru-modal\" wf-deep-blur=\"cancel()\">\n" +
    "    <div class=\"PaymentModal Modal\" ng-if=\"step == 'loading'\">\n" +
    "        <div class=\"Modal-loaderContainer\" >\n" +
    "            <div class=\"Loader Loader--large\">Loading...</div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"PaymentModal Modal\" ng-if=\"step != 'paid' && step != 'loading'\">\n" +
    "        <span class=\"PaymentModal-price\">${{ item.fixedChargeItemAmount | number:2 }}</span>\n" +
    "        <span class=\"PaymentModal-price PaymentModal-price--discounted\" ng-show=\"state.couponEnabled && state.couponApplied\" ng-cloak>Discounted</span>\n" +
    "        <span class=\"PaymentModal-icon\">\n" +
    "            <wf-icon src=\"{{ itemIcon(item.fixedChargeItemType) }}\"></wf-icon>\n" +
    "        </span>\n" +
    "        <h4 class=\"PaymentModal-title\">{{ item.fixedChargeItemName }}</h4>\n" +
    "        <p class=\"PaymentModal-desc\">{{ item.fixedChargeItemDescription }}</p>\n" +
    "        <ng-include src=\"'/views/warrior/nibiru/_coupon_step.html'\" ng-show=\"step == 'coupon'\"></ng-include>\n" +
    "        <ng-include src=\"'/views/warrior/nibiru/_initial_step.html'\" ng-show=\"step == 'initial'\"></ng-include>\n" +
    "        <ng-include src=\"'/views/warrior/nibiru/_billing_payment_step.html'\" ng-show=\"step == 'billingPaymentPage'\"></ng-include>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"PaymentModal Modal\" ng-if=\"step == 'paid' && step != 'loading'\" fl-analytics-subsection=\"paid-page\">\n" +
    "        <span class=\"PaymentModal-icon\">\n" +
    "            <wf-icon src=\"check\"></wf-icon>\n" +
    "        </span>\n" +
    "        <h4 class=\"PaymentModal-title\">Thank you!</h4>\n" +
    "        <p class=\"PaymentModal-desc\">Payment Successful</p>\n" +
    "        <button class=\"PaymentModal-btn Btn\"\n" +
    "            data-dismiss=\"modal\"\n" +
    "            ng-click=\"cancel()\"\n" +
    "            fl-analytics=\"close-modal\">Close</button>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"PaymentModal Modal\" ng-if=\"step == 'error'\" fl-analytics-subsection=\"error-page\">\n" +
    "        <span class=\"PaymentModal-icon\">\n" +
    "            <wf-icon src=\"warrior-logo-small--dark\"></wf-icon>\n" +
    "        </span>\n" +
    "        <h4 class=\"PaymentModal-title\">Sorry!</h4>\n" +
    "        <p class=\"PaymentModal-desc\">{{ errorMessage }}</p>\n" +
    "        <button class=\"PaymentModal-btn Btn\"\n" +
    "            data-dismiss=\"modal\"\n" +
    "            ng-click=\"addNewPaymentMethod()\"\n" +
    "            fl-analytics=\"try-again\">Try again</button>\n" +
    "    </div>\n" +
    "    <tmh/>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/warrior/onboarding.html',
    "<div class=\"default-modal-content\" ng-if=\"pageNumber == 0\">\n" +
    "    <div ng-controller=\"onboardTopicsToLearnCtrl\">\n" +
    "        <h3>What topics do you want to learn more about?</h3>\n" +
    "        <ul>\n" +
    "            <li>\n" +
    "                <span><strong>Selected Topic</strong></span>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "                <span>UnSelected Topic</span>\n" +
    "            </li>\n" +
    "            <li ng-repeat=\"topic in topics\" ng-click=\"selectTopic($index)\">\n" +
    "                <span ng-if=\"topic.selected\"><strong>{{topic.name}}</strong></span>\n" +
    "                <span ng-if=\"!topic.selected\">{{topic.name}}</span>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"default-modal-content\" ng-show=\"pageNumber == 1\">\n" +
    "    <div ng-controller=\"onboardUploadPhotoCtrl\">\n" +
    "        <h3>Upload your profile image</h3>\n" +
    "        <div class=\"file-input-area\">\n" +
    "            <span class=\"btn btn-secondary btn-xxsmall file-input-btn\">\n" +
    "        <span class=\"icon-plus\"></span>\n" +
    "            <span>Add image</span>\n" +
    "            <input class=\"file-input-upload\" type=\"file\" id=\"fileInput\" name=\"WSO-file-upload\" name=\"file\" nv-file-select uploader=\"uploader\" options=\"uploadOptions\">\n" +
    "            </span>\n" +
    "        </div>\n" +
    "        <div class=\"form-progress-wrapper\" ng-repeat=\"file in uploader.queue\">\n" +
    "            <div class=\"form-progress progress\">\n" +
    "                <div class=\"progress-bar\" role=\"progressbar\" fl-progress-bar=\"file.progress\" style=\"width: {{file.progress}}\">\n" +
    "                    {{file.file.name}}: {{file.progress}}%\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"form-progress-icons\">\n" +
    "                <button class=\"btn btn-plain btn-xsmall btn-progress-bar\" type=\"button\" ng-click=\"file.cancel()\" ng-show=\"file.isUploading\">\n" +
    "                    <span class=\"icon-cross action\"></span>\n" +
    "                </button>\n" +
    "                <button class=\"btn btn-plain btn-xsmall btn-progress-bar\" type=\"button\" ng-click=\"remove_new_file(file);\" ng-show=\"!file.isUploading\">\n" +
    "                    <span class=\"icon-trash action\"></span>\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <img src=\"{{img_url}}\" ng-if=\"img_url\">\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"default-modal-content\" ng-if=\"pageNumber == 2\">\n" +
    "    <div ng-controller=\"onboardTopicsOfExpertiseCtrl\">\n" +
    "        <h3>What topics are you an expert in?</h3>\n" +
    "        <ul>\n" +
    "            <li ng-repeat=\"topic in topics\" ng-click=\"selectTopic($index)\">\n" +
    "                <span ng-if=\"topic.selected\"><strong>{{topic.name}}</strong></span>\n" +
    "                <span ng-if=\"!topic.selected\">{{topic.name}}</span>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"default-modal-content\" ng-if=\"pageNumber == 3\">\n" +
    "    <div ng-controller=\"onboardWarRoomCtrl\">\n" +
    "        <h3>Join the War Room</h3> As a new member of Warrior Forum join over 30,000 members at the War-Room\n" +
    "        <a href=\"http://www.warriorforum.com/war-room/join\" class=\"btn btn-primary\" target=\"_blank\">Learn more about the War Room</a>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<button class=\"btn btn-primary\" ng-click=\"cancel()\">Later</button>\n" +
    "<button class=\"btn btn-primary\" ng-click=\"next()\" ng-if=\"pageNumber < 3\">Continue</button>\n"
  );


  $templateCache.put('/views/warrior/paymentchoiceautobump.html',
    "<div class=\"auto-bump-section\" ng-if=\"(item.fixedChargeItemType === 'bump' || item.fixedChargeItemType === 'new') && !item.hasAutoBump\">\n" +
    "    <input id=\"auto-bump\" type=\"checkbox\" ng-model=\"item.isAutoBump\" class=\"Checkbox\">\n" +
    "    <label class=\"Checkbox auto-bump-label\" for=\"auto-bump\">\n" +
    "        <span class=\"Checkbox-text\">Automatically bump my WSO when it falls off the first page.</span>\n" +
    "    </label>\n" +
    "</div>\n" +
    "<div ng-if=\"item.hasAutoBump\" class=\"auto-bump-section bumped-info\">This thread is set to auto bump when it falls off the first page</div>\n"
  );


  $templateCache.put('/views/warrior/paymentchoicemodal.html',
    "<div class=\"default-modal-header\" fl-analytics-section=\"wf-paymentpage-grey-modal\">\n" +
    "    <button class=\"default-modal-close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\" fl-analytics-subsection=\"header\" fl-analytics=\"close\">&times;</button>\n" +
    "    <div class=\"default-modal-logo\"></div>\n" +
    "    <h1 class=\"default-modal-title\">\n" +
    "        {{item.fixedChargeItemName}}\n" +
    "        <span class=\"item-price\"><span ng-if=\"item.fixedChargeItemAmount\">$</span>{{item.fixedChargeItemAmount | number:2}}</span>\n" +
    "    </h1>\n" +
    "</div>\n" +
    "<div class=\"default-modal-body\" fl-analytics-section=\"wf-paymentpage-grey-modal\">\n" +
    "    <form class=\"form default-form\" novalidate role=\"form\" stripe-form=\"handleStripe\" name=\"stripeform\" ng-if=\"step=='initial'\">\n" +
    "        <div class=\"form-group radio-group\">\n" +
    "            <div class=\"radio-group-item\" ng-click=\"paymentchoice='stripe'\">\n" +
    "                <input type=\"radio\" name=\"paymentmethod\" class=\"radio-group-option\" ng-disabled=\"disableStripe\">\n" +
    "                <label class=\"radio-label\">\n" +
    "                    <span class=\"radio-image default-modal-credit-card-colour\"></span>\n" +
    "                    <span class=\"radio-image-disabled default-modal-credit-card-disabled\"></span>\n" +
    "                    Pay with <br> Credit Card\n" +
    "                </label>\n" +
    "            </div>\n" +
    "            <div class=\"radio-group-item\" ng-click=\"paymentchoice='paypal'\">\n" +
    "                <input type=\"radio\" name=\"paymentmethod\" class=\"radio-group-option\" checked=\"\">\n" +
    "                <label class=\"radio-label\">\n" +
    "                    <span class=\"radio-image default-modal-paypal-white\"></span>\n" +
    "                    <span class=\"radio-image-disabled default-modal-paypal-disabled\"></span>\n" +
    "                    Pay with <br> PayPal\n" +
    "                </label>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"payment-modal-option\" ng-show=\"paymentchoice=='stripe'\">\n" +
    "            <ol class=\"form-fields\">\n" +
    "                <li class=\"form-group\">\n" +
    "                    <label class=\"form-label\">Your Credit Card Number</label>\n" +
    "                    <div class=\"input-group\">\n" +
    "                        <div class=\"input-group-addon\">\n" +
    "                            <span class=\"icon-wf-credit\"></span>\n" +
    "                        </div>\n" +
    "                        <input class=\"input-group-field\" type=\"text\" name=\"card\" ng-model=\"number\" placeholder=\"Valid Card Number\" required payments-validate=\"card\" payments-format=\"card\" ng-change=\"clearError()\">\n" +
    "                    </div>\n" +
    "                    <div class=\"form-error-message\" ng-if=\"(stripeform.card.$touched || stripeform.$submitted) && stripeform.card.$invalid\" ng-messages=\"stripeform.card.$error\">\n" +
    "                        <span ng-message=\"required\">Please input your card number</span>\n" +
    "                        <span ng-message=\"card\">Invalid card</span>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "                <li class=\"form-group form-card-expiry\">\n" +
    "                    <label class=\"form-label\">Expiry Date</label>\n" +
    "                    <div class=\"input-group\">\n" +
    "                        <div class=\"input-group-addon\">\n" +
    "                            <span class=\"icon-wf-date\"></span>\n" +
    "                        </div>\n" +
    "                        <input class=\"input-group-field\" type=\"text\" name=\"expiry\" placeholder=\"MM/YYYY\" ng-model=\"expiry\" required payments-validate=\"expiry\" payments-format=\"expiry\" ng-change=\"clearError()\">\n" +
    "                    </div>\n" +
    "                    <div class=\"form-error-message\" ng-if=\"(stripeform.expiry.$touched || stripeform.$submitted) && stripeform.expiry.$invalid\" ng-messages=\"stripeform.expiry.$error\">\n" +
    "                        <span ng-message=\"required\">Please input your card expiry date</span>\n" +
    "                        <span ng-message=\"expiry\">Invalid date</span>\n" +
    "                    </div>\n" +
    "                    <div class=\"form-error-message\" ng-if=\"stripeError\"><span>{{stripeError}}</span></div>\n" +
    "                </li>\n" +
    "                <li class=\"form-group form-card-cvc\">\n" +
    "                    <label class=\"form-label\">CVC Code</label>\n" +
    "                    <div class=\"input-group\">\n" +
    "                        <div class=\"input-group-addon\">\n" +
    "                            <span class=\"icon-wf-lock\"></span>\n" +
    "                        </div>\n" +
    "                        <input class=\"input-group-field\" type=\"text\" name=\"cvc\" payments-validate=\"cvc\" placeholder=\"CVC\" ng-model=\"cvc\" required payments-format=\"cvc\" payments-type-model=\"type\" ng-change=\"clearError()\">\n" +
    "                    </div>\n" +
    "                    <div class=\"form-error-message\" ng-if=\"(stripeform.cvc.$touched || stripeform.$submitted) && stripeform.cvc.$invalid\" ng-messages=\"stripeform.cvc.$error\">\n" +
    "                        <span ng-message=\"required\">Please input your card cvc</span>\n" +
    "                        <span ng-message=\"cvc\">Invalid CVC</span>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "            </ol>\n" +
    "            <button class=\"btn btn-large btn-full\" fl-analytics-subsection=\"initial-page\" ng-click=\"clickPurchase()\" fl-analytics=\"add-new-card\" ng-class=\"{'processing': processing}\">Pay <span ng-if=\"item.fixedChargeItemAmount\">$</span>{{item.fixedChargeItemAmount | number:2}}</button>\n" +
    "        </div>\n" +
    "        <div class=\"payment-modal-content payment-modal-option\" ng-show=\"paymentchoice=='paypal'\">\n" +
    "            <span alt=\"Pay with PayPal in a new window\" class=\"default-modal-paypal-screenshot payment-modal-image-preview\"></span>\n" +
    "            <div class=\"payment-modal-text\">A new window will open asking you to complete payment using PayPal.</div>\n" +
    "            <button ng-click=\"selectPaypal()\" class=\"btn btn-paypal\" ng-class=\"{'processing': processing}\">Check out with <span class=\"btn-paypal-logo default-modal-paypal-logo-simple\"></span></button>\n" +
    "        </div>\n" +
    "        <div class=\"auto-bump-container\">\n" +
    "            <wf-payment-choice-auto-bump item=\"{{item}}\"></wf-payment-choice-auto-bump>\n" +
    "        </div>\n" +
    "    </form>\n" +
    "    <div class=\"payment-modal-content\" ng-if=\"step=='billingPaymentPage'\" fl-analytics-section=\"wf-paymentpage-grey-modal\">\n" +
    "        <div><button class=\"btn\" ng-click=\"payWithBillingAgreement(item, referenceAccount)\" ng-class=\"{processing: processing}\" fl-analytics=\"purchase\" fl-analytics-subsection=\"billing-page\">Purchase</button></div>\n" +
    "        <p class=\"payment-modal-text\">with</p>\n" +
    "        <p class=\"payment-modal-text\"><strong>{{referenceAccount.name}}</strong></p>\n" +
    "        <p><a class=\"unlink-card\" ng-if=\"referenceAccount.type=='Stripe'\" ng-click=\"removeStripeBillingAccount()\">Remove Card</a></p>\n" +
    "        <wf-payment-choice-auto-bump item=\"{{item}}\"></wf-payment-choice-auto-bump>\n" +
    "        <p><button fl-analytics=\"add-new-method\" fl-analytics-subsection=\"billing-page\" ng-click=\"addNewPaymentMethod()\" class=\"btn btn-full\" ng-class=\"{processing: processing}\">Choose another payment method</button></p>\n" +
    "    </div>\n" +
    "    <div class=\"payment-modal-content\" ng-if=\"step=='paid'\">\n" +
    "        <p class=\"payment-modal-text\"><strong>You have paid successfully.</strong></p>\n" +
    "        <button class=\"btn\" ng-click=\"redirect()\">OK</button>\n" +
    "    </div>\n" +
    "    <div class=\"payment-modal-content\" ng-if=\"step=='error'\">\n" +
    "        <p>{{errorMessage}}</p>\n" +
    "        <button class=\"btn\" fl-analytics=\"try-again\" fl-analytics-subsection=\"try-again\" ng-click=\"addNewPaymentMethod()\">Please try it again</button>\n" +
    "    </div>\n" +
    "    <div ng-if=\"step == 'loading'\" class=\"is-loading modal-content-loading\"></div>\n" +
    "    <tmh/>\n" +
    "</div>\n" +
    "<div class=\"default-modal-footer\">\n" +
    "</div>\n"
  );


  $templateCache.put('/views/warrior/PaymentModal.html',
    "<!-- Payment Modal template with customizable header, use like this\n" +
    "\n" +
    "    <div ng-multi-template=\"/views/warrior/paymentmodal.html\">\n" +
    "        <span name=\"header\">\n" +
    "            Custom Header\n" +
    "        </span>\n" +
    "    </div>\n" +
    "-->\n" +
    "<div fl-analytics-section=\"wf-paymentpage-grey-modal\">\n" +
    "    <div class=\"default-modal-header\" fl-analytics-subsection=\"header\">\n" +
    "        <button class=\"default-modal-close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\" fl-analytics=\"close\">&times;</button>\n" +
    "        <span ng-multi-transclude=\"header\">\n" +
    "            <div class=\"default-modal-logo\"></div>\n" +
    "            <h1 class=\"default-modal-title\">\n" +
    "                {{item.fixedChargeItemName}}\n" +
    "                <span class=\"item-price\"><span ng-if=\"item.fixedChargeItemAmount\">$</span>{{item.fixedChargeItemAmount | number:2}}</span>\n" +
    "            </h1>\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div class=\"default-modal-body\">\n" +
    "        <form class=\"form default-form\" novalidate role=\"form\" stripe-form=\"handleStripe\" name=\"stripeform\" ng-if=\"step=='initial'\" fl-analytics-subsection=\"initial-page\">\n" +
    "            <div class=\"form-group radio-group\">\n" +
    "                <div class=\"radio-group-item\" ng-click=\"paymentchoice='stripe'\">\n" +
    "                    <input type=\"radio\" name=\"paymentmethod\" class=\"radio-group-option\" checked>\n" +
    "                    <label class=\"radio-label\">\n" +
    "                        <span class=\"radio-image default-modal-credit-card-colour\"></span>\n" +
    "                        <span class=\"radio-image-disabled default-modal-credit-card-disabled\"></span>\n" +
    "                        Pay with <br> Credit Card\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "                <div class=\"radio-group-item\" ng-click=\"paymentchoice='paypal'\">\n" +
    "                    <input type=\"radio\" name=\"paymentmethod\" class=\"radio-group-option\">\n" +
    "                    <label class=\"radio-label\">\n" +
    "                        <span class=\"radio-image default-modal-paypal-white\"></span>\n" +
    "                        <span class=\"radio-image-disabled default-modal-paypal-disabled\"></span>\n" +
    "                        Pay with <br> PayPal\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"payment-modal-option\" ng-show=\"paymentchoice=='stripe'\">\n" +
    "                <ol class=\"form-fields\">\n" +
    "                    <li class=\"form-group\" ng-if=\"show.email\">\n" +
    "                        <label class=\"form-label\">Your Email</label>\n" +
    "                        <div class=\"input-group\">\n" +
    "                            <div class=\"input-group-addon\">\n" +
    "                                <span class=\"icon-wf-email\"></span>\n" +
    "                            </div>\n" +
    "                            <input class=\"input-group-field\" type=\"text\" name=\"email\" ng-model=\"item.email\" placeholder=\"Email Address\" required fl-guardpost ng-change=\"clearError()\">\n" +
    "                        </div>\n" +
    "                        <div class=\"form-error-message\" ng-if=\"(stripeform.email.$touched || stripeform.$submitted) && stripeform.email.$invalid\" ng-messages=\"stripeform.email.$error\">\n" +
    "                            <span ng-message=\"required\">Please enter your email address</span>\n" +
    "                            <span ng-message=\"email\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                            <span ng-message=\"invalid\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                            <span ng-message=\"uniqueInvalid\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                            <span ng-message=\"format_incorrect\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                            <span ng-message=\"guardpost\">Invalid email address. <span ng-if=\"signupform.email.suggestion\">Did you mean {{signupform.email.suggestion }}? </span></span>\n" +
    "                            <span ng-message=\"unique\">Email already exists, please try a different email</span>\n" +
    "                            <span ng-message=\"used\">Email already exists, please try a different email</span>\n" +
    "                        </div>\n" +
    "                    </li>\n" +
    "                    <li class=\"form-group\">\n" +
    "                        <label class=\"form-label\">Your Credit Card Number</label>\n" +
    "                        <div class=\"input-group\">\n" +
    "                            <div class=\"input-group-addon\">\n" +
    "                                <span class=\"icon-wf-credit\"></span>\n" +
    "                            </div>\n" +
    "                            <input class=\"input-group-field\" type=\"text\" name=\"card\" ng-model=\"number\" placeholder=\"Valid Card Number\" required payments-validate=\"card\" payments-format=\"card\" ng-change=\"clearError()\">\n" +
    "                        </div>\n" +
    "                        <div class=\"form-error-message\" ng-if=\"(stripeform.card.$touched || stripeform.$submitted) && stripeform.card.$invalid\" ng-messages=\"stripeform.card.$error\">\n" +
    "                            <span ng-message=\"required\">Please input your card number</span>\n" +
    "                            <span ng-message=\"card\">Invalid card</span>\n" +
    "                        </div>\n" +
    "                    </li>\n" +
    "                    <li class=\"form-group form-card-expiry\">\n" +
    "                        <label class=\"form-label\">Expiry Date</label>\n" +
    "                        <div class=\"input-group\">\n" +
    "                            <div class=\"input-group-addon\">\n" +
    "                                <span class=\"icon-wf-date\"></span>\n" +
    "                            </div>\n" +
    "                            <input class=\"input-group-field\" type=\"text\" name=\"expiry\" placeholder=\"MM/YYYY\" ng-model=\"expiry\" required payments-validate=\"expiry\" payments-format=\"expiry\" ng-change=\"clearError()\">\n" +
    "                        </div>\n" +
    "                        <div class=\"form-error-message\" ng-if=\"(stripeform.expiry.$touched || stripeform.$submitted) && stripeform.expiry.$invalid\" ng-messages=\"stripeform.expiry.$error\">\n" +
    "                            <span ng-message=\"required\">Please input your card expiry date</span>\n" +
    "                            <span ng-message=\"expiry\">Invalid expiry, please enter the date with month and year separated by a \"space\"</span>\n" +
    "                        </div>\n" +
    "                        <div class=\"form-error-message\" ng-if=\"stripeError\"><span>{{stripeError}}</span></div>\n" +
    "                    </li>\n" +
    "                    <li class=\"form-group form-card-cvc\">\n" +
    "                        <label class=\"form-label\">CVC Code</label>\n" +
    "                        <div class=\"input-group\">\n" +
    "                            <div class=\"input-group-addon\">\n" +
    "                                <span class=\"icon-wf-lock\"></span>\n" +
    "                            </div>\n" +
    "                            <input class=\"input-group-field\" type=\"text\" name=\"cvc\" ng-model=\"cvc\" required ng-pattern=\"/^[0-9]{3,4}$/\" ng-maxlength=\"4\" maxlength=\"4\" ng-change=\"clearError()\">\n" +
    "                        </div>\n" +
    "                        <div class=\"form-error-message\" ng-if=\"(stripeform.cvc.$touched || stripeform.$submitted) && stripeform.cvc.$invalid\" ng-messages=\"stripeform.cvc.$error\">\n" +
    "                            <span ng-message=\"required\">Please input your card cvc</span>\n" +
    "                            <span ng-message=\"pattern\">Invalid CVC</span>\n" +
    "                        </div>\n" +
    "                    </li>\n" +
    "                </ol>\n" +
    "                <div class=\"payment-modal-pay-btn\">\n" +
    "                    <button class=\"btn btn-primary btn-full\" ng-click=\"clickPurchase()\" fl-analytics=\"pay-stripe\" ng-class=\"{'processing': processing}\">Pay <span ng-if=\"item.fixedChargeItemAmount\">$</span>{{item.fixedChargeItemAmount | number:2}}</button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"payment-modal-content payment-modal-option\" ng-show=\"paymentchoice=='paypal'\">\n" +
    "                <!-- <span alt=\"Pay with PayPal in a new window\" class=\"default-modal-paypal-screenshot payment-modal-image-preview\"></span> -->\n" +
    "                <div class=\"payment-modal-text\" style=\"color:#222\">A new window will open asking you to complete payment using PayPal.</div>\n" +
    "                <button ng-click=\"selectPaypal()\" fl-analytics=\"pay-paypal\" class=\"btn btn-paypal btn-full btn-primary\" ng-class=\"{'processing': processing}\">Check out with PayPal</button>\n" +
    "            </div>\n" +
    "\n" +
    "        </form>\n" +
    "        <div class=\"payment-modal-content\" ng-if=\"step=='billingPaymentPage'\" fl-analytics-subsection=\"billing-page\" >\n" +
    "            <div><button class=\"btn btn-full btn-primary processing\" ng-click=\"payWithBillingAgreement(item, referenceAccount)\" ng-class=\"{processing: processing}\">Purchase</button></div>\n" +
    "            <p class=\"payment-modal-text\">with</p>\n" +
    "            <p class=\"payment-modal-text\"><strong>{{referenceAccount.name}}</strong></p>\n" +
    "            <p><a class=\"unlink-card\" ng-if=\"referenceAccount.type=='Stripe'\" ng-click=\"removeStripeBillingAccount()\">Remove Card</a></p>\n" +
    "            <p><button fl-analytics=\"add-new-method\" ng-click=\"addNewPaymentMethod()\" class=\"btn btn-small btn-secondary\" ng-class=\"{processing: processing}\">Choose another payment method</button></p>\n" +
    "        </div>\n" +
    "        <div class=\"payment-modal-content\" ng-if=\"step=='paid'\" fl-analytics-subsection=\"paid\">\n" +
    "            <p class=\"payment-modal-text\"><strong>You have paid successfully.</strong></p>\n" +
    "            <button class=\"btn\" ng-click=\"cancel()\">OK</button>\n" +
    "        </div>\n" +
    "        <div class=\"payment-modal-content\" ng-if=\"step=='error'\" fl-analytics-subsection=\"error\">\n" +
    "            <p>{{errorMessage}}</p>\n" +
    "            <button class=\"btn\" fl-analytics=\"try-again\" ng-click=\"addNewPaymentMethod()\">Please try it again</button>\n" +
    "        </div>\n" +
    "        <div ng-if=\"step == 'loading'\" class=\"is-loading modal-content-loading\"></div>\n" +
    "    </div>\n" +
    "    <div class=\"default-modal-footer\">\n" +
    "    </div>\n" +
    "</div>"
  );


  $templateCache.put('/views/warrior/SignupModalAbTestOneStep.html',
    "<div ng-multi-template='/views/warrior/FullScreenSignupModalBase.html'>\n" +
    "  <h1 name=\"header\" class=\"OnboardingModal-title\">Internet Marketing Insights are Only One Step Away!</h1>\n" +
    "</div>\n" +
    "\n"
  );


  $templateCache.put('/views/warrior/WarriorTopicChoice.html',
    "<div class=\"Modal-wrapper\">\n" +
    "    <div class=\"Modal\">\n" +
    "        <span class=\"CategorySelection-desc\">{{encourage()}}</span>\n" +
    "        <ul class=\"CategorySelection-previewList\">\n" +
    "            <li class=\"CategorySelection-previewItem\" ng-repeat=\"topic in selectedTopics\">\n" +
    "                <wf-icon class=\"wfIcon-selected\"  src=\"{{topic.iconName}}\"></wf-icon>\n" +
    "            </li>\n" +
    "            <li class=\"CategorySelection-previewItem CategorySelection-previewItem--empty\">\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "        <hr class=\"SectionDivider\">\n" +
    "\n" +
    "        <div action=\"\">\n" +
    "            <ul class=\"CategorySelection\">\n" +
    "                <li class=\"CategorySelection-item\" ng-repeat=\"topic in topics\">\n" +
    "                    <div class=\"CategorySelection-item-container\">\n" +
    "                        <input type=\"checkbox\" id=\"category{{$index}}\" ng-click=\"select(topic)\" ng-model=\"topic.selected\">\n" +
    "                        <label for=\"category{{$index}}\">\n" +
    "                            <wf-icon class=\"wfIcon-{{topic.iconName}}\"  class=\"CategorySelection-icon\" src=\"{{topic.iconName}}\"></wf-icon>\n" +
    "                            {{topic.name}}\n" +
    "                        </label>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "            <button class=\"CategorySelection-expand\">\n" +
    "                Load More\n" +
    "            </button>\n" +
    "            <div class=\"CategorySelection-ctaSet\">\n" +
    "                <button class=\"Btn\" ng-click=\"dismiss()\">\n" +
    "                    Save and Continue\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </civ>\n" +
    "    </div>\n" +
    "</div>"
  );


  $templateCache.put('/views/warrior/warroomsignuplogin.html',
    "<div class=\"default-modal-header\" fl-analytics-section=\"warroom-signup-login-modal\">\n" +
    "    <button class=\"default-modal-close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\" fl-analytics=\"close\">&times;</button>\n" +
    "    <div class=\"default-modal-logo\"></div>\n" +
    "    <h1 class=\"default-modal-title\">\n" +
    "        Get Access to the War Room\n" +
    "        <span class=\"item-price\">$97</span>\n" +
    "    </h1>\n" +
    "</div>\n" +
    "<div class=\"default-modal-body\" fl-analytics-section=\"warroom-signup-login-modal\">\n" +
    "    <div class=\"default-modal-info-column\">\n" +
    "        <div class=\"default-modal-paypal-colour\"></div>\n" +
    "        <div class=\"default-modal-paypal-screenshot info-column-image-preview\"></div>\n" +
    "        <div class=\"info-column-text\">A new window will open asking you to complete payment using PayPal.</div>\n" +
    "    </div>\n" +
    "    <div class=\"default-modal-content-column\">\n" +
    "        <form class=\"form default-form\" role=\"form\">\n" +
    "            <ol class=\"form-fields\">\n" +
    "                <li class=\"form-group btn-group\">\n" +
    "                    <label class=\"btn btn-secondary btn-small\" fl-analytics=\"choose-signup\">\n" +
    "                        <input type=\"radio\" ng-model=\"choice\" value=\"signup\"> I am a New User\n" +
    "                    </label>\n" +
    "                    <label class=\"btn btn-secondary btn-small\" fl-analytics=\"choose-login\">\n" +
    "                        <input type=\"radio\" ng-model=\"choice\" value=\"login\"> I’m an Existing User\n" +
    "                    </label>\n" +
    "                </li>\n" +
    "            </ol>\n" +
    "        </form>\n" +
    "        <form class=\"form default-form\" role=\"form\" ng-if=\"choice == 'signup'\" name=\"signupform\"  method=\"post\" novalidate ng-submit=\"signupform.$valid && createAccountSubmit(user)\" form-locator fl-analytics-subsection=\"warroom-signup-form\">\n" +
    "            <ol class=\"form-fields\">\n" +
    "                <li class=\"form-group\">\n" +
    "                    <label class=\"form-label\">Email Address</label>\n" +
    "                    <div class=\"input-group\">\n" +
    "                        <div class=\"input-group-addon\">\n" +
    "                            <span class=\"icon-wf-email\"></span>\n" +
    "                        </div>\n" +
    "                        <input class=\"input-group-field\" type=\"email\" name=\"email\" ng-model=\"user.email\" placeholder=\"Email Address\" fl-ensure-unique=\"email\" fl-guardpost ng-model=\"email\" required>\n" +
    "                    </div>\n" +
    "                    <div class=\"form-error-message\" ng-if=\"signupform.email.$touched || signupform.$submitted\" ng-messages=\"signupform.email.$error\">\n" +
    "                        <span ng-message=\"required\">Please enter your email address</span>\n" +
    "                        <span ng-message=\"email\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                        <span ng-message=\"invalid\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                        <span ng-message=\"format_incorrect\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                        <span ng-message=\"guardpost\">Invalid email address. <span ng-if=\"signupform.email.suggestion\">Did you mean {{signupform.email.suggestion }}? </span></span>\n" +
    "                        <span ng-message=\"unique\">Email already exists, please try a different email</span>\n" +
    "                        <span ng-message=\"used\">Email already exists, please try a different email</span>\n" +
    "                    </p>\n" +
    "                </li>\n" +
    "                <li class=\"form-group\">\n" +
    "                    <label class=\"form-label\">New Username</label>\n" +
    "                    <div class=\"input-group\">\n" +
    "                        <div class=\"input-group-addon\">\n" +
    "                            <span class=\"icon-wf-user\"></span>\n" +
    "                        </div>\n" +
    "                        <input class=\"input-group-field\" type=\"text\" name=\"username\" ng-model=\"user.username\" placeholder=\"Username\" fl-ensure-unique=\"username\" id=\"username\" ng-minlength=\"2\" required>\n" +
    "                    </div>\n" +
    "                    <div class=\"form-error-message\" ng-if=\"signupform.username.$touched || signupform.$submitted\" ng-messages=\"signupform.username.$error\">\n" +
    "                        <span ng-message=\"required\">Please enter a username</span>\n" +
    "                        <span ng-message=\"invalid\">Username is invalid</span>\n" +
    "                        <span ng-message=\"uniqueInvalid\">Invalid, please try a different username</span>\n" +
    "                        <span ng-message=\"unique\">Username is taken, please try a different username</span>\n" +
    "                    </p>\n" +
    "                </li>\n" +
    "                <li class=\"form-group\">\n" +
    "                    <label class=\"form-label\">Password</label>\n" +
    "                    <div class=\"input-group\">\n" +
    "                        <div class=\"input-group-addon\">\n" +
    "                            <span class=\"icon-wf-lock\"></span>\n" +
    "                        </div>\n" +
    "                        <input class=\"input-group-field\" type=\"password\" ng-model=\"user.password\" ng-pattern=\"/[0-9]/\" ng-minlength=\"6\" placeholder=\"Type a password\" name=\"password\" id=\"password\" required>\n" +
    "                    </div>\n" +
    "                    <div class=\"form-error-message\" ng-if=\"signupform.password.$touched || signupform.$submitted\" ng-messages=\"signupform.password.$error\">\n" +
    "                        <span ng-message=\"required\">Please type a password for your account</span>\n" +
    "                        <span ng-message=\"minlength\">Your password must be at least 6 characters</span>\n" +
    "                        <span ng-message=\"pattern\">Your password must contain at least 1 numeric character</span>\n" +
    "                    </p>\n" +
    "                </li>\n" +
    "                <li class=\"form-group\">\n" +
    "                    <label class=\"form-label\">Re-enter Password</label>\n" +
    "                    <div class=\"input-group\">\n" +
    "                        <div class=\"input-group-addon\">\n" +
    "                            <span class=\"icon-wf-lock\"></span>\n" +
    "                        </div>\n" +
    "                        <input class=\"input-group-field\" type=\"password\" name=\"confirmPassword\" ng-model=\"user.confirmPassword\" placeholder=\"Confirm your password\" fl-repeat-password=\"password\" required>\n" +
    "                    </div>\n" +
    "                    <div class=\"form-error-message\" ng-if=\"signupform.confirmPassword.$touched || signupform.$submitted\" ng-messages=\"signupform.confirmPassword.$error\">\n" +
    "                        <span ng-message=\"required\">Please re-enter your password to confirm it.</span>\n" +
    "                        <span ng-message=\"repeat\">Passwords do not match!</span>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "                <li class=\"form-group\">\n" +
    "                    <div class=\"AuthForm-captcha\" ng-model=\"user.captcha\" vc-recaptcha name=\"captcha\" required ></div>\n" +
    "                    <div class=\"Form-errorMsg\" ng-if=\"signupform.captcha.$touched || signupform.$submitted\" ng-messages=\"signupform.captcha.$error\">\n" +
    "                        <span ng-message=\"required\" id=\"warning-captcha-missing\">Captcha is missing!</span>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "            </ol>\n" +
    "            <div class=\"default-modal-paypal-cta\">\n" +
    "                <button type=\"submit\" class=\"btn btn-paypal\" ng-class=\"{'processing': processing}\" fl-analytics=\"pay-with-paypal\">Check out with <div class=\"btn-paypal-logo default-modal-paypal-logo-simple\"></div></button>\n" +
    "            </div>\n" +
    "        </form>\n" +
    "        <form class=\"form default-form\" role=\"form\" ng-if=\"choice == 'login'\" name=\"loginform\" novalidate ng-submit=\"loginform.$valid && loginSubmit(user)\" form-locator fl-analytics-subsection=\"warroom-login-form\">\n" +
    "            <ol class=\"form-fields\">\n" +
    "                <li class=\"form-group\">\n" +
    "                    <label class=\"form-label\">Username</label>\n" +
    "                    <div class=\"input-group\">\n" +
    "                        <div class=\"input-group-addon\">\n" +
    "                            <span class=\"icon-wf-user\"></span>\n" +
    "                        </div>\n" +
    "                        <input class=\"input-group-field\" type=\"text\" name=\"username\" ng-model=\"user.username\" placeholder=\"Username\" required>\n" +
    "                    </div>\n" +
    "                    <div class=\"form-error-message\" ng-if=\"loginform.username.$touched || loginform.$submitted\" ng-messages=\"loginform.username.$error\">\n" +
    "                        <span ng-message=\"required\">Please enter a username.</span>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "                <li class=\"form-group\">\n" +
    "                    <label class=\"form-label\">Password</label>\n" +
    "                    <div class=\"input-group\">\n" +
    "                        <div class=\"input-group-addon\">\n" +
    "                            <span class=\"icon-wf-lock\"></span>\n" +
    "                        </div>\n" +
    "                        <input class=\"input-group-field\" type=\"password\" ng-model=\"user.password\" placeholder=\"Type your password\" name=\"password\" id=\"password\" required>\n" +
    "                    </div>\n" +
    "                    <div class=\"form-error-message\" ng-if=\"loginform.password.$touched || loginform.$submitted\" ng-messages=\"loginform.password.$error\">\n" +
    "                        <span ng-message=\"required\">Please type a password for your account.</span>\n" +
    "                    </div>\n" +
    "                    <div class=\"form-error-message\" ng-if=\"unknown_error\">\n" +
    "                        <span>An unknown error occured, please try again later.</span>\n" +
    "                    </div>\n" +
    "                    <div class=\"form-error-message\" ng-if=\"login_error\">\n" +
    "                        <span ng-if=\"login_error == 'exceeded'\">You have exceeded the maximum number of login attempts, please try again in 15 minutes</span>\n" +
    "                        <span ng-if=\"login_error == 'failed'\">Your username or password is incorrect</span>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "            </ol>\n" +
    "            <div class=\"default-modal-paypal-cta\">\n" +
    "                <button type=\"submit\" class=\"btn btn-paypal\" ng-class=\"{'processing': processing}\" fl-analytics=\"pay-with-paypal\">Check out with <div class=\"btn-paypal-logo default-modal-paypal-logo-simple\"></div></button>\n" +
    "            </div>\n" +
    "        </form>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"default-modal-footer\">\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wfManager/addCuratedThreadForm.html',
    "<form class=\"Form\" ng-class=\"{'is-success' : $ctrl.state.success}\">\n" +
    "    <fieldset class=\"Form-fieldset\">\n" +
    "        <ol class=\"Form-steps\">\n" +
    "            <li class=\"Form-step\">\n" +
    "                <div class=\"InputGroup\">\n" +
    "                    <input class=\"Input\" type=\"text\" placeholder=\"thread id here\" ng-model=\"$ctrl.threadId\"/>\n" +
    "                    <button class=\"Btn Btn--small Btn--secondary\"\n" +
    "                        ng-click=\"$ctrl.submit()\"\n" +
    "                        ng-disabled=\"!$ctrl.threadId || $ctrl.state.loading\"\n" +
    "                        ng-class=\"{'Btn--success' : $ctrl.state.success, 'is-Btn-loading': $ctrl.state.loading}\">\n" +
    "                        Add\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "        </ol>\n" +
    "    </fieldset>\n" +
    "</form>\n"
  );


  $templateCache.put('/views/wfManager/bumpCuratedThread.html',
    "<button class=\"Btn Btn-primary Btn--small\" ng-click=\"$ctrl.bump()\" ng-disabled=\"$ctrl.state.loading\">Bump</button>\n"
  );


  $templateCache.put('/views/wfManager/cancelAutoBumpButton.html',
    "<button class=\"Btn Btn-primary\" ng-click=\"$ctrl.openConfirmationModal()\" ng-show=\"$ctrl.state.initialized\" ng-cloak>\n" +
    "    <span ng-if=\"!($ctrl.state.success || $ctrl.errorMessage)\">Cancel Auto-Bump</span>\n" +
    "    <span ng-if=\"$ctrl.state.success\" ng-cloak>Cancelled!</span>\n" +
    "    <span ng-if=\"$ctrl.errorMessage\" ng-cloak>{{ $ctrl.errorMessage }}</span>\n" +
    "</button>\n"
  );


  $templateCache.put('/views/wfManager/cancelMembershipButton.html',
    "<button ng-click=\"$ctrl.openConfirmationModal()\"\n" +
    "    ng-disabled=\"$ctrl.state.loading || !$ctrl.membership.renewable\"\n" +
    "    ng-show=\"$ctrl.state.ready\"\n" +
    "    ng-cloak>\n" +
    "    <span ng-if=\"$ctrl.state.success\" ng-cloak>\n" +
    "        Unsubscribed!\n" +
    "    </span>\n" +
    "    <span ng-if=\"$ctrl.state.error\" ng-cloak>\n" +
    "        Try Again\n" +
    "    </span>\n" +
    "    <span ng-if=\"!$ctrl.membership.renewable\" ng-cloak>\n" +
    "        Cancelled\n" +
    "    </span>\n" +
    "    <span ng-if=\"$ctrl.membership.renewable && !$ctrl.state.error && !$ctrl.state.success\">\n" +
    "        Cancel Membership\n" +
    "    </span>\n" +
    "</button>\n"
  );


  $templateCache.put('/views/wfManager/createThreadForm.html',
    "<div class=\"PostWidget\">\n" +
    "    <figure class=\"PostWidget-figure\">\n" +
    "        <img ng-src=\"{{ $ctrl.user.avatar || $ctrl.fallbackAvatar }}\" fallback-src=\"{{ $ctrl.fallbackAvatar }}\" alt=\"Avatar of {{ $ctrl.user.username }}\" class=\"Avatar Avatar--small\">\n" +
    "    </figure>\n" +
    "    <form name=\"newThreadForm\" class=\"PostWidget-form Form\" ng-submit=\"newThreadForm.$valid && $ctrl.submit()\" novalidate>\n" +
    "        <fieldset class=\"Form-fieldset\">\n" +
    "            <ol class=\"Form-steps\">\n" +
    "                <li class=\"Form-step\">\n" +
    "                    <span class=\"Input-wrapper Input-wrapper--hasPointer\">\n" +
    "                        <input type=\"text\" name=\"subject\" ng-model=\"$ctrl.newThread.subject\" required ng-minlength=\"5\" ng-maxlength=\"100\" placeholder=\"What do you want to discuss or know about?\">\n" +
    "                        <aside ng-show=\"newThreadForm.$submitted && newThreadForm.subject.$error.required\" class=\"Alert Alert--error\">Please enter a subject</aside>\n" +
    "                        <aside ng-show=\"newThreadForm.$submitted && newThreadForm.subject.$error.minlength\" class=\"Alert Alert--error\">Please enter a minimum of 5 characters</aside>\n" +
    "                        <aside ng-show=\"newThreadForm.$submitted && newThreadForm.subject.$error.maxlength\" class=\"Alert Alert--error\">Please limit the title to 100 characters</aside>\n" +
    "                    </span>\n" +
    "                </li>\n" +
    "                <li class=\"Form-step media--available@mobile\">\n" +
    "                    <span class=\"Input-wrapper Input-wrapper--hasPointer\">\n" +
    "                        <textarea rows=\"6\" name=\"message\" ng-model=\"$ctrl.newThread.message\" required ng-minlength=\"10\" placeholder=\"Enter details here...\"></textarea>\n" +
    "                        <aside ng-show=\"newThreadForm.$submitted && newThreadForm.message.$error.required\" class=\"Alert Alert--error\">Please enter thread message</aside>\n" +
    "                        <aside ng-show=\"newThreadForm.$submitted && newThreadForm.message.$error.minlength\" class=\"Alert Alert--error\">Please enter a minimum of 10 characters</aside>\n" +
    "                    </span>\n" +
    "                </li>\n" +
    "                <li class=\"Form-step VbEditorToolbar media--hidden@mobile\">\n" +
    "                    <div text-angular=\"text-angular\"\n" +
    "                      name=\"message\"\n" +
    "                      ng-model=\"$ctrl.newThread.message\"\n" +
    "                      required ng-minlength=\"10\"\n" +
    "                      placeholder=\"Enter details here...\"\n" +
    "                      ta-disabled=\"disabled\"\n" +
    "                      ta-username-tag=\"enabled\"\n" +
    "                      class=\"post-wso-editor\">\n" +
    "                    </div>\n" +
    "                    <aside ng-show=\"newThreadForm.$submitted && newThreadForm.message.$error.required\" class=\"Alert Alert--error\">Please enter thread message</aside>\n" +
    "                    <aside ng-show=\"newThreadForm.$submitted && newThreadForm.message.$error.minlength\" class=\"Alert Alert--error\">Please enter a minimum of 10 characters</aside>\n" +
    "                </li>\n" +
    "                <aside class=\"Alert Alert--error\" ng-show=\"$ctrl.nonFieldError && $ctrl.state.submitted\">{{ $ctrl.nonFieldError }}</aside>\n" +
    "                <li class=\"Form-step\">\n" +
    "                    <p><strong>Note:</strong> New threads now require approval, this usually happens within 60 seconds</p>\n" +
    "                </li>\n" +
    "                <li class=\"PostWidget-submitStep Form-step\">\n" +
    "                    <span class=\"PostWidget-selectContainer\">\n" +
    "                        <select class=\"PostWidget-select\" ng-options=\"topic as topic.name for topic in $ctrl.topicList\"\n" +
    "                            name=\"selectedTopic\"\n" +
    "                            ng-model=\"$ctrl.selectedTopic\"\n" +
    "                            required>\n" +
    "                        </select>\n" +
    "                        <aside ng-show=\"newThreadForm.$submitted && newThreadForm.selectedTopic.$error.required\" class=\"PostWidget-selectContainer-error Alert Alert--error\">Please choose a topic</aside>\n" +
    "                    </span>\n" +
    "                    <span class=\"PostWidget-btnContainer\">\n" +
    "                        <input type=\"submit\" class=\"PostWidget-btn Btn Btn--small\" value=\"New Post\" ng-disabled=\"$ctrl.state.isSubmitting && $newThreadForm.$invalid\" ></input>\n" +
    "                    </span>\n" +
    "                </li>\n" +
    "            </ol>\n" +
    "        </fieldset>\n" +
    "    </form>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wfManager/linkTypeThreadForm.html',
    "<form name=\"threadForm\" class=\"Form\" novalidate ng-submit=\"threadForm.$valid && $ctrl.submit()\">\n" +
    "    <fieldset class=\"Form-fieldset\">\n" +
    "    <ol class=\"Form-steps\">\n" +
    "        <li class=\"Form-step\">\n" +
    "            <label class=\"Form-label\">Title</label>\n" +
    "            <input type=\"text\" name=\"title\" required ng-model=\"$ctrl.thread.title\">\n" +
    "        </li>\n" +
    "        <li class=\"Form-step\">\n" +
    "            <label class=\"Form-label\">Destination Url</label>\n" +
    "            <input type=\"url\" name=\"destinationUrl\" required ng-model=\"$ctrl.thread.destinationUrl\">\n" +
    "        </li>\n" +
    "        <li class=\"Form-step VbEditorToolbar\">\n" +
    "            <div text-angular=\"text-angular\"\n" +
    "              class=\"post-wso-editor\"\n" +
    "              ng-model=\"$ctrl.thread.message\">\n" +
    "            </div>\n" +
    "        </li>\n" +
    "        <li class=\"Form-step\">\n" +
    "            <button type=\"submit\" class=\"Btn\" ng-disabled=\"$ctrl.state.loading\" style=\"float:right;\">Submit</button>\n" +
    "        </li>\n" +
    "    </ol>\n" +
    "    </fieldset>\n" +
    "</form>\n"
  );


  $templateCache.put('/views/wfManager/postModerationControls.html',
    "<button class=\"Btn Btn--small\" ng-click=\"$ctrl.launchDecimator()\">Spam</button>\n" +
    "<button class=\"Btn Btn--small Btn--secondary\" ng-click=\"$ctrl.approvePost()\" ng-disabled=\"$ctrl.postApproved\">Approve</button>\n"
  );


  $templateCache.put('/views/wfManager/referralInput.html',
    "<form class=\"ReferralForm Form\" ng-class=\"{'is-success' : $ctrl.state.success}\">\n" +
    "    <fieldset class=\"Form-fieldset\">\n" +
    "        <ol class=\"Form-steps\">\n" +
    "            <li class=\"Form-step\">\n" +
    "                <div class=\"InputGroup\">\n" +
    "                    <input class=\"Input\" type=\"text\" placeholder=\"Enter email address...\" ng-model=\"$ctrl.referral.email\"/>\n" +
    "                    <button class=\"ReferralForm-submit Btn Btn--small Btn--secondary\"\n" +
    "                        ng-click=\"$ctrl.invite()\"\n" +
    "                        ng-disabled=\"$ctrl.state.loading || !$ctrl.isValidEmail()\"\n" +
    "                        ng-class=\"{'Btn--success' : $ctrl.state.success, 'is-Btn-loading': $ctrl.state.loading}\">\n" +
    "                        <span class=\"ReferralForm-submit-text\">Invite</span>\n" +
    "                        <wf-icon src=\"check--light\"></wf-icon>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "                <span class=\"Form-errorMsg\" ng-show=\"$ctrl.errorMessage\" ng-cloak>{{ $ctrl.errorMessage }}</span>\n" +
    "            </li>\n" +
    "        </ol>\n" +
    "    </fieldset>\n" +
    "</form>\n"
  );


  $templateCache.put('/views/wfManager/removeCuratedThread.html',
    "<button class=\"Btn Btn-primary Btn--hollow Btn--small\" ng-click=\"$ctrl.remove()\" ng-disabled=\"$ctrl.state.loading\">Remove</button>\n"
  );


  $templateCache.put('/views/wfManager/replyForm.html',
    "<div class=\"PostWidget\">\n" +
    "    <figure class=\"PostWidget-figure\">\n" +
    "        <img class=\"Avatar Avatar--small\"\n" +
    "            ng-src=\"{{ $ctrl.author.avatar_url || $ctrl.avatarPlaceholder }}\"\n" +
    "            fallback-src=\"{{ $ctrl.avatarPlaceholder }}\"\n" +
    "            alt=\"Avatar of {{ $ctrl.author.username }}\" />\n" +
    "    </figure>\n" +
    "\n" +
    "    <form class=\"PostWidget-form\" wf-deep-blur=\"$ctrl.unfocus()\">\n" +
    "        <div class=\"InputCombo\">\n" +
    "            <span class=\"Input-wrapper\">\n" +
    "                <div ng-if=\"$ctrl.state.showMessageEditor\" class=\"VbEditorToolbar\">\n" +
    "                    <div text-angular=\"text-angular\"\n" +
    "                      placeholder=\"{{ $ctrl.placeholder }}\"\n" +
    "                      class=\"post-wso-editor post-wso-editor--small\"\n" +
    "                      ng-model=\"$ctrl.newPost.content\"\n" +
    "                      ta-disabled=\"disabled\"\n" +
    "                      ta-username-tag=\"enabled\"\n" +
    "                      fl-analytics=\"body\">\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <input type=\"text\" class=\"PostWidget-input Input\" rows=\"1\"\n" +
    "                    placeholder=\"{{ $ctrl.placeholder }}\"\n" +
    "                    ng-if=\"!$ctrl.state.showMessageEditor\"\n" +
    "                    ng-model=\"$ctrl.newPost.content\"\n" +
    "                    ng-focus=\"$ctrl.displayHiddenElements()\">\n" +
    "                </input>\n" +
    "\n" +
    "                <p ng-show=\"$ctrl.state.showMessageEditor && $ctrl.state.showHelpText && $ctrl.newPost.content.length < 10\" class=\"DiscussionBoard-helpText Form-helpText\">\n" +
    "                    Minimum of <strong>{{ 10 - $ctrl.newPost.content.length }}</strong> characters to post\n" +
    "                </p>\n" +
    "            </span>\n" +
    "            <span class=\"InputCombo-btn\">\n" +
    "                <button class=\"DiscussionBoard-replyBtn Btn Btn--small\"\n" +
    "                    ng-disabled=\"$ctrl.isInvalidPost()\"\n" +
    "                    ng-click=\"$ctrl.postComment()\"\n" +
    "                    ng-cloak>Reply</button>\n" +
    "            </span>\n" +
    "        </div>\n" +
    "\n" +
    "        <aside class=\"Alert Alert--error\" ng-show=\"$ctrl.state.postingFailed && !$ctrl.errorMessage\" ng-cloak>\n" +
    "            Something wrong happened. Please try again.\n" +
    "        </aside>\n" +
    "\n" +
    "        <aside class=\"Alert Alert--error\" ng-show=\"$ctrl.state.postingFailed && $ctrl.errorMessage\" ng-cloak>\n" +
    "            {{ $ctrl.errorMessage }}\n" +
    "        </aside>\n" +
    "\n" +
    "        <div class=\"Loader-overlay\" ng-show=\"$ctrl.state.posting\" ng-cloak>\n" +
    "            <div class=\"Loader\">Loading...</div>\n" +
    "        </div>\n" +
    "    </form>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wfManager/signUpForm.html',
    "<div class=\"AuthForm-container AuthForm--animated\" ng-class=\"{'AuthForm--animated-is-active': $ctrl.state.ready}\" ng-cloak fl-analytics-section=\"inpage-signup-form\">\n" +
    "    <div class=\"AuthForm AuthForm--light AuthForm--twoColumn AuthForm--signUp\">\n" +
    "        <div class=\"AuthForm-main\">\n" +
    "            <form class=\"AuthForm-form Form\" name=\"signupForm\" ng-submit=\"signupForm.$valid && $ctrl.createAccount($ctrl.user)\" ng-show=\"$ctrl.state.signup\" novalidate form-locator fl-analytics-subsection=\"signup\">\n" +
    "                <fieldset class=\"Form-fieldset\">\n" +
    "                    <div class=\"Alert Alert--error\" ng-if=\"signupForm.$submitted && $ctrl.errorMessage\">\n" +
    "                        <span>Something wrong happened :( {{ $ctrl.errorMessage }}</span>\n" +
    "                    </div>\n" +
    "                    <ol class=\"Form-steps\">\n" +
    "                        <li class=\"Form-step\">\n" +
    "                            <label class=\"Form-label\" for=\"username\">Username</label>\n" +
    "                            <input class=\"Input\" type=\"text\" name=\"username\" placeholder=\"username\" ng-model=\"$ctrl.user.username\" ng-minlength=\"2\" fl-ensure-unique=\"username\" required />\n" +
    "                            <div class=\"Form-errorMsg\" ng-if=\"signupForm.username.$touched || signupForm.$submitted\" ng-messages=\"signupForm.username.$error\">\n" +
    "                              <span ng-message=\"required\">Please enter a username</span>\n" +
    "                              <span ng-message=\"invalid\">Username is invalid</span>\n" +
    "                              <span ng-message=\"unique\">Username is taken, please try a different username</span>\n" +
    "                            </div>\n" +
    "                        </li>\n" +
    "                        <li class=\"Form-step\">\n" +
    "                            <label class=\"Form-label\" for=\"email\">Email</label>\n" +
    "                            <input class=\"Input\" type=\"email\" name=\"email\" placeholder=\"me@email.com\" ng-model=\"$ctrl.user.email\" fl-ensure-unique=\"email\" fl-guardpost required />\n" +
    "                            <div class=\"Form-errorMsg\" ng-if=\"signupForm.email.$touched || signupForm.$submitted\" ng-messages=\"signupForm.email.$error\">\n" +
    "                              <span ng-message=\"required\">Please enter your email address</span>\n" +
    "                              <span ng-message=\"email\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                              <span ng-message=\"invalid\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                              <span ng-message=\"format_incorrect\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                              <span ng-message=\"uniqueInvalid\">Your email address is invalid. Please enter a valid one</span>\n" +
    "                              <span ng-message=\"guardpost\">Invalid email address. <span ng-if=\"signupform.email.suggestion\">Did you mean {{signupform.email.suggestion }}? </span></span>\n" +
    "                              <span ng-message=\"unique\">Email already exists, please try a different email</span>\n" +
    "                              <span ng-message=\"used\">Email already exists, please try a different email</span>\n" +
    "                            </div>\n" +
    "                        </li>\n" +
    "                        <li class=\"Form-step\">\n" +
    "                            <label class=\"Form-label\" for=\"password\">Password</label>\n" +
    "                            <input class=\"Input\" type=\"password\" name=\"password\" placeholder=\"********\" ng-model=\"$ctrl.user.password\" ng-minlength=\"6\" ng-pattern=\"/[0-9]/\" required />\n" +
    "                            <div class=\"Form-errorMsg\" ng-if=\"signupForm.password.$touched || signupForm.$submitted\" ng-messages=\"signupForm.password.$error\">\n" +
    "                              <span ng-message=\"required\">Please type a password for your account</span>\n" +
    "                              <span ng-message=\"minlength\">Your password must be at least 6 characters</span>\n" +
    "                              <span ng-message=\"pattern\">Your password must contain at least 1 numeric character</span>\n" +
    "                            </div>\n" +
    "                        </li>\n" +
    "                        <li class=\"Form-step\">\n" +
    "                            <div class=\"AuthForm-captcha\" vc-recaptcha name=\"captcha\" ng-model=\"$ctrl.user.captcha\" required></div>\n" +
    "                            <div class=\"Form-errorMsg\" ng-if=\"signupForm.captcha.$touched || signupForm.$submitted\" ng-messages=\"signupForm.captcha.$error\">\n" +
    "                              <span ng-message=\"required\">Captcha is missing!</span>\n" +
    "                            </div>\n" +
    "                        </li>\n" +
    "                        <li class=\"Form-step\">\n" +
    "                            <button class=\"Btn Btn--wide\" type=\"submit\"\n" +
    "                              ng-class=\"{'is-Btn-loading': $ctrl.state.loading}\"\n" +
    "                              ng-disabled=\"signupForm.$invalid || $ctrl.state.loading\">Sign up</button>\n" +
    "                        </li>\n" +
    "                    </ol>\n" +
    "                </fieldset>\n" +
    "            </form>\n" +
    "            <form class=\"AuthForm-form Form\" name=\"loginForm\" ng-submit=\"loginForm.$valid && $ctrl.loginUser($ctrl.login)\" ng-show=\"!$ctrl.state.signup\" novalidate form-locator fl-analytics=\"login\">\n" +
    "                <fieldset class=\"Form-fieldset\">\n" +
    "                    <div class=\"Alert Alert--error\" ng-if=\"loginForm.$submitted && $ctrl.errorMessage\">\n" +
    "                        <span>Something wrong happened :( {{ $ctrl.errorMessage }}</span>\n" +
    "                    </div>\n" +
    "                    <ol class=\"Form-steps\">\n" +
    "                        <li class=\"Form-step\">\n" +
    "                            <label class=\"Form-label\" for=\"username\">Username</label>\n" +
    "                            <input class=\"Input\" type=\"text\" name=\"username\" placeholder=\"username\" ng-model=\"$ctrl.login.username\" required />\n" +
    "                            <div class=\"Form-errorMsg\" ng-if=\"loginForm.username.$touched || loginForm.$submitted\" ng-messages=\"loginForm.username.$error\">\n" +
    "                              <span ng-message=\"required\">Please enter a username</span>\n" +
    "                            </div>\n" +
    "                        </li>\n" +
    "                        <li class=\"Form-step\">\n" +
    "                            <label class=\"Form-label\" for=\"password\">Password</label>\n" +
    "                            <input class=\"Input\" type=\"password\" name=\"password\" placeholder=\"********\" ng-model=\"$ctrl.login.password\" required />\n" +
    "                            <div class=\"Form-errorMsg\" ng-if=\"loginForm.password.$touched || loginForm.$submitted\" ng-messages=\"loginForm.password.$error\">\n" +
    "                              <span ng-message=\"required\">Please type a password for your account</span>\n" +
    "                            </div>\n" +
    "                        </li>\n" +
    "                        <li class=\"Form-step\">\n" +
    "                            <button class=\"Btn Btn--wide\" type=\"submit\"\n" +
    "                              ng-class=\"{'is-Btn-loading': $ctrl.state.loading}\"\n" +
    "                              ng-disabled=\"loginForm.$invalid || $ctrl.state.loading\">Log in</button>\n" +
    "                        </li>\n" +
    "                    </ol>\n" +
    "                </fieldset>\n" +
    "            </form>\n" +
    "            <div class=\"AuthForm-divider Divider Divider--simple\">\n" +
    "                <span class=\"AuthForm-divider-title Divider-title\">\n" +
    "                    OR\n" +
    "                </span>\n" +
    "            </div>\n" +
    "            <div class=\"AuthForm-right-pane\">\n" +
    "                <span class=\"AuthForm-right-pane-title\">\n" +
    "                    Create your account on\n" +
    "                </span>\n" +
    "                <span class=\"AuthForm-right-pane-logo\">\n" +
    "                    <wf-icon src=\"warrior-logo\"></wf-icon>\n" +
    "                </span>\n" +
    "                <p class=\"AuthForm-right-pane-desc\">\n" +
    "                    And sell you product on the World's Largest Internet Marketing Place\n" +
    "                </p>\n" +
    "                <div class=\"AuthForm-right-pane-action\">\n" +
    "                    <div class=\"AuthForm-right-pane-action-item\">\n" +
    "                        <a href=\"{{$ctrl.fbLoginUrl}}\" class=\"AuthForm-action-btn Btn Btn--decent Btn--wide\" fl-analytics=\"facebook-button\">\n" +
    "                            Sign in with Facebook\n" +
    "                        </a>\n" +
    "                    </div>\n" +
    "                    <div class=\"AuthForm-right-pane-action-item\">\n" +
    "                        <a href=\"{{$ctrl.googleLoginUrl}}\" class=\"AuthForm-action-btn Btn Btn--wide Btn--tertiary\" fl-analytics=\"google-button\">\n" +
    "                            Sign in with Google\n" +
    "                        </a>\n" +
    "                    </div>\n" +
    "                    <div class=\"AuthForm-right-pane-action-item\">\n" +
    "                        <a class=\"AuthForm-action-btn Btn Btn--wide Btn--hollow\" ng-click=\"$ctrl.toggleForm()\" ng-show=\"$ctrl.state.signup\" fl-analytics=\"login-toggle-button\">\n" +
    "                            Log in using an existing account\n" +
    "                        </a>\n" +
    "                        <a class=\"AuthForm-action-btn Btn Btn--wide Btn--hollow\" ng-click=\"$ctrl.toggleForm()\" ng-show=\"!$ctrl.state.signup\" fl-analytics=\"signup-toggle-button\">\n" +
    "                            Create a new account\n" +
    "                        </a>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('/views/wfManager/threadPublishButton.html',
    "<button class=\"Btn Btn--secondary Btn--small\" ng-click=\"$ctrl.launch()\">\n" +
    "    Launch\n" +
    "</button>\n"
  );

}]);

'use strict';

angular.element(document).ready(function() {
  window.$('a[href$="register.php"]').attr({'wf-signup': '', 'href':'javascript:void(0)'}); // jshint ignore:line
  angular.bootstrap(document, ['wfManager']);
});
